/* eslint-disable no-fallthrough */
/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable default-case */
/* eslint-disable no-alert */
/* eslint-disable no-console */
/* eslint-disable max-len */
/* eslint-disable camelcase */
/* eslint-disable prefer-const */
import React from 'react';
import Logger from './Logger';
import hark from 'hark';
import { getSignalingUrl } from './urlFactory';
import { SocketTimeoutError } from './utils';
import { switchToNextAudioDevice, startDeviceChangeListener } from './utils/audioDeviceManager';
import * as requestActions from './store/actions/requestActions';
import * as meActions from './store/actions/meActions';
import * as intlActions from './store/actions/intlActions';
import * as roomActions from './store/actions/roomActions';
import * as peerActions from './store/actions/peerActions';
import * as peerVolumeActions from './store/actions/peerVolumeActions';
import * as settingsActions from './store/actions/settingsActions';
import * as toolareaAction from './store/actions/toolareaActions';
import * as appearanceActions from './store/actions/appearanceActions';
import * as chatActions from './store/actions/chatActions';
import * as privateChatActions from './store/actions/privateChatActions';
import * as fileActions from './store/actions/fileActions';
import * as lobbyPeerActions from './store/actions/lobbyPeerActions';
import * as consumerActions from './store/actions/consumerActions';
import * as producerActions from './store/actions/producerActions';
import * as notificationActions from './store/actions/notificationActions';
import * as transportActions from './store/actions/transportActions';
import * as webinarActions from './store/actions/webinarActions';
import * as viewTranscriptionAction from './store/actions/viewTranscriptionAction';
import * as PresenceActions from './store/actions/presenceActions';
import Spotlights from './Spotlights';
import Spotpages from './Spotpages';
import { permissions } from './permissions';
import * as locales from './intl/locales';
import { createIntl } from 'react-intl';
import * as recorderActions from './store/actions/recorderActions';
import { directReceiverTransform, opusReceiverTransform } from './transforms/receiver';
import { config } from './config';
import bowser from 'bowser';
import ChromaKey from './matting';
import AWS from 'aws-sdk';
import { canPIP, isInPIP, supportsPIP, closePIP } from './components/pictureInPicture/pipUtils/pip';
// import { pipViewMode } from './components/pictureInPicture/pipUtils/pipViewMode';
import { makePeerConsumerSelector, makePermissionSelector, meProducersSelector, spotlightPeersSelector } from './store/selectors';
import { decodeToken } from 'react-jwt';
import { getWebinarDetals } from './libs/apis/webinarApi';

import io from 'socket.io-client';
import * as transcriptionactions from './store/actions/transcriptionaction';
import { getTranscriptionData } from './components/MeetingDrawer/Transcription/api';
import { decryptDataForVc } from './libs/crypto';
import { toast } from 'react-toastify';
import deviceInfo from './deviceInfo';
import * as tpScreenActions from './store/actions/tpScreenActions';
import { throttle } from 'lodash';
import SIPCalling from './SIP';

// ({ default: io } = await import(

// 	/* webpackPrefetch: true */
// 	/* webpackChunkName: "socket.io" */
// 	'socket.io-client'
// ));

import axios from 'axios';

// AWS.config.update({
// 	accessKeyId     : import.meta.env.VITE_accessKeyId,
// 	secretAccessKey : import.meta.env.VITE_secretAccessKey
// });

const myBucket = new AWS.S3({
	params : { Bucket: import.meta.env.VITE_s3Bucket },
	region : import.meta.env.VITE_s3Region
});

let createTorrent;

let WebTorrent;

let saveAs;

let mediasoupClient;

// let io;

let ScreenShare;

let audioProcess;

const logger = new Logger('RoomClient');

// const queue = new AwaitQueue();

const VIDEO_CONSTRAINS =
{
	'low' :
	{
		width : 320
	},
	'medium' :
	{
		width : 640
	},
	'high' :
	{
		width : 1280
	},
	'veryhigh' :
	{
		width : 1920
	},
	'ultra' :
	{
		width : 3840
	}
};

const DEFAULT_NETWORK_PRIORITIES =
{
	audio            : 'high',
	mainVideo        : 'high',
	additionalVideos : 'medium',
	screenShare      : 'medium'
};

let store;

function getVideoConstrains(resolution, aspectRatio)
{
	const entry = VIDEO_CONSTRAINS[resolution] || VIDEO_CONSTRAINS.medium;

	// Ask for the width we want and express the shape as an aspectRatio
	// constraint, rather than deriving an explicit height. Deriving it asks for
	// an exact pixel pair (e.g. 1280x960 for 'high' at 4:3) that most cameras
	// have no mode for, and because `ideal` is a soft constraint the browser
	// silently falls back to another mode instead of erroring — which is how a
	// 'high' selection could still end up capturing 640x480.
	return {
		width       : { ideal: entry.width },
		aspectRatio : { ideal: aspectRatio }
	};
}

/** Data saver (mediaSession.lowBandwidthMode): capture at medium (640-wide, e.g. 640×360 @ 16:9). */
function getCaptureResolution(settings)
{
	if (!store || typeof store.getState !== 'function')
		return settings.resolution;

	return store.getState().mediaSession?.lowBandwidthMode ? 'medium' : settings.resolution;
}

const PC_PROPRIETARY_CONSTRAINTS =
{
	optional : [ { googDscp: true } ]
};

// How long we wait for schedule/getmeeting before producing with the
// simulcast setting we already have. Keeps a slow API from blocking the join.
const MEETING_DETAILS_FETCH_TIMEOUT = 5000;

const VIDEO_SIMULCAST_PROFILES =
{
	3840 :
		[
			{ scaleResolutionDownBy: 12, maxBitrate: 150000 },
			{ scaleResolutionDownBy: 6, maxBitrate: 500000 },
			{ scaleResolutionDownBy: 1, maxBitrate: 10000000 }
		],
	1920 :
		[
			{ scaleResolutionDownBy: 6, maxBitrate: 150000 },
			{ scaleResolutionDownBy: 3, maxBitrate: 500000 },
			{ scaleResolutionDownBy: 1, maxBitrate: 3500000 }
		],
	1280 :
		[
			{ scaleResolutionDownBy: 4, maxBitrate: 150000 },
			{ scaleResolutionDownBy: 2, maxBitrate: 500000 },
			{ scaleResolutionDownBy: 1, maxBitrate: 1200000 }
		],
	640 :
		[
			{ scaleResolutionDownBy: 2, maxBitrate: 150000 },
			{ scaleResolutionDownBy: 1, maxBitrate: 500000 }
		],
	320 :
		[
			{ scaleResolutionDownBy: 1, maxBitrate: 150000 }
		]
};

// Used for VP9 webcam video.
const VIDEO_KSVC_ENCODINGS =
	[
		{ scalabilityMode: 'S3T3_KEY' }
	];

// Used for VP9 desktop sharing.
const VIDEO_SVC_ENCODINGS =
	[
		{ scalabilityMode: 'S3T3', dtx: true }
	];

/**
 * Validates the simulcast `encodings` array extracting the resolution scalings
 * array.
 * ref. https://www.w3.org/TR/webrtc/#rtp-media-api
 *
 * @param {*} encodings
 * @returns the resolution scalings array
 */
function getResolutionScalings(encodings)
{
	const resolutionScalings = [];

	// SVC encodings
	if (encodings.length === 1)
	{
		const { spatialLayers } =
			mediasoupClient.parseScalabilityMode(encodings[0].scalabilityMode);

		for (let i = 0; i < spatialLayers; i++)
		{
			resolutionScalings.push(2 ** (spatialLayers - i - 1));
		}

		return resolutionScalings;
	}

	// Simulcast encodings
	let scaleResolutionDownByDefined = false;

	encodings.forEach((encoding) =>
	{
		if (encoding.scaleResolutionDownBy !== undefined)
		{
			// at least one scaleResolutionDownBy is defined
			scaleResolutionDownByDefined = true;
			// scaleResolutionDownBy must be >= 1.0
			resolutionScalings.push(Math.max(1.0, encoding.scaleResolutionDownBy));
		}
		else
		{
			// If encodings contains any encoding whose scaleResolutionDownBy
			// attribute is defined, set any undefined scaleResolutionDownBy
			// of the other encodings to 1.0.
			resolutionScalings.push(1.0);
		}
	});

	// If the scaleResolutionDownBy attribues of sendEncodings are
	// still undefined, initialize each encoding's scaleResolutionDownBy
	// to 2^(length of sendEncodings - encoding index - 1).
	if (!scaleResolutionDownByDefined)
	{
		encodings.forEach((encoding, index) =>
		{
			resolutionScalings[index] = 2 ** (encodings.length - index - 1);
		});
	}

	return resolutionScalings;
}

let intl;

// Chrome 140+ compatible insertable streams detection
const insertableStreamsSupported = Boolean(
	RTCRtpSender.prototype.createEncodedStreams ||
	RTCRtpReceiver.prototype.createEncodedStreams ||
	window.RTCRtpScriptTransform // Chrome 140+ v2 API
);

export default class RoomClient
{
	/**
	 * @param  {Object} data
	 * @param  {Object} data.store - The Redux store.
	 * @param  {Object} data.intl - react-intl object
	 */
	static init(data)
	{
		store = data.store;
	}

	constructor(
		{
			peerId,
			accessCode,
			device,
			produce,
			headless,
			forceTcp,
			displayName,
			muted,
			basePath,
			// token,
			projectId,
			screenPage,
			mode,
			mDeviceId,
			mDeviceType,
			_uid,
			record,
			hostname,
			meetingType,
			pairId,
			// getLan,
			cpanelSocket,
			presenceUserId,
			sipUserID,
			callId
		} = {})
	{

		if (!peerId)
			throw new Error('Missing peerId');
		else if (!device)
			throw new Error('Missing device');

		logger.debug(
			'constructor() [peerId: "%s", device: "%s", produce: "%s", forceTcp: "%s", displayName ""]',
			peerId, device.flag, produce, forceTcp, displayName);

		this._signalingUrl = null;

		// Closed flag.
		this._closed = false;

		// Whether we should produce.
		this._produce = produce;

		// Whether we force TCP
		this._forceTcp = forceTcp;

		// URL basepath
		this._basePath = basePath;

		this._record = record;

		this._uid = _uid;

		this._layoutDataWB = null;

		this._roomTemplate = null;
		this._layoutDataSC = [];

		this._chromaStream = null;

		this._hostName = hostname;
		// this._hostName = 'apps.inmeet.ai';
		// this._hostName = 'devapps.inmeet.ai';
		this._fileShareLayoutData = null;
		this._videoData = null;
		this._meetingType = meetingType;

		this._webinarSocket = null;

		this._annotationsSocket=null;

		this.newDate = new Date().valueOf();

		this.Diff = null;

		this.videosArray = store.getState().room.pipVideos;
		// this.emojiArray = store.getState().toolarea.selectedAnimeEmoji;

		// Use displayName
		this._displayName = null;
		this._pairId = null;

		this._sipUserID = sipUserID;

		if (pairId)
		{
			this._pairId = pairId;
		}

		if (this._record)
		{
			store.dispatch(roomActions.setRecordMode(true));
			store.dispatch(roomActions.setHideSelfView(true));
			store.dispatch(settingsActions.setBottomBar(false));
		}
		if (displayName)
		{
			try
			{
				this._displayName = window.atob(displayName);
				store.dispatch(meActions.setMeDislayName(this._displayName));
				store.dispatch(settingsActions.setDisplayName(this._displayName));
			}
			catch (err)
			{
				this._displayName = null;
			}
		}

		this._tracker = 'wss://tracker.lab.vvc.niif.hu:443';

		// Torrent support
		this._torrentSupport = null;

		// Whether simulcast should be used.
		// this._useSimulcast = false;

		this._useSimulcast = config.simulcast;

		// Whether simulcast should be used for sharing
		this._useSharingSimulcast = config.simulcastSharing;

		// Cached schedule/getmeeting (or webinar details) request, so the join
		// flow and the post-join consumers share a single network hit.
		this._meetingDetailsPromise = null;

		this._muted = muted;

		// This device
		this._device = device;

		// My peer name.
		this._peerId = peerId;

		this._pipActiveSpeaker = null;

		this._roomActiveSpeaker = null;

		// Access code
		this._accessCode = accessCode;

		// this._token = token;

		this.screenShareWithAudio = false;

		this._projectId = projectId;

		this.breakoutRoomData = null;

		this.isBreakoutRoom = false;

		this._screenPage = screenPage;

		this._mode = mode;

		this._mDeviceId = mDeviceId;

		this._mDeviceType = mDeviceType;

		this.broadcastSocket = null;

		// if (mDeviceType)
		// {
		store.dispatch(roomActions.setMDeviceId(mDeviceType));
		// }

		this._totalPageLength = 0;

		this.cpanelSocket = cpanelSocket;

		this.hasPermission = makePermissionSelector(permissions.MODERATE_ROOM);

		this.Moderator = this.hasPermission(store.getState());

		this.vBackgroundStream = null;

		this._roomTranscriptionStart=true;

		this.videoKeydown = false;
		this._sipUserJoined = false;

		if (Number(this._screenPage) > 0 || mode === 'speaker' || mode === 'screen')
		{
			console.log('fasasdas disadaISDAsduADS');
			this._spotpages = new Spotpages(Number(this._screenPage), this);

			store.dispatch(tpScreenActions.setScreenNumber(Number(this._screenPage)));

			store.dispatch(settingsActions.setBottomBar(false));
			// store.dispatch(settingsActions.setLayoutHideIcone(false));
			store.dispatch(roomActions.setHideSelfView(true));
			store.dispatch(roomActions.setTPStatus(true, true));
			if (this._mode === 'speaker')
			{
				store.dispatch(roomActions.setDisplayMode('activeSpeakerview'));
			}
			else if (this._mode === 'screen')
			{
				store.dispatch(roomActions.setDisplayMode('presenter'));
			}
			else
			{
				store.dispatch(roomActions.setDisplayMode('pagescreen'));
			}
		}
		else
		{
			if (this._displayName)
			{
				// eslint-disable-next-line no-restricted-globals
				window.history.replaceState({}, null, encodeURIComponent(location.pathname.slice(1)) || '/');
				// store.dispatch(roomActions.setAutoJoin(true));
			}
			else
			{
				store.dispatch(roomActions.setTPStatus(false, false));
			}

			if (!this._record)
			{
				store.dispatch(settingsActions.setBottomBar(true));
			}
		}

		if (this._meetingType === 'presence')
		{
			console.log('asdasdasd asdsd');
			store.dispatch(roomActions.setAutoJoin(true));
		}

		store.dispatch(settingsActions.setScreenPage(this._screenPage));

		// Alert sounds
		this._soundAlerts = { 'default': { audio: new Audio('/sounds/notify.mp3') } };
		if (config.notificationSounds)
		{
			for (const [ k, v ] of Object.entries(config.notificationSounds))
			{
				if (v != null && v.play !== undefined)
					this._soundAlerts[k] = {
						audio : new Audio(v.play),
						delay : v.delay ? v.delay : 0
					};
			}
		}

		// Socket.io peer connection
		this._signalingSocket = null;

		// The room ID
		this._roomId = null;

		this._breakoutRoomName = '';

		this._currentRoomId = null;

		this._isBreakoutRoomStart = false;

		this.peersForAllScreens = config.tpScreenLimit;

		// mediasoup-client Device instance.
		// @type {mediasoupClient.Device}
		this._mediasoupDevice = null;
		// console.log('devicedevice', device);

		// Put the browser info into state
		// console.log('device===', device);
		store.dispatch(meActions.setBrowser(device));

		// Our WebTorrent client
		this._webTorrent = null;

		// Max spotlights
		if (device.platform === 'desktop')
			this._maxSpotlights = config.lastN;
		else
			this._maxSpotlights = config.mobileLastN;

		if (this._sipUserID)
		{
			store.dispatch(
				settingsActions.setLastN(1));
		}
		else
		{
			store.dispatch(
				settingsActions.setLastN(this._maxSpotlights));

		}

		// Manager of spotlight
		this._spotlights = new Spotlights(this._maxSpotlights,
			store.getState().settings.hideNoVideoParticipants, this);

		// Transport for sending.
		this._sendTransport = null;

		// Transport for receiving.
		this._recvTransport = null;

		// Local mic mediasoup Producer.
		this._micProducer = null;

		// Every mic producer created and not yet closed. Normally just _micProducer; any other is
		// one that would keep sending after a mute, so mute and close act on all of them.
		this._micProducers = new Set();

		// Raw capture stream, RNNoise AudioContext and 'ended' listener behind each mic producer.
		this._micCaptures = new Map();

		// Latest mute intent, and a counter bumped by every mute/unmute so slower in-flight mic
		// work can tell it was overtaken.
		this._micDesiredMuted = false;
		this._micStateSeq = 0;

		// Set when the SFU may disagree with a local mute; _reconcileMic() re-sends the pause.
		this._micServerStateDirty = false;
		this._micPauseInFlight = false;
		this._micReconcileInterval = null;

		// Mic as the user had it ('on' | 'muted' | 'off') when signaling dropped, restored on rejoin.
		this._micStateBeforeDisconnect = null;

		// Local mic hark
		this._hark = null;

		this._micInProgress = false;

		// Local MediaStream for hark
		this._harkStream = null;

		// Local webcam mediasoup Producer.
		this._webcamProducer = null;

		// Extra videos being produced
		this._extraVideoProducers = new Map();

		// Map of webcam MediaDeviceInfos indexed by deviceId.
		// @type {Map<String, MediaDeviceInfos>}
		this._webcams = {};

		this._audioDevices = {};

		this._audioOutputDevices = {};

		this.timmerForJoinMainRoom = null;

		// mediasoup Consumers.
		// @type {Map<String, mediasoupClient.Consumer>}
		this._consumers = new Map();

		this._screenSharing = null;

		this._screenSharingProducer = null;

		this._screenSharingAudioProducer = null;

		this.breakoutRoomData = null;

		this.isBreakoutRoom = false;

		this._roomName = '';

		this._transcript = '';

		this._presenceUserId = presenceUserId;
		this._deviceInfo = deviceInfo();

		// this._transcriptStartTime = null;

		// this._selfActiveSpeaker = null;

		this._startKeyListener();

		// this._startDevicesListener();

		startDeviceChangeListener(this, store, () => intl);

		this._languageUpdate = store.getState().intl.locale;

		this.screenshareOnOffState = null;

		this.setLocale(store.getState().intl.locale);

		if (store.getState().settings.localPicture)
		{
			store.dispatch(meActions.setPicture(store.getState().settings.localPicture));
		}
		store.dispatch(
			settingsActions.setRecorderSupportedMimeTypes(this.getRecorderSupportedMimeTypes())
		);

		// Receive transport restart ICE object
		this._recvRestartIce = { timer: null, restarting: false };

		// Send transport restart ICE object
		this._sendRestartIce = { timer: null, restarting: false };

		if (this._sipUserID !== null && this._sipUserID !== undefined)
		{
			store.dispatch(roomActions.updateSIPURI(this._sipUserID));

			// store.dispatch(meActions.setMeDislayName(this._sipUserID));
			// store.dispatch(settingsActions.setDisplayName(this._sipUserID));
			// store.dispatch(roomActions.updateCallerURI(atob(this._callId)));
			this._SIP = new SIPCalling(this._sipUserID, callId, this);
		}

		this._sipInvitation = null;

		this._sipAudioStream = null;

		this._sipVideoStream = null;

		this._sipAudioMicCtx = new AudioContext();
		this._sipDestination = this._sipAudioMicCtx.createMediaStreamDestination();
		this._SipGainNode = this._sipAudioMicCtx.createGain();
		this._sipCloseMeeting = true;
		this._sipModeratorId = null;
		this._screenSharingActive = false;

		if (headless && !this._SIP)
		{
			const encodedRoomId =
					encodeURIComponent(decodeURIComponent(window.location.pathname.slice(1)));

			this.join({
				roomId    : encodedRoomId,
				joinVideo : this._sipUserID ? false : true,
				joinAudio : this._sipUserID ? false : true
			});
		}

		this._activeSpeaker=null;

		// if (getLan)
		// {
		// 	this.setLocale(getLan, 'key');
		// }

	}

	_clearPipActiveSpeaker()
	{
		this._pipActiveSpeaker = null;
		store.dispatch(roomActions.setPipActiveSpeaker(null));
	}

	getRoomID()
	{
		return this._roomId;
	}

	enableScreenShareVideo(status)
	{
		if (status && this._webcamProducer)
		{
			this.disableWebcam();
		}
		else if (this.screenshareOnOffState)
		{

			this.updateWebcam({ start: true });
		}
		store.dispatch(roomActions.setMeScreenShareHide(status));
	}

	/* Hooks */
	_hoookEnableDisableCamera()
	{
		console.log('this._webcamProducer======', this._webcamProducer);
		// store.dispatch(roomActions.setHideSelfView(_value));
		if (this._webcamProducer)
			this.disableWebcam();
		else
			this.updateWebcam({ start: true });

	}

	setGroupList(data)
	{
		console.log('data==================================', data);

		if (data)
		{

			store.dispatch(PresenceActions.setGroupMemberList(data?.groupList));

			store.dispatch(PresenceActions.setCallDetails(data?.callDetails));

			store.dispatch(PresenceActions.setGroupMemberListInProgress(false));

		}

	}

	_hookToggleMic()
	{
		if (this._micProducer)
		{
			// Mute intent, not producer.paused: voice activation pauses the producer while silent.
			if (!this._micDesiredMuted)
			{
				this.muteMic();

				store.dispatch(requestActions.notify(
					{
						text : intl.formatMessage({
							id             : 'devices.microphoneMute',
							defaultMessage : 'Muted your microphone'
						})
					}));
			}
			else
			{
				this.unmuteMic();

				store.dispatch(requestActions.notify(
					{
						text : intl.formatMessage({
							id             : 'devices.microphoneUnMute',
							defaultMessage : 'Unmuted your microphone'
						})
					}));
			}
		}
		else
		{
			this.updateMic({ start: true });

			store.dispatch(requestActions.notify(
				{
					text : intl.formatMessage({
						id             : 'devices.microphoneEnable',
						defaultMessage : 'Enabled your microphone'
					})
				}));
		}
	}

	_hookScreenShare()
	{
		const { screenProducer } = { ...meProducersSelector(store.getState()) };

		if (!this._screenSharingProducer && !screenProducer)
		{

			this.updateScreenSharing({ start: true });

		}
		else
		{

			this.disableScreenSharing();
		}
	}

	_hookWhiteboardShare()
	{
		// const whiteboardStatus;
		const result = { accessLink: `https://wb.invc.in/#room=${this.getRoomID()},4hk1OT3cCrh3k5PgQc3amg` };

		if (store.getState().room.wbData && Object.keys(store.getState().room.wbData).length > 0)
		{
			this.removeWhiteBoardLayout();

			window.parent.postMessage(JSON.stringify({ cmd: 'WHITEBOARD_STATUS', value: { whiteBoard: false, pId: this._peerId } }), '*');
		}
		else
		{
			this.setLayoutMode('whiteboardview', result);

			window.parent.postMessage(JSON.stringify({ cmd: 'WHITEBOARD_STATUS', value: { whiteBoard: true, pId: this._peerId } }), '*');

		}
	}

	/* End Hooks */

	async sendSipUserToLobby()
	{
		console.log('sipUserCallStatus');

		// await this.sendRequest('sipUserCallStatus', { peerId: this._peerId, uid: this._uid });

		if (this._micProducer)
		{
			await this.disableMic();

			this._micProducer = null;
		}

		if (this._webcamProducer)
		{
			await this.disableWebcam();

			this._webcamProducer = null;
		}
		// await this.sendRequest('sendSipUserToLobby', { peerId: this._peerId });
		// window.location.reload();

		// if (!(this._sipCloseMeeting))
		// {
		// }

	}

	async performSIPConferenceAction(peerId, action)
	{
		logger.debug('performSIPConferenceAction() [peerId:"%s"]', peerId);

		try
		{
			axios.post('https://fsapii.instavc.com/conference-action', {
				conference_number : `conference_${this._roomTemplate?.meetingDetails?.uniqueMeetingID}`,
				id                : peerId,
				action            : action
			}).then((res) =>
			{
				console.log('res?.data', String(res?.data?.output), action);

				if (action === 'kick')
				{
					if (res?.data && res?.data?.output === `+OK kicked ${peerId}`)
					{
						store.dispatch(roomActions.setSIPConferenceUserMuteActions({ id: peerId, status: 'kick', actionType: 'kick' }));
					}
				}
				else if (action === 'mute')
				{
					console.log('res?.data', res?.data);

					if (res?.data && res?.data?.output === `+OK mute ${peerId}`)
					{
						store.dispatch(roomActions.setSIPConferenceUserMuteActions({ id: peerId, status: 'true', actionType: 'audio' }));

					}
				}
				else if (action === 'unmute')
				{
					console.log('res?.data', res?.data);

					if (res?.data && res?.data?.output === `+OK unmute ${peerId}`)
					{
						store.dispatch(roomActions.setSIPConferenceUserMuteActions({ id: peerId, status: 'false', actionType: 'audio' }));

					}
				}
				else if (action === 'vmute')
				{
					console.log('res?.data', res?.data);

					if (res?.data && res?.data?.output === `+OK vmute ${peerId}`)
					{
						store.dispatch(roomActions.setSIPConferenceUserMuteActions({ id: peerId, status: 'true', actionType: 'video' }));

					}
				}
				else if (action === 'unvmute')
				{
					console.log('res?.data', res?.data);

					if (res?.data && res?.data?.output === `+OK unvmute ${peerId}`)
					{
						store.dispatch(roomActions.setSIPConferenceUserMuteActions({ id: peerId, status: 'false', actionType: 'video' }));

					}
				}
			})
				.catch((err) =>
				{
					console.log('performSIPConferenceAction', err);
				});
		}
		catch (error)
		{
			logger.error('mutePeer() [error:"%o"]', error);
		}

		store.dispatch(
			peerActions.setMutePeerInProgress(peerId, false));
	}

	async performSIPConferenceTask(task, id)
	{
		logger.debug('performSIPConferenceTask() [task:"%s"]', task, id);

		try
		{
			axios.post('https://fsapii.instavc.com/conference-task', {
				conference_number : `conference_${this._roomTemplate?.meetingDetails?.uniqueMeetingID}`,
				action            : task,
				id                : task === 'mute all' ? id : undefined
			}).then((res) =>
			{
				console.log('res?.data in conference-task', String(res?.data?.output), task);

				if (task === 'mute all')
				{
					console.log('res?.data', res?.data);

					store.dispatch(roomActions.setConferenceMuteAction(true));

					// callback({ task: task, res: res?.data?.output });

					// if (res?.data && res?.data?.output === `+OK kicked ${peerId}`)
					// {
					// 	store.dispatch(roomActions.setSIPConferenceUserMuteActions({ id: peerId, status: 'kick' }));
					// }
				}
				else if (task === 'unmute all')
				{
					console.log('res?.data', res?.data);

					store.dispatch(roomActions.setConferenceMuteAction(false));

					// callback({ task: task, res: res?.data?.output });

					// if (res?.data && res?.data?.output === `+OK kicked ${peerId}`)
					// {
					// 	store.dispatch(roomActions.setSIPConferenceUserMuteActions({ id: peerId, status: 'kick' }));
					// }
				}
				// else if (task === 'mute')
				// {
				// 	console.log('res?.data', res?.data);

				// 	if (res?.data && res?.data?.output === `+OK mute ${peerId}`)
				// 	{
				// 		store.dispatch(roomActions.setSIPConferenceUserMuteActions({ id: peerId, status: 'true' }));

				// 	}
				// }
				// else if (task === 'unmute')
				// {
				// 	console.log('res?.data', res?.data);

				// 	if (res?.data && res?.data?.output === `+OK unmute ${peerId}`)
				// 	{
				// 		store.dispatch(roomActions.setSIPConferenceUserMuteActions({ id: peerId, status: 'false' }));

				// 	}
				// }
			})
				.catch((err) =>
				{
					console.log('performSIPConferenceTask', err);
				});
		}
		catch (error)
		{
			logger.error('mutePeer() [error:"%o"]', error);
		}
	}

	async handleSIPSpotlight(id)
	{

		logger.debug('handleSIPSpotlight() [peerID:"%s"]', id);

		try
		{
			axios.post('https://fsapii.instavc.com/conference-spotlight', {
				conference_number : `conference_${this._roomTemplate?.meetingDetails?.uniqueMeetingID}`,
				id                : id
			}).then((res) =>
			{
				console.log('res in handleSIPSpotlight', res.data);

				if (res?.data && res?.data?.output === `+OK floor ${id}`)
				{
					store.dispatch(roomActions.handleSIPSpotlight(id));
				}
				else
				{
					store.dispatch(roomActions.handleSIPSpotlight(''));
				}

			})
				.catch((error) =>
				{
					console.log('error in handleSIPSpotlight', error);
				});
		}
		catch (err)
		{
			console.log('Error in handlingsSIPSpotlight', err);
		}
	}

	async listUsers()
	{
		// setLoading(true);
		// setError(null);
		try
		{
			// const response = await fetch('http://${import.meta.env.VITE_SIP_DOMAIN}:3030/conference/list');
			// const data = await response.json();

			// if (response.ok) {
			//     setUsers(data.users);
			// } else {
			//     setError('Failed to list users: ' + data.error);
			// }

			axios.get(`https://fsapii.instavc.com/conference/conference_${this._roomTemplate?.meetingDetails?.uniqueMeetingID}/list`).then((response) =>
			{
				console.log(`Conference ${this._roomTemplate?.meetingDetails?.uniqueMeetingID} List Response:`, response.data);
				if (response.data)
				{

					store.dispatch(roomActions.setSIPConferenceUsers(response.data));
					const filteredSIPUsers = response?.data.filter((each) =>
					{
						if (String(each?.sipNumber.split('@')[0]) === String(this._roomTemplate?.meetingDetails?.sipRooms[0].userId))
						{
							return each;
						}
					});

					console.log('filteredSIPUsers', filteredSIPUsers);

					if (filteredSIPUsers.length >= 1)
					{
						console.log('User >= 1');
						this._sipUserJoined = true;
						// if (filteredSIPUsers.length >= 2)
						// {
						// 	filteredSIPUsers.map((each) => each?.id && this.performSIPConferenceAction(each?.id, 'hup'));
						// }
					}

					// {

					// 	if (String(each?.sipNumber.split('@')[0]) === String(this._roomTemplate?.meetingDetails?.sipRooms[0].userId))
					// 	{

					// 		this._sipUserJoined = true;
					// 	}
					// });

					const isModerator = this._havePermission(permissions.MODERATE_ROOM);

					if (isModerator)
					{
						const sipUsers = response.data.filter((each) => String(each?.sipNumber.split('@')[0]) === String(this._roomTemplate?.meetingDetails?.sipRooms[0].userId));

						if (sipUsers && sipUsers.length > 1)
						{

							// sipUsers.map((each) =>
							// {

							// 	if (each)
							// 	{
							// 		this.performSIPConferenceAction(each?.id, 'hup');
							// 	}
							// });
						}

					}
				}
			})
				.catch((error) =>
				{
					if (error.response)
					{
						console.error('Error Response:', error.response.data);
					}
					else
					{
						console.error('Error:', error.message);
					}
				});

		}
		catch (error)
		{
			console.error('Error:', error);
			// setError('Error fetching user list.');
		}
		// setLoading(false);
	}

	// Function to perform an action (mute, unmute, kick) on a user
	async performAction(action, callerId)
	{
		try
		{
			const response = await fetch(`https://fsapii.instavc.com/conference/${action}`, {
				method  : 'POST',
				headers : {
					'Content-Type' : 'application/json'
				},
				body : JSON.stringify({ callerId })
			});

			const data = await response.json();

			if (response.ok)
			{
				alert(`User ${action}d successfully`);
				this.listUsers(); // Refresh the user list after action
			}
			else
			{
				alert(`Failed to ${action} user: ${ data.error}`);
			}
		}
		catch (error)
		{
			console.error('Error:', error);
			alert(`Error performing ${action} action.`);
		}
	}

	async endCallIfOneUser()
	{
		console.log('store.getState()?.peers?.lengthstore.getState()?.peers?.length', store.getState()?.peers);
		if (store.getState()?.peers && Object.keys(store.getState()?.peers)?.length === 1)
		{
			await this.sendRequest('endCallIfOneUser');
		}
	}

	/* End Hooks */

	async close(url, type)
	{
		logger.debug('close()');

		if (Number(this._screenPage) > 0 || this._mode === 'speaker' || this._mode === 'screen')
		{
			return;
		}
		const device = deviceInfo();

		try
		{
			if (this._deviceInfo.platform === 'desktop' && this._deviceInfo.name === 'electron' && type === 'self')
			{
				await this.sendRequest('moderator:leaveMeeting', type);
			}
		}
		catch (error)
		{
			console.log('error in moderator:leaveMeeting==', error);
		}
		const recordingStatus = store.getState().recorder?.localRecordingState?.status;

		this._closed = false;
		if (this._closed)
			return;
		if (recordingStatus === 'start')
		{
			this.sendRequest('setLocalRecording', { localRecordingState: 'stop' });
		}
		this._closed = true;
		this._signalingSocket?.close();
		
		if (this._micReconcileInterval)
		{
			clearInterval(this._micReconcileInterval);
			this._micReconcileInterval = null;
		}

		// Clean up transcription health check interval
		if (this._transcriptionHealthCheckInterval) {
			clearInterval(this._transcriptionHealthCheckInterval);
			this._transcriptionHealthCheckInterval = null;
		}
		
		// Disconnect transcription socket
		if (this._transcriptionSocket) {
			this._transcriptionSocket.disconnect();
			this._transcriptionSocket = null;
		}
		// Close mediasoup Transports.
		if (this._sendTransport)
			this._sendTransport.close();
		if (this._recvTransport)
			this._recvTransport.close();
		store.dispatch(roomActions.setRoomState('closed'));
		window.parent.postMessage({ cmd: 'END_STATUS', value: { endStatus: true, pId: this._peerId, displayName: store.getState().settings.displayName } }, '*');
		// sessionStorage.removeItem('token');
		// sessionStorage.removeItem('projectId');
		// sessionStorage.removeItem('projectId');
		// sessionStorage.removeItem('uid');
		sessionStorage.clear();
		if (device.platform === 'desktop' && device.name === 'electron')
		{
			if (window.location.host.includes('localhost:'))
			{
				if (this._havePermission(permissions.MODERATE_ROOM))
				{
					// window.location = `https://${window.location.host}/desktop_room`;
					window.location = `${window.location.origin}/desktop_room`;
				}
				else if (url)
				{
					window.location = url;
				}
				else
				{
					// window.location = `https://${window.location.host}/endMeeting?leave=true`;
					window.location = `${window.location.origin}/endMeeting?leave=true`;
				}
			}
			else
			if (this._havePermission(permissions.MODERATE_ROOM))
			{
				window.location = `https://${window.location.hostname}/desktop_room`;
			}
			else if (url)
			{
				window.location = url;
			}
			else
			{
				window.location = `https://${window.location.hostname}/endMeeting?leave=true`;
			}
		}
		else if (this._roomTemplate)
		{
			// window.location = import.meta.env.VITE_config;
			// // window.location = this._roomTemplate.data.exitUrl;
			if (this._meetingType === 'presence')
			{
				console.log('inside=======================================================');
				window.parent.postMessage({ cmd: 'PresenceEndCall', value: { endStatus: true } }, '*');
				window.location = import.meta.env.VITE_config;

				return;
			}
			if (this._havePermission(permissions.MODERATE_ROOM))
			{
				window.location = import.meta.env.VITE_config;
			}
			else if (url)
			{
				window.location = url;
			}
			else
			{
				window.location = `https://${window.location.hostname}/endMeeting?leave=true`;
			}
		}
		else
		{
			window.location = `/${this._roomId}`;
		}
	}

	closebreakout(data)
	{
		if (this._closed)
			return;

		this._closed = true;

		logger.debug('close()');

		this._signalingSocket.close();

		// Close mediasoup Transports.
		if (this._sendTransport)
			this._sendTransport.close();

		if (this._recvTransport)
			this._recvTransport.close();

		this._spotlights.clearSpotlights();
		store.dispatch(peerActions.clearPeers());
		this._clearPipActiveSpeaker();
		store.dispatch(consumerActions.clearConsumers());
		store.dispatch(producerActions.clearProducer());
		store.dispatch(roomActions.clearSpotlights());

		store.dispatch(roomActions.setRoomState('closed'));

		const { subRoomData } = data;

		setTimeout(() =>
		{
			this.join({
				roomId    : `${this._roomId}-${subRoomData.subRoomID}`,
				joinVideo : false,
				joinAudio : false
			});
		}, 100);

		// sessionStorage.clear();

		// if (this._roomTemplate)
		// {
		// 	window.location = this._roomTemplate.data.exitUrl;
		// }
		// else
		// {
		// 	window.location = `/${this._roomId}`;
		// }
	}

	_startKeyListener()
	{
		// Add keydown event listener on document
		document.addEventListener('keydown', (event) =>
		{
			if (event.repeat) return;
			const key = String.fromCharCode(event.which);

			const source = event.target;

			const exclude = [ 'input', 'textarea', 'div' ];

			if (exclude.indexOf(source.tagName.toLowerCase()) === -1)
			{
				logger.debug('keyDown() [key:"%s"]', key);

				switch (key)
				{

					/*
					case String.fromCharCode(37):
					{
						const newPeerId = this._spotlights.getPrevAsSelected(
							store.getState().room.selectedPeerId);

						if (newPeerId) this.setSelectedPeer(newPeerId);
						break;
					}

					case String.fromCharCode(39):
					{
						const newPeerId = this._spotlights.getNextAsSelected(
							store.getState().room.selectedPeerId);

						if (newPeerId) this.setSelectedPeer(newPeerId);
						break;
					}
					*/

					case '&':
						// Code for up arrow key press
						if (store?.getState()?.room.cameraControl && store?.getState()?.room.cameraControl?.id !== this._peerId)
						{
							// consumer get based on id then use ptz

							console.log('consumerrrrrr', store?.getState()?.room.cameraControl?.consumerId);

							const consumer=store.getState()?.consumers[store?.getState()?.room.cameraControl?.consumerId];

							console.log('consumer', consumer);

							if (consumer?.tilt < consumer?.tiltRange?.max)
							{
								const tiltStep = (consumer?.tiltRange?.max - consumer?.tiltRange?.min) / 12;
								const newTilt = Math.min(consumer?.tilt + tiltStep, consumer?.tiltRange?.max);

								this.sendRequest('moderator:changePTZ', { ptz: { 'tilt': newTilt }, peerId: store?.getState()?.room.cameraControl?.id, id: consumer.producerId });

								console.log('this._consumers.get(consumerId)', consumer);

							}

							console.log('Up arrow pressed', consumer);
						}
						break;
					case '(':
						// Code for down arrow key press
						if (store?.getState()?.room.cameraControl && store?.getState()?.room.cameraControl?.id !== this._peerId)
						{
							const consumer=store.getState()?.consumers[store?.getState()?.room.cameraControl?.consumerId];

							if (consumer?.tilt > consumer?.tiltRange?.min)
							{

								const tiltStep = (consumer?.tiltRange?.max - consumer?.tiltRange?.min) / 12;
								const newTilt = Math.max(consumer?.tilt - tiltStep, consumer?.tiltRange?.min);

								this.sendRequest('moderator:changePTZ', { ptz: { 'tilt': newTilt }, peerId: store?.getState()?.room.cameraControl?.id, id: consumer.producerId });

							}
							console.log('Down arrow pressed', consumer);
						}
						break;
					case '%':
						// Code for left arrow key press
						if (store?.getState()?.room.cameraControl && store?.getState()?.room.cameraControl?.id !== this._peerId)
						{
							const consumer=store.getState()?.consumers[store?.getState()?.room.cameraControl?.consumerId];

							if (consumer?.pan > consumer?.panRange?.min)
							{
								const panStep = (consumer?.panRange?.max - consumer?.panRange?.min) / 24;
								const newPan = Math.max(consumer?.pan - panStep, consumer?.panRange?.min);

								this.sendRequest('moderator:changePTZ', { ptz: { 'pan': newPan }, peerId: store?.getState()?.room.cameraControl?.id, id: consumer.producerId });
							}
							console.log('Left arrow pressed', consumer);
						}
						break;
					case "'":
						// Code for right arrow key press
						if (store?.getState()?.room.cameraControl && store?.getState()?.room.cameraControl?.id !== this._peerId)
						{
							const consumer=store.getState()?.consumers[store?.getState()?.room.cameraControl?.consumerId];

							if (consumer?.pan < consumer?.panRange?.max)
							{

								const panStep = (consumer?.panRange?.max - consumer?.panRange?.min) / 24;
								const newPan = Math.min(consumer?.pan + panStep, consumer?.panRange?.max);

								this.sendRequest('moderator:changePTZ', { ptz: { 'pan': newPan }, peerId: store?.getState()?.room.cameraControl?.id, id: consumer.producerId });

							}
							console.log('Right arrow pressed', consumer);
						}
						break;

					case '»':
						// Code for right arrow key press
						if (store?.getState()?.room.cameraControl && store?.getState()?.room.cameraControl?.id !== this._peerId)
						{
							const consumer=store.getState()?.consumers[store?.getState()?.room.cameraControl?.consumerId];

							if (consumer.zoom < consumer.zoomRange.max)
							{
								console.log('zoomIn pressed', consumer);
								const zoomStep = (consumer?.zoomRange?.max - consumer?.zoomRange?.min) / 8;
								const newzoom = Math.min(consumer?.zoom + zoomStep, consumer?.zoomRange?.max);

								this.sendRequest('moderator:changePTZ', { ptz: { 'zoom': newzoom }, peerId: store?.getState()?.room.cameraControl?.id, id: store?.getState()?.room.cameraControl?.consumers[0] });
							}
						}
						break;

					case '½':
						// Code for right arrow key press
						if (store?.getState()?.room.cameraControl && store?.getState()?.room.cameraControl?.id !== this._peerId)
						{
							const consumer=store.getState()?.consumers[store?.getState()?.room.cameraControl?.consumers[0]];

							if (consumer.zoom > consumer.zoomRange.min)
							{
								console.log('zoomout pressed', consumer);
								const zoomStep = (consumer?.zoomRange?.max - consumer?.zoomRange?.min) / 8;
								const newzoom = Math.max(consumer?.zoom - zoomStep, consumer?.zoomRange?.min);

								this.sendRequest('moderator:changePTZ', { ptz: { 'zoom': newzoom }, peerId: store?.getState()?.room.cameraControl?.id, id: store?.getState()?.room.cameraControl?.consumers[0] });
							}
						}
						break;

					case 'A': // Activate advanced mode
					{
						store.dispatch(settingsActions.toggleAdvancedMode());
						store.dispatch(requestActions.notify(
							{
								text : intl.formatMessage({
									id             : 'room.toggleAdvancedMode',
									defaultMessage : 'Toggled advanced mode'
								})
							}));
						break;
					}

					case '1': // Set democratic view
					{
						store.dispatch(roomActions.setDisplayMode('democratic'));
						store.dispatch(requestActions.notify(
							{
								text : intl.formatMessage({
									id             : 'room.setDemocraticView',
									defaultMessage : 'Changed layout to democratic view'
								})
							}));
						break;
					}

					case '2': // Set filmstrip view
					{
						const peersLength = store.getState().peers;

						if (Object.values(peersLength).length > 1)
						{

							store.dispatch(roomActions.setDisplayMode('filmstrip'));
							store.dispatch(requestActions.notify(
								{
									text : intl.formatMessage({
										id             : 'room.setFilmStripView',
										defaultMessage : 'Changed layout to filmstrip view'
									})
								}));
						}

						break;
					}

					// case '3': // Set whiteboard view
					// {
					// 	if (this._layoutDataWB === null)
					// 	{
					// 		store.dispatch(requestActions.notify(
					// 			{
					// 				text : intl.formatMessage({
					// 					id             : 'room.shareWb',
					// 					defaultMessage : 'Please share whiteboard before you apply this shortcut'
					// 				})
					// 			}));

					// 		return;
					// 	}

					// 	store.dispatch(
					// 		roomActions.setWhiteboardData(this._layoutDataWB));

					// 	store.dispatch(roomActions.setDisplayMode('whiteboardview'));
					// 	store.dispatch(requestActions.notify(
					// 		{
					// 			text : intl.formatMessage({
					// 				id             : 'room.setWhiteboardView',
					// 				defaultMessage : 'Changed layout to whiteboard view'
					// 			})
					// 		}));
					// 	break;
					// }

					// case '4': // Set Screenshare view
					// {
					// 	if (this._layoutDataSC.length <= 0)
					// 	{
					// 		store.dispatch(requestActions.notify(
					// 			{
					// 				text : intl.formatMessage({
					// 					id             : 'room.shareScreen',
					// 					defaultMessage : 'Please share screen before you apply this shortcut'
					// 				})
					// 			}));

					// 		return;
					// 	}
					// 	else
					// 	{

					// 		this.addSelectedPeer(this._layoutDataSC[0]);
					// 		store.dispatch(
					// 			roomActions.setActiveScreenId(this._layoutDataSC[0], this._layoutDataSC));

					// 	}
					// 	store.dispatch(roomActions.setDisplayMode('screenshareview'));
					// 	store.dispatch(requestActions.notify(
					// 		{
					// 			text : intl.formatMessage({
					// 				id             : 'room.setScreeshareView',
					// 				defaultMessage : 'Changed layout to screenshare view'
					// 			})
					// 		}));
					// 	break;
					// }
					case '3': // Set Whiteboard view
					{
						if (this._layoutDataWB != null)
						{
							store.dispatch(roomActions.setDisplayMode('whiteboardview'));
							store.dispatch(requestActions.notify(
								{
									text : intl.formatMessage({
										id             : 'room.whiteboardview',
										defaultMessage : 'Changed layout to whiteboard view'
									})
								}));
						}
						break;
					}

					case '4': // Set Screenshare view
					{
						if (this._layoutDataSC.length > 0)
						{
							store.dispatch(roomActions.setDisplayMode('screenshareview'));
							store.dispatch(requestActions.notify(
								{
									text : intl.formatMessage({
										id             : 'room.ScreeshareView',
										defaultMessage : 'Changed layout to screenshare view'
									})
								}));
						}
						break;
					}

					case '5': // Set Dcument view
					{
						if (store.getState().room.uploadDocument && Object.keys(store.getState().room.uploadDocument.length > 0))
						{
							store.dispatch(roomActions.setDisplayMode('fileShareView'));
							store.dispatch(requestActions.notify(
								{
									text : intl.formatMessage({
										id             : 'room.fileShareView',
										defaultMessage : 'Changed layout to fileShare view'
									})
								}));
						}
						break;
					}
					case '6': // Set Video view
					{
						if (store.getState().room.videoData && Object.keys(store.getState().room.videoData).length > 0)
						{
							store.dispatch(roomActions.setDisplayMode('videoShareView'));
							store.dispatch(requestActions.notify(
								{
									text : intl.formatMessage({
										id             : 'room.videoShareView',
										defaultMessage : 'Changed layout to videoShare view'
									})
								}));
						}
						break;
					}
					case '7': // Set page view
					{
						// store.dispatch(roomActions.setDisplayMode('pagescreen'));
						// store.dispatch(requestActions.notify(
						// 	{
						// 		text : intl.formatMessage({
						// 			id             : 'room.setPageScreen',
						// 			defaultMessage : 'Changed layout to pagescreen view'
						// 		})
						// 	}));
						break;
					}

					case ' ': // Push To Talk start
					{
						if (this._micProducer && (this._havePermission(permissions.MODERATE_ROOM) || (!this._havePermission(permissions.MODERATE_ROOM) && store.getState().toolarea.hostControlMicroPhone)))
						// if (this._micProducer)
						{
							if (this._micDesiredMuted)
							{
								this.unmuteMic();
							}
						}

						break;
					}
					case 'M': // Toggle microphone
					{
						if (this._micProducer && (this._havePermission(permissions.MODERATE_ROOM) || (!this._havePermission(permissions.MODERATE_ROOM) && store.getState().toolarea.hostControlMicroPhone)))
						{
							if (!this._micDesiredMuted)
							{
								this.muteMic();

								store.dispatch(requestActions.notify(
									{
										text : intl.formatMessage({
											id             : 'devices.microphoneMute',
											defaultMessage : 'Muted your microphone'
										})
									}));
							}
							else
							{
								this.unmuteMic();

								store.dispatch(requestActions.notify(
									{
										text : intl.formatMessage({
											id             : 'devices.microphoneUnMute',
											defaultMessage : 'Unmuted your microphone'
										})
									}));
							}
						}
						else
						if (this._havePermission(permissions.MODERATE_ROOM) || (!this._havePermission(permissions.MODERATE_ROOM) && store.getState().toolarea.hostControlMicroPhone))
						{
							this.updateMic({ start: true });

							store.dispatch(requestActions.notify(
								{
									text : intl.formatMessage({
										id             : 'devices.microphoneEnable',
										defaultMessage : 'Enabled your microphone'
									})
								}));
						}
						else if (this._micProducer && !this._micDesiredMuted)
						{
							this.muteMic();

							store.dispatch(requestActions.notify(
								{
									text : intl.formatMessage({
										id             : 'devices.microphoneMute',
										defaultMessage : 'Muted your microphone'
									})
								}));
						}

						break;
					}

					case 'V': // Toggle video
					{
						if (this.videoKeydown === false)
						{
							this.videoKeydown = true;
							setTimeout(async () =>
							{
								if (this._webcamProducer && (this._havePermission(permissions.MODERATE_ROOM) || (!this._havePermission(permissions.MODERATE_ROOM) && store.getState().toolarea.hostControlVideoControl)))
								{
									this.disableWebcam();
								}
								else
								if (this._havePermission(permissions.MODERATE_ROOM) || (!this._havePermission(permissions.MODERATE_ROOM) && store.getState().toolarea.hostControlVideoControl))
								{
									this.updateWebcam({ start: true });
								}
								else if (this._webcamProducer)
								{
									this.disableWebcam();
								}
								this.videoKeydown = false;
							}, 500);
						}
						break;
					}

					case 'H': // Open help dialog
					{
						store.dispatch(roomActions.setHelpOpen(true));

						break;
					}

					default:
					{
						break;
					}
				}
			}
		});

		window.addEventListener('load', () =>
		{
			// window.focus();
			document.body.tabIndex = -1; // Ensure body is focusable if it's not by default
			document.body.focus();
		});

		document.addEventListener('keyup', (event) =>
		{
			const key = String.fromCharCode(event.which);

			const source = event.target;

			const exclude = [ 'input', 'textarea', 'div' ];

			if (exclude.indexOf(source.tagName.toLowerCase()) === -1)
			{
				logger.debug('keyUp() [key:"%s"]', key);

				switch (key)
				{
					case ' ': // Push To Talk stop
					{
						if (this._micProducer)
						{
							// Intent, so a release still mutes while the push-to-talk unmute is awaiting the SFU.
							if (!this._micDesiredMuted)
							{
								this.muteMic();
							}
						}

						break;
					}
					default:
					{
						break;
					}
				}
			}
			event.preventDefault();
		}, true);
	}

	// _startDevicesListener()
	// {
	// 	navigator.mediaDevices.addEventListener('devicechange', async () =>
	// 	{
	// 		logger.debug('_startDevicesListener() | navigator.mediaDevices.ondevicechange');

	// 		await this._updateAudioDevices();
	// 		await this._updateWebcams();
	// 		await this._updateAudioOutputDevices();

	// 		store.dispatch(requestActions.notify(
	// 			{
	// 				text : intl.formatMessage({
	// 					id             : 'devices.devicesChanged',
	// 					defaultMessage : 'Your devices changed, configure your devices in the settings dialog'
	// 				})
	// 			}));
	// 	});
	// }

	setLocale(locale, key)
	{
		/* Checking to see if the locale is null. If it is, it is setting the locale to the detected locale. */
		if (locale === null) locale = locales.detect();
		if (key === 'key')
		{
			const one = locales.loadOne(locale);

			store.dispatch(intlActions.updateIntl({
				locale   : one.locale[0],
				messages : one.messages,
				list     : locales.getList()
			}));

			intl = createIntl({
				locale   : store.getState().intl.locale,
				messages : store.getState().intl.messages
			});

			document.documentElement.lang = store.getState().intl.locale.toUpperCase();
		}
		else
		if (locales.detect().length > 2)
		{
			const loc = locales.detect().split(/[-_]/)[0];

			const one = locales.loadOne(loc);

			store.dispatch(intlActions.updateIntl({
				locale   : one.locale[0],
				messages : one.messages,
				list     : locales.getList()
			}));

			intl = createIntl({
				locale   : store.getState().intl.locale,
				messages : store.getState().intl.messages
			});

			document.documentElement.lang = store.getState().intl.locale.toUpperCase();
		}
		else
		{

			const one = locales.loadOne(locales.detect());

			store.dispatch(intlActions.updateIntl({
				locale   : one.locale[0],
				messages : one.messages,
				list     : locales.getList()
			}));

			intl = createIntl({
				locale   : store.getState().intl.locale,
				messages : store.getState().intl.messages
			});

			document.documentElement.lang = store.getState().intl.locale.toUpperCase();
		}

	}

	login(roomId = this._roomId)
	{
		const url = `/auth/login?peerId=${this._peerId}&roomId=${roomId}`;

		window.open(url, 'loginWindow');
	}

	logout(roomId = this._roomId)
	{
		window.open(`/auth/logout?peerId=${this._peerId}&roomId=${roomId}`, 'logoutWindow');
	}

	setLoggedIn(loggedIn)
	{
		logger.debug('setLoggedIn() | [loggedIn: "%s"]', loggedIn);

		store.dispatch(meActions.loggedIn(loggedIn));

	}

	setPicture(picture)
	{
		store.dispatch(settingsActions.setLocalPicture(picture));
		store.dispatch(meActions.setPicture(picture));
		this.changePicture(picture);
	}

	receiveLoginChildWindow(data)
	{
		logger.debug('receiveFromChildWindow() | [data:"%o"]', data);

		const { picture } = data;

		let displayName;

		if (typeof (data.displayName) === 'undefined' || !data.displayName)
			displayName = '';
		else
			displayName = data.displayName;

		store.dispatch(settingsActions.setDisplayName(displayName));

		store.dispatch(meActions.setMeDislayName(displayName));

		this._displayName = displayName;

		if (!store.getState().settings.localPicture)
		{
			store.dispatch(meActions.setPicture(picture));
		}

		store.dispatch(meActions.loggedIn(true));

		store.dispatch(requestActions.notify(
			{
				text : intl.formatMessage({
					id             : 'room.loggedIn',
					defaultMessage : 'You are logged in'
				})
			}));
	}

	receiveLogoutChildWindow()
	{
		logger.debug('receiveLogoutChildWindow()');

		if (!store.getState().settings.localPicture)
		{
			store.dispatch(meActions.setPicture(null));
		}

		store.dispatch(meActions.loggedIn(false));

		store.dispatch(requestActions.notify(
			{
				text : intl.formatMessage({
					id             : 'room.loggedOut',
					defaultMessage : 'You are logged out'
				})
			}));
	}

	_soundNotification(type = 'default')
	{
		const { notificationSounds } = store.getState().settings;
		const { templateNotificationSound } = store.getState().toolarea;

		console.log('templateNotificationSound====', templateNotificationSound);

		// alert(templateNotificationSound);
		if (!templateNotificationSound)
		{
			return;
		}

		if (notificationSounds)
		{
			// const soundAlert = this._soundAlerts[type] === undefined
			// 	? this._soundAlerts['default'] : this._soundAlerts[type];

			const soundAlert = this._soundAlerts[type] && this._soundAlerts[type];

			const now = Date.now();

			if (soundAlert && soundAlert.last && (now - soundAlert.last) < soundAlert.delay)
			{
				return;
			}
			if (soundAlert)
			{
				soundAlert.last = now;
			}

			const alertPromise = soundAlert?.audio?.play();

			if (alertPromise)
			{
				alertPromise
					.then()
					.catch((error) =>
					{
						logger.error('_soundAlert.play() [error:"%o"]', error);
					});
			}
		}
	}

	timeoutCallback(callback)
	{
		let called = false;

		const interval = setTimeout(
			() =>
			{
				if (called)
					return;
				called = true;
				callback(new SocketTimeoutError('Request timed out'));
			},
			config.requestTimeout
		);

		return (...args) =>
		{
			if (called)
				return;
			called = true;
			clearTimeout(interval);

			callback(...args);
		};
	}

	_sendRequest(method, data)
	{
		return new Promise((resolve, reject) =>
		{
			if (!this._signalingSocket)
			{
				reject('No socket connection');
			}
			else
			{
				this._signalingSocket.emit(
					'request',
					{ method, data },
					this.timeoutCallback((err, response) =>
					{
						if (err)
							reject(err);
						else
							resolve(response);
					})
				);
			}
		});
	}

	async getTransportStats()
	{
		try
		{
			if (this._recvTransport)
			{
				logger.debug('getTransportStats() - recv [transportId: "%s"]', this._recvTransport.id);

				const recv = await this.sendRequest('getTransportStats', { transportId: this._recvTransport.id });

				store.dispatch(
					transportActions.addTransportStats(recv, 'recv'));
			}

			if (this._sendTransport)
			{
				logger.debug('getTransportStats() - send [transportId: "%s"]', this._sendTransport.id);

				const send = await this.sendRequest('getTransportStats', { transportId: this._sendTransport.id });

				store.dispatch(
					transportActions.addTransportStats(send, 'send'));
			}
		}
		catch (error)
		{
			logger.error('getTransportStats() [error:"%o"]', error);
		}
	}

	async deleteDocumentInFileShare(data)
	{
		const file = store.getState().room.uploadDocument;

		try
		{

			if (file && Object.keys(file).length > 0)
			{
				// const params = {
				// 	key : file.key

				// };

				// myBucket.deleteObject(params, async (err, res) =>
				// {
				// 	if (err)
				// 	{
				// 	}
				// 	else
				// 	{
				if (this._roomTemplate.data.democratic)
				{
					await this.sendRequest('removeShareFile', { layout: 'democratic', file: data });
					this.sendAnnotationsRequst(false);
				}
				if (this._roomTemplate.data.filmStrip)
				{
					await this.sendRequest('removeShareFile', { layout: 'filmstrip', file: data });
					this.sendAnnotationsRequst(false);
				}
				store.dispatch(roomActions.setDocument(null));
				store.dispatch(roomActions.setTotalPages(0));
				// 		store.dispatch(roomActions.setOpenFileUploadPopup(false));
				// 	}
				// });
			}
		}
		catch (error)
		{
			console.log('Failed to remove layout');
		}

	}

	async sendRequest(method, data)
	{
		logger.debug('sendRequest() [method:"%s", data:"%o"]', method, data);

		for (let tries = 0; tries < config.requestRetries; tries++)
		{
			try
			{
				return await this._sendRequest(method, data);
			}
			catch (error)
			{
				if (
					error instanceof SocketTimeoutError &&
					tries < config.requestRetries
				)
					logger.warn('sendRequest() | timeout, retrying [attempt:"%s"]', tries, method, data);
				else
					throw error;
			}
		}
	}

	async changePanelListDisplayName(panelListDisplayName, panelListPeerId)
	{
		panelListDisplayName = panelListDisplayName.trim();

		try
		{
			await this.sendRequest('changePanelListDisplayName', { panelListDisplayName, panelListPeerId });
		}
		catch (error)
		{
			console.log(error);
		}
	}

	async changeDisplayName(displayName)
	{
		displayName = displayName.trim();

		if (!displayName)
			displayName = `Guest ${Math.floor(Math.random() * (100000 - 10000)) + 10000}`;

		logger.debug('changeDisplayName() [displayName:"%s"]', displayName);

		store.dispatch(
			meActions.setDisplayNameInProgress(true));

		try
		{
			await this.sendRequest('changeDisplayName', { displayName });

			store.dispatch(settingsActions.setDisplayName(displayName));

			store.dispatch(meActions.setMeDislayName(displayName));

			store.dispatch(requestActions.notify(
				{
					text : intl.formatMessage({
						id             : 'room.changedDisplayName',
						defaultMessage : 'Your display name changed to {displayName}'
					}, {
						displayName
					})
				}));

			this._displayName = displayName;

		}
		catch (error)
		{
			logger.error('changeDisplayName() [error:"%o"]', error);

			store.dispatch(requestActions.notify(
				{
					type : 'error',
					text : intl.formatMessage({
						id             : 'room.changeDisplayNameError',
						defaultMessage : 'An error occurred while changing your display name'
					})
				}));
		}

		store.dispatch(
			meActions.setDisplayNameInProgress(false));
	}

	async changeDisplayEmail(displayEmail)
	{
		displayEmail = displayEmail.trim();

		// if (!displayEmail)
		// 	displayEmail = `Guest ${Math.floor(Math.random() * (100000 - 10000)) + 10000}`;

		// logger.debug('changeDisplayEmail() [displayEmail:"%s"]', displayEmail);

		// store.dispatch(
		// 	meActions.setDisplayNameInProgress(true));

		try
		{
			await this.sendRequest('changeDisplayEmail', { displayEmail });

			store.dispatch(settingsActions.setDisplayEmail(displayEmail));

		}
		catch (error)
		{
			logger.error('changeDisplayEmail() [error:"%o"]', error);

			store.dispatch(requestActions.notify(
				{
					type : 'error',
					text : intl.formatMessage({
						id             : 'room.changeDisplayEmailError',
						defaultMessage : 'An error occurred while changing your display Email'
					})
				}));
		}
	}
	async changePicture(picture)
	{
		logger.debug('changePicture() [picture: "%s"]', picture);

		try
		{
			await this.sendRequest('changePicture', { picture });
		}
		catch (error)
		{
			logger.error('changePicture() [error:"%o"]', error);
		}
	}

	// async uploadFileToS3(file, folder)
	// {
	// 	return new Promise((resolve, reject) =>
	// 	{
	// 		try
	// 		{
	// 			axios.post(`${import.meta.env.VITE_S3_Uploads}/upload?folderPath=${folder}`, file)
	// 				.then((response) =>
	// 				{
	// 					resolve(response.data);
	// 				})
	// 				.catch((error) =>
	// 				{
	// 					console.error('Error in upload picture', error);
	// 					reject(error);
	// 				});
	// 		}
	// 		catch (e)
	// 		{
	// 			console.error('Error in upload picture', e);
	// 			reject(e);
	// 		}
	// 	});
	// }
	async uploadFileToS3(file, folder)
	{
		logger.debug('uploadFileToS3() [file: "%s"]', file);

		let fileName =
    `${file?.name?.replace(/ /g, '_').replace('+', '_')
    	.split('.')[0]
    }${new Date().valueOf()}` +
    `.${
    	file?.name?.split('.')[file?.name?.split('.')?.length - 1]}`;

		// const params = {
		// 	key          : `${folder}/${new Date().valueOf() + file.name}`,
		// 	Body         : file,
		// 	customPrefix : { public: '' }
		// };

		try
		{

			const customPrefix = `${folder}/`;
			const fullPath = `${customPrefix}${fileName}`;

			console.log('fullPathhhhhhhhhhhhhh', fullPath);

			const urlBody = { key: fullPath, contentType: file.type };
			const presignedUrlResponse=	await axios.post(`${import.meta.env.VITE_USERS}/generatepresignedurl`, urlBody);

			console.log('presignedUrlResponse', presignedUrlResponse?.data?.data);

			// const presignedUrlResponse = await generatePresignedUrl(urlBody);

			if (!presignedUrlResponse?.data?.status)
			{
				throw new Error('Failed to generate presigned URL');
			}
			const uploadResponse = await axios.put(presignedUrlResponse?.data?.data, file, {
				headers : {
					'Content-Type' : file.type
				}
			});

			console.log('uploadddddd', uploadResponse);

			if (uploadResponse.status !== 200)
			{
				throw new Error('Failed to upload file');
			}

			// const response = await myBucket.upload(params).promise();

			return { url : `${import.meta.env.VITE_CLOUDFRONT_URL}/${fullPath}`,
				key : fullPath };

		}
		catch (e)
		{
			console.log('error in upload picture', e);

			store.dispatch(requestActions.notify(
				{
					type : 'error',
					text : intl.formatMessage({
						id             : 'room.virtualBGError',
						defaultMessage : 'Unable to upload image'
					})
				}));
		}
	}

	async uploadBufferFileToS3(fileData, file, page, folder)
	{
		logger.debug('uploadFileToS3() [file: "%s"]', fileData);
		const fileBuffer = Buffer.from(fileData, 'base64');

		const params = {
			key             : `${folder}/${page}+${file.name}`,
			Body            : fileBuffer,
			customPrefix    : { public: '' },
			ContentEncoding : 'base64',
			ContentType     : 'image/png'
		};

		try
		{

			const response = await myBucket.upload(params).promise();

			return response;
		}
		catch (e)
		{
			console.log('error in upload picture', e);

			store.dispatch(requestActions.notify(
				{
					type : 'error',
					text : intl.formatMessage({
						id             : 'room.virtualBGError',
						defaultMessage : 'Unable to upload image'
					})
				}));
		}
	}

	async createBackground(background, blur)
	{
		if (background === undefined)
		{
			if (this._chromaStream)
			{
				this._chromaStream.close();
				this._chromaStream = null;
			}

			return;
		}

		// Reuse existing pipeline when only changing background image/blur –
		// no new WebGL context, no black frame, no replaceTrack.
		if (this._chromaStream && this._chromaStream.capStream && this._webcamProducer)
		{
			this._chromaStream.updateBackground(background, blur);
			window.chromaStream = this._chromaStream;

			return;
		}

		if (!this._chromaStream)
		{
			this._chromaStream = new ChromaKey();
		}

		this.updateChromaCam(background, blur);
	}

	async updateChromaCam(background, blur)
	{
		let track;

		// eslint-disable-next-line camelcase
		let v_track;

		// try
		// {
		if (!this._mediasoupDevice?.canProduce('video'))
			throw new Error('cannot produce video');

		store.dispatch(settingsActions.setVideoMuted(false));

		store.dispatch(meActions.setWebcamInProgress(true));

		const settings = store.getState().settings;
		const {
			aspectRatio,
			frameRate
		} = settings;
		const resolution = getCaptureResolution(settings);

		// If we already have a dedicated background stream, reuse it so that
		// switching from one virtual background to another does not trigger a
		// fresh getUserMedia call or tear down the existing producer.
		if (!this.vBackgroundStream || this.vBackgroundStream.getVideoTracks().length === 0)
		{
			const deviceId = await this._getWebcamDeviceId();
			// const device = this._webcams[deviceId];

			if (this._webcamProducer)
			{
				await this.disableWebcam({ preserveChromaForVirtualBg: true });
			}

			try {
				this.vBackgroundStream = await navigator.mediaDevices.getUserMedia(
					{
						video :
						{
							deviceId : { exact: deviceId },
							...getVideoConstrains(resolution, aspectRatio),
							frameRate
						}
					});
			} catch (e) {
				console.log('Failed to get exact video device for background, trying with ideal constraint:', e);
				// Fallback to ideal constraint if exact fails
				try {
					this.vBackgroundStream = await navigator.mediaDevices.getUserMedia(
						{
							video :
							{
								deviceId : { ideal: deviceId },
								...getVideoConstrains(resolution, aspectRatio),
								frameRate
							}
						});
				} catch (fallbackError) {
					console.log('Fallback also failed, using default video device for background:', fallbackError);
					// Final fallback to default video device
					this.vBackgroundStream = await navigator.mediaDevices.getUserMedia(
						{
							video :
							{
								...getVideoConstrains(resolution, aspectRatio),
								frameRate
							}
						});
				}
			}
		}
		if ((blur === 'blur') || (blur === 'lightBlur'))
		{

			this._chromaStream.doLoad(this.vBackgroundStream, background, blur);
		}
		else
		{
			this._chromaStream.doLoad(this.vBackgroundStream, background, blur);
		}

		// Wait for the first frame to be drawn before replacing the track so we
		// don't send a black frame. If the first frame never arrives (e.g.
		// WebGL/MediaPipe unavailable), keep the previous track.
		let firstFrameOk = true;
		const timeoutMs = 10000;

		try
		{
			await Promise.race([
				this._chromaStream.waitForFirstFrame(),
				new Promise((_, reject) => setTimeout(() => reject(new Error('Virtual background first frame timeout')), timeoutMs))
			]);
		}
		catch (err)
		{
			firstFrameOk = false;
			logger.warn('Virtual background first frame wait failed, keeping previous track:', err?.message || err);
		}

		if (!firstFrameOk)
		{
			return;
		}

		// ([ track ] = this.vBackgroundStream.getVideoTracks());
		([ track ] = this._chromaStream.capStream.getVideoTracks());
		window.chromaStream = this._chromaStream;
		([ v_track ] = this.vBackgroundStream.getVideoTracks());

		// window.LocalVideoStream = this.vBackgroundStream;
		const { deviceId: trackDeviceId, width, height } = v_track.getSettings();

		logger.debug('getUserMedia track settings:', v_track.getSettings());

		store.dispatch(settingsActions.setSelectedWebcamDevice(trackDeviceId));

		const hasExistingProducer = !!this._webcamProducer;

		// If a webcam producer already exists for this background stream, just
		// replace its track so we don't recreate transports/producers every
		// time the user switches backgrounds.
		if (hasExistingProducer && typeof this._webcamProducer.replaceTrack === 'function')
		{
			await this._webcamProducer.replaceTrack(track);
		}
		else
		{
		const lowBandwidthMode = store.getState().mediaSession.lowBandwidthMode;
		if (this._useSimulcast && !lowBandwidthMode)
		{
			const encodings = this._getEncodings(width, height);

			const resolutionScalings = getResolutionScalings(encodings);

			this._webcamProducer = await this._sendTransport?.produce(
				{
					track,
					encodings,
					codecOptions :
					{
						videoGoogleStartBitrate : 1000
					},
					appData :
					{
						source : 'webcam',
						width,
						height,
						resolutionScalings
					}
				});
		}
		else
		{
			this._webcamProducer = await this._sendTransport?.produce({
				track,
				...(lowBandwidthMode ?
					{
						encodings : [ { maxBitrate: 300000 } ],
						codecOptions :
						{
							videoGoogleStartBitrate : 150
						}
					} :
					{}),
				appData :
				{
					source : 'webcam',
					width,
					height
				}
			});
		}

		store.dispatch(producerActions.addProducer(
			{
				id            : this._webcamProducer.id,
				source        : 'webcam',
				paused        : this._webcamProducer.paused,
				track         : this._webcamProducer.track,
				rtpParameters : this._webcamProducer.rtpParameters,
				codec         : this._webcamProducer.rtpParameters.codecs[0].mimeType.split('/')[1]
			}));

		this._webcamProducer.on('transportclose', () =>
		{
			this._webcamProducer = null;
		});

		this._webcamProducer.on('trackended', () =>
		{
			store.dispatch(requestActions.notify(
				{
					type : 'error',
					text : intl.formatMessage({
						id             : 'devices.cameraDisconnected',
						defaultMessage : 'Camera disconnected'
					})
				}));

			this.disableWebcam();
		});
		}

		store.dispatch(settingsActions.setVideoMuted(false));

		await this._updateWebcams();
		// }
		// catch (error)
		// {
		// 	logger.error('updateWebcam() [error:"%o"]', error);

		// 	store.dispatch(requestActions.notify(
		// 		{
		// 			type : 'error',
		// 			text : intl.formatMessage({
		// 				id             : 'devices.cameraError',
		// 				defaultMessage : 'An error occurred while accessing your camera'
		// 			})
		// 		}));

		// 	if (track)
		// 		track.stop();
		// }

		store.dispatch(
			meActions.setWebcamInProgress(false));
	}

	async removeBackground()
	{
		if (this._webcamProducer)
		{
			if (store.getState().room.virtualBg || store.getState().room.virtualBgEffect)
			{
				// if (this._webcamProducer){
				// 	await this.disableWebcam();
				// }
				this._chromaStream.close();
				this._chromaStream = null;
				this.vBackgroundStream.getTracks().forEach((each) => each.stop());
				this.updateWebcam({ start: true });
				store.dispatch(
					roomActions.setVirtualBgDetails('', ''));
			}
		}
		else
		{
			store.dispatch(
				roomActions.setVirtualBgDetails('', ''));
		}
	}

	async deleteS3Folder(selFolder)
	{
		try
		{
			// List all objects (files and subfolders) within the folder

			// console.log('sel', selFolder);

			const params = {
				Bucket : import.meta.env.VITE_s3Bucket,
				Prefix : selFolder.key
			};
			const data = await myBucket.listObjectsV2(params).promise();

			// console.log('ddddddddddddd', data);

			// Prepare the list of objects to delete
			const objectsToDelete = data.Contents.map((obj) =>
			{
				return { key: obj.key };
			});

			console.log('obbbbbbbbbbbb', objectsToDelete);

			// Delete objects in bulk
			if (objectsToDelete.length > 0)
			{
				const deleteParams = {
					Bucket : import.meta.env.VITE_s3Bucket,
					Delete : {
						Objects : objectsToDelete
					}
				};

				await myBucket.deleteObjects(deleteParams).promise();
			}

			console.log('Folder and its contents deleted successfully');
		}
		catch (err)
		{
			console.error('Error:', err);
			throw err;
		}
	}

	async deleteS3Object(each)
	{

		console.log('each...........', each);
		// try
		// {

		// 	const response = await axios.delete(`${import.meta.env.VITE_S3_Uploads}/delete?fileKey=${each.key}`);

		// 	console.log('response', response);

		// 	return response.data;
		// }
		// catch (e)
		// {
		// 	console.log('error in upload picture', e);

		// 	store.dispatch(requestActions.notify(
		// 		{
		// 			type : 'error',
		// 			text : intl.formatMessage({
		// 				id             : 'room.virtualBGError',
		// 				defaultMessage : 'Unable to upload image'
		// 			})
		// 		}));
		// }

		try
		{

			axios.post(`${import.meta.env.VITE_USERS}/deletecontent`, { key: each.key });
		}

		catch (err)
		{
			console.log('errr', err);
		}

		// const deleteImage = myBucket.deleteObject({
		// 	Bucket : import.meta.env.VITE_s3Bucket,
		// 	Key    : each.key || each.key
		// }, function(err, res)
		// {
		// 	if (err)
		// 	{

		// 		console.log('errrrrrrrrrrrr', err);

		// 		return err;
		// 	}
		// 	else
		// 	{
		// 		console.log('haiiiiiiii', res);

		// 		return res;
		// 	}
		// });

	}

	// RP - 10Jun2022
	async setLayoutMode(layout, layoutData)
	{
		try
		{
			await this.sendRequest('setWhiteboardLayout', { layout, layoutData });
		}
		catch (error)
		{
			// console.log('Failed to set layout')
		}
	}

	async removeWhiteBoardLayout()
	{
		try
		{
			window.parent.postMessage(JSON.stringify({ cmd: 'WHITEBOARD_STATUS', value: { whiteBoard: false, pId: this._peerId } }), '*');

			if (store.getState().room.allScreens.length > 0)
			{
				await this.sendRequest('setWhiteboardLayout', { layout: 'screenshareview', layoutData: null });
			}
			else if (this._videoData)
			{
				await this.sendRequest('setWhiteboardLayout', { layout: 'videoShareView', layoutData: null });
			}
			else if (this._fileShareLayoutData)
			{
				await this.sendRequest('setWhiteboardLayout', { layout: 'fileShareView', layoutData: null });
			}
			else if (this._roomTemplate.data.democratic)
			{
				await this.sendRequest('setWhiteboardLayout', { layout: 'democratic', layoutData: null });
			}
			else if (this._roomTemplate.data.filmStrip)
			{
				await this.sendRequest('setWhiteboardLayout', { layout: 'filmstrip', layoutData: null });
			}
			else
			{
				await this.sendRequest('setWhiteboardLayout', { layout: 'democratic', layoutData: null });
			}
		}
		catch (error)
		{
			console.log('Failed to remove layout');
		}
	}

	async postInVcMainChat(body)
	{
		axios.post(`${import.meta.env.VITE_InVcMainchatAPI}/saveChat`, body).then(() =>
		{
			// eslint-disable-next-line no-console
		});

	}

	async sendChatMessage(messageData)
	{
		logger.debug('sendChatMessage() [chatMessage:"%s"]', messageData);

		try
		{
			// store.dispatch(
			// 	chatActions.addMessage(
			// 		{
			// 			...messageData,
			// 			// name    : 'Me',
			// 			sender  : 'client',
			// 			picture : undefined,
			// 			isRead  : true
			// 		}
			// 	)
			// );

			const chatMessage = {
				...messageData,
				meetingId : this._roomTemplate.meetingDetails.meetingId
			};

			store.dispatch(chatActions.setIsScrollEnd(true));

			await this.sendRequest('chatMessage', { chatMessage });
			// const body = {
			// 	userId    : messageData.peerId,
			// 	meetingId : this._roomTemplate.meetingDetails.meetingId,
			// 	message   : messageData.text,
			// 	sendTime  : messageData.time,
			// 	userName  : messageData.name,
			// 	type      : 'message',
			// 	picture   : messageData.picture

			// };

			// await this.postInVcMainChat(body);

		}
		catch (error)
		{
			logger.error('sendChatMessage() [error:"%o"]', error);

			store.dispatch(requestActions.notify(
				{
					type : 'error',
					text : intl.formatMessage({
						id             : 'room.chatError',
						defaultMessage : 'Unable to send chat message'
					})
				}));
		}
	}

	async sendPrivateMessage(chatMessage)
	{
		logger.debug('sendPrivateMessage() [chatMessage:"%s"]', chatMessage);

		try
		{
			store.dispatch(
				privateChatActions.addPrivateMessage(
					{
						toId    : chatMessage.toId,
						message :
						{
							...chatMessage.message,
							sender : 'client',
							isRead : true
						},
						displayName : chatMessage?.displayName,
						picture     : chatMessage?.picture
					}
				)
			);

			await this.sendRequest('privateChatMessage', { chatMessage });

		}
		catch (err)
		{
			console.log('error===', err);
		}
	}

	updateSocketChat(data)
	{
		store.dispatch(
			chatActions.addBroadcastMessage(
				[
					{
						...data,
						myId : window.btoa(store.getState().me.email)
					}
				]
			)
		);
		store.dispatch(
			chatActions.setIsBroadcastScrollEnd(true));
	}

	async postBroadcastChat(obj)
	{
		await axios.post(`${import.meta.env.VITE_InVcMainchatAPI}/createChat`, obj).then(() =>
		{
			// eslint-disable-next-line no-console
		});

	}

	async sendBroadcastChatMessage(body, reply)
	{
		logger.debug('sendChatMessage() [chatMessage:"%s"]', body);
		try
		{
			// const body = {
			// 	userId    : chatMessage.peerId,
			// 	meetingId : this._roomId,
			// 	message   : chatMessage.text,
			// 	sendTime  : new Date().valueOf(),
			// 	sender    : 'Host',
			// 	userName  : chatMessage.name
			// };

			if (this._meetingType === 'webinar' && this._havePermission(permissions.MODERATE_ROOM))
			{
				if (reply && reply.socketId)
				{
					this.updateSocketChat(body);
					await this._webinarSocket.emit('reply-message', reply.socketId, body);
				}
				else
				{
					await this._webinarSocket.emit('send-message', body);
				}

			}
			else if (this._meetingType !== 'webinar' && this._havePermission(permissions.MODERATE_ROOM))
			{

				this.broadcastSocket.emit('send-message', body);
			}
			else
			if (reply && reply.socketId)
			{
				this.updateSocketChat(body);
				store.getState().webinar.webinarSocket.emit('reply-message', reply.socketId, body);
			}
			else
			{
				store.getState().webinar.webinarSocket.emit('send-message', body);
			}
			await this.postBroadcastChat(body);
			// await socket.on('get-message', (data) =>
			// {

		}
		catch (error)
		{
			logger.error('sendChatMessage() [error:"%o"]', error);

			store.dispatch(requestActions.notify(
				{
					type : 'error',
					text : intl.formatMessage({
						id             : 'room.chatError',
						defaultMessage : 'Unable to send chat message'
					})
				}));
		}
	}

	async sendMsgToWebinarUsers(payload)
	{

		try
		{
			// await axios.post('https://localhost:3443/msgToPanelists', payload,
			await axios.post(`${import.meta.env.VITE_WEBINAR_SOCKET}msgToWebinarUsers`, payload
			)
				.then((res) =>
				{
					console.log('dattaaaaaa', res);
				})
				.catch((err) =>
				{
					console.log('error in get Data', err);
				});

			await this.postBroadcastChat(payload);

		}
		catch (err)
		{
			console.log('error============', err);
		}

	}

	async sendMessageToPanelists(payload)
	{

		try
		{
			// await axios.post('https://localhost:3443/msgToPanelists', payload,
			await axios.post(`https://${config.serverHostname}/msgToPanelists`, payload
				// {
				// 	withCredentials : true,
				// 	headers         : {
				// 		'Content-Type' : 'application/json'
				// 	}
				// }
			)
				.then((res) =>
				{
					console.log('dattaaaaaa', res);
				})
				.catch((err) =>
				{
					console.log('error in get Data', err);
				});

			await this.postBroadcastChat(payload);

		}
		catch (err)
		{
			console.log('error============', err);
		}

	}

	async sendMsgConfig(method, body)
	{
		logger.debug('sendMsgConfig() [chatMessage:"%s"]', body);
		try
		{

			// if (this._meetingType === 'webinar' && this._havePermission(permissions.MODERATE_ROOM))
			// {

			store.getState().webinar.webinarSocket.emit(method, body);
			await this.postBroadcastChat(body);

		}
		catch (error)
		{
			logger.error('sendMsgConfig() [error:"%o"]', error);

			store.dispatch(requestActions.notify(
				{
					type : 'error',
					text : intl.formatMessage({
						id             : 'room.chatError',
						defaultMessage : 'Unable to send chat message'
					})
				}));
		}
	}

	// async sendMsgToPanelists(mettingId, body)
	// {
	// 	logger.debug('sendMsgConfig() [chatMessage:"%s"]', body);
	// 	try
	// 	{

	// 		// if (this._meetingType === 'webinar' && this._havePermission(permissions.MODERATE_ROOM))
	// 		// {

	// 		console.log('haiiiiiiiiiiii', mettingId, body);
	// 		console.log('hellooo', this._webinarSocket);

	// 		store.getState().webinar.webinarSocket.emit('msgToPanelists', mettingId, body);

	// 	}
	// 	catch (error)
	// 	{
	// 		logger.error('sendMsgConfig() [error:"%o"]', error);

	// 		store.dispatch(requestActions.notify(
	// 			{
	// 				type : 'error',
	// 				text : intl.formatMessage({
	// 					id             : 'room.chatError',
	// 					defaultMessage : 'Unable to send chat message'
	// 				})
	// 			}));
	// 	}
	// }

	saveFile(file)
	{
		file.getBlob((err, blob) =>
		{
			if (err)
			{
				store.dispatch(requestActions.notify(
					{
						type : 'error',
						text : intl.formatMessage({
							id             : 'filesharing.saveFileError',
							defaultMessage : 'Unable to save file'
						})
					}));

				return;
			}

			saveAs(blob, file.name);
		});
	}

	async saveChat(displayName)
	{
		console.log('this._roomTemplate', this._roomTemplate.data.isPrivateChat);
		const html = window.document.getElementsByTagName('html')[0].cloneNode(true);

		const chatEl = html.querySelector('#chatList');

		html.querySelector('body').replaceChildren(chatEl);

		let fileName = '';

		if (displayName)
		{
			fileName = `${displayName.replace(/\s/g, '_')}.html`;
		}
		else
		{
			fileName = `${this._roomTemplate.meetingDetails.meetingName.replace(/\s/g, '_')}.html`;
		}

		// remove unused tags
		[ 'script', 'link' ].forEach((element) =>
		{
			const el = html.getElementsByTagName(element);

			let i = el.length;

			while (i--) el[i].parentNode.removeChild(el[i]);
		});

		// Function to fetch and embed images with retry logic
		async function fetchImageWithRetry(src, retries = 3)
		{
			for (let attempt = 0; attempt < retries; attempt++)
			{
				try
				{
					const response = await fetch(src, { mode: 'no-cors' });

					if (!response.ok) throw new Error(`Failed to fetch image: ${response.statusText}`);
					const data = await response.blob();
					const reader = new FileReader();

					return new Promise((resolve, reject) =>
					{
						reader.onloadend = () => resolve(reader.result);
						reader.onerror = reject;
						reader.readAsDataURL(data);
					});
				}
				catch (error)
				{
					console.error(`Attempt ${attempt + 1} failed: ${error.message}`);
					if (attempt === retries - 1) throw error; // Rethrow on the last attempt
				}
			}
		}

		// Embed images
		for await (const img of html.querySelectorAll('img'))
		{
			try
			{
				img.src = await fetchImageWithRetry(img.src);
			}
			catch (error)
			{
				console.error(`Failed to embed image ${img.src}: ${error.message}`);
			}
		}

		const blob = new Blob([ html.innerHTML ], { type: 'text/html;charset=utf-8' });

		saveAs(blob, fileName);
	}

	sortChat(order)
	{
		store.dispatch(
			chatActions.sortChat(order)
		);
	}

	async handleDownload(magnetUri, fileName)
	{
		const response = await fetch(magnetUri);
		const blob = await response.blob();
		const url = URL.createObjectURL(blob);
		const link = document.createElement('a');

		link.href = url;
		link.download = fileName;

		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
		// store.dispatch(
		// 	fileActions.setFileActive(magnetUri));

		// const existingTorrent = this._webTorrent.get(magnetUri);

		// if (existingTorrent)
		// {
		// 	// Never add duplicate torrents, use the existing one instead.
		// 	this._handleTorrent(existingTorrent);

		// 	return;
		// }

		// this._webTorrent.add(magnetUri, this._handleTorrent);
	}

	_handleTorrent(torrent)
	{
		// Torrent already done, this can happen if the
		// same file was sent multiple times.
		if (torrent.progress === 1)
		{
			store.dispatch(
				fileActions.setFileDone(
					torrent.magnetURI,
					torrent.files
				));

			return;
		}

		// let lastMove = 0;

		torrent.on('download', () =>
		{
			// if (Date.now() - lastMove > 1000)
			// {
			store.dispatch(
				fileActions.setFileProgress(
					torrent.magnetURI,
					torrent.progress
				));

			// lastMove = Date.now();
			// }
		});

		torrent.on('done', () =>
		{
			store.dispatch(
				fileActions.setFileDone(
					torrent.magnetURI,
					torrent.files
				));
		});
	}

	exitScreenShareIfRequired(peerId, force = false)
	{
		if (this._layoutDataSC.includes(peerId))
		{
			if ((Number(this._screenPage) === 0 && (this._mode === undefined || this._mode === null)) || Number(this._screenPage) > 0)
			{
				this.removeSelectedPeer(peerId);
			}
			this._layoutDataSC = this._layoutDataSC.filter((item) => item !== peerId);
			if (this._layoutDataSC.length > 0)
			{
				// store.dispatch(roomActions.setDisplayMode('screenshareview'));
				this.addSelectedPeer(this._layoutDataSC[0]);
				store.dispatch(
					roomActions.setActiveScreenId(this._layoutDataSC[0], this._layoutDataSC));

				// based on active speaker changing view in presentation screen

				if (this._mode && this._mode === 'screen')
				{
					if (store.getState().room.allScreens.length > 0 && store.getState().activeScreenId && store.getState().peers[store.getState().activeScreenId])
					{
						store.dispatch(
							roomActions.setTpScreenPresentationView('screenshareview')
						);
					}
				}
			}
			else if (this._layoutDataWB)
			{
				// once stop screen share showing whiteboardview based on this._layoutDataWB
				if (this._mode && this._mode === 'screen')
				{
					store.dispatch(
						roomActions.setAllScreens(this._layoutDataSC));
					store.dispatch(
						roomActions.setTpScreenPresentationView('whiteboardview')
					);
				}
				else if (Number(this._screenPage) === 0 && (this._mode === undefined || this._mode === null))
				{
					store.dispatch(
						roomActions.setAllScreens(this._layoutDataSC));
					store.dispatch(roomActions.setDisplayMode('whiteboardview'));
				}
			}
			else if (this._fileShareLayoutData)
			{
				if (this._mode && this._mode === 'screen')
				{
					store.dispatch(
						roomActions.setAllScreens(this._layoutDataSC));
					if (store.getState().room.uploadDocument && Object.keys(store.getState().room.uploadDocument).length > 0)
					{
						store.dispatch(
							roomActions.setTpScreenPresentationView('fileShareView')
						);
					}
					store.dispatch(roomActions.setDisplayMode('presenter'));
				}
				else
				{
					store.dispatch(
						roomActions.setAllScreens(this._layoutDataSC));
					store.dispatch(roomActions.setDisplayMode('fileShareView'));
				}
			}
			else if (this._videoData)
			{
				store.dispatch(
					roomActions.setAllScreens(this._layoutDataSC));
				store.dispatch(roomActions.setDisplayMode('videoShareView'));
			}
			else
			{
				store.dispatch(
					roomActions.setAllScreens(this._layoutDataSC));

				// if there is no presentation by default value is showing
				if (Number(this._screenPage) > 0)
				{
					store.dispatch(roomActions.setDisplayMode('pagescreen'));

				}
				else if (this._mode && this._mode === 'speaker')
				{
					store.dispatch(roomActions.setDisplayMode('activeSpeakerview'));
				}
				else if (this._mode && this._mode === 'screen')
				{
					store.dispatch(
						roomActions.setActiveScreenId(null, this._layoutDataSC));
					if (store.getState().room.wbData && Object.keys(store.getState().room.wbData).length > 0)
					{
						store.dispatch(
							roomActions.setTpScreenPresentationView('whiteboardview')
						);
					}
					else if (store.getState().room.uploadDocument && Object.keys(store.getState().room.uploadDocument).length > 0)
					{
						store.dispatch(
							roomActions.setTpScreenPresentationView('fileShareView')
						);
					}
					else
					{
						store.dispatch(
							roomActions.setTpScreenPresentationView('')
						);
					}
					store.dispatch(roomActions.setDisplayMode('presenter'));
				}
				else
				{
					store.dispatch(roomActions.setDisplayMode('democratic'));
				}
			}
		}

		if (force)
		{
			console.log('this._layoutDataWB else', this._layoutDataWB);
			store.dispatch(roomActions.setDisplayMode('democratic'));
		}
	}

	// exitScreenShareIfRequired(peerId, force = false) {
	// 	const storeDispatch = store.dispatch;

	// 	const updateDisplayMode = (mode) => storeDispatch(roomActions.setDisplayMode(mode));
	// 	const updateActiveScreenId = (id, layout) => storeDispatch(roomActions.setActiveScreenId(id, layout));
	// 	const updateTpScreenPresentationView = (view) => storeDispatch(roomActions.setTpScreenPresentationView(view));
	// 	const updateAllScreens = (layout) => storeDispatch(roomActions.setAllScreens(layout));

	// 	if (this._layoutDataSC.includes(peerId)) {
	// 		if ((Number(this._screenPage) === 0 && (this._mode == null)) || Number(this._screenPage) > 0) {
	// 			this.removeSelectedPeer(peerId);
	// 		}
	// 		this._layoutDataSC = this._layoutDataSC.filter(item => item !== peerId);

	// 		if (this._layoutDataSC.length > 0) {
	// 			this.addSelectedPeer(this._layoutDataSC[0]);
	// 			updateActiveScreenId(this._layoutDataSC[0], this._layoutDataSC);

	// 			if (this._mode === 'screen') {
	// 				const state = store.getState();
	// 				if (state.room.allScreens.length > 0 && state.activeScreenId && state.peers[state.activeScreenId]) {
	// 					updateTpScreenPresentationView('screenshareview');
	// 				}
	// 			}
	// 		} else if (this._layoutDataWB) {
	// 			if (this._mode === 'screen') {
	// 				updateAllScreens(this._layoutDataSC);
	// 				updateTpScreenPresentationView('whiteboardview');
	// 			} else if (Number(this._screenPage) === 0 && this._mode == null) {
	// 				updateAllScreens(this._layoutDataSC);
	// 				updateDisplayMode('whiteboardview');
	// 			}
	// 		} else if (this._fileShareLayoutData) {
	// 			if (this._mode === 'screen') {
	// 				const state = store.getState();
	// 				if (state.room.uploadDocument && Object.keys(state.room.uploadDocument).length > 0) {
	// 					updateTpScreenPresentationView('fileShareView');
	// 				}
	// 				updateDisplayMode('presenter');
	// 			} else {
	// 				updateAllScreens(this._layoutDataSC);
	// 				updateDisplayMode('fileShareView');
	// 			}
	// 		} else if (this._videoData) {
	// 			updateAllScreens(this._layoutDataSC);
	// 			updateDisplayMode('videoShareView');
	// 		} else {
	// 			updateAllScreens(this._layoutDataSC);

	// 			if (Number(this._screenPage) > 0) {
	// 				updateDisplayMode('pagescreen');
	// 			} else if (this._mode === 'speaker') {
	// 				updateDisplayMode('activeSpeakerview');
	// 			} else if (this._mode === 'screen') {
	// 				updateActiveScreenId(null, this._layoutDataSC);
	// 				const state = store.getState();
	// 				if (state.room.wbData && Object.keys(state.room.wbData).length > 0) {
	// 					updateTpScreenPresentationView('whiteboardview');
	// 				} else if (state.room.uploadDocument && Object.keys(state.room.uploadDocument).length > 0) {
	// 					updateTpScreenPresentationView('fileShareView');
	// 				} else {
	// 					updateTpScreenPresentationView('');
	// 				}
	// 				updateDisplayMode('presenter');
	// 			} else {
	// 				updateDisplayMode('democratic');
	// 			}
	// 		}
	// 	}

	// 	if (force) {
	// 		console.log('this._layoutDataWB else', this._layoutDataWB);
	// 		updateDisplayMode('democratic');
	// 	}
	// }

	removeCanvas(peerId)
	{
		const canvas=window.canvas;

		canvas.getObjects().forEach((obj) =>
		{
			if ((obj.id === 'pointer' || obj.id === 'pointerText' || obj.id === 'spotlight' || obj.id === 'spotlightText') && peerId === obj.peerId)
			{
				console.log('Removing existing object:', obj);
				canvas.remove(obj);
			}
		});
		window.canvas=canvas;
	}

	async shareFiles(data)
	{
		store.dispatch(requestActions.notify(
			{
				text : intl.formatMessage({
					id             : 'filesharing.startingFileShare',
					defaultMessage : 'Attempting to share file'
				})
			}));

		createTorrent(data.attachment, (err, torrent) =>
		{
			if (err)
			{
				store.dispatch(requestActions.notify(
					{
						type : 'error',
						text : intl.formatMessage({
							id             : 'filesharing.unableToShare',
							defaultMessage : 'Unable to share file'
						})
					}));

				return;
			}

			const existingTorrent = this._webTorrent.get(torrent);

			if (existingTorrent)
			{
				store.dispatch(requestActions.notify(
					{
						text : intl.formatMessage({
							id             : 'filesharing.successfulFileShare',
							defaultMessage : 'File successfully shared'
						})
					}));

				const file = {
					...data,
					peerId    : this._peerId,
					magnetUri : existingTorrent.magnetURI
				};

				store.dispatch(fileActions.addFile(file));

				this._sendFile(file);

				return;
			}

			this._webTorrent.seed(
				data.attachment,
				{ announceList: [ [ this._tracker ] ] },
				(newTorrent) =>
				{
					store.dispatch(requestActions.notify(
						{
							text : intl.formatMessage({
								id             : 'filesharing.successfulFileShare',
								defaultMessage : 'File successfully shared'
							})
						}));

					const file = {
						...data,
						peerId    : this._peerId,
						magnetUri : newTorrent.magnetURI
					};

					store.dispatch(fileActions.addFile(file));

					this._sendFile(file);
				});
		});
	}

	async _sendFile(file)
	{
		logger.debug('sendFile() [magnetUri:"%o"]', file.magnetUri);

		try
		{
			await this.sendRequest('sendFile', file);
		}
		catch (error)
		{
			logger.error('sendFile() [error:"%o"]', error);

			store.dispatch(requestActions.notify(
				{
					type : 'error',
					text : intl.formatMessage({
						id             : 'filesharing.unableToShare',
						defaultMessage : 'Unable to share file'
					})
				}));
		}
	}

	async _sendPrivateFile(file)
	{
		logger.debug('sendFile() [magnetUri:"%o"]', file?.magnetUri);

		try
		{
			await this.sendRequest('sendPrivateFile', { ...file });
		}
		catch (error)
		{
			logger.error('sendFile() [error:"%o"]', error);

			store.dispatch(requestActions.notify(
				{
					type : 'error',
					text : intl.formatMessage({
						id             : 'filesharing.unableToShare',
						defaultMessage : 'Unable to share file'
					})
				}));
		}
	}

	async muteMic()
	{
		logger.debug('muteMic()');

		const seq = ++this._micStateSeq;

		this._micDesiredMuted = true;

		// Silence every mic producer first, so no audio leaves even if the request below fails.
		for (const producer of this._allMicProducers())
		{
			producer.pause();
		}

		const producer = this._micProducer;

		if (!producer)
		{
			// Nothing to signal yet; an updateMic() in flight picks this up and produces muted.
			store.dispatch(settingsActions.setAudioMuted(true));

			return;
		}

		// The icon follows the media, which is silent from here on.
		this._setMicMutedState(producer, true);

		try
		{
			await this.sendRequest(
				'pauseProducer', { producerId: producer.id });

			if (seq === this._micStateSeq)
				this._micServerStateDirty = false;
		}
		catch (error)
		{
			// The SFU may still treat the (silent) producer as live; _reconcileMic() retries the pause.
			this._micServerStateDirty = true;

			logger.error('muteMic() [error:"%o"]', error);

			const object = {
				type  : 'mic',
				error : 'Unable to mute mic'
			};

			window.parent.postMessage(JSON.stringify({ cmd: 'eventError', value: object }), '*');

			store.dispatch(requestActions.notify(
				{
					type : 'error',
					text : intl.formatMessage({
						id             : 'devices.microphoneMuteError',
						defaultMessage : 'Unable to mute your microphone'
					})
				}));
			if (this._deviceInfo.platform === 'desktop' && this._deviceInfo.name === 'electron')
			{
				this.sendRequest('displayErrorLogs', { type: 'audio', error: 'Unable to mute your microphone' });
			}
		}
	}

	async unmuteMic()
	{
		logger.debug('unmuteMic()');

		const seq = ++this._micStateSeq;

		this._micDesiredMuted = false;

		const producer = this._micProducer;

		if (!producer)
		{
			// An updateMic() already in flight reads this; otherwise start the mic unmuted.
			store.dispatch(settingsActions.setAudioMuted(false));

			await this.updateMic({ start: true, muted: false });

			return;
		}

		try
		{
			// The SFU resumes first and the local track stays disabled until it has. Resuming locally
			// first left the mic live behind a muted icon whenever this request failed.
			await this.sendRequest(
				'resumeProducer', { producerId: producer.id });

			if (producer !== this._micProducer || producer.closed)
				return;

			if (seq !== this._micStateSeq)
			{
				// A mute came in meanwhile, and this resume may have reached the SFU after its pause.
				if (this._micDesiredMuted)
					await this._sendMicPause(producer);

				return;
			}

			this._micServerStateDirty = false;

			producer.resume();

			this._setMicMutedState(producer, false);
		}
		catch (error)
		{
			// Timed-out requests are retried, so the SFU may have resumed anyway; the mic stays muted
			// here and _reconcileMic() re-pauses it there.
			this._micServerStateDirty = true;

			if (seq === this._micStateSeq)
				this._micDesiredMuted = true;

			logger.error('unmuteMic() [error:"%o"]', error);

			const object = {
				type  : 'mic',
				error : 'Unable to unmute mic'
			};

			window.parent.postMessage(JSON.stringify({ cmd: 'eventError', value: object }), '*');

			store.dispatch(requestActions.notify(
				{
					type : 'error',
					text : intl.formatMessage({
						id             : 'devices.microphoneUnMuteError',
						defaultMessage : 'Unable to unmute your microphone'
					})
				}));
			if (this._deviceInfo.platform === 'desktop' && this._deviceInfo.name === 'electron')
			{
				this.sendRequest('displayErrorLogs', { type: 'audio', error: 'Unable to unmute your microphone' });
			}
		}
	}

	// Redux state and side effects that follow the mic's mute state. Callers set the media itself.
	_setMicMutedState(producer, muted)
	{
		if (muted)
		{
			this.detachHarkListeners();

			store.dispatch(
				producerActions.setProducerPaused(producer.id));
		}
		else
		{
			this.attachHarkListeners();

			store.dispatch(
				producerActions.setProducerResumed(producer.id));
		}

		store.dispatch(
			settingsActions.setAudioMuted(muted));

		if ('mediaSession' in navigator && isInPIP())
		{
			navigator.mediaSession.setMicrophoneActive(!muted);
		}

		store.dispatch(settingsActions.setMediaPerms({
			...store.getState().settings.mediaPerms,
			audio : !muted
		}));

		if (muted)
			this.disconnectTranscriptionSocket();
		else
			this.connectToTranscriptionSocket();
	}

	// Every open mic producer: the current one plus any that were never closed.
	_allMicProducers()
	{
		const producers = new Set(this._micProducers);

		if (this._micProducer)
			producers.add(this._micProducer);

		return [ ...producers ].filter((producer) => !producer.closed);
	}

	_trackMicProducer(producer, capture = null)
	{
		this._micProducers.add(producer);

		if (capture)
			this._micCaptures.set(producer, capture);

		producer.on('transportclose', () => this._forgetMicProducer(producer));
	}

	_forgetMicProducer(producer)
	{
		this._micProducers.delete(producer);

		const capture = this._micCaptures.get(producer);

		if (capture)
		{
			this._micCaptures.delete(producer);
			this._releaseMicCapture(capture);
		}

		if (this._micProducer === producer)
			this._micProducer = null;
	}

	// Stops the raw capture track and closes the RNNoise AudioContext behind a mic. Closing the
	// producer only stops the processed track, so the device stayed captured and the raw track's
	// 'ended' listener stayed armed.
	_releaseMicCapture({ rawStream, audioContext, onRawTrackEnded })
	{
		for (const rawTrack of rawStream.getTracks())
		{
			rawTrack.removeEventListener('ended', onRawTrackEnded);
			rawTrack.stop();
		}

		if (audioContext && audioContext.state !== 'closed')
			audioContext.close().catch(() => {});
	}

	async _retireMicProducer(producer, { notifyServer = true } = {})
	{
		this._forgetMicProducer(producer);

		producer.close();

		store.dispatch(
			producerActions.removeProducer(producer.id));

		if (!notifyServer)
			return;

		try
		{
			await this.sendRequest(
				'closeProducer', { producerId: producer.id });
		}
		catch (error)
		{
			logger.error('_retireMicProducer() [error:"%o"]', error);
		}
	}

	async _sendMicPause(producer)
	{
		this._micPauseInFlight = true;

		try
		{
			await this.sendRequest(
				'pauseProducer', { producerId: producer.id });

			this._micServerStateDirty = false;
		}
		catch (error)
		{
			this._micServerStateDirty = true;

			logger.warn('_sendMicPause() [error:"%o"]', error);
		}
		finally
		{
			this._micPauseInFlight = false;
		}
	}

	// Safety net run on an interval: whatever the UI shows as muted must really be silent, and only
	// the current mic producer may exist.
	_reconcileMic()
	{
		if (this._micInProgress)
			return;

		for (const producer of this._micProducers)
		{
			if (producer.closed)
				this._forgetMicProducer(producer);
		}

		// A SIP bridge never applies the mute state when it produces, so a stale audioMuted must not
		// silence it.
		const audioMuted = store.getState().settings.audioMuted && !this._sipAudioStream;

		for (const producer of this._allMicProducers())
		{
			if (producer !== this._micProducer)
			{
				logger.warn('_reconcileMic() | closing orphan mic producer [producerId:"%s"]', producer.id);

				this._retireMicProducer(producer);
			}
			else if (audioMuted && (!producer.paused || producer.track?.enabled))
			{
				logger.warn('_reconcileMic() | mic live while muted, pausing [producerId:"%s"]', producer.id);

				producer.pause();

				this._micServerStateDirty = true;
			}
		}

		if (audioMuted && this._micServerStateDirty && this._micProducer && !this._micPauseInFlight)
			this._sendMicPause(this._micProducer);
	}

	changeMaxSpotlights(maxSpotlights)
	{
		this._spotlights.maxSpotlights = maxSpotlights;

		store.dispatch(
			settingsActions.setLastN(maxSpotlights));
	}

	async updateSpeakerResumeConsumers(peerId)
	{
		console.log('this._consumers.values()====', this._consumers.values());
		for (const consumer of this._consumers.values())
		{
			const consumerFind = store.getState().consumers[consumer.id];

			if (consumer.kind === 'video' && consumerFind && consumerFind !== undefined)
			{
				if (consumer.appData.peerId === peerId)
				{
					// console.log('resume======================');
					await this._resumeConsumer(consumer, { initial: true });
					break;
				}
			}

		}
	}

	async updateSpeakerPauseConsumers(peerId)
	{

		console.log('this._consumers.values()====', this._consumers.values());
		for (const consumer of this._consumers.values())
		{
			const consumerFind = store.getState().consumers[consumer.id];

			if (consumer.kind === 'video' && consumerFind && consumerFind !== undefined)
			{
				if (consumer.appData.peerId === peerId)
				{
					await this._pauseConsumer(consumer);
					store.dispatch(
						roomActions.removeSelectedPeer(consumer.appData.peerId));

					break;

				}
			}

		}
	}

	async _resumeConsumersBulk(consumers) {
		const consumerIds = consumers.map(consumer => consumer.id);
		try {
			await this.sendRequest('resumeConsumersBulk', { consumerIds });
			for (const consumer of consumers) {
				consumer.resume();
				consumer['initiallyPaused'] = true;
			}
			store.dispatch(
				consumerActions.setConsumerbulkResumed(consumerIds));
		} catch (error) {
			//error will contain Ids of consumers that are not found in mediasoup
			logger.error('_resumeConsumersBulk() [error:"%o"]', error);
			console.log('_resumeConsumersBulk() [error:"%o"]', error);
			const newConsumers = consumers.filter(obj => !error.results.includes(obj.id));
			error.results.forEach(consumerId => {
				console.log(consumerId);
				this._closeConsumer(consumerId);
			});
			for (const consumer of newConsumers) {
				consumer.resume();
				consumer['initiallyPaused'] = true;
			}
			store.dispatch(
				consumerActions.setConsumerbulkResumed(consumerIds));
		}
	}
	async _pauseConsumersBulk(consumers) {
		const consumerIds = consumers.map(consumer => consumer.id);
		try {
			await this.sendRequest('pauseConsumersBulk', { consumerIds });
            for (const consumer of consumers) {
                consumer.pause();
            }
			store.dispatch(
				consumerActions.setConsumerbulkPaused(consumerIds));
		} catch (error) {
            //error will contain Ids of consumers that are not found in mediasoup
			logger.error('_pauseConsumersBulk() [error:"%o"]', error);
			console.log('_pauseConsumersBulk() [error:"%o"]', error);
			const newConsumers = consumers.filter(obj => !error.results.includes(obj.id));
			error.results.forEach(consumerId => {
				console.log(consumerId);
				this._closeConsumer(consumerId);
			  });
              for (const consumer of newConsumers) {
                consumer.pause();
              }
              store.dispatch(
                consumerActions.setConsumerbulkPaused(consumerIds));
		}
	}
	// Updated consumers based on spotlights
	// if video pause issue comes add index condition
	async updateSpotlights(spotlights = null)
	{
		console.log('sptlights=====values==========', this._consumers.values());

		logger.debug('updateSpotlights()');

		if (spotlights)
		{
			store.dispatch(roomActions.setSpotlights(spotlights));
		}
		try
		{

			if (this._mode === 'speaker')
			{
				console.log('speaker');
			}
			else if (this._mode === 'screen')
			{
				for (const consumer of this._consumers.values())
				{
					if (consumer.kind === 'video')
					{
						if (consumer.appData.peerId === store.getState().room.activeScreenId)
						{
							await this._resumeConsumer(consumer, { initial: true });
						}
						else
						{
							await this._pauseConsumer(consumer);
							store.dispatch(
								roomActions.removeSelectedPeer(consumer.appData.peerId));
						}
					}

				}
			}
			else if (Number(this._screenPage) > 0)
			{

				const screenPeers = store.getState()?.room?.tpScreenPagePeers?.find((eachScreen) => eachScreen?.screenNumber == this._screenPage);

				for (const consumer of this._consumers.values())
				{
					if (consumer.kind === 'video')
					{
						let peerFind = false;

						if (screenPeers?.peers.length > 0)
						{
							for (let each of screenPeers?.peers)
							{
								if (each.id === consumer.appData.peerId)
								{
									peerFind = true;
									break;
								}
							}
						}

						if (peerFind)
						{
							// if (consumer.track.muted)
							// {

							await this._resumeConsumer(consumer, { initial: true });
							// }

						}
						// else if (consumer.appData.source === 'screen')
						// {
						// 	await this._resumeConsumer(consumer);
						// }
						else
						{

							// console.log('updateSpotlights function');

							// console.log('inside spot ==', spotlights, consumer.paused);
							await this._pauseConsumer(consumer);
							store.dispatch(
								roomActions.removeSelectedPeer(consumer.appData.peerId));
						}
					}
				}
			}
			else
			{

				this.pauseOrResumeConsumers({ activeConsumer: null, spotlights });
                // try
				// {

				// 	for (const consumer of this._consumers.values())
				// 	{
				// 		if (consumer.kind === 'video')
				// 		{
				// 			if ((spotlights.includes(consumer.appData.peerId) && consumer.appData.source !== 'screen') || (consumer.appData.peerId === store.getState().room.activeSpeakerId && consumer.appData.source !== 'screen') || (consumer.appData.peerId === store.getState().room.activePeerId && consumer.appData.source !== 'screen'))
				// 			{

				// 				await this._resumeConsumer(consumer);
				// 			}
				// 			else if (consumer.appData.source === 'screen')
				// 			{

				// 				await this._resumeConsumer(consumer);
				// 			}
				// 			else
				// 			{
				// 				// console.log('pauseConsumer___1_updateSpotlights');

				// 				// console.log('inside spot ==', spotlights, this._consumers.values());
				// 				await this._pauseConsumer(consumer);
				// 				store.dispatch(
				// 					roomActions.removeSelectedPeer(consumer.appData.peerId));

				// 			}
				// 		}
				// 	}
				// }
				// catch (error)
				// {
				// 	logger.error('updateSpotlights() [error:"%o"]', error);
				// }

			}
		}
		catch (err)
		{
			console.log('error===pause', err);
		}

		// try
		// {

		// 	if (Number(this._screenPage) > 0)
		// 	{
		// 		return;
		// 	}

		// 	for (const consumer of this._consumers.values())
		// 	{
		// 		if (consumer.kind === 'video')
		// 		{

		// 			let index;

		// 			if (Number(this._screenPage) > 0)
		// 			{
		// 				// index = spotlights.findIndex((each) => each.id === consumer.appData.peerId);
		// 				index = store.getState().room.spotlights.indexOf(consumer.appData.peerId);
		// 			}
		// 			else
		// 			{
		// 				index = store.getState().room.spotlights.indexOf(consumer.appData.peerId);
		// 			}

		// 			if ((index > -1 && consumer.appData.source !== 'screen') || (consumer.appData.peerId === store.getState().room.activeSpeakerId && consumer.appData.source !== 'screen') || (consumer.appData.peerId === store.getState().room.activePeerId && consumer.appData.source !== 'screen'))
		// 			{
		// 				await this._resumeConsumer(consumer);
		// 			}
		// 			else if (consumer.appData.source === 'screen')
		// 			{
		// 				await this._resumeConsumer(consumer);
		// 			}
		// 			else
		// 			{
		// 				// console.log('consumetrr=r====', consumer);

		// 				// console.log('updateSpotlights function');

		// 				// console.log('inside spot ==', spotlights, this._consumers.values());
		// 				await this._pauseConsumer(consumer);
		// 				store.dispatch(
		// 					roomActions.removeSelectedPeer(consumer.appData.peerId));
		// 			}
		// 		}
		// 	}

		// 	// for (const consumer of this._consumers.values())
		// 	// {
		// 	// 	if (consumer.kind === 'video')
		// 	// 	{
		// 	// 		const index = spotlights.findIndex((each) => each.id === consumer.appData.peerId);

		// 	// 		if (index > -1)
		// 	// 		{
		// 	// 			await this._resumeConsumer(consumer);
		// 	// 		}
		// 	// 		else
		// 	// 		{
		// 	// 			await this._pauseConsumer(consumer);
		// 	// 			store.dispatch(
		// 	// 				roomActions.removeSelectedPeer(consumer.appData.peerId));
		// 	// 		}
		// 	// 	}
		// 	// }
		// }
		// catch (error)
		// {
		// 	logger.error('updateSpotlights() [error:"%o"]', error);
		// }
	}

	disconnectLocalHark()
	{
		logger.debug('disconnectLocalHark()');

		if (this._harkStream != null)
		{
			let [ track ] = this._harkStream.getAudioTracks();

			track.stop();
			track = null;

			this._harkStream = null;
		}

		if (this._hark != null)
			this._hark.stop();
	}

	// connectLocalHark(track)
	// {

	// 	logger.debug('connectLocalHark() [track:"%o"]', track);

	// 	this._harkStream = new MediaStream();

	// 	const newTrack = track?.clone();

	// 	this._harkStream.addTrack(newTrack);

	// 	newTrack.enabled = true;

	// 	this._hark = hark(this._harkStream,
	// 		{
	// 			play      : false,
	// 			interval  : 10,
	// 			threshold : store.getState().settings.noiseThreshold,
	// 			history   : 100
	// 		});

	// 	this._hark.lastVolume = -100;

	// 	this._hark.on('volume_change', (volume) =>
	// 	{

	// 		console.log('newTracknewTracknewTracknewTrack=',newTrack);
	// 		// if(this._micProducer.paused){
	// 		// 	newTrack.enabled = false;
	// 		// 	return
	// 		// }

	// 		console.log('this._micProducer.pausedthis._micProducer.paused', this._micProducer.paused);

	// 		volume = Math.round(volume);

	// 		// Update only if there is a bigger diff
	// 		if (this._micProducer && Math.abs(volume - this._hark.lastVolume) > 0.5)
	// 		{
	// 			// Decay calculation: keep in mind that volume range is -100 ... 0 (dB)
	// 			// This makes decay volume fast if difference to last saved value is big
	// 			// and slow for small changes. This prevents flickering volume indicator
	// 			// at low levels
	// 			if (volume < this._hark.lastVolume)
	// 			{
	// 				volume = Math.round(
	// 					this._hark.lastVolume -
	// 					Math.pow(
	// 						(volume - this._hark.lastVolume) /
	// 						(100 + this._hark.lastVolume)
	// 						, 2
	// 					) * 10);
	// 			}

	// 			this._hark.lastVolume = volume;

	// 			store.dispatch(peerVolumeActions.setPeerVolume(this._peerId, volume));

	// 		}
	// 		const mediaParams = store.getState().settings.mediaPerms;

	// 		if (mediaParams?.audio && Math.abs(volume - this._hark.lastVolume) > 0.5)
	// 		{
	// 			if (volume < this._hark.lastVolume)
	// 			{
	// 				volume = Math.round(
	// 					this._hark.lastVolume -
	// 					Math.pow(
	// 						(volume - this._hark.lastVolume) /
	// 						(100 + this._hark.lastVolume)
	// 						, 2
	// 					) * 10);
	// 			}

	// 			this._hark.lastVolume = volume;
	// 			store.dispatch(settingsActions.setPeerFrequency(volume));
	// 		}
	// 	});

	// 	this._hark.on('speaking', () =>
	// 	{
	// 		store.dispatch(meActions.setIsSpeaking(true));

	// 		if (
	// 			(store.getState().settings.voiceActivatedUnmute ||
	// 				store.getState().me.isAutoMuted) &&
	// 			this._micProducer &&
	// 			this._micProducer.paused
	// 		)
	// 			this._micProducer.resume();

	// 		store.dispatch(meActions.setAutoMuted(false)); // sanity action
	// 	});

	// 	this._hark.on('stopped_speaking', () =>
	// 	{
	// 		store.dispatch(meActions.setIsSpeaking(false));

	// 		if (
	// 			store.getState().settings.voiceActivatedUnmute &&
	// 			this._micProducer &&
	// 			!this._micProducer.paused
	// 		)
	// 		{
	// 			this._micProducer.pause();

	// 			store.dispatch(meActions.setAutoMuted(true));
	// 		}

	// 		this._hark.off('volume_change');
	// 	});
	// }

	connectLocalHark(track)
	{

		try
		{

			logger.debug('connectLocalHark() [track:"%o"]', track);

			this._harkStream = new MediaStream();
			const newTrack = track?.clone();

			this._harkStream.addTrack(newTrack);
			newTrack.enabled = true;

			// Initialize hark with the media stream
			this._hark = hark(this._harkStream, {
				play      : false,
				interval  : 10,
				threshold : store.getState().settings.noiseThreshold,
				history   : 100
			});

			this._hark.lastVolume = -100;

			this.attachHarkListeners();

		}
		catch (err)
		{
			console.log('error=======', err);
		}
	}

	// Handle stopped speaking event
	handleStoppedSpeaking()
	{

		store.dispatch(meActions.setIsSpeaking(false));

		if (store.getState().settings.voiceActivatedUnmute &&
			this._micProducer &&
			!this._micProducer.paused)
		{
			this._micProducer.pause();
			store.dispatch(meActions.setAutoMuted(true));
		}
	}

	// Handle speaking event
	handleSpeaking()
	{
		store.dispatch(meActions.setIsSpeaking(true));

		// Only lifts a voice-activation pause; resuming here never reaches the SFU, and it must not
		// undo a real mute.
		if ((store.getState().settings.voiceActivatedUnmute ||
			store.getState().me.isAutoMuted) &&
			!store.getState().settings.audioMuted &&
			this._micProducer &&
			this._micProducer.paused)
		{
			this._micProducer.resume();
		}

		store.dispatch(meActions.setAutoMuted(false)); // Sanity action
	}

    handleVolumeChange = throttle((volume) =>
    {
    	// Skip if the mic is muted

    	volume = Math.round(volume);

    	// Update only if there is a significant change in volume
    	if (this._micProducer && Math.abs(volume - this._hark.lastVolume) > 0.5)
    	{
    		if (volume < this._hark.lastVolume)
    		{
    			volume = Math.round(
    				this._hark.lastVolume -
					Math.pow((volume - this._hark.lastVolume) / (100 + this._hark.lastVolume), 2) * 10
    			);
    		}

    		// Only update if the difference is significant
    		if (Math.abs(volume - this._hark.lastVolume) > 0.5)
    		{
    			this._hark.lastVolume = volume;
    			store.dispatch(peerVolumeActions.setPeerVolume(this._peerId, volume));
    		}
    	}
    }, 100); // Adjust throttle interval as needed

    // Function to attach hark listeners
    attachHarkListeners()
    {
    	if (!this._hark)
    		return;

    	// Registering again would stack duplicate handlers.
    	this.detachHarkListeners();

    	this._hark.on('volume_change', this.handleVolumeChange);
    	this._hark.on('speaking', this.handleSpeaking);
    	this._hark.on('stopped_speaking', this.handleStoppedSpeaking);
    }

    // Function to detach hark listeners
    detachHarkListeners()
    {
    	if (!this._hark)
    		return;

    	this._hark.off('volume_change');
    	this._hark.off('speaking');
    	this._hark.off('stopped_speaking');
    }

    async updateMeetDetails(meetObj)
    {
    	// console.log('meee', meetObj);
    	if (!meetObj)
    		return;

    	if (!this._roomTemplate)
    		this._roomTemplate = {};

    	// Merge rather than replace so a partial payload can't drop existing keys.
    	this._roomTemplate.meetingDetails = {
    		...this._roomTemplate.meetingDetails,
    		...meetObj
    	};
    }

    // Guarded setter for _roomTemplate: never let a missing/partial server
    // payload wipe a good template (see lockRoom / updateRoomtemptData paths).
    _applyRoomTemplate(next, source)
    {
    	if (!next)
    	{
    		logger.warn('_applyRoomTemplate() ignored empty template [source:"%s"]', source);

    		return;
    	}

    	// If the incoming template dropped meetingDetails but we already have it,
    	// preserve it instead of overwriting with a partial object.
    	if (!next.meetingDetails && this._roomTemplate?.meetingDetails)
    	{
    		next = { ...next, meetingDetails: this._roomTemplate.meetingDetails };
    	}

    	this._roomTemplate = next;
    }

    async changeAudioOutputDevice(deviceId)
    {
    	logger.debug('changeAudioOutputDevice() [deviceId:"%s"]', deviceId);

    	store.dispatch(
    		meActions.setAudioOutputInProgress(true));

    	try
    	{

    		const device = this._audioOutputDevices[deviceId];

    		if (!device)
    			throw new Error('Selected audio output device no longer available');

    		store.dispatch(settingsActions.setSelectedAudioOutputDevice(deviceId));

    		await this._updateAudioOutputDevices();
    	}
    	catch (error)
    	{
    		logger.error('changeAudioOutputDevice() [error:"%o"]', error);
    	}

    	store.dispatch(
    		meActions.setAudioOutputInProgress(false));
    }

    // Resolves { stream, audioContext }. The AudioContext stays open while the stream is in use,
    // so the caller must close it when the mic is retired (null when falling back to the input).
    async startRNNoise(inputStream)
    {
    	const context = new AudioContext({ sampleRate: 44100 });

    	return new Promise((resolve, reject) =>
    	{
    		const destination = context.createMediaStreamDestination();

    		console.log('window-=================================', window.RNNoiseNode, window);

    		if (!window.RNNoiseNode)
    		{
    			console.error('RNNoiseNode is not initialized.');
    			context.close();

    			return resolve({ stream: inputStream, audioContext: null }); // Resolve with the input stream as fallback
    		}

    		window.RNNoiseNode
    			.register(context)
    			.then(() =>
    			{
    				const source = context.createMediaStreamSource(inputStream);
    				const rnnoise = new window.RNNoiseNode(context);

    				rnnoise.connect(destination);
    				source.connect(rnnoise);

    				console.log('destinationdestination', destination);
    				resolve({ stream: destination.stream, audioContext: context }); // Resolve with the processed stream
    			})
    			.catch((e) =>
    			{
    				console.error('Error in RNNoiseNode setup:', e);
    				context.close();
    				resolve({ stream: inputStream, audioContext: null }); // Resolve with the input stream as fallback
    			});
    	});
    }

    // Only Firefox supports applyConstraints to audio tracks
    // See:
    // https://bugs.chromium.org/p/chromium/issues/detail?id=796964
    async updateMic({
    	start = false,
    	restart = true,
    	newDeviceId = null,
    	muted = null
    } = {})
    {
    	logger.debug(
    		'updateMic() [start:"%s", restart:"%s", newDeviceId:"%s", muted:"%s"]',
    		start,
    		restart,
    		newDeviceId,
    		muted
    	);

    	// Claimed before the first await. It used to be set only after _getAudioDeviceId(), so two
    	// overlapping calls could both pass it and each produce a mic, leaving one untracked and live.
    	if (this._micInProgress)
    		return;

    	this._micInProgress = true;

    	const stateSeq = this._micStateSeq;
    	let track;
    	let capture = null;

    	try
    	{
			this.connectToTranscriptionSocket();

    		if (!this._mediasoupDevice.canProduce('audio'))
    			throw new Error('cannot produce audio');

    		if (newDeviceId && !restart)
    			throw new Error('changing device requires restart');

    		if (newDeviceId)
    			store.dispatch(settingsActions.setSelectedAudioDevice(newDeviceId));

    		store.dispatch(meActions.setAudioInProgress(true));

    		const deviceId = await this._getAudioDeviceId();
    		const device = this._audioDevices[deviceId];

    		console.log('this._sipAudioStream', this._sipAudioStream);

    		if (!device && !this._sipAudioStream)
    			throw new Error('no audio devices');

    		const {
    			autoGainControl,
    			echoCancellation,
    			noiseSuppression,
    			sampleRate,
    			channelCount,
    			sampleSize,
    			opusStereo,
    			opusDtx,
    			opusFec,
    			opusPtime,
    			opusMaxPlaybackRate
    		} = store.getState().settings;

    		if (((restart && this._micProducer) || start) && !this._sipAudioStream)
    		{
				this.disconnectTranscriptionSocket();

    			this.disconnectLocalHark();

    			// An explicit `muted` wins. Otherwise a restart keeps the state the user sees (not
    			// producer.paused, which voice-activated unmute toggles) and a fresh start is an unmute.
    			let wantMuted = typeof muted === 'boolean' ?
    				muted : Boolean(this._micProducer) && store.getState().settings.audioMuted;

    			if (store.getState().room.joinDailogStreams)
    			{
    				store.getState().room.joinDailogStreams.getTracks().forEach((t) =>
    				{
    					t.stop();

    				});

    				store.dispatch(roomActions.setJoinDailogStreams(null));
    			}
    			if (this._micProducer || this._micProducers.size > 0)
    			{
    				await this.disableMic();
    			}

    			const ua = navigator.userAgent;
    			const browser = bowser.getParser(ua);

				let normalStream

				try{
					normalStream = await navigator.mediaDevices.getUserMedia(
						{
							audio : {
								deviceId   : { exact: deviceId },
								sampleRate : (browser.satisfies({ safari: '>=0' })) ? undefined : sampleRate,
								channelCount,
								autoGainControl,
								echoCancellation,
								noiseSuppression,
								sampleSize : (browser.satisfies({ safari: '>=0' })) ? undefined : sampleSize
							}
				
							// audio : true
						}
					);
				
				}catch(e){
					console.log('Failed to get exact device, trying with ideal constraint:', e);
					// Fallback to ideal constraint if exact fails
					try {
						normalStream = await navigator.mediaDevices.getUserMedia(
							{
								audio : {
									deviceId   : { ideal: deviceId },
									sampleRate : (browser.satisfies({ safari: '>=0' })) ? undefined : sampleRate,
									channelCount,
									autoGainControl,
									echoCancellation,
									noiseSuppression,
									sampleSize : (browser.satisfies({ safari: '>=0' })) ? undefined : sampleSize
								}
							}
						);
					} catch (fallbackError) {
						console.log('Fallback also failed, using default audio device:', fallbackError);
						// Final fallback to default audio device
						normalStream = await navigator.mediaDevices.getUserMedia(
							{
								audio : {
									sampleRate : (browser.satisfies({ safari: '>=0' })) ? undefined : sampleRate,
									channelCount,
									autoGainControl,
									echoCancellation,
									noiseSuppression,
									sampleSize : (browser.satisfies({ safari: '>=0' })) ? undefined : sampleSize
								}
							}
						);
					}
				}
			const [ tracknnormal ] = normalStream.getAudioTracks();


    			const { deviceId: trackDeviceId } = tracknnormal.getSettings();

    			store.dispatch(settingsActions.setSelectedAudioDevice(trackDeviceId));

    			let micProducer = null;

    			// Safari fix: Listen for trackended on the ORIGINAL track before RNNoise processing
    			// When using Web Audio API (RNNoise), the processed track doesn't fire trackended
    			// when the physical device disconnects - only the original track does
    			const onRawTrackEnded = async () =>
    			{
    				logger.debug('Original audio track ended event | device disconnected (pre-RNNoise track)');

    				// Only the producer this track feeds may react. Checking for any producer let every
    				// older track of the same device tear down the current mic at once, racing into duplicates.
    				if (!micProducer || this._micProducer !== micProducer)
    				{
    					logger.debug('Original track ended | producer already replaced, ignoring event');
    					return;
    				}

    				// Save the mute state before disabling
    				const wasMicMuted = this._micDesiredMuted;

    				// Disable the existing mic producer
    				await this.disableMic();

    				// Attempt to switch to next available device
    				const switchSuccess = await switchToNextAudioDevice(this, wasMicMuted, 'trackended-original', store, intl);

    				// If switch failed or no devices available, show error notification
    				if (!switchSuccess)
    				{
    					store.dispatch(requestActions.notify(
    						{
    							type : 'error',
    							text : intl.formatMessage({
    								id             : 'devices.microphoneDisconnected',
    								defaultMessage : 'Microphone disconnected'
    							})
    						}));
    					if (this._deviceInfo.platform === 'desktop' && this._deviceInfo.name === 'electron')
    					{
    						this.sendRequest('displayErrorLogs', { type: 'audio', error: 'Microphone disconnected' });
    					}
    				}
    			};

    			tracknnormal.addEventListener('ended', onRawTrackEnded);

    			capture = { rawStream: normalStream, audioContext: null, onRawTrackEnded };

    			const { stream, audioContext } = await this.startRNNoise(normalStream);

    			capture.audioContext = audioContext;

    			console.log('stream-===========================', stream);

    			([ track ] = stream.getAudioTracks());

    			track.onmute = () =>
    			{
    				console.log('sadskdaisdasid asid said asid asida sds');
    			};
    			// const { deviceId: trackDeviceId } = track.getSettings();

    			// store.dispatch(settingsActions.setSelectedAudioDevice(trackDeviceId));

    			const networkPriority =
					config.networkPriorities?.audio ?
						config.networkPriorities?.audio :
						DEFAULT_NETWORK_PRIORITIES.audio;

    			// A mute or unmute that came in while this ran decides the state.
    			if (stateSeq !== this._micStateSeq)
    				wantMuted = this._micDesiredMuted;

    			// Produce with the track already disabled when muted: mediasoup-client then starts the
    			// producer paused and the SFU is asked to as well, so no audio leaves before the mute.
    			track.enabled = !wantMuted;

    			micProducer = await this._sendTransport.produce(
    				{
    					track,
    					encodings :
							[
								{
									networkPriority
								}
							],
    					codecOptions :
						{
							opusStereo          : opusStereo,
							opusFec             : opusFec,
							opusDtx             : opusDtx,
							opusMaxPlaybackRate : opusMaxPlaybackRate,
							opusPtime           : opusPtime
						},
    					appData :
							{ source: 'mic', paused: wantMuted, micDevice: true }
    				});

    			this._micProducer = micProducer;
    			this._trackMicProducer(micProducer, capture);
    			capture = null;

    			store.dispatch(producerActions.addProducer(
    				{
    					id            : micProducer.id,
    					source        : 'mic',
    					paused        : micProducer.paused,
    					track         : micProducer.track,
    					rtpParameters : micProducer.rtpParameters,
    					codec         : micProducer.rtpParameters.codecs[0].mimeType.split('/')[1]
    				}));
    			store.dispatch(settingsActions.setMediaPerms({
    				...store.getState().settings.mediaPerms,
    				audio : true
    			}));

    			if ('mediaSession' in navigator && isInPIP())
    			{
    				navigator.mediaSession.setMicrophoneActive(true);
    			}

    			// Note: Device disconnection is handled by the 'ended' event on the original track (tracknnormal)
    			// which fires reliably across all browsers including Safari

				this.connectToTranscriptionSocket();
				this.connectLocalHark(track);

    			if (stateSeq !== this._micStateSeq)
    				wantMuted = this._micDesiredMuted;

    			// Not awaited: the media is already in the right state locally, and waiting on the SFU
    			// would hold _micInProgress (dropping device changes) for as long as the request retries.
    			if (wantMuted)
    				this.muteMic();
    			else if (micProducer.paused)
    				this.unmuteMic();
    			else
    			{
    				// Produced live, so say so now. Leaving this to a trailing unmuteMic() kept a stale
    				// muted icon over a live mic whenever that request was slow or failed.
    				this._micDesiredMuted = false;
    				this._setMicMutedState(micProducer, false);
    			}
    		}
    		else if (this._sipAudioStream)
    		{
    			console.log('sipaudio', this._sipAudioStream);
    			try
    			{
    				const networkPriority =
					config.networkPriorities?.audio ?
						config.networkPriorities?.audio :
						DEFAULT_NETWORK_PRIORITIES.audio;

    				const audioStream = new MediaStream();

    				audioStream.addTrack(this._sipAudioStream);

    				console.log('stream.getAudioTracks', this._sipAudioStream);

    				([ track ] = audioStream.getAudioTracks());

    				// console.log('new<stream', track);

    				// Overwriting _micProducer without closing it left the previous SIP mic sending.
    				if (this._micProducer || this._micProducers.size > 0)
    					await this.disableMic();

    				this._micProducer = await this._sendTransport.produce(
    					{
    						track,
    						encodings :
						[
							{
								networkPriority
							}
						],
    						codecOptions :
						{
							opusStereo          : opusStereo,
							opusFec             : opusFec,
							opusDtx             : opusDtx,
							opusMaxPlaybackRate : opusMaxPlaybackRate,
							opusPtime           : opusPtime
						},
    						appData :
						{ source: 'mic', micDevice: true }
    					});

    				this._trackMicProducer(this._micProducer);
    			}
    			catch (e)
    			{
    				console.log('_sipAudioStream audio error', e);
    			}
    			console.log('_sipAudioStream audio', this._micProducer);
    		}
    		else if (this._micProducer)
    		{
    			({ track } = this._micProducer);

    			const ua = navigator.userAgent;
    			const browser = bowser.getParser(ua);

    			await track.applyConstraints(
    				{
    					sampleRate : (browser.satisfies({ safari: '>=0' })) ? undefined : sampleRate,
    					channelCount,
    					autoGainControl,
    					echoCancellation,
    					noiseSuppression,
    					sampleSize : (browser.satisfies({ safari: '>=0' })) ? undefined : sampleSize
    				}
    			);

    			if (this._harkStream != null)
    			{
    				const [ harkTrack ] = this._harkStream.getAudioTracks();

    				harkTrack && await harkTrack.applyConstraints(
    					{
    						sampleRate : (browser.satisfies({ safari: '>=0' })) ? undefined : sampleRate,
    						channelCount,
    						autoGainControl,
    						echoCancellation,
    						noiseSuppression,
    						sampleSize : (browser.satisfies({ safari: '>=0' })) ? undefined : sampleSize
    					}
    				);
    			}
    		}

    		// TODO update recorder inputs
    		/*
			if (recorder != null)
			{
				recorder.addTrack(new MediaStream([ this._micProducer.track ]));
			}
			*/
    		await this._updateAudioDevices();
    	}
    	catch (error)
    	{

    		logger.error('updateMic() [error:"%o"]', error);

    		const object = {
    			type  : 'mic',
    			error : 'Unable to unmute mic'
    		};

    		if ('mediaSession' in navigator && isInPIP())
    		{
    			navigator.mediaSession.setMicrophoneActive(false);
    		}

    		window.parent.postMessage(JSON.stringify({ cmd: 'eventError', value: object }), '*');

    		store.dispatch(requestActions.notify(
    			{
    				type : 'error',
    				text : intl.formatMessage({
    					id             : 'devices.microphoneError',
    					defaultMessage : 'An error occurred while accessing your microphone'
    				})
    			}));

    		if (track)
    			track.stop();

    		if (capture)
    			this._releaseMicCapture(capture);

    		if (error.name === 'NotAllowedError')
    		{
    			// Do the necessary UI
    			// store.dispatch(roomActions.setInAudioAccesble(false));
    			store.dispatch(roomActions.setPermissionRelaodPopUp(true));

    		}

    	}
    	finally
    	{
    		this._micInProgress = false;
    	}

    	store.dispatch(meActions.setAudioInProgress(false));
    }

    async updateWebcam({
    	init = false,
    	start = false,
    	restart = false,
    	newDeviceId = null,
    	newResolution = null,
    	newFrameRate = null
    } = {})
    {
    	logger.debug(
    		'updateWebcam() [start:"%s", restart:"%s", newDeviceId:"%s", newResolution:"%s", newFrameRate:"%s"]',
    		start,
    		restart,
    		newDeviceId,
    		newResolution,
    		newFrameRate
    	);

    	let track;

    	try
    	{
    		if (this._meetingType === 'presence' && store.getState().room?.callType === 'audioCall')
    		{
    			return;
    		}

    		if (!this._mediasoupDevice.canProduce('video'))
    			throw new Error('cannot produce video');

    		if (newDeviceId && !restart)
    			throw new Error('changing device requires restart');

    		if (newDeviceId)
    		{
    			store.dispatch(settingsActions.setVideoResolution('medium'));
    			store.dispatch(settingsActions.setSelectedWebcamDevice(newDeviceId));
    		}
    		if (newResolution)
    			store.dispatch(settingsActions.setVideoResolution(newResolution));

    		if (newFrameRate)
    			store.dispatch(settingsActions.setVideoFrameRate(newFrameRate));

    		const { videoMuted } = store.getState().settings;

    		if (init && (this._meetingType !== 'presence' && videoMuted))
    			return;
    		else
    			store.dispatch(settingsActions.setVideoMuted(false));

    		store.dispatch(meActions.setWebcamInProgress(true));

    		const deviceId = await this._getWebcamDeviceId();

    		const device = this._webcams[deviceId];

    		if (!device && !this._sipVideoStream)
    			throw new Error('no webcam devices');

    		const settings = store.getState().settings;
    		const {
    			aspectRatio,
    			frameRate
    		} = settings;
    		const resolution = getCaptureResolution(settings);

    		console.log('this._sipVideoStream', this._sipVideoStream);

    		if (((restart && this._webcamProducer) || start) && !this._sipVideoStream)
    		{
    			if (this._webcamProducer)
    				await this.disableWebcam();

    			try
    			{

					let supports;

    				let isCameraControl = false;

    				let panVal;

    				let tiltVal;

    				let zoomVal;

    				let widthVal;

    				let heightVal;

    				let trackDeviceId;

    				let currentPan;

    				let currentTilt;

    				let currentZoom;
					
					let stream;
    				try
    				{
    					stream = await navigator.mediaDevices.getUserMedia(
    						{
    							video :
								{
    									deviceId : { exact: deviceId },
    									...getVideoConstrains(resolution, aspectRatio),
    									frameRate
    								}
    						});
    				}
    				catch (exactError)
    				{   
						console.log('exactError', exactError);
    					stream = await navigator.mediaDevices.getUserMedia(
    						{
    							video :
								{
    									deviceId : { ideal: deviceId },
    									...getVideoConstrains(resolution, aspectRatio),
    									frameRate
    								}
    						});
    				}

    				supports = navigator.mediaDevices.getSupportedConstraints();

    				([ track ] = stream.getVideoTracks());

					const { pan, tilt, zoom } = track.getCapabilities();
					if (supports.pan && supports.tilt && supports.zoom && pan && tilt && zoom)
    					{
    						console.log('cameraControl....', supports);
    						isCameraControl = true;
    					}

    				const { zoom: previousZoomVal } = track.getSettings();
    				// eslint-disable-next-line no-shadow
    				// const [ track ] = await stream.getVideoTracks();

    				// const { deviceId: trackDeviceId, width, height, pan: currentPan, tilt: currentTilt, zoom: currentZoom } = track.getSettings();

    				if (supports.pan && supports.tilt && supports.zoom && previousZoomVal && previousZoomVal > 1)
    				{

    					if (track.getCapabilities)
    					{
    						// const { zoom } = track.getCapabilities();

    						const constraints = {
    							...getVideoConstrains(resolution, aspectRatio),
    							frameRate,
    							advanced : [ { zoom: zoom.min } ]
    						};

    						await track?.applyConstraints(constraints).then((res) =>
    						{
    							console.log('setting zoom value to 1=======', res);
    						});
    					}
    				}

    				// eslint-disable-next-line no-shadow
    				// const [ track ] = await stream.getVideoTracks();

    				const { deviceId: id, width, height, pan: currentPanValue, tilt: currentTiltValue, zoom: currentZoomValue } = track.getSettings();

					trackDeviceId=id;
    					widthVal=width;
    					heightVal=height;
    					currentPan=currentPanValue;
    					currentTilt=currentTiltValue;
    					currentZoom=currentZoomValue;

    				if (track.getCapabilities)
    				{
    					// const { pan, tilt, zoom } = track.getCapabilities();

    					console.log('getCapabilities', track.getCapabilities());

    					panVal = pan;
    					tiltVal = tilt;
    					zoomVal = zoom;

    					// Proceed with using capabilities
    				}

    				logger.debug('getUserMedia track settings:', track.getSettings());

    				if ((panVal || tiltVal || zoomVal) && this._deviceInfo.platform === 'desktop' && this._deviceInfo.name === 'electron')
    				{
    					await this.sendRequest('setptzOptions', { pan: panVal, tilt: tiltVal, zoom: zoomVal, currentPan, currentTilt, currentZoom });
    				}
    				store.dispatch(settingsActions.setSelectedWebcamDevice(trackDeviceId));

    				const networkPriority =
						config.networkPriorities?.mainVideo ?
							config.networkPriorities?.mainVideo :
							DEFAULT_NETWORK_PRIORITIES.mainVideo;

    				const lowBandwidthMode = store.getState().mediaSession.lowBandwidthMode;

    				if (this._useSimulcast && !lowBandwidthMode)
    				{
    					const encodings = this._getEncodings(width, height);
    					const resolutionScalings = getResolutionScalings(encodings);

    					/**
						 * TODO:
						 * I receive DOMException:
						 * Failed to execute 'addTransceiver' on 'RTCPeerConnection':
						 * Attempted to set an unimplemented parameter of RtpParameters.
						encodings.forEach((encoding) =>
						{
							encoding.networkPriority=networkPriority;
						});
						*/
    					encodings[0].networkPriority = networkPriority;

    					this._webcamProducer = await this._sendTransport.produce(
    						{
    							track,
    							encodings,
    							codecOptions :
								{
    								videoGoogleStartBitrate : 1000
    							},
    							appData :
								{
    									source : 'webcam',
    									peerName          : this._displayName,
    									panRange          : panVal,
    									tiltRange         : tiltVal,
    									zoomRange         : zoomVal,
    									pan               : currentPan,
    									tilt              : currentTilt,
    									zoom              : currentZoom,
    									width             : widthVal,
    								    height            : heightVal,
    									resolutionScalings,
    									isCameraControl
    								}
    						});
    				}
    				else
    				{
    					this._webcamProducer = await this._sendTransport.produce({
    						track,
    						encodings : [
    							lowBandwidthMode ?
    								{ networkPriority, maxBitrate: 300000 } :
    								{ networkPriority }
    						],
    						...(lowBandwidthMode ?
    							{
    								codecOptions :
    								{
    									videoGoogleStartBitrate : 150
    								}
    							} :
    							{}),
    						appData   :
							{
								source : 'webcam',
								peerName          : this._displayName,
								panRange          : panVal,
								tiltRange         : tiltVal,
								zoomRange         : zoomVal,
								pan               : currentPan,
								tilt              : currentTilt,
								zoom              : currentZoom,
								width             : widthVal,
								height            : heightVal,
								isCameraControl
							}
    					});
    				}

    				store.dispatch(producerActions.addProducer(
    					{
    						id            : this._webcamProducer.id,
    						source        : 'webcam',
    						paused        : this._webcamProducer.paused,
    						track         : this._webcamProducer.track,
    						rtpParameters : this._webcamProducer.rtpParameters,
							panRange          : panVal,
    						tiltRange         : tiltVal,
    						zoomRange         : zoomVal,
    						pan               : currentPan,
    						tilt              : currentTilt,
    						zoom              : currentZoom,
    						width             : widthVal,
    						height            : heightVal,
    						codec         : this._webcamProducer.rtpParameters.codecs[0].mimeType.split('/')[1],
							isCameraControl
    					}));

    				store.dispatch(settingsActions.setMediaPerms({
    					...store.getState().settings.mediaPerms,
    					video : true
    				}));

    				if ('mediaSession' in navigator && isInPIP())
    				{
    					navigator.mediaSession.setCameraActive(true);

    				}
    				this._webcamProducer.on('transportclose', () =>
    				{
    					this._webcamProducer = null;
    				});

    				this._webcamProducer.on('trackended', () =>
    				{
    					store.dispatch(requestActions.notify(
    						{
    							type : 'error',
    							text : intl.formatMessage({
    								id             : 'devices.cameraDisconnected',
    								defaultMessage : 'Camera disconnected'
    							})
    						}));
    					if (this._deviceInfo.platform === 'desktop' && this._deviceInfo.name === 'electron')
    					{
    						this.sendRequest('displayErrorLogs', { type: 'video', error: 'Camera disconnected' });
    					}

    					this.disableWebcam();
    				});

    				store.dispatch(settingsActions.setVideoMuted(false));
    			}
    			catch (err)
    			{
    				console.log('error=========================', err);
    				if (err.name === 'NotAllowedError')
    				{
    					// Do the necessary UI
    					store.dispatch(roomActions.setPermissionRelaodPopUp(true));
    				}
    				store.dispatch(requestActions.notify(
    					{
    						type : 'error',
    						text : intl.formatMessage({
    							id             : 'devices.cameraError',
    							defaultMessage : 'Your camera is either in use by another application or cannot be accessed.'
    						})
    					}));

    				if (this._deviceInfo.platform === 'desktop' && this._deviceInfo.name === 'electron')
    				{
    					this.sendRequest('displayErrorLogs', { type: 'video', error: 'Your camera is either in use by another application or cannot be accessed.' });
    				}

    			}
    		}
    		else if (this._sipVideoStream)
    		{
    			try
    			{

    				const networkPriority =
					config.networkPriorities?.mainVideo ?
						config.networkPriorities?.mainVideo :
						DEFAULT_NETWORK_PRIORITIES.mainVideo;

    				const { deviceId: trackDeviceId, width, height } = this._sipVideoStream.getSettings();

    				logger.debug('trackDeviceId', trackDeviceId);

    				console.log('SIP_STREAM', this._sipVideoStream);

    				const newStream = new MediaStream();

    				newStream.addTrack(this._sipVideoStream);

    				([ track ] = newStream.getVideoTracks());

    				console.log('newVideostream', track);

    				this._webcamProducer = await this._sendTransport.produce(
    					{
    						track,
    						encodings    : [ { networkPriority } ],
    						codecOptions :
						{
							videoGoogleStartBitrate : 1000
						},
    						appData :
						{
							source : 'webcam',
							width,
							height
							// resolutionScalings
						}
    					});
    			}
    			catch (e)
    			{
    				console.log('_sipVideoStream errorrrrr', e);
    			}
    			console.log('this._sipVideoStream=====', this._webcamProducer);
    		}
    		else if (this._webcamProducer)
    		{
    			({ track } = this._webcamProducer);

    			await track.applyConstraints(
    				{
    					...getVideoConstrains(resolution, aspectRatio),
    					frameRate
    				}
    			);

    			// Also change resolution of extra video producers 
    			// need to change this also when resolution giving for particular streams
    			for (const producer of this._extraVideoProducers.values())
    			{
    				({ track } = producer);

    				await track.applyConstraints(
    					{
    						...getVideoConstrains(resolution, aspectRatio),
    						frameRate
    					}
    				);
    			}
    		}

    		await this._updateWebcams();

    		if (store.getState().room.virtualBg || store.getState().room.virtualBgEffect)
    		{
    			// this._chromaStream.doLoad(stream, store.getState().room.virtualBg, store.getState().room.virtualBgEffect);
    			this.createBackground(store.getState().room.virtualBg, store.getState().room.virtualBgEffect);
    		}
    	}
    	catch (error)
    	{
    		logger.error('updateWebcam() [error:"%o"]', error);

    		const object = {
    			type  : 'camera',
    			error : 'Unable to update camera'
    		};

    		if ('mediaSession' in navigator && isInPIP())
    		{
    			navigator.mediaSession.setCameraActive(false);
    		}
    		window.parent.postMessage(JSON.stringify({ cmd: 'eventError', value: object }), '*');

    		store.dispatch(requestActions.notify(
    			{
    				type : 'error',
    				text : intl.formatMessage({
    					id             : 'devices.cameraError',
    					defaultMessage : 'Your camera is either in use by another application or cannot be accessed.'
    				})
    			}));

    		if (track)
    			track.stop();

    		if (error.name === 'NotAllowedError')
    		{
    			// Do the necessary UI
    			store.dispatch(roomActions.setPermissionRelaodPopUp(true));
    		}

    		if (this._deviceInfo.platform === 'desktop' && this._deviceInfo.name === 'electron')
    		{
    			this.sendRequest('displayErrorLogs', { type: 'video', error: 'Your camera is either in use by another application or cannot be accessed.' });
    		}

    	}

    	store.dispatch(
    		meActions.setWebcamInProgress(false));
    }

    // getLayoutData(layoutName)
    // {

    // 	return new Promise((resolve, reject) => {
    // 		this.sendRequest('requestLayoutData', { layoutName }).then(res => {
    // 			if(layoutName === 'screenshareview') {
    // 				this._layoutDataSC = res.screensharedata;
    // 				if(res.screensharedata.length > 0){
    // 					this.addSelectedPeer(this._layoutDataSC[0]);
    // 					store.dispatch(
    // 						roomActions.setActiveScreenId(this._layoutDataSC[0], this._layoutDataSC));
    // 				}
    // 			}
    // 			//
    // 			resolve(res);
    // 		}).catch(err => {
    // 			// console.log('Hello Error', err)
    // 			reject(err);
    // 		});
    // 	});

    // 	// if(layoutName === 'whiteboardview'){
    // 	// 	return this._layoutDataWB;
    // 	// }else if(layoutName === 'screenshareview') {
    // 	// 	this.addSelectedPeer(this._layoutDataSC);
    // 	// 	return this._layoutDataSC;
    // 	// }
    // }

    setNextScreen(screenid)
    {
    	this.addSelectedPeer(screenid);
    	store.dispatch(
    		roomActions.setActiveScreenId(screenid, this._layoutDataSC));
    }

    addSelectedPeer(peerId)
    {
    	logger.debug('addSelectedPeer() [peerId:"%s"]', peerId);

    	if (store.getState().room.allScreens.includes(peerId))
    	{
    		store.dispatch(
    			roomActions.setActiveScreenId(peerId, this._layoutDataSC));
    	}

    	this._spotlights.addPeerToSelectedSpotlights(peerId);

    	if (store.getState().room.selectedPeers.indexOf(peerId) === -1)
    	{
    		store.dispatch(
    			roomActions.addSelectedPeer(peerId));
    	}
    }

    setSelectedPeer(peerId)
    {
    	logger.debug('setSelectedPeer() [peerId:"%s"]', peerId);

    	this.clearSelectedPeers();
    	this.addSelectedPeer(peerId);
    }

    removeSelectedPeer(peerId)
    {
    	logger.debug('removeSelectedPeer() [peerId:"%s"]', peerId);

    	this._spotlights.removePeerFromSelectedSpotlights(peerId);

    	store.dispatch(
    		roomActions.removeSelectedPeer(peerId));
    }

    clearSelectedPeers()
    {
    	logger.debug('clearSelectedPeers()');

    	this._spotlights.clearPeersFromSelectedSpotlights();

    	store.dispatch(
    		roomActions.clearSelectedPeers());
    }

    async promoteAllLobbyPeers()
    {
    	logger.debug('promoteAllLobbyPeers()');

    	store.dispatch(
    		roomActions.setLobbyPeersPromotionInProgress(true));

    	try
    	{
    		await this.sendRequest('promoteAllPeers');
    	}
    	catch (error)
    	{
    		logger.error('promoteAllLobbyPeers() [error:"%o"]', error);
    	}

    	store.dispatch(
    		roomActions.setLobbyPeersPromotionInProgress(false));
    }

    async promoteLobbyPeer(peerId)
    {
    	logger.debug('promoteLobbyPeer() [peerId:"%s"]', peerId);

    	store.dispatch(
    		lobbyPeerActions.setLobbyPeerPromotionInProgress(peerId, true));

    	try
    	{
    		await this.sendRequest('promotePeer', { peerId });
    	}
    	catch (error)
    	{
    		logger.error('promoteLobbyPeer() [error:"%o"]', error);
    	}

    	store.dispatch(
    		lobbyPeerActions.setLobbyPeerPromotionInProgress(peerId, false));
    }

    async sendSipCallRequest(callerId)
    {

    	logger.debug('sendSipCallRequest() [callerId:"%s"]', callerId);

    	try
    	{
    		await this.sendRequest('sipIncomingCallRequest', { callerId });
    	}
    	catch (error)
    	{
    		logger.error('sendSipCallRequest() [error:"%o"]', error);
    	}
    }

    async dialOutToSipEndpoint(data)
    {

    	logger.debug('dialOutToSipEndpoint() [userId:"%s"]', data);

    	try
    	{
    		await this.sendRequest('dialOutToSipEndpoint', data);
    	}
    	catch (error)
    	{
    		logger.error('dialOutToSipEndpoint() [error:"%o"]', error);
    	}

    }

    async sendAnnotationsRequst(isAnnotationStart)
    {

    	try
    	{

    		console.log('handleShare', this._annotationsSocket);
    		if (isAnnotationStart)
    		{
    			this.connectToAnnotationsSocket();

    			store.dispatch(requestActions.notify(
    				{
    					text : intl.formatMessage({
    						id             : 'room.startAnnotation',
    						defaultMessage : 'Annotation has started.'
    					})
    				}));
    		}
    		else
    		{
    			store.dispatch(requestActions.notify(
    				{
    					text : intl.formatMessage({
    						id             : 'room.startAnnotation',
    						defaultMessage : 'Annotation has been stopped.'
    					})
    				}));
    			this._annotationsSocket.disconnect();
    		}
    		await this.sendRequest('isAnnotationStart', { isAnnotationStart });
    	}
    	catch (err)
    	{
    		console.log('error===================', err);
    	}

    }

    async sendTranscriptionStart(isTranscriptionStart)
    {

    	if (isTranscriptionStart)
    	{
			this.connectToTranscriptionSocket();

    		store.dispatch(requestActions.notify(
    			{
    				text : intl.formatMessage({
    					id             : 'room.startTranscription',
    					defaultMessage : 'Transcription has started.'
    				})
    			}));
    	}
    	else
    	{
    		store.dispatch(requestActions.notify(
    			{
    				text : intl.formatMessage({
    					id             : 'room.startTranscription',
    					defaultMessage : 'Transcription has been stopped.'
    				})
    			}));
    		store.dispatch(transcriptionactions.clearCCData());
    		store.dispatch(roomActions.setIsEnableCC(false));
    		this._transcriptionSocket.disconnect();
    	}
		this._roomTranscriptionStart=isTranscriptionStart;
		console.warn('transcriptionstarttestinglogs', this._roomTranscriptionStart);
    	await this.sendRequest('isTranscriptionStart', { isTranscriptionStart });
    	// await this.sendRequest('transcript', data);
    }

    // async base64ToPCM(base64String)
    // {
    // 	let pcmData = [];
    // 	// Decode the base64 string to binary data

    // 	const binaryString = base64String.toString('base64');
    // 	// const binaryString = atob(base64String);

    // 	// Create an array to store the PCM data

    // 	// Iterate through the binary data, reading two bytes at a time
    // 	for (let i = 0; i < binaryString.length; i += 2)
    // 	{
    // 		const byte1 = binaryString.charCodeAt(i);
    // 		const byte2 = binaryString.charCodeAt(i + 1);
    // 		const pcmValue = (byte2 << 8) | byte1; // Combine the bytes into a 16-bit PCM value

    // 		pcmData.push(pcmValue);
    // 	}

    // 	// return pcmData;

    // 	this.sendAudioBlob(pcmData);
    // }

    // async sendAudioBase64Toserver(data)
    // {

    // 	// // await this.sendRequest('transcript', data);
    // 	// console.log('sendAudioBlob__', data);
    // 	if (this._transcriptionSocket)
    // 	{
    // 		await this._transcriptionSocket.emit('send_audio_data', data);
    // 	}

    // 	// await this.sendRequest('transcript', data);

    // }

	async sendAudioBase64Toserver(blob) {
		// Add batching to reduce network calls
		if (!this._audioBlobQueue) {
			this._audioBlobQueue = [];
			this._audioBlobTimer = null;
		}
		
		this._audioBlobQueue.push(blob);
		
		// Batch audio blobs to reduce network overhead
		if (this._audioBlobTimer) {
			clearTimeout(this._audioBlobTimer);
		}
		
		this._audioBlobTimer = setTimeout(async () => {
			if (this._audioBlobQueue.length > 0) {
				const blobsToSend = this._audioBlobQueue.splice(0);
				
				// Send batched blobs
				await this._sendBatchedAudioBlobs(blobsToSend);
			}
		}, 200); // Batch every 200ms instead of immediate sending
	}
	
	// ADD this new method:
	async _sendBatchedAudioBlobs(blobs) {
		try {
			// Process blobs efficiently
			for (const blob of blobs) {
				if (this._transcriptionSocket && this._transcriptionSocket.connected) {
					await this._transcriptionSocket.emit('send_audio_data', blob);
				} else {
					console.warn('⚠️ Transcription socket not available or not connected');
				}
			}
		} catch (error) {
			console.error('❌ Batch audio processing error:', error);
		}
	}

    async sendTotalAudio(data)
    {

    	// await this.sendRequest('transcript', data);
    	console.log('storeAudioBlob__', data);
    	// if (this._transcriptionSocket)
    	// {
    	await this.sendRequest('setTranscriptData', data);
    	// await this._transcriptionSocket.emit('setTranscriptData', data);
    	// }
    }

    async removeLobbypeer(peerId)
    {
    	try
    	{
    		await this.sendRequest('removeLobbyPeer', { peerId });
    	}
    	catch (error)
    	{
    		logger.error('removeLobbyPeer() [error:"%o"]', error);
    	}
    }

    async denyAllLobbyPeers()
    {
    	try
    	{
    		await this.sendRequest('denyAllLobbyPeers');
    	}
    	catch (error)
    	{
    		logger.error('denyAllLobbyPeers() [error:"%o"]', error);
    	}
    }

    async clearChat()
    {
    	logger.debug('clearChat()');

    	store.dispatch(
    		roomActions.setClearChatInProgress(true));

    	try
    	{
    		await this.sendRequest('moderator:clearChat');

    		store.dispatch(chatActions.clearChat());

    		store.dispatch(fileActions.clearFiles());
    	}
    	catch (error)
    	{
    		logger.error('clearChat() [error:"%o"]', error);
    	}

    	store.dispatch(
    		roomActions.setClearChatInProgress(false));
    }

    /*
	async clearFileSharing()
	{
		logger.debug('clearFileSharing()');

		store.dispatch(
			roomActions.setClearFileSharingInProgress(true));

		try
		{
			await this.sendRequest('moderator:clearFileSharing');

			store.dispatch(fileActions.clearFiles());
		}
		catch (error)
		{
			logger.error('clearFileSharing() [error:"%o"]', error);
		}

		store.dispatch(
			roomActions.setClearFileSharingInProgress(false));
	}
	*/

    async hostAcceptedIncomingCall(callerId, peerId)
    {
    	logger.debug('hostAcceptedIncomingCall() [callerId:"%s", peerId:"%s"]', callerId, peerId);

    	try
    	{
    		await this.sendRequest('hostAcceptedIncomingCall', { callerId, peerId });
    	}
    	catch (error)
    	{
    		logger.error('hostAcceptedIncomingCall() [error:"%o"]', error);
    	}

    }

    async newSIPDialOut(data)
    {
    	logger.debug('newSIPDialOut() [callerId:"%s", peerId:"%s"]', data);

    	try
    	{
    		await this.sendRequest('newSIPDialOut', data);
    	}
    	catch (error)
    	{
    		logger.error('newSIPDialOut() [error:"%o"]', error);
    	}

    }

    async hostRejectedIncomingCall(callerId, peerId)
    {
    	logger.debug('hostRejectedIncomingCall() [callerId:"%s", peerId:"%s"]', callerId, peerId);

    	try
    	{
    		await this.sendRequest('hostRejectedIncomingCall', { callerId, peerId });
    	}
    	catch (error)
    	{
    		logger.error('hostRejectedIncomingCall() [error:"%o"]', error);
    	}
    }

    async handleSIPAutoAcceptCalls(value)
    {
    	logger.debug('handleSIPAutoAcceptCalls() [callerId:"%s", peerId:"%s"]');

    	try
    	{
    		await this.sendRequest('handleSIPAutoAcceptCalls', { value });
    	}
    	catch (error)
    	{
    		logger.error('handleSIPAutoAcceptCalls() [error:"%o"]', error);
    	}

    }

    async givePeerRole(peerId, roleId)
    {
    	logger.debug('givePeerRole() [peerId:"%s", roleId:"%s"]', peerId, roleId);

    	store.dispatch(
    		peerActions.setPeerModifyRolesInProgress(peerId, true));

    	try
    	{
    		await this.sendRequest('moderator:giveRole', { peerId, roleId });
    	}
    	catch (error)
    	{
    		logger.error('givePeerRole() [error:"%o"]', error);
    	}

    	store.dispatch(
    		peerActions.setPeerModifyRolesInProgress(peerId, false));
    }

    async hostDeniedRole(peerId)
    {
    	try
    	{
    		await this.sendRequest('hostDeniedPeerShareRole', { peerId: peerId });

    	}
    	catch (error)
    	{
    		logger.error('hostDeniedRole() [error:"%o"]', error);
    	}
    }

    async removePeerRole(peerId, roleId)
    {
    	logger.debug('removePeerRole() [peerId:"%s", roleId:"%s"]', peerId, roleId);

    	store.dispatch(
    		peerActions.setPeerModifyRolesInProgress(peerId, true));

    	try
    	{
    		await this.sendRequest('moderator:removeRole', { peerId, roleId });
    	}
    	catch (error)
    	{
    		logger.error('removePeerRole() [error:"%o"]', error);
    	}

    	store.dispatch(
    		peerActions.setPeerModifyRolesInProgress(peerId, false));
    }

    async kickPeer(peerId)
    {
    	logger.debug('kickPeer() [peerId:"%s"]', peerId);

    	store.dispatch(
    		peerActions.setPeerKickInProgress(peerId, true));

    	try
    	{
    		await this.sendRequest('moderator:kickPeer', { peerId });
    	}
    	catch (error)
    	{
    		logger.error('kickPeer() [error:"%o"]', error);
    	}

    	store.dispatch(
    		peerActions.setPeerKickInProgress(peerId, false));
    }

    async mutePeer(peerId)
    {
    	logger.debug('mutePeer() [peerId:"%s"]', peerId);

    	store.dispatch(
    		peerActions.setMutePeerInProgress(peerId, true));

    	try
    	{
    		await this.sendRequest('moderator:mute', { peerId });
    	}
    	catch (error)
    	{
    		logger.error('mutePeer() [error:"%o"]', error);
    	}

    	store.dispatch(
    		peerActions.setMutePeerInProgress(peerId, false));
    }

    async muteSIPPeer(peerId)
    {
    	logger.debug('mutePeer() [peerId:"%s"]', peerId);

    	store.dispatch(
    		peerActions.setMutePeerInProgress(peerId, true));

    	try
    	{
    		await this.sendRequest('moderator:sipmute', { peerId });
    	}
    	catch (error)
    	{
    		logger.error('mutePeer() [error:"%o"]', error);
    	}

    	store.dispatch(
    		peerActions.setMutePeerInProgress(peerId, false));
    }

    async unmuteSIPAudio(peerId)
    {
    	logger.debug('unmuteSIPAudio() [peerId:"%s"]', peerId);

    	try
    	{
    		await this.sendRequest('unmuteSIPAudio', { peerId });
    	}
    	catch (error)
    	{
    		logger.error('unmuteSIPAudio() [error:"%o"]', error);
    	}

    }

    async stopPeerVideo(peerId)
    {
    	logger.debug('stopPeerVideo() [peerId:"%s"]', peerId);

    	store.dispatch(
    		peerActions.setStopPeerVideoInProgress(peerId, true));

    	try
    	{
    		await this.sendRequest('moderator:stopVideo', { peerId });
    	}
    	catch (error)
    	{
    		logger.error('stopPeerVideo() [error:"%o"]', error);
    	}

    	store.dispatch(
    		peerActions.setStopPeerVideoInProgress(peerId, false));
    }

    async moderatorRequestPeerVideoOrAudio(peerId, type)
    {
    	logger.debug('moderatorRequestPeerVideo() [peerId:"%s"]', peerId, type);

    	try
    	{
    		await this.sendRequest('moderator:requestPeerVideoOrAudio', { peerId, type });
    	}
    	catch (error)
    	{
    		logger.error('stopPeerVideo() [error:"%o"]', error);
    	}
    }

    async stopPeerScreenSharing(peerId)
    {
    	logger.debug('stopPeerScreenSharing() [peerId:"%s"]', peerId);

    	store.dispatch(
    		peerActions.setStopPeerScreenSharingInProgress(peerId, true));

    	try
    	{
    		await this.sendRequest('moderator:stopScreenSharing', { peerId });
    	}
    	catch (error)
    	{
    		logger.error('stopPeerScreenSharing() [error:"%o"]', error);
    	}

    	store.dispatch(
    		peerActions.setStopPeerScreenSharingInProgress(peerId, false));
    }

    async muteAllPeers()
    {
    	logger.debug('muteAllPeers()');

    	store.dispatch(
    		roomActions.setMuteAllInProgress(true));

    	try
    	{
    		await this.sendRequest('moderator:muteAll');
    	}
    	catch (error)
    	{
    		logger.error('muteAllPeers() [error:"%o"]', error);
    	}

    	store.dispatch(
    		roomActions.setMuteAllInProgress(false));
    }

    async stopAllPeerVideo()
    {
    	logger.debug('stopAllPeerVideo()');

    	store.dispatch(
    		roomActions.setStopAllVideoInProgress(true));

    	try
    	{
    		await this.sendRequest('moderator:stopAllVideo');
    	}
    	catch (error)
    	{
    		logger.error('stopAllPeerVideo() [error:"%o"]', error);
    	}

    	store.dispatch(
    		roomActions.setStopAllVideoInProgress(false));
    }

    async stopAllPeerScreenSharing()
    {
    	logger.debug('stopAllPeerScreenSharing()');

    	store.dispatch(
    		roomActions.setStopAllScreenSharingInProgress(true));

    	try
    	{
    		await this.sendRequest('moderator:stopAllScreenSharing');
    	}
    	catch (error)
    	{
    		logger.error('stopAllPeerScreenSharing() [error:"%o"]', error);
    	}

    	store.dispatch(
    		roomActions.setStopAllScreenSharingInProgress(false));
    }

    async closeMeeting(url, type)
    {
    	logger.debug('closeMeeting()');

    	store.dispatch(
    		roomActions.setCloseMeetingInProgress(true));

    	try
    	{
    		if (this._roomTemplate?.meetingDetails?.multidisplay)
    		{
    			this.stopTelepresence();
    		}

    		if (this._isBreakoutRoomStart)
    		{
    			await this.closeBreakoutRooms(true);
    		}
    		if (store.getState().room.webinarStreamOn && this._webinarSocket)
    		{
    			this._webinarSocket.emit('moderator:closeMeeting', this._roomId, { exitUrl: url, customType: type });
    		}
    		await this.sendRequest('moderator:closeMeeting', { mainRoomId: this._roomId });

    	}
    	catch (error)
    	{
    		logger.error('closeMeeting() [error:"%o"]', error);
    	}
    	// if (this._havePermission(permissions.MODERATE_ROOM) && store.getState().me.roleType === 'Host')
    	// {
    	// 	this.cpanelSocket?.emit('conf-meeting-closed', { meetingClosed: true });

    	// }
    	store.dispatch(
    		roomActions.setCloseMeetingInProgress(false));
    }

    // type: mic/webcam/screen
    // mute: true/false
    async modifyPeerConsumer(peerId, type, mute)
    {
    	logger.debug(
    		'modifyPeerConsumer() [peerId:"%s", type:"%s"]',
    		peerId,
    		type
    	);

    	if (type === 'mic')
    		store.dispatch(
    			peerActions.setPeerAudioInProgress(peerId, true));
    	else if (type === 'webcam')
    		store.dispatch(
    			peerActions.setPeerVideoInProgress(peerId, true));
    	else if (type === 'screen')
    		store.dispatch(
    			peerActions.setPeerScreenInProgress(peerId, true));

    	try
    	{
    		for (const consumer of this._consumers.values())
    		{
    			if (consumer.appData.peerId === peerId && consumer.appData.source === type)
    			{
    				if (mute)
    				{
    					await this._pauseConsumer(consumer);
    				}
    				else
    				{
    					await this._resumeConsumer(consumer);
    				}
    			}
    		}
    		if (this._deviceInfo.platform === 'desktop' && this._deviceInfo.name === 'electron')
    		{
    			await this.sendRequest('modifyPeerConsumer', { peerId, type, mute });
    		}

    	}
    	catch (error)
    	{
    		logger.error('modifyPeerConsumer() [error:"%o"]', error);
    	}

    	if (type === 'mic')
    		store.dispatch(
    			peerActions.setPeerAudioInProgress(peerId, false));
    	else if (type === 'webcam')
    		store.dispatch(
    			peerActions.setPeerVideoInProgress(peerId, false));
    	else if (type === 'screen')
    		store.dispatch(
    			peerActions.setPeerScreenInProgress(peerId, false));
    }

    async setVolume(volumeLevel)
    {
    	try
    	{
    		// Create an AudioContext if not already created
    		const audioContext = new AudioContext();

    		// Create a GainNode to control overall volume
    		const masterGainNode = audioContext.createGain();

    		masterGainNode.connect(audioContext.destination); // Connect to the speakers

    		// Ensure volumeLevel is within acceptable bounds (0 to 1)
    		if (volumeLevel < 0)
    		{
    			volumeLevel = 0;
    		}
    		else if (volumeLevel > 1)
    		{
    			volumeLevel = 1;
    		}

    		// Set the gain value of the master GainNode based on volumeLevel
    		masterGainNode.gain.value = volumeLevel;

    		// const consumers=micProducersSelector(store.getState());

    		// console.log('dddddddddddddd', consumers);

    		// for (const consumer of consumers)
    		// {
    		// 	consumer.audioGain = volumeLevel;
    		// }

    		// try
    		// {
    		// 	for (const consumer of this._consumers.values())
    		// 	{
    		// 		// if (consumer.appData.peerId === peerId)
    		// 		// {
    		// 		store.dispatch(consumerActions.setConsumerAudioGain(consumer.id, volumeLevel));
    		// 		// }
    		// 	}
    		// }
    		// catch (error)
    		// {
    		// 	logger.error('setAudioGain() [error:"%o"]', error);
    		// }
    	}
    	catch (error)
    	{
    		console.error('Error adjusting overall volume:', error);
    	}
    }

    async setAudioGain(micConsumer, peerId, audioGain)
    {
    	logger.debug(
    		'setAudioGain() [micConsumer:"%o", peerId:"%s", type:"%s"]',
    		micConsumer,
    		peerId,
    		audioGain
    	);

    	if (!micConsumer)
    	{
    		return;
    	}

    	micConsumer.audioGain = audioGain;

    	try
    	{
    		for (const consumer of this._consumers.values())
    		{
    			if (consumer.appData.peerId === peerId)
    			{
    				store.dispatch(consumerActions.setConsumerAudioGain(consumer.id, audioGain));
    			}
    		}
    	}
    	catch (error)
    	{
    		logger.error('setAudioGain() [error:"%o"]', error);
    	}
    }

    async _pauseConsumer(consumer)
    {

    	if (consumer.paused || consumer.closed)
    		return;

    	try
    	{

    		const consumerFind = store.getState().consumers[consumer.id];


    		if (consumerFind && consumerFind !== undefined&& consumer.id !==store.getState().room.fullScreenConsumer)
    		{
    			await this.sendRequest('pauseConsumer', { consumerId: consumer.id });

    			consumer.pause();

    			store.dispatch(
    				consumerActions.setConsumerPaused(consumer.id, 'local'));
    		}
    	}
    	catch (error)
    	{
    		logger.error('_pauseConsumer() [consumerId: %s; error:"%o"]', consumer.id, error);
    		if (error.notFoundInMediasoupError)
    		{
    			this._closeConsumer(consumer.id);
    		}
    	}
    }

    async _resumeConsumer(consumer, { initial = false } = {})
    {
    	logger.debug('_resumeConsumer() [consumer:"%o"]', consumer);

    	if (Number(this._screenPage)>0 || this._mode === 'speaker' || this._mode === 'screen')
    	{
    		if ((!initial && !consumer.paused) || consumer.closed)
    		{
    			return;
    		}
    	}
    	else if ((consumer.initiallyPaused && (!initial && !consumer.paused)) || consumer.closed)
    	{
    		return;
    	}

    	try
    	{

    		const consumerFind = store.getState().consumers[consumer.id];

    		if (consumerFind && consumerFind !== undefined)
    		{
    			consumer.resume();
    			consumer['initiallyPaused'] = true;
    			await this.sendRequest('resumeConsumer', { consumerId: consumer.id });
    			store.dispatch(
    				consumerActions.setConsumerResumed(consumer.id, 'local'));
    		}
    	}
    	catch (error)
    	{
    		logger.error('_resumeConsumer() [consumerId: %s; error:"%o"]', consumer.id, error);
    		if (error.notFoundInMediasoupError)
    		{
    			consumer['initiallyPaused'] = true;

    			this._closeConsumer(consumer.id);
    		}
    	}
    }

	async pauseOrResumeConsumers({ activeConsumer, spotlights })
	{
		console.log('pauseOrResumeConsumers',activeConsumer,spotlights);
		try
		{
			const activeSpeakerId = store.getState().room.activeSpeakerId;
			const activePeerId = store.getState().room.activePeerId;
			const consumersToResume = [];
			const consumersToPause = [];
			for (const consumer of this._consumers.values())
			{
				if (consumer.kind === 'video')
					{
					console.log('consumerpauseresume',consumer.paused,consumer.initiallyPaused);
					const peerId = consumer.appData.peerId;
					const resume = spotlights?(spotlights.includes(peerId) ||
									peerId === activeSpeakerId  || 
									peerId === activePeerId ||
									consumer.appData.source === 'screen'):
						            activeConsumer.id===consumer.id ;
					if (resume)
					{
						if (consumer.paused || !consumer.initiallyPaused)
						consumersToResume.push(consumer);
					}
					else if(!consumer.paused)
					{
						consumersToPause.push(consumer);
						store.dispatch(
							roomActions.removeSelectedPeer(peerId));
					}
				}
			}
			if (consumersToResume.length > 0) {
				await this._resumeConsumersBulk(consumersToResume);
			}
			if (consumersToPause.length > 0) {
				await this._pauseConsumersBulk(consumersToPause);
			}
		}
		catch (error)
		{
			logger.error('pauseOrResumeConsumers() [error:"%o"]', error);
		}
	}

    async consumerAdded(consumer)
    {
    	console.log('consumer==', consumer);
    	// if (Number(this._screenPage) > 0)
    	// {
    	// 	// const screenPeers = store.getState()?.room?.tpScreenPagePeers?.find((eachScreen) => eachScreen?.screenNumber == this._screenPage);

    	// 	// console.log('screenPeers==', screenPeers);

    	// 	// let peerFind = false;

    	// 	// for (let each of screenPeers.peers)
    	// 	// {
    	// 	// 	if (each.id === consumer.appData.peerId)
    	// 	// 	{
    	// 	// 		peerFind = true;
    	// 	// 		break;
    	// 	// 	}
    	// 	// }

    	// 	// console.log('peerFind===', peerFind);

    	// 	if (consumer.kind !== 'audio' && consumer.appData.source !== 'screen')
    	// 	{
    	// 		this._consumers.set(consumer.id, consumer);
    	// 	}
    	// }
    	// else if (this._mode === 'screen')
    	// {
    	// 	if (consumer.appData.peerId === store.getState().room.activeScreenId)
    	// 	{
    	// 		this._consumers.set(consumer.id, consumer);
    	// 	}
    	// }
    	// else if (this._mode === 'speaker')
    	// {
    	// 	if (consumer.kind !== 'audio' && consumer.appData.source !== 'screen')
    	// 	{
    	// 		this._consumers.set(consumer.id, consumer);
    	// 	}
    	// }
    	// else
    	// {
    	this._consumers.set(consumer.id, consumer);
    	// }
    }

    async setConsumerToSpotLight(consumer)
    {

    	// if (Number(this._screenPage) > 0)
    	// {
    	// 	// const screenPeers = store.getState()?.room?.tpScreenPagePeers?.find((eachScreen) => eachScreen?.screenNumber == this._screenPage);

    	// 	// let peerFind = false;

    	// 	// if (screenPeers?.peers.length > 0)
    	// 	// {
    	// 	// 	for (let each of screenPeers?.peers)
    	// 	// 	{
    	// 	// 		if (each.id === consumer.peerId)
    	// 	// 		{
    	// 	// 			peerFind = true;
    	// 	// 			break;
    	// 	// 		}
    	// 	// 	}
    	// 	// }

    	// 	// if (peerFind)
    	// 	// {
    	// 	// 	this._spotlights.addVideoConsumer(consumer);
    	// 	// }
    	// }
    	// else if (this._mode === 'screen')
    	// {
    	// 	if (consumer.peerId === store.getState().room.activeScreenId)
    	// 	{
    	// 		// this._spotlights.addVideoConsumer(consumer);
    	// 	}
    	// }
    	// else if (this._mode === 'speaker')
    	// {
    	// 	// if (consumer.peerId === store.getState().room.activeSpeakerId)
    	// 	// {
    	// 	// 	this._spotlights.addVideoConsumer(consumer);
    	// 	// }
    	// }
    	if (Number(this._screenPage) === 0 && (this._mode === undefined || this._mode === null))
    	{
    		this._spotlights.addVideoConsumer(consumer);
    	}
    }

    async _startConsumer(consumer)
    {

    	if (Number(this._screenPage) > 0)
    	{
    		// const screenPeers = store.getState()?.room?.tpScreenPagePeers?.find((eachScreen) => eachScreen?.screenNumber == this._screenPage);

    		let peerFind = false;

    		// if (screenPeers?.peers.length > 0)
    		if (store.getState()?.tpscreensdata?.screenPeers?.length > 0)
    		{
    			for (let each of store.getState()?.tpscreensdata?.screenPeers)
    			{
    				if (each.id === consumer.appData.peerId)
    				{
    					peerFind = true;
    					break;
    				}
    			}
    		}

    		// console.log('peerFind==', peerFind);

    		if (peerFind)
    		{
    			return await this._resumeConsumer(consumer, { initial: true });
    		}
    	}
    	else if (this._mode === 'screen')
    	{
    		if (consumer.appData.peerId === store.getState().room.activeScreenId)
    		{
    			console.log('pererererererererer');

    			return await this._resumeConsumer(consumer, { initial: true });
    		}
    	}
    	else if (this._mode === 'speaker')
    	{
    		if (consumer.appData.peerId === store.getState().room.activeSpeakerId)
    		{
    			return await this._resumeConsumer(consumer, { initial: true });
    		}
    	}
    	else
    	{
    		return this._resumeConsumer(consumer, { initial: true });
    	}

    }

    async lowerPeerHand(peerId)
    {
    	logger.debug('lowerPeerHand() [peerId:"%s"]', peerId);

    	store.dispatch(
    		peerActions.setPeerRaisedHandInProgress(peerId, true));

    	try
    	{
    		await this.sendRequest('moderator:lowerHand', { peerId });
    	}
    	catch (error)
    	{
    		logger.error('lowerPeerHand() [error:"%o"]', error);
    	}

    	store.dispatch(
    		peerActions.setPeerRaisedHandInProgress(peerId, false));
    }

    async setRaisedHand(raisedHand)
    {
    	logger.debug('setRaisedHand: ', raisedHand);

    	store.dispatch(
    		meActions.setRaisedHandInProgress(true));

    	try
    	{
    		await this.sendRequest('raisedHand', { raisedHand });

    		store.dispatch(
    			meActions.setRaisedHand(raisedHand));
    	}
    	catch (error)
    	{
    		logger.error('setRaisedHand() [error:"%o"]', error);

    		// We need to refresh the component for it to render changed state
    		store.dispatch(meActions.setRaisedHand(!raisedHand));
    	}

    	store.dispatch(
    		meActions.setRaisedHandInProgress(false));
    }

    async setMaxSendingSpatialLayer(spatialLayer)
    {
    	logger.debug('setMaxSendingSpatialLayer() [spatialLayer:"%s"]', spatialLayer);

    	try
    	{
    		if (this._webcamProducer)
    			await this._webcamProducer.setMaxSpatialLayer(spatialLayer);
    		if (this._screenSharingProducer)
    			await this._screenSharingProducer.setMaxSpatialLayer(spatialLayer);
    	}
    	catch (error)
    	{
    		logger.error('setMaxSendingSpatialLayer() [error:"%o"]', error);
    	}
    }

    async setConsumerPreferredLayers(consumerId, spatialLayer, temporalLayer)
    {
    	logger.debug(
    		'setConsumerPreferredLayers() [consumerId:"%s", spatialLayer:"%s", temporalLayer:"%s"]',
    		consumerId, spatialLayer, temporalLayer);

    	try
    	{
    		await this.sendRequest(
    			'setConsumerPreferedLayers', { consumerId, spatialLayer, temporalLayer });

    		store.dispatch(consumerActions.setConsumerPreferredLayers(
    			consumerId, spatialLayer, temporalLayer));
    	}
    	catch (error)
    	{
    		logger.error('setConsumerPreferredLayers() [consumerId: %s; error:"%o"]', consumerId, error);
    		if (error.notFoundInMediasoupError)
    		{
    			this._closeConsumer(consumerId);
    		}
    	}
    }

    async restartIce(transport, ice, delay)
    {
    	logger.debug('restartIce() [transport:%o ice:%o delay:%d]', transport, ice, delay);

    	if (!transport)
    	{
    		logger.error('restartIce(): missing valid transport object');

    		return;
    	}

    	if (!ice)
    	{
    		logger.error('restartIce(): missing valid ice object');

    		return;
    	}

    	clearTimeout(ice.timer);
    	ice.timer = setTimeout(async () =>
    	{
    		try
    		{
    			if (ice.restarting)
    			{
    				return;
    			}
    			ice.restarting = true;

    			const iceParameters = await this.sendRequest(
    				'restartIce',
    				{ transportId: transport.id });

    			await transport.restartIce({ iceParameters });
    			ice.restarting = false;
    			logger.debug('ICE restarted');
    		}
    		catch (error)
    		{
    			logger.error('restartIce() [failed:%o]', error);

    			ice.restarting = false;
    			ice.timer = setTimeout(() =>
    			{
    				this.restartIce(transport, ice, delay * 2);
    			}, delay);
    		}
    	}, delay);
    }

    setConsumerPreferredLayersMax(consumer)
    {
    	if (consumer.type === 'simple')
    	{
    		return;
    	}

    	logger.debug(
    		'setConsumerPreferredLayersMax() [consumerId:"%s"]', consumer.id);

    	if (consumer.preferredSpatialLayer !== consumer.spatialLayers - 1 ||
			consumer.preferredTemporalLayer !== consumer.temporalLayers - 1)
    	{
    		return this.setConsumerPreferredLayers(consumer.id,
    			consumer.spatialLayers - 1, consumer.temporalLayers - 1);
    	}
    }

    adaptConsumerPreferredLayers(consumer, viewportWidth, viewportHeight)
    {
    	if (consumer.type === 'simple')
    	{
    		return;
    	}

    	if (!viewportWidth || !viewportHeight)
    	{
    		return;
    	}

    	const {
    		id,
    		preferredSpatialLayer,
    		preferredTemporalLayer,
    		width,
    		height,
    		resolutionScalings
    	} = consumer;
    	const adaptiveScalingFactor = Math.min(Math.max(
    		config.adaptiveScalingFactor || 0.75, 0.5), 1.0);

    	logger.debug(
    		'adaptConsumerPreferredLayers() [consumerId:"%s", width:"%d", height:"%d" resolutionScalings:[%s] viewportWidth:"%d", viewportHeight:"%d"]',
    		consumer.id, width, height, resolutionScalings.join(', '),
    		viewportWidth, viewportHeight);

    	let newPreferredSpatialLayer = 0;

    	for (let i = 0; i < resolutionScalings.length; i++)
    	{
    		const levelWidth = adaptiveScalingFactor * width / resolutionScalings[i];
    		const levelHeight = adaptiveScalingFactor * height / resolutionScalings[i];

    		if (viewportWidth >= levelWidth || viewportHeight >= levelHeight)
    		{
    			newPreferredSpatialLayer = i;
    		}
    		else
    		{
    			break;
    		}
    	}

    	let newPreferredTemporalLayer = consumer.temporalLayers - 1;

    	if (newPreferredSpatialLayer === 0 && newPreferredTemporalLayer > 0)
    	{
    		const lowestLevelWidth = width / resolutionScalings[0];
    		const lowestLevelHeight = height / resolutionScalings[0];

    		if (viewportWidth < lowestLevelWidth * 0.5
				&& viewportHeight < lowestLevelHeight * 0.5)
    		{
    			newPreferredTemporalLayer -= 1;
    		}
    		if (newPreferredTemporalLayer > 0
				&& viewportWidth < lowestLevelWidth * 0.25
				&& viewportHeight < lowestLevelHeight * 0.25)
    		{
    			newPreferredTemporalLayer -= 1;
    		}
    	}

    	if (preferredSpatialLayer !== newPreferredSpatialLayer ||
			preferredTemporalLayer !== newPreferredTemporalLayer)
    	{
    		return this.setConsumerPreferredLayers(id,
    			newPreferredSpatialLayer, newPreferredTemporalLayer);
    	}

    }

    async setConsumerPriority(consumerId, priority)
    {
    	logger.debug(
    		'setConsumerPriority() [consumerId:"%s", priority:%d]',
    		consumerId, priority);

    	try
    	{
    		await this.sendRequest('setConsumerPriority', { consumerId, priority });

    		store.dispatch(consumerActions.setConsumerPriority(consumerId, priority));
    	}
    	catch (error)
    	{
    		logger.error('setConsumerPriority() [consumerId: %s; error:"%o"]', consumerId, error);
    		if (error.notFoundInMediasoupError)
    		{
    			this._closeConsumer(consumerId);
    		}
    	}
    }

    async requestConsumerKeyFrame(consumerId)
    {
    	logger.debug('requestConsumerKeyFrame() [consumerId:"%s"]', consumerId);

    	try
    	{
    		await this.sendRequest('requestConsumerKeyFrame', { consumerId });
    	}
    	catch (error)
    	{
    		logger.error('requestConsumerKeyFrame() [consumerId: %s; error:"%o"]', consumerId, error);
    		if (error.notFoundInMediasoupError)
    		{
    			this._closeConsumer(consumerId);
    		}
    	}
    }

    async _loadDynamicImports()
    {
    	({ default: createTorrent } = await import(

    		/* webpackPrefetch: true */
    		/* webpackChunkName: "createtorrent" */
    		'create-torrent'
    	));

    	({ default: WebTorrent } = await import(

    		/* webpackPrefetch: true */
    		/* webpackChunkName: "webtorrent" */
    		'webtorrent'
    	));

    	({ default: saveAs } = await import(

    		/* webpackPrefetch: true */
    		/* webpackChunkName: "file-saver" */
    		'file-saver'
    	));

    	({ default: ScreenShare } = await import(

    		/* webpackPrefetch: true */
    		/* webpackChunkName: "screensharing" */
    		'./ScreenShare'
    	));

    	mediasoupClient = await import(

    		/* webpackPrefetch: true */
    		/* webpackChunkName: "mediasoup" */
    		'mediasoup-client'
    	);

    	({ default: audioProcess } = await import(

    		/* webpackPrefetch: true */
    		/* webpackChunkName: "file-saver" */
    		'./dist/rnnoise-runtime'
    	));

    	// ({ default: io } = await import(

    	// 	/* webpackPrefetch: true */
    	// 	/* webpackChunkName: "socket.io" */
    	// 	'socket.io-client'
    	// ));
    }

    // setStartTime(time)
    // {
    // 	this._transcriptStartTime = time;
    // }

    // async sendTextToRedis()
    // {
    // 	const findSelfCC = store.getState()?.transcriptionreducer?.find((eachCC) => eachCC.peerId === store?.me?.meId);

    // 	console.log('findSelfCC==', findSelfCC);

    // 	if (findSelfCC)
    // 	{
    // 		console.log('fdssdafafdfffffffffffffffffffffffffffffffffffffff', findSelfCC?.oldConversation);

    // 		this.sendTotalAudio({
    // 			peerId                : store?.me?.meId,
    // 			displayName           : store?.me?.displayName,
    // 			roomId                : store?.me?.roomClient?._roomId,
    // 			conversationStartTime : this._transcriptStartTime,
    // 			transcribedText       : findSelfCC?.oldConversation,
    // 			duration              : Math.round((Math.abs(new Date().valueOf() - this._transcriptStartTime))/1000)
    // 		});

    // 		const updateData={ ...findSelfCC, oldConversation: '' };

    // 		store.dispatch(transcriptionactions.addOldTranscriptionData(updateData));
    // 	}
    // }

    async connectToBroadcastSocket()
    {
    	this.broadcastSocket = await io('https://invcwebinarapi.instavc.com/');
    	this.broadcastSocket.emit('room', this._peerId, this._roomId, this._uid, store.getState().me.displayName, 'host', this._roomTemplate.meetingDetails.meetingId, store.getState().settings.countryName, store.getState().settings.countryCode, function(data)
    	{
    		store.dispatch(roomActions.setWebinarPeers(data.webinarUsers));
    	});

    	this.broadcastSocket.on('get-message', (data) =>
    	{
    		this.updateSocketChat(data);
    	});

    	this.broadcastSocket.on('new_webinar_user', (data) =>
    	{
    		store.dispatch(roomActions.setWebinarPeers([ data ]));
    	});
    	this.broadcastSocket.on('webinaruser_disconnected', (userId, socketId) =>
    	{
    		// Remove by socketId (unique per session), not userId — the same person can now
    		// join from multiple tabs / as speaker + attendee, so one session leaving must
    		// not drop the others sharing the same userId.
    		store.dispatch(roomActions.deleteWebinarPeers(socketId));
    	});
    }

    async connectToWebinarSocket()
    {
    	const socketURI = import.meta.env.VITE_WEBINAR_SOCKET;

    	// const socketURI = 'http://localhost:7016/';

    	this._webinarSocket = await io.connect(`${socketURI}`);

    	this._webinarSocket.emit('room', this._peerId, this._roomId, this._uid, store.getState().me.displayName, 'host', this._roomTemplate.meetingDetails.meetingId, store.getState().settings.countryName, store.getState().settings.countryCode, function(data)
    	{
    		store.dispatch(roomActions.setWebinarPeers(data.webinarUsers));
    	});

    	this._webinarSocket.on('get-message', (data) =>
    	{
    		this.updateSocketChat(data);
    	});

    	this._webinarSocket.on('msgToHost', (data) =>
    	{
    		this.updateSocketChat(data);
    	});

    	this._webinarSocket.on('new_webinar_user', (data) =>
    	{
    		store.dispatch(roomActions.setWebinarPeers([ data ]));
    	});
    	this._webinarSocket.on('webinaruser_disconnected', (userId, socketId) =>
    	{
    		// Remove by socketId (unique per session), not userId — see connectToBroadcastSocket.
    		store.dispatch(roomActions.deleteWebinarPeers(socketId));
    	});
    }

	async disconnectTranscriptionSocket() {
		console.log('Manually disconnecting transcription socket');
		
		if (this._transcriptionSocket) {
			try {
                      this._transcriptionSocket.emit('endSpeechRecognize', { isStop: true });
						this._transcriptionSocket.disconnect();
						this._transcriptionSocket = null;
						console.log('✅ Transcription socket disconnected successfully');
			} catch (error) {
				console.error('Error disconnecting transcription socket:', error);
			}
		} else {
			console.log('No transcription socket to disconnect');
		}
	}
    async connectToTranscriptionSocket()
    {
		if (this._transcriptionSocket || !this._micProducer || this._micProducer.paused || !store.getState().room.isTranscriptionStart ) {
			return;
		}
    	// Transcription Socket
    	// const transcriptionURL = `https://10.10.40.62:8502/?peerId=${this._peerId}&roomId=${this._roomId}&projectId=${this._projectId}&displayName=${store?.getState()?.me?.displayName}`;
    	const transcriptionURL = `wss://${import.meta.env.VITE_vcTranscriptionSocket}/?peerId=${this._peerId}&roomId=${this._roomId}&projectId=${this._projectId}&displayName=${store?.getState()?.me?.displayName}`;
        try{
    	this._transcriptionSocket = io(`${transcriptionURL}`);
		
				console.log('this._transcriptionSocket', this._transcriptionSocket);
		
				this._transcriptionSocket?.on('connect', () =>
				{
					// this._transcriptionSocket.emit('join', this._roomId);
					this._transcriptionSocket.emit('startSpeechRecognize', { isStart: true });
				});
		
				// this._transcriptionSocket.on('transcriptiondata', (transcriptionData) =>
				// {
				// 	store.dispatch(transcriptionactions.addTranscriptionData(transcriptionData?.transcriptiondata));
		
				// });
		
				this._transcriptionSocket.on('receive_audio_text', (data) =>
				{
					console.log('data===finalTextfinalText', data);
					store.dispatch(viewTranscriptionAction.setFinaltext(data));
				});
		
				// Enhanced error recovery event handlers
				this._transcriptionSocket.on('transcription_error', (data) =>
				{
					console.error('Transcription service error:', data);
					
					// Show user-friendly error notification
					store.dispatch(requestActions.notify({
						type: 'error',
						title: 'Transcription Error',
						text: data.canRetryLater ? 
							'Transcription service is temporarily unavailable. Please try again later.' :
							'Transcription service configuration error. Please contact support.',
						timeout: 5000
					}));
		
					// If non-retryable error, disable transcription UI
					if (!data.canRetryLater) {
						store.dispatch(roomActions.setTranscriptionEnabled(false));
					}
				});
		
				this._transcriptionSocket.on('transcription_retry', (data) =>
				{
					console.log('Transcription service retrying:', data);
					
					// Show retry notification to user
					store.dispatch(requestActions.notify({
						type: 'info',
						title: 'Reconnecting Transcription',
						text: `Reconnecting transcription service... (attempt ${data.attempt}/${data.maxAttempts})`,
						timeout: 3000
					}));
				});
		
				this._transcriptionSocket.on('transcriptionHealth', (data) =>
				{
					console.log('Transcription service health:', data);
					
					// Update transcription service status in store
					store.dispatch(roomActions.setTranscriptionHealth({
						healthy: data.healthy,
						connected: data.connected,
						metrics: data.metrics,
						lastUpdate: Date.now()
					}));
				});
		
				this._transcriptionSocket?.on('disconnect', () =>
				{
					console.log('🔌 _transcriptionSocket Peer "disconnect" event');
					
					// Show disconnection notification
					store.dispatch(requestActions.notify({
						type: 'warning',
						title: 'Transcription Disconnected',
						text: 'Transcription service disconnected. Attempting to reconnect...',
						timeout: 3000
					}));
				});
		
				this._transcriptionSocket?.on('reconnect', (attemptNumber) =>
				{
					console.log('_transcriptionSocket reconnected after', attemptNumber, 'attempts');
					
					// Show reconnection success
					store.dispatch(requestActions.notify({
						type: 'success',
						title: 'Transcription Restored',
						text: 'Transcription service reconnected successfully.',
						timeout: 3000
					}));
				});
		
				// Periodically check transcription service health
				this._transcriptionHealthCheckInterval = setInterval(() => {
					if (this._transcriptionSocket && this._transcriptionSocket.connected) {
						this._transcriptionSocket.emit('getTranscriptionHealth');
					}
				}, 30000); // Check every 30 seconds
        }catch(error){
            console.warn('error in connection transcription socket', error);
        }

    }
    async clearAnnotationData()
    {
    	if (store.getState().room.uploadDocument && store.getState().room.uploadDocument.peerId === store.getState().me.id)
    	{
    		this._annotationsSocket?.emit('clearAnnotationData', { meetingId: this?._roomTemplate?.meetingDetails?.meetingId });
    		// this._annotationsSocket.disconnect();
    	}
    }
    async connectToAnnotationsSocket()
    {
    	try
    	{
    		const annotationsUrl = `${import.meta.env.VITE_ANNOTATIONS_SERVER}?roomId=${this._roomId}`;

    		// const annotationsUrl = `http://localhost:8220/?roomId=${this._roomId}`;

    		this._annotationsSocket = io(`${annotationsUrl}`);
    		this._annotationsSocket?.on('connect', () =>
    		{
    			console.log('connected to the annotations socket');
    			// this._annotationsSocket?.emit('startAnnotations', 'yes');
    		});
    		this._annotationsSocket.on('connect_error', (error) =>
    		{
    			console.error('Error connecting to annotations socket:', error);
    		});
    	}
    	catch (error)
    	{
    		console.error('Error connecting to annotations socket:', error);
    	}
    }

    async setPeerDataToMainRoom(data)
    {
    	const { peerData, breakoutRoomId } = data;
    	const roomdata = store.getState().room.breakoutRoomsNewList;

    	for (let room of roomdata)
    	{
    		const index = room?.participantsList.findIndex((each) =>
    		{
    			return each?.id === peerData.id;
    		});

    		if (index > -1)
    		{
    			room.participantsList.splice(index, 1);
    		}

    		if (room.id === breakoutRoomId)
    		{
    			room.participantsList.push(peerData);
    		}
    	}

    	store.dispatch(roomActions.setBreakedRoomsNew([ ...roomdata ]));

    	this.sendBreakoutRoomDataToMainRoom();

    }

    async join({ roomId, joinVideo, joinAudio, breakoutRooms = false, breakoutPeerId = null, breakoutRoomId = null, from = '' })
    {
    	await this._loadDynamicImports();

    	this._roomId = roomId;

    	this._breakoutRoomName = this.breakoutRoomData?.roomName;

    	this._currentRoomId = breakoutRoomId ? breakoutRoomId : roomId;

    	store.dispatch(roomActions.setRoomName(roomId));

    	// this._signalingUrl = getSignalingUrl(this._peerId, roomId,
    	// 	this._token, this._projectId, this._screenPage, this._uid, this._record, this._mDeviceId, this._mDeviceType, this._displayName);
    	const deviceData = deviceInfo();

    	let deviceType = null;

    	this._displayName = store.getState().me.displayName;

    	if (deviceData.platform === 'desktop' && deviceData.name === 'electron')
    	{
    		deviceType = 'display';
    	}
    	else if (this._meetingType === 'presence')
    	{
    		deviceType = 'presence';
    	}
    	this._signalingUrl = getSignalingUrl(breakoutRooms ? breakoutPeerId : this._peerId, roomId,
    		this._projectId, this._screenPage, this._uid, this._record, this._mDeviceId, this._mDeviceType, this._displayName, breakoutRooms, breakoutRoomId, null, deviceType, this._pairId, this._mode, this._presenceUserId);

    	// if (this._mDeviceType !== 'ios')
    	// {
    	this._screenSharing = ScreenShare.create(this._device);
    	// }

    	this._signalingSocket = io(this._signalingUrl);

    	store.dispatch(roomActions.setRoomState('connecting'));

    	this._signalingSocket.on('connect', () =>
    	{
    		logger.debug('signaling Peer "connect" event');

    		window.parent.postMessage({ cmd: 'reconnection', value: { isReconnected: true } }, '*');
    	});

    	this._signalingSocket.on('disconnect', (reason) =>
    	{
    		logger.warn('signaling Peer "disconnect" event [reason:"%s"]', reason);

    		this._closed = false;

    		if (this._closed)
    			return;

    		if (reason === 'io server disconnect')
    		{
    			store.dispatch(requestActions.notify(
    				{
    					text : intl.formatMessage({
    						id             : 'socket.disconnected',
    						defaultMessage : 'You are disconnected'
    					})
    				}));

    			this.close(null, 'self');
    		}
    		else if (reason === 'transport error')
    		{
    			this._transcriptionSocket?.disconnect();
    		}

    		store.dispatch(requestActions.notify(
    			{
    				text : intl.formatMessage({
    					id             : 'socket.reconnecting',
    					defaultMessage : 'You are disconnected, attempting to reconnect'
    				})
    			}));

    		// store.dispatch(meActions.clearRoles());

    		if (this._screenSharingProducer)
    		{
    			this._screenSharingProducer.close();

    			store.dispatch(
    				producerActions.removeProducer(this._screenSharingProducer.id));

    			this._screenSharingProducer = null;
    		}

    		if (this._webcamProducer)
    		{
    			this._webcamProducer.close();

    			store.dispatch(
    				producerActions.removeProducer(this._webcamProducer.id));

    			this._webcamProducer = null;
    		}

    		for (const producer of this._extraVideoProducers.values())
    		{
    			producer.close();

    			store.dispatch(
    				producerActions.removeProducer(producer.id));
    		}
    		this._extraVideoProducers.clear();

    		// Remember the mic as the user had it. The SFU drops this peer, so the rejoin is a fresh
    		// roomReady that would otherwise produce an unmuted mic for a user who had muted.
    		if (this._sendTransport && this._micStateBeforeDisconnect === null)
    		{
    			const hadMic = Boolean(this._micProducer) || this._micInProgress;

    			this._micStateBeforeDisconnect = !hadMic ? 'off' : (this._micDesiredMuted ? 'muted' : 'on');
    		}

    		for (const producer of this._allMicProducers())
    		{
    			this._retireMicProducer(producer, { notifyServer: false });
    		}

    		this._micProducer = null;

    		if (this._sendTransport)
    		{
    			this._sendTransport.close();

    			this._sendTransport = null;
    		}

    		if (this._recvTransport)
    		{
    			this._recvTransport.close();

    			this._recvTransport = null;
    		}

    		this._spotlights.clearSpotlights();

    		store.dispatch(roomActions.setWebinarPeers([]));

    		this.disconnectLocalHark();

    		store.dispatch(peerActions.clearPeers());
    		store.dispatch(consumerActions.clearConsumers());
    		store.dispatch(roomActions.clearSpotlights());
    		store.dispatch(roomActions.setRoomState('connecting'));

    		store.dispatch(roomActions.setIsTranscriptionStart(false));
    	});

    	this._signalingSocket.on('reconnect_failed', () =>
    	{
    		logger.warn('signaling Peer "reconnect_failed" event');

    		store.dispatch(requestActions.notify(
    			{
    				text : intl.formatMessage({
    					id             : 'socket.disconnected',
    					defaultMessage : 'You are disconnected'
    				})
    			}));

    		this.close(null, 'self');
    	});

    	this._signalingSocket.on('reconnect', (attemptNumber) =>
    	{
    		console.log('sadad das daid aida dsad');
    		logger.debug('signaling Peer "reconnect" event [attempts:"%s"]', attemptNumber);

    		store.dispatch(requestActions.notify(
    			{
    				text : intl.formatMessage({
    					id             : 'socket.reconnected',
    					defaultMessage : 'You are reconnected'
    				})
    			}));

    		window.parent.postMessage({ cmd: 'reconnection', value: { isReconnected: true } }, '*');
    		console.log('said aksdaida disa dad');
    		store.dispatch(roomActions.setRoomState('connected'));
    	});

    	// window.parent.postMessage(JSON.stringify({ cmd: 'JOIN_STATUS', value: { joinStatus: true, pId: this._peerId, displayName: store.getState().settings.displayName } }), '*');

    	window.parent.postMessage('JOIN_STATUS', '*');

    	this._signalingSocket.on('request', async (request, cb) =>
    	{
    		logger.debug(
    			'socket "request" event [method:"%s", data:"%o"]',
    			request.method, request.data);

    		switch (request.method)
    		{
    			case 'recodorstreamstarted':
    			{

    				// eslint-disable-next-line no-console
    				cb();
    				break;
    			}
    			// case 'breakoutjoin':
    			// {
    			// 	const { breakoutData } = request.data;

    			// 	this.breakoutRoomData = breakoutData.breakoutPeers;

    			// 	// this.isBreakoutRoom = true;

    			// 	store.dispatch(roomActions.setBreakoutRoomJoin(true));
    			// 	store.dispatch(roomActions.setIsBreakoutRoomJoin(true));

    			// 	// try
    			// 	// {
    			// 	// 	for (const consumer of this._consumers.values())
    			// 	// 	{
    			// 	// 		if (consumer.kind === 'audio')
    			// 	// 		{
    			// 	// 			if (!breakoutData.breakoutPeers.includes(consumer.appData.peerId))
    			// 	// 			{
    			// 	// 				await this._pauseConsumer(consumer);
    			// 	// 			}
    			// 	// 		}
    			// 	// 	}
    			// 	// }
    			// 	// catch (error)
    			// 	// {
    			// 	// 	logger.error('updateBreakoutView() [error:"%o"]', error);
    			// 	// }

    			// 	// store.dispatch(roomActions.setBreakoutPeers(breakoutData.breakoutPeers));
    			// 	// store.dispatch(roomActions.setDisplayMode('breakoutview'));

    			// 	// this.pauseMicOfNonBreakout(breakoutData.breakoutPeers);
    			// 	// this.closebreakout(request.data);
    			// 	// alert('Breakout join');
    			// 	cb();
    			// 	break;
    			// }
    			case 'revokebreakout':
    			{
    				store.dispatch(roomActions.setDisplayMode('democratic'));
    				this.resumeMicOfNonBreakout();
    				cb();
    				break;
    			}

    			case 'breakoutRoomToMainRoom':
    			{

    				this.joinBreakoutRoomToMainRoom();
    				cb();
    				break;
    			}
    			// case 'closeBreakoutRoomToMainRoom':
    			// {
    			// 	// store.dispatch(roomActions.setEndBreakoutSession('breakoutRoomStopPeerSide'));

    			// 	// setTimeout(() =>
    			// 	// {
    			// 	// 	this.joinBreakoutRoomToMainRoom();
    			// 	// 	store.dispatch(roomActions.setEndBreakoutSession(''));
    			// 	// }, 20000);

    			// 	await this.joinBrRoomToMainRoomHostPeersAndTpScreeen();

    			// 	cb();
    			// 	break;
    			// }

    			case 'breakoutRoomIsStopped':
    			{

    				store.dispatch(roomActions.setBreakoutRoomJoin(false));
    				store.dispatch(roomActions.setIsBreakoutRoomJoin(false));
    				cb();
    				break;
    			}

    			default:
    			{
    				logger.error('unknown request.method "%s"', request.method);

    				cb(500, `unknown request.method "${request.method}"`);
    			}
    		}
    	});

    	const removeBreakoutRoomPeer = (peerId) =>
    	{
    		const copyBreakoutRoomsNewList = store.getState().room.breakoutRoomsNewList;

    		const copyBreakoutRoomPeers = store.getState().room.breakoutRoomPeers;

    		for (let room of copyBreakoutRoomsNewList)
    		{
    			if (room?.participantsList.length > 0)
    			{
    				const index = room.participantsList.findIndex((each) => each.id === peerId);

    				if (index > -1)
    				{
    					room?.participantsList.splice(index, 1);
    				}
    			}
    		}

    		store.dispatch(roomActions.setBreakedRoomsNew([ ...copyBreakoutRoomsNewList ]));

    		for (let peer of copyBreakoutRoomPeers)
    		{
    			const index = copyBreakoutRoomPeers.findIndex((each) => each.id === peerId);

    			if (peer?.id === peerId)
    			{
    				copyBreakoutRoomPeers.splice(index, 1);
    			}
    		}

    		store.dispatch(roomActions.handleBreakoutRoomPeers([ ...copyBreakoutRoomPeers ]));
    	};

    	this._signalingSocket.on('notification', async (notification) =>
    	{
    		logger.debug(
    			'socket "notification" event [method:"%s", data:"%o"]',
    			notification.method, notification.data);

    		try
    		{
    			switch (notification.method)
    			{

    				case 'roomUnlock':
    				{
    					// const { roomTemplate } = notification.data;

    					// this._roomTemplate = roomTemplate;
    					// store.dispatch(roomActions.setInLobby(false));
    					break;
    				}
    				case 'sessionExpire':
    				{
    					// const { displayName } = store.getState().settings;
    					// const { picture } = store.getState().me;
    					const { roomTemplate } = notification.data;

    					console.warn('[RT-OVERWRITE] source=sessionExpire hasTemplate=', !!roomTemplate, 'hasMeetingDetails=', !!roomTemplate?.meetingDetails, 'payload=', notification.data);

    					this._applyRoomTemplate(roomTemplate, 'sessionExpire');
    					store.dispatch(roomActions.setSessionExp(true));

    					if (roomTemplate?.data?.waitingRoomUrlStatus)
    					{
    						// eslint-disable-next-line max-len
    						store.dispatch(toolareaAction.waitingRoomUrl(roomTemplate.data.waitingRoomUrl));
    					}

    					this._signalingSocket?.close();
    					// eslint-disable-next-line no-console
    					// await this.sendRequest('changeDisplayName', { displayName });
    					// await this.sendRequest('changePicture', { picture });
    					break;
    				}
    				case 'enteredLobby':
    				{
    					const { displayName } = store.getState().settings;
    					const { picture } = store.getState().me;
    					const { roomTemplate } = notification.data;

    					console.warn('[RT-OVERWRITE] source=enteredLobby hasTemplate=', !!roomTemplate, 'hasMeetingDetails=', !!roomTemplate?.meetingDetails, 'payload=', notification.data);

    					this._applyRoomTemplate(roomTemplate, 'enteredLobby');
    					store.dispatch(roomActions.setInLobby(true));
    					// }
    					// catch (err)
    					// {
    					// 	// eslint-disable-next-line no-console
    					// }

    					if (roomTemplate?.data?.waitingRoomUrlStatus)
    					{
    						// eslint-disable-next-line max-len
    						store.dispatch(toolareaAction.waitingRoomUrl(roomTemplate.data.waitingRoomUrl));
    					}

    					// eslint-disable-next-line no-console
    					await this.sendRequest('changeDisplayName', { displayName });
    					await this.sendRequest('changePicture', { picture });
    					break;
    				}
    				case 'enteredSIPRoom':
    				{

    					console.log('enteredSIPRoom');

    					// const { displayName } = store.getState().settings;
    					// const { picture } = store.getState().me;
    					const { roomTemplate } = notification.data;

    					console.log('enteredSIPRoom');

    					console.warn('[RT-OVERWRITE] source=enteredSIPRoom hasTemplate=', !!roomTemplate, 'hasMeetingDetails=', !!roomTemplate?.meetingDetails, 'payload=', notification.data);

    					this._applyRoomTemplate(roomTemplate, 'enteredSIPRoom');
    					if (roomTemplate?.data?.waitingRoomUrlStatus)
    					{
    						// eslint-disable-next-line max-len
    						store.dispatch(toolareaAction.waitingRoomUrl(roomTemplate.data.waitingRoomUrl));
    					}
    					break;
    				}

    				case 'acceptRejectIncomingSipCall':
    				{
    					// const { callerId, peerId } = notification.data;

    					const isModerator = this._havePermission(permissions.MODERATE_ROOM);

    					if (isModerator)
    					{

    						store.dispatch(roomActions.openSIPIncomingCallReq(true));
    						store.dispatch(roomActions.acceptRejectIncomingCall(notification.data));
    					}

    					break;
    				}
    				case 'cancelledCall':
    				{
    					// const { peerId } = notification.data;

    					const isModerator = this._havePermission(permissions.MODERATE_ROOM);

    					if (isModerator)
    					{
    						store.dispatch(roomActions.openSIPIncomingCallReq(false));
    						store.dispatch(roomActions.updateSipUserCallStatus(notification.data));
    					}

    					break;
    				}
    				case 'hostAcceptedIncomingCall':
    				{
    					const { callerId } = notification.data;

    					if (this._SIP)
    					{
    						store.dispatch(meActions.setMeDislayName(callerId));
    						store.dispatch(settingsActions.setDisplayName(callerId));
    						this._SIP.acceptIncomingCall();
    					}
    					break;
    				}
    				case 'hostRejectedIncomingCall':
    				{

    					if (this._SIP)
    					{
    						this._SIP.rejectIncomingCall();
    					}
    					break;
    				}
    				case 'sipUserCallStatus':
    				{
    					// const { peerId } = notification.data;

    					const isModerator = this._havePermission(permissions.MODERATE_ROOM);

    					if (isModerator)
    					{
    						// store.dispatch(roomActions.updateSipUserCallStatus(peerId));
    					}
    					break;
    				}
    				case 'makeACallToSipUser':
    				{
    					const { userId } = notification.data;

    					if (this._SIP)
    					{
    						this._SIP.makeACallToSipUser(userId);
    					}
    					break;
    				}
    				case 'rejectOngoingCall':
    				{
    					if (this._SIP)
    					{
    						this._SIP.rejectOngoingCall();
    					}
    					break;
    				}
    				case 'dialOutToSipEndpoint':
    				{
    					const { userId } = notification.data;

    					console.log('dialOutToSipEndpoint', userId);

    					if (this._SIP)
    					{
    						this._SIP.makeACallToSipUser(userId);
    					}
    					break;
    				}
    				case 'signInRequired':
    				{
    					store.dispatch(meActions.loggedIn(false));
    					store.dispatch(roomActions.setSignInRequired(true));

    					break;
    				}

    				case 'overRoomLimit':
    				{
    					store.dispatch(roomActions.setOverRoomLimit(true));

    					break;
    				}

    				case 'limitJoin':
    				{
    					store.dispatch(requestActions.notify(
    						{
    							text : intl.formatMessage({
    								id             : 'room.new_Peer',
    								defaultMessage : 'Room Limit exceed but someone wants join the meeting...'
    							})
    						}));
    					break;
    				}

    				case 'recodstatus':
    				{
    					break;
    				}

    				case 'roomReady':
    				{
    					const { turnServers, hostControlsObj } = notification.data;

    					this._turnServers = turnServers;

    					store.dispatch(roomActions.toggleJoined());
    					store.dispatch(roomActions.setInLobby(false));
    					store.dispatch(roomActions.setSessionExp(false));

    					// Set only when rejoining after a disconnect; the first join uses what join() was given.
    					const micState = this._micStateBeforeDisconnect;

    					this._micStateBeforeDisconnect = null;

    					if (this._meetingType === 'presence')
    					{

    						await this._joinRoom({
    							joinVideo : store.getState().room?.callType === 'videoCall' ? true : false,
    							joinAudio : micState ? micState !== 'off' : true,
    							joinMuted : micState === 'muted'
    						});
    					}
    					else
    					{
    						await this._joinRoom({
    							joinVideo : joinVideo && hostControlsObj.hostControlVideoControl,
    							joinAudio : (micState ? micState !== 'off' : joinAudio) && hostControlsObj.hostControlMicroPhone,
    							joinMuted : micState === 'muted'
    						});
    					}

    					break;
    				}

    				case 'roomBack':
    				{
    					const micState = this._micStateBeforeDisconnect;

    					this._micStateBeforeDisconnect = null;

    					if (this._meetingType === 'presence')
    					{

    						await this._joinRoom({
    							joinVideo : store.getState().room?.callType === 'videoCall' ? true : false,
    							joinAudio : micState ? micState !== 'off' : true,
    							joinMuted : micState === 'muted'
    						});
    					}
    					else
    					{
    						await this._joinRoom({
    							joinVideo : !store.getState().settings.videoMuted,
    							joinAudio : micState ? micState !== 'off' : !store.getState().settings.audioMuted,
    							joinMuted : micState === 'muted',
    							returning : true
    						});
    					}

    					break;
    				}

    				case 'lockRoom':
    				{

    					const { displayName } = store.getState().settings;
    					const { picture } = store.getState().me;
    					const { roomTemplate } = notification.data;

    					console.log('display', displayName, picture);

    					console.warn('[RT-OVERWRITE] source=lockRoom hasTemplate=', !!roomTemplate, 'hasMeetingDetails=', !!roomTemplate?.meetingDetails, 'payload=', notification.data);

    					this._applyRoomTemplate(roomTemplate, 'lockRoom');
    					store.dispatch(
    						roomActions.setRoomLocked());

    					if (from === 'brRoomToMainRoom')
    					{
    						toast.dismiss();
    						toast.warn(intl.formatMessage({ id: 'room.locked', defaultMessage: 'Room is now locked' }), {
    							position : toast.POSITION.TOP_RIGHT
    						});
    					}
    					store.dispatch(requestActions.notify(
    						{
    							text : intl.formatMessage({
    								id             : 'room.locked',
    								defaultMessage : 'Room is now locked'
    							})
    						}));

    					if (roomTemplate?.data?.waitingRoomUrlStatus)
    					{
    						// eslint-disable-next-line max-len
    						store.dispatch(toolareaAction.waitingRoomUrl(roomTemplate.data.waitingRoomUrl));
    					}

    					// eslint-disable-next-line no-console
    					await this.sendRequest('changeDisplayName', { displayName });
    					await this.sendRequest('changePicture', { picture });
    					break;
    				}

    				case 'unlockRoom':
    				{
    					// Restore template in case an earlier lock/partial payload dropped it.
    					this._applyRoomTemplate(notification?.data?.roomTemplate, 'unlockRoom');

    					store.dispatch(
    						roomActions.setRoomUnLocked());

    					store.dispatch(requestActions.notify(
    						{
    							text : intl.formatMessage({
    								id             : 'room.unlocked',
    								defaultMessage : 'Room is now unlocked'
    							})
    						}));

    					break;
    				}

    				case 'parkedPeer':
    				{
    					const { peerId, displayName } = notification.data;

    					store.dispatch(
    						lobbyPeerActions.addLobbyPeer(peerId));
    					store.dispatch(
    						lobbyPeerActions.setLobbyPeerDisplayName(displayName, peerId));
    					store.dispatch(
    						roomActions.setToolbarsVisible(true));

    					this._soundNotification(notification.method);

    					store.dispatch(requestActions.notify(
    						{
    							text : intl.formatMessage({
    								id             : 'room.newLobbyPeer',
    								defaultMessage : 'New participant entered the lobby'
    							})
    						}));

    					break;
    				}

    				case 'parkedPeers':
    				{
    					const { lobbyPeers } = notification.data;

    					if (lobbyPeers.length > 0)
    					{
    						lobbyPeers.forEach((peer) =>
    						{
    							store.dispatch(
    								lobbyPeerActions.addLobbyPeer(peer.id));

    							store.dispatch(
    								lobbyPeerActions.setLobbyPeerDisplayName(
    									peer.displayName,
    									peer.id
    								)
    							);

    							store.dispatch(
    								lobbyPeerActions.setLobbyPeerPicture(
    									peer.picture,
    									peer.id
    								)
    							);
    						});

    						store.dispatch(
    							roomActions.setToolbarsVisible(true));

    						this._soundNotification(notification.method);

    						store.dispatch(requestActions.notify(
    							{
    								text : intl.formatMessage({
    									id             : 'room.newLobbyPeer',
    									defaultMessage : 'New participant entered the lobby'
    								})
    							}));
    					}

    					break;
    				}

    				case 'scrollDif':
    				{
    					store.dispatch(roomActions.setScrollValue(notification.data));
    					break;
    				}

    				case 'lobby:peerClosed':
    				{
    					const { peerId } = notification.data;

    					store.dispatch(
    						lobbyPeerActions.removeLobbyPeer(peerId));

    					store.dispatch(requestActions.notify(
    						{
    							text : intl.formatMessage({
    								id             : 'room.lobbyPeerLeft',
    								defaultMessage : 'Participant in lobby left'
    							})
    						}));

    					break;
    				}

    				case 'lobby:promotedPeer':
    				{
    					const { peerId } = notification.data;

    					store.dispatch(
    						lobbyPeerActions.removeLobbyPeer(peerId));

    					break;
    				}

    				case 'lobby:changeDisplayName':
    				{
    					const { peerId, displayName } = notification.data;

    					store.dispatch(
    						lobbyPeerActions.setLobbyPeerDisplayName(displayName, peerId));

    					store.dispatch(requestActions.notify(
    						{
    							text : intl.formatMessage({
    								id             : 'room.lobbyPeerChangedDisplayName',
    								defaultMessage : 'Participant in lobby changed name to {displayName}'
    							}, {
    								displayName
    							})
    						}));

    					if (peerId === this._peerId)
    						this._displayName = displayName;

    					break;
    				}

    				case 'msgToPanelists':
    				{
    					console.log('chattttt', notification.data);
    					this.updateSocketChat(notification.data);
    					break;
    				}

    				case 'lobby:changePicture':
    				{
    					const { peerId, picture } = notification.data;

    					store.dispatch(
    						lobbyPeerActions.setLobbyPeerPicture(picture, peerId));

    					store.dispatch(requestActions.notify(
    						{
    							text : intl.formatMessage({
    								id             : 'room.lobbyPeerChangedPicture',
    								defaultMessage : 'Participant in lobby changed picture'
    							})
    						}));

    					break;
    				}

    				case 'setAccessCode':
    				{
    					const { accessCode } = notification.data;

    					store.dispatch(
    						roomActions.setAccessCode(accessCode));

    					store.dispatch(requestActions.notify(
    						{
    							text : intl.formatMessage({
    								id             : 'room.setAccessCode',
    								defaultMessage : 'Access code for room updated'
    							})
    						}));

    					break;
    				}

    				case 'updateMic':
    				{
    					// const { isStart, muteUnmute } = notification.data;

    					console.log('notification.data===', notification.data);

    					this._hookToggleMic();

    					break;
    				}

    				case 'updateWebcam':
    				{
    					this._hoookEnableDisableCamera();
    					break;
    				}

    				case 'startOrStopTelepresence':
    				{
    					if (notification?.data?.isStart)
    					{
    						this.startTelepresence();
    					}
    					else
    					{
    						this.stopTelepresence();
    					}
    					break;
    				}

    				case 'peerPerEachScreen':
    				{
    					const { screenLimit, eachScreen } = notification.data;

    					this.handleSelect(screenLimit, eachScreen);

    					break;
    				}

    				case 'removePeerFromScreen':
    				{
    					const { peer, eachScreen } = notification.data;

    					console.log('notification.data===', notification.data);

    					this.handleRemove(peer, eachScreen);
    					break;
    				}

    				case 'peerPerAllScreens':
    				{
    					const { limit } = notification.data;

    					this.handleAllScreens(limit);
    					break;
    				}

    				case 'movePeerScreenToScreen':
    				{
    					const { moveScreen, peer, currentScreen } = notification.data;

    					this.handleMovePeer(moveScreen, peer, currentScreen);
    					break;
    				}
    				case 'layoutChange':
    				{
    					store.dispatch(roomActions.setDisplayMode(notification?.data?.layout));
    					break;
    				}

    				case 'volumeChange':
    				{
    					const { volume } = notification?.data;

    					console.log('volumeeeeeeeeee', notification?.data);

    					// store.dispatch(roomActions.setDisplayMode(notification?.data?.layout));
    					await this.setVolume(volume);

    					break;
    				}

    				case 'camFocusingEvents':
    				{

    					console.log('camZoomEvents................', notification?.data);
    					this.controlPtzOptions(notification.data);

    					// this.updateWebcam({
    					// 	// restart    : true,
    					// 	newZoomVal : notification?.data
    					// });
    					break;
    				}

					case 'requestCameraAccess':
    				{
    					console.log('cameraRequest................', notification?.data);
    					store.dispatch(roomActions.setCameraRequestDialog({ ...notification?.data, open: true }));
    					break;
    				}

    				case 'declineCameraAccess':
    				{
    					toast.warning(`${notification?.data?.displayName || 'Someone'} declined your camera control request`, {
    						position  : toast.POSITION.TOP_RIGHT,
    						autoClose : 3000,
    						// icon      : (<img src='/icons/info.svg' alt='Camera revoked' style={{ width: 24, height: 24, objectFit: 'contain' }}/>)
    					});
    					break;
    				}

    				case 'gotCameraAccess':
    				{
    					const isModerator=this._havePermission(permissions.MODERATE_ROOM);
    					const data=store.getState().room?.cameraRequestDialog;

    					console.log('gotCameraAccess................', notification?.data);
    					if (notification?.data?.peerId === this._peerId)
    					{
    						store.dispatch(roomActions.setCameraRequestDialog({ cameraAccess: true }));
    						store.dispatch(roomActions.setCameraControlEvent({ ...data }));
    						toast.dismiss();
    						toast.warning(`${notification?.data?.displayName || 'Someone'} accepted your camera control request`, {
    							position  : toast.POSITION.TOP_RIGHT,
    							autoClose : 3000,
    							icon      : (<img src='/icons/info.svg' alt='Camera revoked' style={{ width: 24, height: 24, objectFit: 'contain' }}/>)
    						});
    					}
    					else if (isModerator)
    					{
    						store.dispatch(peerActions.setPeerCameraAccess(notification?.data?.myId, notification?.data));
    					}
    					break;
    				}

    				case 'lostCameraAccess':
    				{
    					const isModerator=this._havePermission(permissions.MODERATE_ROOM);

    					console.log('lostCameraAccess................', notification?.data);
    					if (notification?.data?.peerId === this._peerId)
    					{
    						store.dispatch(roomActions.setCameraRequestDialog({ cameraAccess: false }));
    						toast.dismiss();
    						store.dispatch(peerActions.setPeerCameraAccess(notification?.data?.myId, null));
    						toast.warning(`${notification?.data?.displayName || 'Someone'} revoked your camera access`, {
    							position  : toast.POSITION.TOP_RIGHT,
    							autoClose : 3000,
    							icon      : (<img src='/icons/info.svg' alt='Camera revoked' style={{ width: 24, height: 24, objectFit: 'contain' }}/>)
    						});
    					}
    					else if (isModerator)
    					{
    						store.dispatch(peerActions.setPeerCameraAccess(notification?.data?.myId, null));
    					}
    					else if (store.getState().room.cameraControlId===notification?.data?.peerId)
    					{
    						store.dispatch(roomActions.setCameraControlId(null));
    					}
    					break;
    				}

    				case 'moderator:changePTZ':
    				{

    					console.log('moderator:changePTZ................', notification?.data);

    					const { id, ptz, peerId }=notification.data;

    					if (peerId === this._peerId)
    					{
    						this.controlPtzOptions(ptz, id);
    					}
    					else
    					{
    						await store.dispatch(consumerActions.updateConsumer({ producerId: id, ...ptz }));
    					}

    					// if (this._havePermission(permissions.MODERATE_ROOM))
    					// {
    					// 	await store.dispatch(consumerActions.updateConsumer({ id, ...ptz }));
    					// }

    					// this.updateWebcam({
    					// 	// restart    : true,
    					// 	newZoomVal : notification?.data
    					// });
    					break;
    				}

    				case 'cameraMoveEvents':
    				{

    					console.log('cameraMoveEvents................', notification?.data);

    					this.controlPtzOptions(notification.data);

    					// const { pan, tilt }=notification.data;

    					// if (pan)
    					// {
    					// 	this.controlPtzOptions(notification.data);
    					// 	break;
    					// }
    					// else if (tilt)
    					// {
    					// 	this.controlPtzOptions(notification.data);
    					// 	break;
    					// }
    					break;
    				}

    				case 'changeWebCam':
    				{

    					console.log('changeWebCam................', notification?.data);

    					this.updateWebcam({
    						restart     : true,
    						newDeviceId : notification?.data
    					});
    					break;
    				}

    				case 'changeMic':
    				{

    					console.log('changeMic................', notification?.data);

    					this.updateMic({
    						restart     : true,
    						newDeviceId : notification?.data
    					});

    					break;
    				}

    				case 'setJoinByAccessCode':
    				{
    					const { joinByAccessCode } = notification.data;

    					store.dispatch(
    						roomActions.setJoinByAccessCode(joinByAccessCode));

    					if (joinByAccessCode)
    					{
    						store.dispatch(requestActions.notify(
    							{
    								text : intl.formatMessage({
    									id             : 'room.accessCodeOn',
    									defaultMessage : 'Access code for room is now activated'
    								})
    							}));
    					}
    					else
    					{
    						store.dispatch(requestActions.notify(
    							{
    								text : intl.formatMessage({
    									id             : 'room.accessCodeOff',
    									defaultMessage : 'Access code for room is now deactivated'
    								})
    							}));
    					}

    					break;
    				}

    				case 'activeSpeaker':
    				{
    					const { peerId } = notification.data;

    					if (this._mode === 'speaker')
    					{
    						if (peerId)
    						{
    							if (!store.getState().room?.activeSpeakerId || (store.getState().room?.activeSpeakerId && store.getState().room?.activeSpeakerId !== peerId))
    							{
    								const peer = store.getState().peers[peerId];

    								if (store.getState().room?.activeSpeakerId && peer)
    								{

    									// this._spotlights.closePeer(store.getState().room?.activeSpeakerId);

    									this.updateSpeakerPauseConsumers(store.getState().room?.activeSpeakerId);
    								}

    								if (peer)
    								{
    									console.log('activePeerId', notification.data);
			                            const consumer = Object.values(store.getState().consumers).some((consumer) => consumer.peerId === peerId);
    									store.dispatch(
    										roomActions.setRoomActiveSpeaker(peerId));
										peer.video &&  !consumer && await this.sendRequest('createConsumerForPeer', { peerList: [ peerId ] });
    									// this._spotlights.addPeers([ peer ]);
    									this.updateSpeakerResumeConsumers(peerId);
    								}

    							}
    						}

    					}
    					else if (Number(this._screenPage) === 0 && (this._mode === undefined || this._mode === null))
    					{
    						if (peerId && this._pipActiveSpeaker !== peerId && peerId !== this._peerId)
    						{
    							this._pipActiveSpeaker = peerId;

    							store.dispatch(roomActions.setPipActiveSpeaker(peerId));
    						}

    						this._activeSpeaker=peerId;

    						// if (peerId && peerId !== this._roomActiveSpeaker)
    						// {
    						// 	console.log('this._roomActiveSpeaker===', this._roomActiveSpeaker);
    						// 	this._roomActiveSpeaker = peerId;
    						// 	const findSelfCC = store.getState()?.transcriptionreducer?.find((eachCC) => eachCC.peerId === store.getState()?.me?.id);

    						// 	console.log('findSelfCC==', findSelfCC);

    						// 	if (findSelfCC)
    						// 	{
    						// 		console.log('fdssdafafdfffffffffffffffffffffffffffffffffffffff', findSelfCC?.oldConversation);

    						// 		this.sendTotalAudio({
    						// 			peerId                : store.getState()?.me?.id,
    						// 			displayName           : store.getState()?.me?.displayName,
    						// 			roomId                : this?._roomId,
    						// 			conversationStartTime : new Date().valueOf(),
    						// 			transcribedText       : findSelfCC?.oldConversation,
    						// 			duration              : Math.round((Math.abs(new Date().valueOf() - new Date().valueOf()))/1000)
    						// 		});

    						// 		const updateData={ ...findSelfCC, oldConversation: '' };

    						// 		store.dispatch(transcriptionactions.addOldTranscriptionData(updateData));
    						// 	}

    						// }

    						// if (this._selfActiveSpeaker && this._selfActiveSpeaker === this._peerId)
    						// {
    						// 	this.sendTextToRedis();
    						// }

    						// if (peerId)
    						// {
    						// 	this._selfActiveSpeaker = peerId;
    						// }

    						if (this._SIP && !this._screenSharingActive)
    						{
    							this._SIP.changeActiveSpeaker(peerId);
    						}

    						store.dispatch(
    							roomActions.setRoomActiveSpeaker(peerId));

    						if (peerId && peerId !== this._peerId)
    							this._spotlights.handleActiveSpeaker(peerId);
    					}

    					break;
    				}

    				case 'changeDisplayName':
    				{
    					const { peerId, displayName, oldDisplayName } = notification.data;

    					store.dispatch(
    						peerActions.setPeerDisplayName(displayName, peerId));

    					store.dispatch(requestActions.notify(
    						{
    							text : intl.formatMessage({
    								id             : 'room.peerChangedDisplayName',
    								defaultMessage : '{oldDisplayName} is now {displayName}'
    							}, {
    								oldDisplayName,
    								displayName
    							})
    						}));

    					if (peerId === this._peerId)
    						this._displayName = displayName;

    					break;
    				}

    				case 'changePicture':
    				{
    					const { peerId, picture } = notification.data;

    					store.dispatch(peerActions.setPeerPicture(peerId, picture));

    					break;
    				}

    				case 'raisedHand':
    				{
    					const {
    						peerId,
    						raisedHand,
    						raisedHandTimestamp
    					} = notification.data;

    					if (peerId === store.getState().me.id)
    					{
    						store.dispatch(
    							meActions.setRaisedHand(raisedHand));
    					}
    					else
    					{

    						store.dispatch(
    							peerActions.setPeerRaisedHand(
    								peerId,
    								raisedHand,
    								raisedHandTimestamp
    							)
    						);
    						const { displayName } = store.getState().peers[peerId];

    						let text;

    						if (raisedHand)
    						{
    							text = intl.formatMessage({
    								id             : 'room.raisedHand',
    								defaultMessage : '{displayName} raised their hand'
    							}, {
    								displayName
    							});
    						}
    						else
    						{
    							text = intl.formatMessage({
    								id             : 'room.loweredHand',
    								defaultMessage : '{displayName} put their hand down'
    							}, {
    								displayName
    							});
    						}

    						if (displayName)
    						{
    							store.dispatch(requestActions.notify(
    								{
    									text
    								}));
    						}

    						this._soundNotification(notification.method);
    					}

    					break;
    				}

    				case 'chatMessage':
    				{
    					const { peerId, chatMessage } = notification.data;

    					console.log('chatMessage peer===', peerId, chatMessage, store.getState().me.id);
    					console.log('chatMessage file===', store.getState().me.id, peerId, store.getState().me.id === peerId);

    					store.dispatch(
    						chatActions.addMessage({ ...chatMessage, sender: store.getState().me.id === peerId ? 'client' : chatMessage.sender, peerId, isRead: store.getState().me.id === peerId ? true : false }));

    					if (
    						!store.getState().toolarea.toolAreaOpen ||
								(store.getState().toolarea.toolAreaOpen &&
									store.getState().toolarea.currentToolTab !== 'chat')
    					) // Make sound
    					{
    						store.dispatch(
    							roomActions.setToolbarsVisible(true));
    						this._soundNotification(notification.method);
    					}

    					break;
    				}

    				case 'privateChatMssg':
    				{
    					const { message } = notification.data.chatMessage;

    					if (store.getState().privateChat.activeParticipant.id === message?.peerId)
    					{
    						store.dispatch(privateChatActions.addPrivateMessage({ toId: message?.peerId, message: { ...message, isRead: true }, displayName: message?.name, picture: message?.picture }));
    					}
    					else
    					{
    						store.dispatch(privateChatActions.addPrivateMessage({ toId: message?.peerId, message: { ...message, isRead: false }, displayName: message?.name, picture: message?.picture }));
    						store.dispatch(
    							roomActions.setToolbarsVisible(true));
    						this._soundNotification();
    					}
    					break;
    				}

    				case 'streamEnrolled':
    				{
    					if (notification.data.exited)
    					{
    						store.dispatch(roomActions.setStreamStatus(false));
    					}
    					else
    					{
    						store.dispatch(roomActions.setStreamStatus(true));
    					}
    					// eslint-disable-next-line no-console
    					break;
    				}

    				case 'sendPeerShareRequest':
    				{
    					let unique = [];
    					const index = store.getState().room.shareRequestdata.findIndex((obj) => obj.peerId === notification.data.peerId);

    					if (index < 0)
    					{
    						unique = [ ...store.getState().room.shareRequestdata, notification.data ];
    					}
    					else
    					{
    						const filter = store.getState().room.shareRequestdata.filter((each) => each.peerId !== notification.data.peerId);

    						unique = [ ...filter, notification.data ];
    					}
    					this._soundNotification();

    					// store.dispatch(
    					// 	roomActions.setShareDailogOpen(true));
    					store.dispatch(
    						roomActions.setShareRequestData(unique)
    					);

    					if (!store.getState().settings.showRequests)
    					{
    						store.dispatch(roomActions.setShareDailogOpen(true));
    					}
    					break;
    				}

    				case 'sendPeerAnnotationRequest':
    				{
    					let unique = [];
    					const index = store.getState().room.annotationsRequestData.findIndex((obj) => obj.peerId === notification.data.peerId);

    					if (index < 0)
    					{
    						unique = [ ...store.getState().room.annotationsRequestData, notification.data ];
    					}
    					else
    					{
    						const filter = store.getState().room.annotationsRequestData.filter((each) => each.peerId !== notification.data.peerId);

    						unique = [ ...filter, notification.data ];
    					}
    					this._soundNotification();

    					store.dispatch(
    						roomActions.setAnnotationsRequestData(unique)
    					);

    					if (!store.getState().settings.showRequests)
    					{
    						store.dispatch(roomActions.setAnnotationDailogOpen(true));
    					}
    					break;
    				}

    				case 'hostDeniedPeerRequest':
    				{
    					const { peerId } = notification.data;

    					if (peerId === this._peerId)
    					{
    						store.dispatch(requestActions.notify(
    							{
    								text : intl.formatMessage({
    									id             : 'moderator.deniedRequest',
    									defaultMessage : 'Host denied the presentation request'
    								})
    							}));

    						store.dispatch(roomActions.setIsScreenshareAccept(false));
    					}
    					break;
    				}

    				case 'hostDeniedAnnotationRequest':
    				{
    					const { peerId } = notification.data;

    					if (peerId === this._peerId)
    					{
    						store.dispatch(requestActions.notify(
    							{
    								text : intl.formatMessage({
    									id             : 'moderator.deniedRequest',
    									defaultMessage : 'Host denied the Annotation request'
    								})
    							}));
    					}
    					break;
    				}
    				case 'setLiveStreamData':
    				{
    					const { youtubeLiveStreamData, facebookLiveStreamData } = notification.data;

    					if (youtubeLiveStreamData && Object.keys(youtubeLiveStreamData).length > 0)
    					{
    						store.dispatch(roomActions.setYoutubeStreamData(youtubeLiveStreamData));

    					}

    					if (facebookLiveStreamData && Object.keys(facebookLiveStreamData).length > 0)
    					{
    						store.dispatch(roomActions.setFacebookStreamData(facebookLiveStreamData));

    					}

    					break;
    				}

    				case 'setLayoutRequested':
    				{
    					const { layout, layoutData } = notification.data;

    					// alert(store.getState().room.isTelepresense);
    					if (store.getState().room.isTelepresense)
    					{
    						if (layout === 'whiteboardview')
    						{
    							this._layoutDataWB = layoutData;
    							// console.log('Layout Data of WB', layoutData);
    							store.dispatch(
    								roomActions.setWhiteboardData(layoutData));

    							store.dispatch(
    								roomActions.setTpScreenPresentationView('whiteboardview')
    							);
    						}
    						else if (layout === 'screenshareview')
    						{

    							this._layoutDataSC = layoutData;
    							this.addSelectedPeer(layoutData[0]);
    							store.dispatch(
    								roomActions.setActiveScreenId(layoutData[0],
    									layoutData));

    							store.dispatch(
    								roomActions.setTpScreenPresentationView('screenshareview')
    							);

    						}
    						if (this._mode && this._mode === 'screen')
    						{
    							store.dispatch(roomActions.setDisplayMode('presenter'));
    						}

    						return;
    					}

    					if (layout === 'whiteboardview')
    					{
    						this._layoutDataWB = layoutData;
    						store.dispatch(
    							roomActions.setWhiteboardData(layoutData));
    					}
    					else if (layout === 'screenshareview')
    					{
    						this._layoutDataSC = layoutData;
    						if (layoutData.length > 0)
    						{
    							this.addSelectedPeer(this._layoutDataSC[0]);
    							store.dispatch(
    								roomActions.setActiveScreenId(this._layoutDataSC[0],
    									this._layoutDataSC));
    						}
    					}

    					if (Number(this._screenPage) > 0)
    					{
    						store.dispatch(roomActions.setDisplayMode('pagescreen'));

    					}
    					else if (this._mode && this._mode === 'speaker')
    					{
    						store.dispatch(roomActions.setDisplayMode('activeSpeakerview'));
    					}
    					else if (this._mode && this._mode === 'screen')
    					{
    						store.dispatch(roomActions.setDisplayMode('presenter'));
    					}
    					else
    					{
    						store.dispatch(roomActions.setDisplayMode(layout));
    					}

    					// if(layout === 'screenshareview' && layoutData) {
    					// 	this.addSelectedPeer(layoutData);
    					// }

    					break;
    				}

    				case 'setFileShareLayoutRequest':
    				{

    					const { layout, layoutData } = notification.data;

    					if (layout === 'fileShareView')
    					{

    						this._fileShareLayoutData = layoutData;
    						if (Object.keys(layoutData).length > 0)
    						{
    							store.dispatch(
    								roomActions.setDocument(layoutData)
    							);
    							store.dispatch(roomActions.setTotalPages(layoutData.pages));
    						}
    						if (this._mode && this._mode === 'screen')
    						{
    							store.dispatch(
    								roomActions.setTpScreenPresentationView('fileShareView')
    							);
    						}
    						else
    						{
    							store.dispatch(roomActions.setDisplayMode('fileShareView'));
    							store.dispatch(roomActions.setPage(1));
    						}
    					}
    					else
    					{
    						store.dispatch(roomActions.setDisplayMode(layout));
    						this._fileShareLayoutData = null;
    						store.dispatch(roomActions.setDocument(null));
    						store.dispatch(roomActions.setTotalPages(0));
    						store.dispatch(roomActions.setPage(1));
    						if (this._annotationsSocket)
    						{
    							this._annotationsSocket.disconnect();
    						}
    						if (this._mode && this._mode === 'screen')
    						{
    							if (store.getState().room.allScreens.length > 0)
    							{
    								store.dispatch(
    									roomActions.setTpScreenPresentationView('screenshareview')
    								);
    							}
    							else if (store.getState().room.wbData && Object.keys(store.getState().room.wbData).length > 0)
    							{
    								store.dispatch(
    									roomActions.setTpScreenPresentationView('whiteboardview')
    								);
    							}
    							else
    							{
    								store.dispatch(
    									roomActions.setTpScreenPresentationView('')
    								);
    							}
    						}
    						else if (Number(this._screenPage) === 0)
    						{
    							if (this._layoutDataSC?.length > 0)
    							{
    								store.dispatch(roomActions.setDisplayMode('screenshareview'));
    							}
    							else if (this._layoutDataWB)
    							{
    								store.dispatch(roomActions.setDisplayMode('whiteboardview'));
    							}
    							else if (this._videoData)
    							{
    								store.dispatch(roomActions.setDisplayMode('videoShareView'));
    							}
    						}
    					}
    					if (Number(this._screenPage) > 0)
    					{
    						store.dispatch(roomActions.setDisplayMode('pagescreen'));

    					}
    					else if (this._mode && this._mode === 'speaker')
    					{
    						store.dispatch(roomActions.setDisplayMode('activeSpeakerview'));
    					}
    					else if (this._mode && this._mode === 'screen')
    					{
    						store.dispatch(roomActions.setDisplayMode('presenter'));
    					}

    					break;
    				}

    				case 'chatVisibilityOptions':
    				{
    					store.dispatch(webinarActions.setWebinarData({ ...store.getState().webinar.webinarData, ...notification.data }));

    					break;
    				}

    				case 'setVideoShareLayoutRequest':
    				{

    					const { layout, layoutData } = notification.data;

    					console.log('setVideoShareLayoutRequest==', notification.data);
    					if (layout === 'videoShareView')
    					{
    						if (this._mode && this._mode === 'screen')
    						{
    							// store.dispatch(roomActions.setVideoData(layoutData));
    							// this._videoData = layoutData;
    							// // if (Object.keys(layoutData).length > 0)
    							// // {
    							// store.dispatch(
    							// 	roomActions.setTpScreenPresentationView('videoShare')
    							// );
    						}
    						else if (Number(this._screenPage) === 0 && (this._mode === undefined || this._mode === null))
    						{
    							this._videoData = layoutData;
    							// if (Object.keys(layoutData).length > 0)
    							// {
    							store.dispatch(roomActions.setVideoData(layoutData));
    							// }
    							store.dispatch(roomActions.setDisplayMode('videoShareView'));

    						}

    					}
    					else
    					{
    						// store.dispatch(roomActions.setDisplayMode(layout));
    						this._videoData = null;
    						store.dispatch(roomActions.setVideoData(null));

    						if (this._mode && this._mode === 'screen')
    						{
    							if (store.getState().room.allScreens.length > 0)
    							{
    								store.dispatch(
    									roomActions.setTpScreenPresentationView('screenshareview')
    								);
    							}
    							else if (store.getState().room.wbData && Object.keys(store.getState().room.wbData).length > 0)
    							{
    								store.dispatch(
    									roomActions.setTpScreenPresentationView('whiteboardview')
    								);
    							}
    							else
    							{
    								console.log('setTpScreenPresentationView=======');
    								store.dispatch(
    									roomActions.setTpScreenPresentationView('')
    								);
    							}

    							store.dispatch(roomActions.setDisplayMode('presenter'));
    						}
    						else if (Number(this._screenPage) === 0)
    						{

    							if (this._layoutDataSC?.length > 0)
    							{
    								store.dispatch(roomActions.setDisplayMode('screenshareview'));
    							}
    							else if (this._layoutDataWB)
    							{
    								store.dispatch(roomActions.setDisplayMode('whiteboardview'));
    							}
    							else if (this._fileShareLayoutData)
    							{
    								store.dispatch(roomActions.setDisplayMode('fileShareView'));
    							}
    							else
    							{
    								store.dispatch(roomActions.setDisplayMode(layout));
    							}
    						}
    						else if (Number(this._screenPage) > 0)
    						{
    							store.dispatch(roomActions.setDisplayMode('pagescreen'));
    						}
    						else if (this._mode && this._mode === 'speaker')
    						{
    							store.dispatch(roomActions.setDisplayMode('activeSpeakerview'));
    						}
    						else
    						{
    							store.dispatch(roomActions.setDisplayMode(layout));
    						}

    					}

    					// if (Number(this._screenPage) > 0)
    					// {
    					// 	store.dispatch(roomActions.setDisplayMode('pagescreen'));

    					// }
    					// else if (this._mode && this._mode === 'speaker')
    					// {
    					// 	store.dispatch(roomActions.setDisplayMode('activeSpeakerview'));
    					// }
    					// else if (this._mode && this._mode === 'screen')
    					// {
    					// 	store.dispatch(roomActions.setDisplayMode('presenter'));
    					// }
    					// else
    					// {
    					// 	store.dispatch(roomActions.setDisplayMode(layout));
    					// }

    					break;
    				}

    				case 'setvideoEvents':
    				{
    					store.dispatch(roomActions.setVideoData(notification.data.videoData));
    					break;
    				}

    				case 'setPeerPage':
    				{
    					store.dispatch(roomActions.setPage(notification.data.page));
    					break;
    				}

    				case 'setWebinarVideo':
    				{
    					const { layout, layoutData } = notification.data;

    					if (layoutData)
    					{
    						store.dispatch(webinarActions.setSelectedwebinarVideo(layoutData));
    						store.dispatch(roomActions.setDisplayMode(layout));
    					}
    					else
    					{
    						store.dispatch(roomActions.setDisplayMode(layout));
    						store.dispatch(webinarActions.setSelectedwebinarVideo(layoutData));
    					}

    					break;
    				}

    				case 'setWebinarAudio':
    				{
    					const { layoutData } = notification.data;

    					store.dispatch(webinarActions.setSelectedWebinarAudio(layoutData));
    					// store.dispatch(roomActions.setDisplayMode(layout));
    					break;
    				}
    				case 'setWebinarOverlays':
    				{

    					store.dispatch(webinarActions.setSelectedWebinarOverlays(notification.data.data));
    					break;
    				}

    				case 'setLogo':
    				{
    					store.dispatch(webinarActions.setSelectedBrandingLogo(notification.data.url));
    					break;
    				}

    				case 'setBackground':
    				{
    					store.dispatch(webinarActions.setSelectedBackground(notification.data.url));
    					break;
    				}

    				case 'removeWhiteboardviewLayout':
    				{
    					const { layout, layoutData } = notification.data;

    					if (store.getState().room.isTelepresense)
    					{

    						this._layoutDataWB = layoutData;
    						store.dispatch(
    							roomActions.setWhiteboardData(layoutData));

    						if (this._mode && this._mode === 'screen')
    						{
    							if (store.getState().room.allScreens.length > 0)
    							{
    								store.dispatch(
    									roomActions.setTpScreenPresentationView('screenshareview')
    								);
    							}
    							else if (store.getState().room.uploadDocument && Object.keys(store.getState().room.uploadDocument).length > 0)
    							{
    								store.dispatch(
    									roomActions.setTpScreenPresentationView('fileShareView')
    								);
    							}
    							else
    							{
    								store.dispatch(
    									roomActions.setTpScreenPresentationView('')
    								);
    							}
    							store.dispatch(roomActions.setDisplayMode('presenter'));
    						}

    						return;
    					}

    					this._layoutDataWB = layoutData;
    					store.dispatch(
    						roomActions.setWhiteboardData(layoutData));

    					store.dispatch(roomActions.setDisplayMode(layout));

    					break;
    				}
    				case 'moderator:clearChat':
    				{
    					store.dispatch(chatActions.clearChat());

    					store.dispatch(fileActions.clearFiles());

    					store.dispatch(requestActions.notify(
    						{
    							text : intl.formatMessage({
    								id             : 'moderator.clearChat',
    								defaultMessage : 'Moderator cleared the chat'
    							})
    						}));

    					break;
    				}

    				case 'setAnimeEmojiRequest':
    				{

    					const { selectedAnimeEmoji } = notification.data;

    					store.dispatch(toolareaAction.handleEmojis(selectedAnimeEmoji));

    					const removeEmoji = () =>
    					{
    						store.dispatch(toolareaAction.removeEmojis());
    					};

    					setTimeout(removeEmoji, 5000);

    					break;
    				}

    				case 'setPollingRequest':
    				{

    					const { pollingData } = notification.data;

    					store.dispatch(toolareaAction.handlePollingDialogue(true));

    					store.dispatch(toolareaAction.handlePollings(pollingData));

    					// store.dispatch(toolareaAction.handleCurrentPolling(pollingData));

    					// const removeEmoji = () =>
    					// {
    					// 	store.dispatch(toolareaAction.removeEmojis());
    					// };

    					// setTimeout(removeEmoji, 5000);

    					break;
    				}

    				case 'setPeerPollSubmitList':
    				{

    					const { peerPollSubmitData } = notification.data;

    					store.dispatch(toolareaAction.peerPollSubmitList(peerPollSubmitData));

    					// store.dispatch(toolareaAction.handleCurrentPolling(pollingData));

    					// const removeEmoji = () =>
    					// {
    					// 	store.dispatch(toolareaAction.removeEmojis());
    					// };

    					// setTimeout(removeEmoji, 5000);

    					break;
    				}

    				case 'setHostControls':
    				{

    					const { hostControlsObj } = notification.data;

    					console.log('hostControlsObj===', hostControlsObj);

    					const duplicateElement = { ...hostControlsObj };

    					console.log('duplicateElement====', duplicateElement);

    					delete hostControlsObj.access;
    					delete hostControlsObj.type;

    					store.dispatch(toolareaAction.setHostControls(hostControlsObj));

    					const isModerator = this._havePermission(permissions.MODERATE_ROOM);

    					const hasVideoPermission = this._havePermission(permissions.SHARE_VIDEO);

    					// const hasPrivateChatPermission=this._havePermission(permissions.PRIVATE_CHAT);

    					const hasAudioPermission = this._havePermission(permissions.SHARE_AUDIO);

    					// const hasInputPermission = this._havePermission(permissions.SHARE_SCREEN);

    					if (!isModerator && hostControlsObj?.hostControlVideoControl && hasVideoPermission)
    					{
    						store.dispatch(requestActions.notify(
    							{
    								text : intl.formatMessage({
    									id             : 'moderator.unmuteVideo',
    									defaultMessage : 'Moderator given video access'
    								})
    							}));
    					}
    					else if (!isModerator && !hostControlsObj.hostControlVideoControl && hasVideoPermission && this._webcamProducer && duplicateElement.type === 'video' && !this._SIP)
    					{
    						this.disableWebcam();
    					}
    					else
    					if (!isModerator && hostControlsObj?.hostControlMicroPhone && hasAudioPermission)
    					{
    						store.dispatch(requestActions.notify({
    							text : intl.formatMessage({
    								id             : 'moderator.unmuteAudio',
    								defaultMessage : 'Moderator given audio access'
    							})
    						}));
    					}
    					else if (duplicateElement.access && !isModerator)
    					{
    						switch (duplicateElement.type)
    						{
    							case 'privateChat':
    								store.dispatch(requestActions.notify({
    									text : intl.formatMessage({
    										id             : 'moderator.privateChat',
    										defaultMessage : 'The Moderator has given access to private chat'
    									})
    								}));
    								break;
    						}
    					}
    					else if (!duplicateElement.access && !isModerator)
    					{

    						switch (duplicateElement.type)
    						{
    							case 'video':
    								store.dispatch(requestActions.notify({
    									text : intl.formatMessage({
    										id             : 'moderator.muteVideo',
    										defaultMessage : 'Moderator stopped your video'
    									})
    								}));
    								break;
    							case 'audio':
    								store.dispatch(requestActions.notify({
    									text : intl.formatMessage({
    										id             : 'moderator.muteAudio',
    										defaultMessage : 'Moderator muted your audio'
    									})
    								}));
    								break;
    							case 'privateChat':
    								store.dispatch(requestActions.notify({
    									text : intl.formatMessage({
    										id             : 'moderator.removePrivateChat',
    										defaultMessage : 'The Moderator has removed access to private chat'
    									})
    								}));
    								break;
    							case 'CC':
    							{
    								if (!hostControlsObj?.hostControlCC && !isModerator)
    								{
    									store.dispatch(roomActions.setIsEnableCC(false));
    								}

    								store.dispatch(requestActions.notify({
    									text : intl.formatMessage({
    										id             : 'moderator.removedCC',
    										defaultMessage : 'Moderator Removed CC'
    									})
    								}));
    							}
    						}
    					}
    					break;
    				}

    				case 'sendFile':
    				{
    					const file = notification.data;

    					console.log('received file===', store.getState().me.id, file.peerId, store.getState().me.id === file.peerId);

    					store.dispatch(fileActions.addFile({ ...file, sender: store.getState().me.id === file.peerId ? 'client' : 'response', isRead: store.getState().me.id === file.peerId ? true : false }));

    					store.dispatch(requestActions.notify(
    						{
    							text : intl.formatMessage({
    								id             : 'room.newFile',
    								defaultMessage : 'New file available'
    							})
    						}));

    					if (
    						!store.getState().toolarea.toolAreaOpen ||
								(store.getState().toolarea.toolAreaOpen &&
									store.getState().toolarea.currentToolTab !== 'chat')
    					) // Make sound
    					{
    						store.dispatch(
    							roomActions.setToolbarsVisible(true));
    						this._soundNotification(notification.method);
    					}

    					break;
    				}

    				case 'sendPrivateFile': {
    					const { file } = notification.data;

    					store.dispatch(privateChatActions.addPrivateMessage({ toId: file?.peerId, message: { ...file, sender: 'response', isRead: false }, displayName: file?.name, picture: file?.picture }));

    					store.dispatch(requestActions.notify(
    						{
    							text : intl.formatMessage({
    								id             : 'room.newFile',
    								defaultMessage : 'New file available'
    							})
    						}));

    					if (store.getState()?.privateChat?.activeParticipant?.id !== file?.peerId)
    					{
    						store.dispatch(
    							roomActions.setToolbarsVisible(true));
    						this._soundNotification();
    					}

    					break;
    				}

    				/*
					case 'moderator:clearFileSharing':
					{
						store.dispatch(fileActions.clearFiles());

						store.dispatch(requestActions.notify(
							{
								text : intl.formatMessage({
									id             : 'moderator.clearFiles',
									defaultMessage : 'Moderator cleared the files'
								})
							}));

						break;
					}
					*/

    				case 'producerScore':
    				{
    					const { producerId, score } = notification.data;

    					store.dispatch(
    						producerActions.setProducerScore(producerId, score));

    					break;
    				}

    				case 'newPeer':
    				{
    					const {
    						id,
    						displayName,
    						picture,
    						roles,
    						returning,
    						// localRecordingState,
    						isBreakoutRoom,
    						brRoomId,
    						roleType,
    						screenShare,
    						isSIPUser,
    						audio,
    						video
    					} = notification.data;

    					if (Number(this._screenPage) > 0 || this._mode === 'speaker')
    					{
    						if (!roles.includes(5337))
    						{
    							store.dispatch(peerActions.addPeer(
    								{ id, displayName, picture, roles, roleType, consumers: [], screenShare, isSIPUser }));
    						}

    					}
    					else if (this._mode === 'screen')
    					{
    						store.dispatch(peerActions.addPeer(
    							{ id, displayName, picture, roles, roleType, consumers: [], screenShare, isSIPUser }));
    					}
    					else
    					{
    						store.dispatch(peerActions.addPeer(
    							{ id, displayName, picture, roles, roleType, consumers: [], screenShare, isSIPUser, audio, video }));
    						if (!screenShare)
    						{
    							this._spotlights.newPeer(id);
    						}

    						if (!isBreakoutRoom)
    						{
    							if (store.getState().me.roles.includes(5337))
    							{

    								this.removeMainPeerFromBrRoom({ id, displayName, picture, roles, roleType, consumers: [] });
    							}

    							if (!roles.includes(5337))
    							{
    								if (!screenShare && !isSIPUser)
    								{
    									const filterData = store.getState().room.breakoutRoomPeers.filter((each) => each.id !== id);

    									store.dispatch(roomActions.handleBreakoutRoomPeers([ ...filterData,
    										{ id, displayName, picture, roles, roleType, consumers: [] }
    									]));
    								}
    							}
    							else
    							{
    								const filterData = store.getState().room.breakoutRoomHost.filter((each) => each.id !== id);

    								store.dispatch(roomActions.handleBreakoutRoomHostList([ ...filterData, { id, displayName, picture, roles, consumers: [] } ]));
    							}
    						}
    						else
    						if (store.getState().me.roles.includes(5337))
    						{
    							this.setPeerDataToMainRoom({ peerData: { id, displayName, picture, roles, roleType, consumers: [] }, breakoutRoomId: brRoomId });
    						}

    					}

    					// store.dispatch(roomActions.handleBreakoutRoomPeers([ ...store.getState().room.breakoutRoomPeers,
    					// 	{ id, displayName, picture, roles, consumers: [] }
    					// ]));

    					// if (Number(this._screenPage))
    					// {
    					// 	this._spotpages.newPeer(id);
    					// }
    					// else
    					// {
    					// 	this._spotlights.newPeer(id);
    					// }

    					if (!returning)
    					{
    						this._soundNotification(notification.method);

    						store.dispatch(requestActions.notify(
    							{
    								text : intl.formatMessage({
    									id             : 'room.newPeer',
    									defaultMessage : '{displayName} joined the room'
    								}, {
    									displayName
    								})
    							}));
    					}

    					// this.cpanelPeerData();

    					break;
    				}

    				case 'mainRoomPeerJoin':
    				{

    					const {
    						id,
    						displayName,
    						picture,
    						roles,
    						screenShare
    					} = notification.data;

    					// const filterData = store.getState().room.breakoutRoomPeers.filter((each) => each.id !== id);

    					// store.dispatch(roomActions.handleBreakoutRoomPeers([ ...filterData,
    					// { id, displayName, picture, roles, consumers: [] }
    					// ]));

    					if (!roles.includes(5337))
    					{

    						if (!screenShare)
    						{
    							const filterData = store.getState().room.breakoutRoomPeers.filter((each) => each.id !== id && !each.screenShare && !each.isSIPUser);

    							store.dispatch(roomActions.handleBreakoutRoomPeers([ ...filterData,
    								{ id, displayName, picture, roles, consumers: [] }
    							]));
    						}

    					}
    					else
    					{
    						const filterData = store.getState().room.breakoutRoomHost.filter((each) => each.id !== id);

    						store.dispatch(roomActions.handleBreakoutRoomHostList([ ...filterData, { id, displayName, picture, roles, consumers: [] } ]));
    					}

    					break;
    				}

					case 'screenShareEnded':
						{
							const { peerId } = notification.data;
							this.exitScreenShareIfRequired(peerId);
							break;
						}

    				case 'peerClosed':
    				{
    					// const { peerId } = notification.data;
    					const { peerId, spotlights } = notification.data;

    					this.exitScreenShareIfRequired(peerId);
    					this.removeCanvas(peerId);

    					for (const consumer of this._consumers.values())
    					{
    						if (peerId === consumer.appData.peerId)
    						{
    							this._closeConsumer(consumer.id);
    						}
    					}

    					store.dispatch(privateChatActions.removePeerChat(peerId));
    					// console.log('spotlights', this._peerId);
						const peerslist=Object.keys(store.getState().peers);
                        console.log('peerslist', peerslist);
    					this._spotlights.closePeer(peerId, spotlights.filter((id) => id !== this._peerId && id !== peerId && peerslist.includes(id)));

    					// this._spotlights.closePeer(peerId);
    					// this._spotlights.closePeer(peerId, spotlights.filter((id) => id !== this._peerId && id !== peerId));

    					store.dispatch(
    						peerActions.removePeer(peerId));

    					if (store.getState().room.breakoutRoomsNewList.length > 0)
    					{
    						removeBreakoutRoomPeer(peerId);
    					}

    					if (this._pipActiveSpeaker === peerId)
    					{
    						this._clearPipActiveSpeaker();
    					}

    					store.dispatch(transcriptionactions.removeClosePeer(peerId));

    					// if ((this._uid === 'cmVjb3JkaW5nQm90VXNlcg===') && Object.values(store.getState().peers).length === 0)
    					// {
    					// 	setTimeout(() =>
    					// 	{
    					// 		this.close();
    					// 	}, 5000);
    					// }
    					if (store.getState().privateChat.activeParticipant?.id === peerId)
    					{
    						store.dispatch(privateChatActions.addActiveParticipant({ ...store.getState().privateChat.activeParticipant, participantPresent: false }));
    					}

    					if (Number(this._screenPage) > 0 || this._mode === 'speaker' || this._mode === 'screen')
    					{
    						this._spotpages.closePeer(peerId);
    					}

    					// this.cpanelPeerData();

    					break;
    				}

    				case 'newConsumer':
    				{
    					const {
    						peerId,
    						producerId,
    						id,
    						kind,
    						rtpParameters,
    						type,
    						appData,
    						producerPaused,
    						score
    					} = notification.data;

    					const consumer = await this._recvTransport.consume(
    						{
    							id,
    							producerId,
    							kind,
    							rtpParameters,
    							appData         : { ...appData, peerId }, // Trick.
    							initiallyPaused : true
    						});

    					if (this._recvTransport.appData.encodedInsertableStreams)
    					{
    						const { enableOpusDetails } = store.getState().settings;

    						if (kind === 'audio' && enableOpusDetails)
    							opusReceiverTransform(consumer.rtpReceiver, consumer.id);
    						else
    							directReceiverTransform(consumer.rtpReceiver);
    					}

    					// Store in the map.
    					// this._consumers.set(consumer.id, consumer);

    					consumer.on('transportclose', () =>
    					{
    						this._consumers.delete(consumer.id);
    					});

    					const { spatialLayers, temporalLayers } =
								mediasoupClient.parseScalabilityMode(
									consumer.rtpParameters.encodings[0].scalabilityMode);

    					const consumerStoreObject = {
    						id                     : consumer.id,
    						peerId                 : peerId,
    						kind                   : kind,
    						type                   : type,
    						locallyPaused          : false,
    						remotelyPaused         : producerPaused,
    						rtpParameters          : consumer.rtpParameters,
    						source                 : consumer.appData.source,
    						width                  : consumer.appData.width,
    						height                 : consumer.appData.height,
    						resolutionScalings     : consumer.appData.resolutionScalings,
							panRange               : consumer.appData?.panRange,
    						pan                    : consumer.appData?.pan,
    						tiltRange              : consumer.appData?.tiltRange,
    						tilt                   : consumer.appData?.tilt,
    						zoomRange              : consumer.appData?.zoomRange,
    						zoom                   : consumer.appData?.zoom,
    						spatialLayers          : spatialLayers,
    						temporalLayers         : temporalLayers,
    						preferredSpatialLayer  : 0,
    						preferredTemporalLayer : 0,
    						priority               : 1,
    						codec                  : consumer.rtpParameters.codecs[0].mimeType.split('/')[1],
    						track                  : consumer.track,
    						score                  : score,
    						audioGain              : undefined,
    						opusConfig             : null,
							isCameraControl        : consumer.appData?.isCameraControl,
    						producerId             : producerId
    					};

    					// this._spotlights.addVideoConsumer(consumerStoreObject);

    					if (Number(this._screenPage) > 0 || this._mode === 'speaker')
    					{
    						if (kind !== 'audio' && consumer.appData.source !== 'screen')
    						{

    							// if (Number(this._screenPage)>0)
    							// {

    							// 	this._spotlights.newPeer(peerId);
    							// }
    							this._consumers.set(consumer.id, consumer);
    							await store.dispatch(consumerActions.addConsumer(consumerStoreObject, peerId));
    							consumer['initiallyPaused'] = false;
    							await this._startConsumer(consumer);
    						}
    					}
    					else if (this._mode === 'screen')
    					{
    						if (consumer.appData.source === 'screen')
    						{
    							this._consumers.set(consumer.id, consumer);
    							await store.dispatch(consumerActions.addConsumer(consumerStoreObject, peerId));
    							consumer['initiallyPaused'] = false;
    							await this._startConsumer(consumer);
    						}
    					}
    					else
    					{
    						this._consumers.set(consumer.id, consumer);
    						await store.dispatch(consumerActions.addConsumer(consumerStoreObject, peerId));
    						// await this._startConsumer(consumer);
    					}

    					if (kind === 'audio')
    					{
    						console.log('starting audio consumer');
    						await this._startConsumer(consumer);
    					}

    					this.setConsumerToSpotLight(consumerStoreObject);

    					// this._spotlights.addVideoConsumer(consumerStoreObject);

    					// consumer['initiallyPaused'] = false;

    					// if (this._consumers.size <= this._maxSpotlights)
    					// {

    					// 	console.log('cosumer_exsits ===== ', this._consumers.size, this._maxSpotlights);

    					// 	await this._startConsumer(consumer);
    					// }

    					if (kind === 'audio')
    					{
    						// consumer.volume = 0;

    						const stream = new MediaStream();

    						stream.addTrack(consumer.track);

    						if (!stream.getAudioTracks()[0])
    							throw new Error('request.newConsumer | given stream has no audio track');

    						consumer.hark = hark(stream, { play: false, interval: 100 });

    						consumer.hark.on('volume_change', (volume) =>
    						{

    							volume = Math.round(volume);
    							// console.log('volume=====', volume);
    							// if (consumer && volume !== consumer.volume)
    							// {

    							// 	console.log('sqqeqeqweqew', volume);
    							// 	consumer.volume = volume;

    							// 	store.dispatch(peerVolumeActions.setPeerVolume(peerId, volume));
    							// }

    							store.dispatch(peerVolumeActions.setPeerVolume(peerId, volume));
    						});

    						if (this._SIP)
    						{
    							this._SIP.mergeActiveSpeakerAudio(store.getState().consumers);
    						}

    					}

    					if (kind === 'video')
    					{
    						if (this._SIP && !this._screenSharingActive)
    						{
    							this._SIP.changeActiveSpeaker(this._activeSpeaker);
    						}
    					}
    					if (this._SIP && consumer.appData.source === 'screen')
    					{
    						this._sipModeratorId = consumer.appData.sipModerator;

    						this._screenSharingActive = true;

    						this._SIP.replaceScreenConsumerTrack(peerId, consumer.appData.sipModerator);
    					}

    					// if (peerId === this._pipActiveSpeaker && isInPIP())
    					// {
    					// 	store.dispatch(roomActions.setPipActiveSpeaker(null));
    					// 	this._pipActiveSpeaker = null;
    					// }

    					console.log('this.consumers=====================', this._consumers.values());
    					break;
    				}

    				case 'consumerClosed':
    				{
    					const { consumerId } = notification.data;
						if(consumerId === store.getState().room.fullScreenConsumer){
							// this.resumeSpotlightConsumersfullscreen();
							this.pauseOrResumeConsumers({activeConsumer:null,spotlights:store.getState().room.spotlights});
							store.dispatch(roomActions.toggleConsumerFullscreen('sendingNull'));
						}

    					const consumerFind = store.getState().consumers[consumerId];

    					if (consumerFind && consumerFind !== undefined)
    					{

    						this._closeConsumer(consumerId);
    						// await this.cpanelPeerResponse();
    					}

    					console.log('this,,d,ads,,,,,,mmmmmmmmmmmmmmmmmmmmmmmmmmm', this._consumers.values());

    					break;
    				}

    				case 'consumerPaused':
    				{
    					const { consumerId } = notification.data;
    					const consumer = this._consumers.get(consumerId);

    					if (!consumer)
    						break;

    					const consumerFind = store.getState().consumers[consumerId];

    					if (consumerFind && consumerFind !== undefined)
    					{
    						store.dispatch(
    							consumerActions.setConsumerPaused(consumerId, 'remote'));

    						this._spotlights.pauseVideoConsumer(consumerId);

    						// await this.cpanelPeerResponse();
    					}

    					break;
    				}

    				case 'consumerResumed':
    				{
    					const { consumerId } = notification.data;
    					const consumer = this._consumers.get(consumerId);

    					if (!consumer)
    						break;

    					const consumerFind = store.getState().consumers[consumerId];

    					if (consumerFind && consumerFind !== undefined)
    					{
    						store.dispatch(
    							consumerActions.setConsumerResumed(consumerId, 'remote'));

    						this._spotlights.resumeVideoConsumer(consumerId);

    						// await this.cpanelPeerResponse();
    					}

    					break;
    				}

    				case 'consumerLayersChanged':
    				{
    					const { consumerId, spatialLayer, temporalLayer } = notification.data;
    					const consumer = this._consumers.get(consumerId);

    					if (!consumer)
    						break;

    					const consumerFind = store.getState().consumers[consumerId];

    					if (consumerFind && consumerFind !== undefined)
    					{

    						store.dispatch(consumerActions.setConsumerCurrentLayers(
    							consumerId, spatialLayer, temporalLayer));
    					}

    					break;
    				}

    				case 'consumerScore':
    				{
    					const { consumerId, score } = notification.data;

    					const consumerFind = store.getState().consumers[consumerId];

    					if (consumerFind && consumerFind !== undefined)
    					{

    						store.dispatch(
    							consumerActions.setConsumerScore(consumerId, score));
    					}

    					break;
    				}

    				case 'moderator:mute':
    				{
    					if (this._SIP)
    					{
    						return;
    					}
    					if ((this._micProducer || this._micInProgress) && !this._micDesiredMuted)
    					{
    						if (notification?.data?.pairId && notification?.data?.pairId !== this._pairId)
    						{
    							this.muteMic();
    						}
    						else if (!notification?.data?.pairId)
    						{
    							this.muteMic();
    						}

    						store.dispatch(requestActions.notify(
    							{
    								text : intl.formatMessage({
    									id             : 'moderator.muteAudio',
    									defaultMessage : 'Moderator muted your audio'
    								})
    							}));
    					}

    					break;
    				}
    				case 'moderator:sipmute':
    				{
    					if ((this._micProducer || this._micInProgress) && !this._micDesiredMuted)
    					{
    						if (notification?.data?.pairId && notification?.data?.pairId !== this._pairId)
    						{
    							this.muteMic();
    						}
    						else if (!notification?.data?.pairId)
    						{
    							this.muteMic();
    						}

    						store.dispatch(requestActions.notify(
    							{
    								text : intl.formatMessage({
    									id             : 'moderator.muteAudio',
    									defaultMessage : 'Moderator muted your audio'
    								})
    							}));
    					}

    					break;
    				}
    				case 'cloudRecordingStatus':
    				{

    					const { status } = notification.data;

    					store.dispatch(meActions.setCloudRecordingInProgress(false));

    					store.dispatch(roomActions.setCloudRecordingLiveStatus(status));
    					store.dispatch(roomActions.setRecordingConsent(status));
    					store.dispatch(roomActions.setEnableDisableCloudRecording(status));

    					break;
    				}

    				case 'broadcastStatus':
    				{
    					const { status } = notification.data;

    					store.dispatch(roomActions.setBroadcastUserStatus(status));
    					store.dispatch(roomActions.setStreamConsentStatus(status));
    					store.dispatch(roomActions.setLiveStreamingOn(status));
    					store.dispatch(meActions.setStreamingInProgress(false));

    					if (store.getState()?.privateChat?.activeTab === 'broadcastChat')
    					{
    						store.dispatch(privateChatActions.addActiveTab('chat'));
    					}

    					break;
    				}
    				case 'startFacebookLive':
    				{
    					const { status } = notification.data;

    					store.dispatch(meActions.setFaceBookStreamingInprogress(false));
    					store.dispatch(roomActions.setFaceBookStreamStatus(status));
    					store.dispatch(roomActions.setStreamConsentStatus(status));

    					break;
    				}

    				case 'startYoutubeLive':
    				{
    					const { status } = notification.data;

    					store.dispatch(meActions.setYoutubeStreamingInprogress(false));
    					store.dispatch(roomActions.setYoutubeStreamStatus(status));
    					store.dispatch(roomActions.setStreamConsentStatus(status));

    					break;
    				}

    				case 'moderator:stopVideo':
    				{
    					if (this._SIP)
    					{
    						return;
    					}

    					if (notification?.data?.pairId && notification?.data?.pairId !== this._pairId)
    					{
    						this.disableWebcam();
    					}
    					else if (!notification?.data?.pairId)
    					{
    						this.disableWebcam();
    					}

    					store.dispatch(requestActions.notify(
    						{
    							text : intl.formatMessage({
    								id             : 'moderator.muteVideo',
    								defaultMessage : 'Moderator stopped your video'
    							})
    						}));

    					break;
    				}

    				case 'moderator:requestPeerVideoOrAudio':
    				{
    					const { type } = notification.data;

    					store.dispatch(toolareaAction.moderatorRequestPeerVideoOrAudio({ type, value: true }));

    					break;
    				}

    				case 'declinedHostRequestedVideoOrAudio':
    				{
    					const { peerId, displayName, type } = notification.data;

    					if (peerId === this._peerId)
    					{
    						if (type === 'video')
    						{
    							store.dispatch(requestActions.notify(
    								{
    									text : intl.formatMessage({
    										id             : 'peer.deniedHostRequestVideo',
    										defaultMessage : `${displayName} denied the video request`
    									})
    								}));
    						}
    						if (type === 'audio')
    						{
    							store.dispatch(requestActions.notify(
    								{
    									text : intl.formatMessage({
    										id             : 'peer.deniedHostRequestAudio',
    										defaultMessage : `${displayName} denied the audio request`
    									})
    								}));
    						}
    					}
    					break;
    				}

    				case 'moderator:stopScreenSharing':
    				{
    					// if (this._deviceInfo.platform === 'desktop' && this._deviceInfo.name === 'electron')
    					// {

    					// }
    					// else
    					// {

    					if (notification?.data?.pairId && notification?.data?.pairId !== this._pairId)
    					{
    						this.disableScreenSharing();
    					}
    					else if (!notification?.data?.pairId)
    					{
    						this.disableScreenSharing();
    					}

    					// }

    					store.dispatch(requestActions.notify(
    						{
    							text : intl.formatMessage({
    								id             : 'moderator.stopScreenSharing',
    								defaultMessage : 'Moderator stopped your screen sharing'
    							})
    						}));

    					break;
    				}

    				case 'moderator:kick':
    				{
    					const device = deviceInfo();

    					if (this._SIP)
    					{
    						this._SIP.rejectOngoingCall();
    						window.location.reload();

    						return;
    					}

    					if (device.platform === 'desktop' && device.name === 'electron' && window.location.host.includes('localhost'))
    					{
    						// this.close(`https://${window.location.host}/kickOut`);
    						this.close(`${window.location.origin}/kickOut`, 'kickOut');
    					}
    					else
    					{
    						// Need some feedback
    						this.close(`https://${window.location.hostname}/kickOut`, 'kickOut');

    						// window.location = `https://${window.location.hostname}/kickOut`;
    					}

    					break;
    				}

    				case 'moderator:leaveMeeting':
    				{
    					// Need some feedback
    					this.close(null, '');
    					break;
    				}

    				case 'moderator:closeMeeting':
    				{
    					const device = deviceInfo();

    					if (this._SIP)
    					{
    						this._sipCloseMeeting = false;
    						this._SIP.rejectOngoingCall();
    						// window.location.reload();

    						return;
    					}

    					if (device.platform === 'desktop' && device.name === 'electron' && window.location.host.includes('localhost'))
    					{
    						// this.close(`https://${window.location.host}/endMeeting`);
    						this.close(`${window.location.origin}/endMeeting`, 'endMeeting');
    					}
    					else
    					{
    						// Need some feedback
    						this.close(`https://${window.location.hostname}/endMeeting`, 'endMeeting');
    						// if (this._havePermission(permissions.MODERATE_ROOM))
    						// {
    						// 	window.location = import.meta.env.VITE_config;
    						// }
    						// else
    						// {
    						// 	window.location =`https://${window.location.hostname}/endMeeting` ;
    						// }
    					}
    					break;
    				}

    				case 'moderator:lowerHand':
    				{
    					this.setRaisedHand(false);

    					break;
    				}

    				case 'gotRole':
    				{
    					const { peerId, roleId, youtubeLiveStreamData, facebookLiveStreamData } = notification.data;

    					const userRoles = store.getState().room.userRoles;

    					if (peerId === this._peerId)
    					{
    						store.dispatch(meActions.addRole(roleId));

    						if (roleId === 9583 && store.getState().room.isScreenshareAccepted)
    						{
    							this.updateScreenSharing({ start: true });
    							store.dispatch(roomActions.setIsScreenshareAccept(false));
    						}

    						store.dispatch(requestActions.notify(
    							{
    								text : intl.formatMessage({
    									id             : 'roles.gotRole',
    									defaultMessage : 'You got the role: {role}'
    								}, {
    									role : userRoles.get(roleId).label
    								})
    							}));
    					}
    					else
    						store.dispatch(peerActions.addPeerRole(peerId, roleId));

    					if (roleId === 5337 && store.getState().room.broadcastUserStatus && peerId === this._peerId)
    					{
    						if (this._meetingType !== 'webinar')
    						{
    							this.connectToBroadcastSocket();

    						}
    						if (this._meetingType === 'webinar')
    						{
    							this.connectToWebinarSocket();
    							store.dispatch(roomActions.setWebinarStreamOn({ webinarStreamOn: true }));

    						}
    					}
    					if (roleId === 5337)
    					{
    						if (youtubeLiveStreamData)
    						{

    							if (Object.keys(youtubeLiveStreamData).length > 0)
    							{
    								store.dispatch(roomActions.setYoutubeStreamData(youtubeLiveStreamData));

    							}
    						}

    						if (facebookLiveStreamData)
    						{
    							if (Object.keys(facebookLiveStreamData).length > 0)
    							{
    								store.dispatch(roomActions.setFacebookStreamData(facebookLiveStreamData));

    							}
    						}
    					}
    					if (roleId === 5337 && this._roomTemplate.meetingDetails &&
							this._roomTemplate.meetingDetails?.isSipEnable)
    					{
    						setInterval(() =>
    						{
    							this.listUsers();
    						}, 10000);
    					}
    					break;
    				}

    				case 'gotAnnotationAccess':
    				{
    					const { peerId, annotationAccess } = notification.data;

    					if (peerId === this._peerId)
    					{
    						console.log('gotAnnotationAccess', annotationAccess);
    						store.dispatch(meActions.setAccessAnnotations(annotationAccess));
    					}

    					break;
    				}

    				case 'lostAnnotationAccess':
    				{
    					const { peerId, annotationAccess } = notification.data;

    					if (peerId === this._peerId)
    					{
    						store.dispatch(meActions.setAccessAnnotations(annotationAccess));
    						window.canvas.isDrawingMode=false;
    						window.canvas.renderAll();
    					}

    					break;
    				}

    				case 'lostRole':
    				{
    					const { peerId, roleId } = notification.data;

    					const userRoles = store.getState().room.userRoles;

    					if (peerId === this._peerId)
    					{
    						store.dispatch(meActions.removeRole(roleId));

    						store.dispatch(requestActions.notify(
    							{
    								text : intl.formatMessage({
    									id             : 'roles.lostRole',
    									defaultMessage : 'You lost the role: {role}'
    								}, {
    									role : userRoles.get(roleId).label
    								})
    							}));
    					}
    					else
    						store.dispatch(peerActions.removePeerRole(peerId, roleId));

    					if (roleId === 5337 && store.getState().room.broadcastUserStatus && peerId === this._peerId)
    					{
    						if (this._meetingType !== 'webinar')
    						{
    							this.broadcastSocket.disconnect();

    						}
    						if (this._meetingType === 'webinar')
    						{
    							this._webinarSocket.disconnect();
    							store.dispatch(roomActions.setWebinarStreamOn({ webinarStreamOn: false }));
    							store.dispatch(roomActions.setWebinarPeers([]));
    						}
    					}

    					break;
    				}
    				case 'addConsentForRecording':
    				{
    					// eslint-disable-next-line no-unused-vars
    					const { peerId, consent } = notification.data;

    					store.dispatch(
    						peerActions.setPeerLocalRecordingConsent(peerId, consent));

    					break;
    				}
    				case 'setLocalRecording':
    				{
    					const { peerId, localRecordingState } = notification.data;
    					const { me, peers } = store.getState();

    					let displayNameOfRecorder;

    					if (peerId === me.id)
    					{
    						displayNameOfRecorder = store.getState().settings.displayName;
    					}
    					else if (peers[peerId])
    						displayNameOfRecorder = store.getState().peers[peerId].displayName;
    					else
    						return;

    					// Save state to peer
    					store.dispatch(
    						peerActions.setPeerLocalRecordingState(peerId, localRecordingState));

    					switch (localRecordingState)
    					{
    						case 'start':
    							await this.addConsentForRecording('agreed');
    							store.dispatch(requestActions.notify(
    								{
    									text : intl.formatMessage({
    										id             : 'room.localRecordingStarted',
    										defaultMessage : '{displayName} started local recording'
    									}, {
    										displayName : displayNameOfRecorder
    									})
    								}));
    							break;
    						case 'resume':
    							store.dispatch(requestActions.notify(
    								{
    									text : intl.formatMessage({
    										id             : 'room.localRecordingResumed',
    										defaultMessage : '{displayName} resumed local recording'
    									}, {
    										displayName : displayNameOfRecorder
    									})
    								}));
    							break;
    						case 'pause':
    						{
    							store.dispatch(requestActions.notify(
    								{
    									text : intl.formatMessage({
    										id             : 'room.localRecordingPaused',
    										defaultMessage : '{displayName} paused local recording'
    									}, {
    										displayName : displayNameOfRecorder
    									})
    								}));
    							break;
    						}
    						case 'stop':
    							store.dispatch(requestActions.notify(
    								{
    									text : intl.formatMessage({
    										id             : 'room.localRecordingStopped',
    										defaultMessage : '{displayName} stopped local recording'
    									}, {
    										displayName : displayNameOfRecorder
    									})
    								}));
    							break;
    						default:
    							break;
    					}
    					break;
    				}

    				case 'breakoutjoin':
    				{
    					// const { breakoutPeers } = notification.data;

    					this.breakoutRoomData = notification.data.breakoutPeers;

    					// this.isBreakoutRoom = true;

    					store.dispatch(roomActions.setBreakoutRoomJoin(true));
    					store.dispatch(roomActions.setIsBreakoutRoomJoin(true));

    					break;
    				}

    				case 'breakoutRoomIsStopped':
    				{
    					store.dispatch(roomActions.setBreakoutRoomJoin(false));
    					store.dispatch(roomActions.setIsBreakoutRoomJoin(false));

    					break;
    				}

    				case 'setPeerToBrRoomList':
    				{
    					if (store.getState().me.roles.includes(5337))
    					{

    						await this.setPeerDataToMainRoom(notification.data);
    					}

    					break;
    				}

    				case 'closeBreakoutRoomToMainRoom':
    				{
    					// store.dispatch(roomActions.setEndBreakoutSession('breakoutRoomStopPeerSide'));

    					// setTimeout(() =>
    					// {
    					// 	this.joinBreakoutRoomToMainRoom();
    					// 	store.dispatch(roomActions.setEndBreakoutSession(''));
    					// }, 20000);

    					await this.joinBrRoomToMainRoomHostPeersAndTpScreeen();

    					break;
    				}

    				case 'breakoutRoomToMainRoom':
    				{

    					this.joinBreakoutRoomToMainRoom();
    					break;
    				}

    				case 'allBrDataToBrRooms':
    				{

    					// store.dispatch(roomActions.setBreakedRoomsNew([ ...notification.data ]));

    					break;
    				}

    				case 'peerLeaveOrCloseInBrRoom':
    				{

    					if (store.getState().me.roles.includes(5337))
    					{

    						this.removeMainPeerFromBrRoom({ id: notification.data.peerId });
    					}

    					break;

    				}

    				case 'tpShiftToBr':
    				{
    					const { brRoomId, type } = notification.data;

    					if (Number(this._screenPage) > 0 || this._mode === 'speaker' || this._mode === 'screen')
    					{
    						type === 'mainRoom' ? this.joinBreakoutRoomToMainRoom() : this.tpScreenBreakoutRoomJoin(brRoomId);
    					}

    					break;
    				}

    				case 'setMainPeerDataToBrHost':
    				{

    					break;
    				}

    				case 'handleBrToMrByHost':
    				{
    					const { data, type } = notification.data;

    					if (!data && type === 'movePeerToBrToMr')
    					{

    						await this.joinBrRoomToMainRoomHostPeersAndTpScreeen();
    					}
    					else if (data && type === 'movePeerBtBrRooms')
    					{
    						this.breakoutRoomData = data;
    						store.dispatch(roomActions.setBreakoutRoomJoin(false));
    						store.dispatch(roomActions.setIsBreakoutRoomJoin(false));

    						if (this._currentRoomId !== data?.id)
    						{
    							store.dispatch(roomActions.setBreakoutRoomJoin(true));
    							store.dispatch(roomActions.setIsBreakoutRoomJoin(true));
    						}
    					}

    					break;
    				}

    				case 'kickoutLobbyPeer':
    				{
    					const { peerId } = notification.data;

    					if (this._peerId === peerId)
    					{
    						this.close(`https://${window.location.hostname}/kickOut`, 'kickOut');
    						// window.location = `https://${window.location.hostname}/kickOut`;
    					}

    					break;
    				}

    				case 'producingStatusChanged':
    				{
    					const { peerId, status } = notification.data;

    						console.log('producingStatusChanged', notification.data);
    						store.dispatch(peerActions.setPeerVideoStatus({ peerId, status }));
    						if (status)
    						{
    							this._spotlights.addPeerToVideoPeerList(peerId);
								Number(this._screenPage) > 0 && await this.sendRequest('createConsumerForPeer', { peerList: [ peerId ] });
    						}
    						else
    						{
    							this._spotlights.removePeerFromVideoPeerList(peerId);
    						}

    					break;
    				}

    				// case 'transcriptiondata':
    				// {

    				// 	// const { transcriptiondata } = notification.data;

    				// 	if (notification.data)
    				// 	{
    				// 		console.log('transcriptiondata====,', notification.data);

    				// 		// this._transcript = transcriptiondata;

    				// 		store.dispatch(transcriptionactions.addTranscriptionData(notification.data));
    				// 	}

    				// 	break;
    				// }

    				case 'annotationsStart':
    				{
    					if (notification?.data?.isAnnotationStart)
    					{

    						this.connectToAnnotationsSocket();

    						store.dispatch(requestActions.notify(
    							{
    								text : intl.formatMessage({
    									id             : 'room.startAnnotation',
    									defaultMessage : 'Annotation has started.'
    								})
    							}));
    					}
    					else
    					{
    						store.dispatch(requestActions.notify(
    							{
    								text : intl.formatMessage({
    									id             : 'room.startAnnotation',
    									defaultMessage : 'Annotation has been stopped.'
    								})
    							}));
    						this._annotationsSocket.disconnect();
    					}
    					break;
    				}
    				case 'transcriptionstart':
    				{
    					if (notification?.data?.isTranscriptionStart)
    					{
							this.connectToTranscriptionSocket();
							this._roomTranscriptionStart=true;
    						store.dispatch(roomActions.setTranscriptionConsent(true));

    						store.dispatch(requestActions.notify(
    							{
    								text : intl.formatMessage({
    									id             : 'room.startTranscription',
    									defaultMessage : 'Transcription has started.'
    								})
    							}));
    					}
    					else
    					{
    						store.dispatch(requestActions.notify(
    							{
    								text : intl.formatMessage({
    									id             : 'room.stopTranscription',
    									defaultMessage : 'Transcription has been stopped.'
    								})
    							}));
							this._roomTranscriptionStart=false;

    						store.dispatch(roomActions.setIsEnableCC(false));
    						store.dispatch(transcriptionactions.clearCCData());
    						store.dispatch(roomActions.setTranscriptionConsent(false));
    						this._transcriptionSocket.disconnect();
    					}

    					store.dispatch(roomActions.setIsTranscriptionStart(notification?.data?.isTranscriptionStart));

    					break;
    				}

    				case 'transcriptiondata':
    				{

    					if (notification?.data?.data?.peerConversation)
    					{
    						store.dispatch(transcriptionactions.addTranscriptionData(notification?.data?.data));
    					}

    					break;
    				}

    				case 'startRecordingError':
    				{

    					store.dispatch(meActions.setCloudRecordingInProgress(false));
    					toast.dismiss();
    					toast.error(intl.formatMessage({ id: 'Problem_starting_recording', defaultMessage: 'There was a problem starting the recording.Please restart.' }), {
    						position : toast.POSITION.TOP_RIGHT
    					});

    					break;
    				}

    				case 'closePopup':
    				{
    					if (notification.data.type === 'presenterRequest')
    					{
    						if (notification.data.action === 'acceptAll' || notification.data.action === 'denyAll')
    						{
    							store.dispatch(roomActions.setShareRequestData([]));
    							store.dispatch(roomActions.handleOpenShareRequest(false));
    							store.dispatch(roomActions.setShareDailogOpen(false));
    						}
    						else if (notification.data.peerId)
    						{
    							const denayPeer = store.getState().room.shareRequestdata.filter(
    								(item) => item.peerId !== notification.data.peerId
    							);

    							store.dispatch(roomActions.setShareRequestData([ ...denayPeer ]));
    						}
    						else
    						{
    							store.dispatch(roomActions.handleOpenShareRequest(false));
    							store.dispatch(roomActions.setShareDailogOpen(false));
    						}
    					}
    					// moderatorRequestPeerVideoOrAudio
    					else if (notification.data.type === 'mrpvoa')
    					{
    						store.dispatch(toolareaAction.moderatorRequestPeerVideoOrAudio({ type: 'video', value: false }));
    						store.dispatch(toolareaAction.moderatorRequestPeerVideoOrAudio({ type: 'audio', value: false }));
    					}
    					else if (notification.data.type === 'DontShowAgain' || notification.data.type === 'show')
    					{

    						console.log('sadkjasdiASDITAs diasdtiasdtaitsd', notification.data.type);
    						store.dispatch(settingsActions.setToggleRequest(notification.data.type === 'show' ? false : true));
    					}
    					else if (notification.data.type === 'pollClose')
    					{
    						store.dispatch(toolareaAction.handlePollingDialogue(false));
    					}
    					break;
    				}

    				case 'streamingError':
    				{
    					if (notification.data.data.type === 'broadcast')
    					{
    						store.dispatch(meActions.setStreamingInProgress(false));
    						toast.dismiss();
    						toast.error(notification.data.data.isStop ? intl.formatMessage({ id: 'Broadcast_stopped', defaultMessage: 'Broadcast was stopped' }) : intl.formatMessage({ id: 'Problem_starting_broadcast', defaultMessage: 'There was a problem starting the broadcast. Please restart.' }), {
    							position : toast.POSITION.TOP_RIGHT
    						});
    					}
    					else if (notification.data.data.type === 'startYoutubeLive')
    					{
    						store.dispatch(meActions.setYoutubeStreamingInprogress(false));
    						toast.dismiss();
    						toast.error(notification.data.data.isStop ? intl.formatMessage({ id: 'youtubeStream_stopped', defaultMessage: 'Youtube streaming was stopped' }) : intl.formatMessage({ id: 'Problem_starting_youtubeStream', defaultMessage: 'There was a problem starting the youtube streaming. Please restart.' }), {
    							position : toast.POSITION.TOP_RIGHT
    						});
    					}
    					else if (notification.data.data.type === 'startFacebookLive')
    					{
    						store.dispatch(meActions.setFaceBookStreamingInprogress(false));
    						toast.dismiss();
    						toast.error(notification.data.data.isStop ? intl.formatMessage({ id: 'faceBookStream_stopped', defaultMessage: 'Facebook streaming was stopped' }) : intl.formatMessage({ id: 'problem_starting_Facebook', defaultMessage: 'There was a problem starting the facebook streaming. Please restart.' }), {
    							position : toast.POSITION.TOP_RIGHT
    						});
    					}
    					break;
    				}
    				case 'sendScreensDataToHost':
    				{
    					store.dispatch(roomActions.setTpScreensPeerData(notification.data.tpScreenData));
    					break;
    				}

    				case 'setCrashPeers':
    				{
    					if (notification?.data?.crashPeerData?.length > 0)
    					{
    						// console.log('setCrashPeers=====notification.data=', notification.data);
    						store.dispatch(tpScreenActions.addCrashPeers(notification?.data?.crashPeerData));

    						for (let peer of notification?.data?.crashPeerData)
    						{
    							this.updateSpeakerResumeConsumers(peer?.id);
    						}
    					}
    					break;
    				}

    				case 'addScreenPeer':
    				{
                        const screenPeer = notification?.data?.screenPeer;
						console.log('addScreenPeer======', screenPeer);
    					if (screenPeer)
    					{
    						store.dispatch(tpScreenActions.addScreenPeer(screenPeer));
                            screenPeer.video && await this.sendRequest('createConsumerForPeer', { peerList: [ screenPeer.id ] });
    						this.updateSpeakerResumeConsumers(screenPeer.id);
    					}

    					break;
    				}

    				case 'tpScreenPeerClose':
    				{
    					// console.log('peerId============', notification?.data);

    					if (notification?.data?.peerId)
    					{
    						store.dispatch(tpScreenActions.removeScreenPeer(notification?.data?.peerId));

    						this.updateSpeakerPauseConsumers(notification?.data?.peerId);

    						// this._spotlights.closePeer(notification?.data?.peerId);
    					}

    					break;
    				}

    				case 'removeExcessScreenPeers':
    				{

    					// console.log('removeExcessScreenPeers============', notification?.data);

    					if (notification?.data?.removeExcessPeers?.length > 0)
    					{
    						for (let peer of notification?.data?.removeExcessPeers)
    						{
    							this.updateSpeakerPauseConsumers(peer?.id);
    							store.dispatch(tpScreenActions.removeScreenPeer(peer?.id));
    						}
    					}

    					store.dispatch(tpScreenActions.setScreenLimit(notification?.data?.limit));

    					break;
    				}

    				case 'addPeersToScreen':
    				{

    					// console.log('addPeersToScreen==', notification.data);
    					if (notification.data)
    					{

    						for (let peer of notification?.data?.addPeersToScreen)
    						{
    							this.updateSpeakerResumeConsumers(peer?.id);
    						}
    						store.dispatch(tpScreenActions.addCrashPeers(notification?.data?.addPeersToScreen));

    						store.dispatch(tpScreenActions.setScreenLimit(notification?.data?.limit));
    					}
    					break;
    				}

    				case 'tpScreensPeerDataToScreenPages':
    				{
    					// store.dispatch(tpScreenActions.clearScreen());
    					// store.dispatch(roomActions.setPeersToScreensPages(notification.data.tpScreenData));
    					// for (let screen of notification.data.tpScreenData)
    					// {
    					// 	if (Number(this._screenPage) == screen.screenNumber)
    					// 	{
    					// 		// let spotLightPeers = [];

    					// 		// for (let peer of screen.peers)
    					// 		// {
    					// 		// 	spotLightPeers.push(peer.id);
    					// 		// }
    					// 		// this.updateSpotlights(spotLightPeers);

    					// 		if (screen.peers.length > 0)
    					// 		{
    					// 			this._spotlights.addPeers(screen.peers);
    					// 		}
    					// 		else
    					// 		{
    					// 			this._spotlights.clearSpotlights();

    					// 		}

    					// 	}
    					// }
    					break;
    				}

    				case 'peersPollSubmitObjToScreens':
    				{
    					store.dispatch(roomActions.setPoolsubmittedData(notification.data.peersPollSubmitObj));

    					if (notification.data.peersPollSubmitObj)
    					{

    						setTimeout(() =>
    						{
    							store.dispatch(roomActions.setPoolsubmittedData(null));
    						}, 5000);
    					}
    					break;
    				}

    				case 'syncLayout':
    				{

    					const { layout, peerId } = notification.data;

    					if (Number(this._screenPage) === 0 && !this._mode)
    					{
    						if ((this._layoutDataWB && this._layoutDataWB.peerId === peerId) || (this._layoutDataSC.includes(peerId)) || (store.getState().room.uploadDocument && store.getState().room.uploadDocument.peerId === peerId))
    						{
    							store.dispatch(roomActions.setDisplayMode(layout));
    						}
    					}
    					if (this._mode === 'screen')
    					{
    						if ((this._layoutDataWB && this._layoutDataWB.peerId === peerId) || (this._layoutDataSC.includes(peerId)) || (store.getState().room.uploadDocument && store.getState().room.uploadDocument.peerId === peerId))
    						{
    							if (layout === 'screenshareview')
    							{
    								store.dispatch(
    									roomActions.setTpScreenPresentationView('screenshareview')
    								);
    							}
    							if (layout === 'whiteboardview')
    							{
    								store.dispatch(
    									roomActions.setTpScreenPresentationView('whiteboardview')
    								);
    							}
    							if (layout === 'fileShareView')
    							{
    								store.dispatch(
    									roomActions.setTpScreenPresentationView('fileShareView')
    								);
    							}
    						}
    					}

    					break;

    				}

    				case 'moderatorChangeDisplayName':
    				{
    					const { peerId, displayName, oldDisplayName } = notification.data;

    					if (peerId === this._peerId)
    					{
    						this._displayName = displayName;
    						store.dispatch(settingsActions.setDisplayName(displayName));

    					}
    					else
    					{
    						store.dispatch(
    							peerActions.setPeerDisplayName(displayName, peerId));

    					}
    					store.dispatch(requestActions.notify(
    						{
    							text : intl.formatMessage({
    								id             : 'room.peerChangedDisplayName',
    								defaultMessage : '{oldDisplayName} is now {displayName}'
    							}, {
    								oldDisplayName,
    								displayName
    							})
    						}));

    					break;
    				}
    				case 'modifyPeerConsumer':
    				{
    					const { peerId, type, mute } = notification.data;

    					this.modifyPeerConsumer(peerId, type, mute);

    					break;
    				}
    				case 'addOrRemoveSpotlight':
    				{
    					const { peerId } = notification.data;

    					this.addToSpotlight(peerId);
    					break;
    				}

    				case 'showOrHideScreenSharePopup':
    				{
    					if (notification.data.open)
    					{
    						store.dispatch(roomActions.setshowScreenSharePopUp(true));
    					}
    					else
    					{
    						store.dispatch(roomActions.setshowScreenSharePopUp(false));
    					}

    					break;
    				}

    				case 'controllerJoined':
    				{

    					await this.sendRequest('displayCallBack', { selectedPeers: store.getState().room?.selectedPeers });

    					break;
    				}
    				case 'screenShareStatus':
    				{
    					const data = notification.data;

    					console.log('dataInScreenShareStatus', data.data);

    					store.dispatch(meActions.setScreenShareStatus(data.data.screenShareStatus));
    					if (data.data.screenShareStatus)
    					{
    						store.dispatch(meActions.setScreenSharePeerId(data.data.peerId));
    					}
    					else
    					{
    						store.dispatch(meActions.setScreenSharePeerId(null));

    					}

    					// console.log('screenShareStatus', store.getState().me?.screenShareStatus);
    					break;
    				}

    				case 'groupCallReconnecting':
    				{
    					if (notification?.data?.isReconnecting)
    					{
    						store.dispatch(PresenceActions.setCallReconnecting(true));
    					}
    					else
    					{
    						store.dispatch(PresenceActions.setCallReconnecting(false));
    					}
    					break;
    				}

    				case 'unmuteSIPAudio':
    				{
    					this.unmuteMic();
    					break;
    				}
    				case 'updateRoomtemptData':
    				{

    					console.warn('[RT-OVERWRITE] source=updateRoomtemptData hasTemplate=', !!notification?.data, 'hasMeetingDetails=', !!notification?.data?.meetingDetails, 'payload=', notification?.data);

    					this._applyRoomTemplate(notification?.data, 'updateRoomtemptData');

    					window.RoomTemplate = this._roomTemplate;

    					store.dispatch(webinarActions.setWebinarData({ ...store.getState().webinar.webinarData, transcription: notification?.data?.meetingDetails?.transcription }));

    					break;
    				}

    				default:
    				{
    					logger.error(
    						'unknown notification.method "%s"', notification.method);
    				}
    			}
    		}
    		catch (error)
    		{
    			logger.error('error on socket "notification" event [error:"%o"]', error);

    			store.dispatch(requestActions.notify(
    				{
    					type : 'error',
    					text : intl.formatMessage({
    						id             : 'socket.requestError',
    						defaultMessage : 'Error on server request'
    					})
    				}));
    		}

    	});
    }

    isPeerExcludeBreakoutRoom(peer, filterPeers)
    {

    	const index = filterPeers.findIndex((each) => each.id === peer.id);

    	if (index === -1)
    	{
    		if (peer.roles.includes(5337))
    		{
    			return { isHost: true, findPeer: peer };
    		}
    		else
    		{

    			return { isHost: false, findPeer: peer };
    		}

    	}
    	else
    	{
    		return { isHost: false, findPeer: null };
    	}
    }

    removeMainPeerFromBrRoom(newPeer)
    {
    	const brRoomData = store.getState().room.breakoutRoomsNewList;

    	for (let eachRoom of brRoomData)
    	{
    		const index = eachRoom.participantsList.findIndex((peer) => peer.id === newPeer.id);

    		if (index > -1)
    		{
    			eachRoom.participantsList.splice(index, 1);

    			break;
    		}
    		else
    		{
    			const breakoutRoomPeers = store.getState().room.breakoutRoomPeers;

    			const peerIndex = breakoutRoomPeers?.findIndex((peer) => peer.id === newPeer.id);

    			if (peerIndex > -1)
    			{
    				breakoutRoomPeers.splice(peerIndex, 1);
    				store.dispatch(roomActions.handleBreakoutRoomPeers([ ...breakoutRoomPeers ]));
    			}

    		}
    	}

    	store.dispatch(roomActions.setBreakedRoomsNew([ ...brRoomData ]));

    	this.sendBreakoutRoomDataToMainRoom();
    }

    /**
     * Fires schedule/getmeeting (or the webinar details API for webinars) once
     * per room client and caches the promise, so the pre-produce simulcast
     * check and the post-join consumers reuse the same response.
     */
    _getMeetingDetailsResponse()
    {
    	if (!this._meetingDetailsPromise)
    	{
    		const meetingId = this._roomTemplate?.meetingDetails?.meetingId;

    		if (!meetingId || this._roomTemplate?.meetingDetails?.productCode)
    		{
    			this._meetingDetailsPromise = Promise.resolve(null);
    		}
    		else if (this._meetingType === 'webinar')
    		{
    			this._meetingDetailsPromise = getWebinarDetals(meetingId);
    		}
    		else
    		{
    			this._meetingDetailsPromise = axios.get(`${import.meta.env.VITE_SHEDULE}/getmeeting/${meetingId}?type=${this._meetingType}`);
    		}
    	}

    	return this._meetingDetailsPromise;
    }

    /**
     * Applies `isSimulcastEnable` coming from a meeting payload. The meeting
     * record is the source of truth, so this overrides whatever the room
     * template / config said. No-op when the payload doesn't carry the flag.
     */
    _applySimulcastFromMeeting(meetingData)
    {
    	if (!meetingData)
    		return;

    	const source = [ meetingData, meetingData?.meetingDetails, meetingData?.data, meetingData?.data?.meetingDetails ]
    		.find((each) => each && Object.prototype.hasOwnProperty.call(each, 'isSimulcastEnable'));

    	if (!source)
    	{
    		console.log('isSimulcastEnable not present in meeting details, keeping simulcast as', this._useSimulcast);

    		return;
    	}

    	// config.simulcast still acts as the global kill switch.
    	this._useSimulcast = Boolean(source.isSimulcastEnable) && config.simulcast;

    	console.log('simulcast resolved from meeting details', { isSimulcastEnable: source.isSimulcastEnable, useSimulcast: this._useSimulcast });
    }

    /**
     * Resolves the simulcast setting from the meeting APIs before any producer
     * is created. Bounded by MEETING_DETAILS_FETCH_TIMEOUT so a slow or failing
     * API degrades to the current setting instead of stalling the join.
     */
    async _resolveSimulcastBeforeProducing()
    {
    	try
    	{
    		const timedOut = Symbol('meetingDetailsTimeout');

    		const res = await Promise.race([
    			this._getMeetingDetailsResponse(),
    			new Promise((resolve) => setTimeout(() => resolve(timedOut), MEETING_DETAILS_FETCH_TIMEOUT))
    		]);

    		if (res === timedOut)
    		{
    			console.log('getmeeting did not answer in time, producing with simulcast', this._useSimulcast);

    			return;
    		}

    		// Webinar details come back as an array, getmeeting as an object.
    		const meetingData = this._meetingType === 'webinar' ? res?.data?.[0] : res?.data;

    		this._applySimulcastFromMeeting(meetingData);
    	}
    	catch (error)
    	{
    		console.log('error resolving simulcast from meeting details', error);
    	}
    }

    async _joinRoom({ joinVideo, joinAudio, returning, joinMuted = false })
    {
    	logger.debug('_joinRoom()');

    	const { displayName, enableOpusDetails } = store.getState().settings;

    	store.dispatch(meActions.setMeDislayName(displayName));

    	const { picture } = store.getState().me;

    	try
    	{
    		this._torrentSupport = WebTorrent.WEBRTC_SUPPORT;

    		this._webTorrent = this._torrentSupport && new WebTorrent({
    			tracker : {
    				rtcConfig : {
    					iceServers : this._turnServers
    				}
    			}
    		});

    		this._webTorrent.on('error', (error) =>
    		{
    			logger.error('Filesharing [error:"%o"]', error);

    			store.dispatch(requestActions.notify(
    				{
    					type : 'error',
    					text : intl.formatMessage({
    						id             : 'filesharing.error',
    						defaultMessage : 'There was a filesharing error'
    					})
    				}));
    		});

    		this._mediasoupDevice = new mediasoupClient.Device();

    		const routerRtpCapabilities =
				await this.sendRequest('getRouterRtpCapabilities');

    		routerRtpCapabilities.headerExtensions = routerRtpCapabilities.headerExtensions
    			.filter((ext) => ext.uri !== 'urn:3gpp:video-orientation');


				            // Ensure RID extension is available for Chrome simulcast compatibility
            // Check if RID extension exists in router capabilities
            // const hasRidExtension = routerRtpCapabilities.headerExtensions.some(
            //     ext => ext.uri === 'urn:ietf:params:rtp-hdrext:sdes:rtp-stream-id' ||
            //            ext.uri === 'urn:ietf:params:rtp-hdrext:sdes:repaired-rtp-stream-id'
            // );

            // // If RID extension is missing and simulcast is enabled, add it to capabilities
            // // This is a workaround for servers that don't include RID extension
            // if (!hasRidExtension && this._useSimulcast)
            // {
            //     logger.warn('RID extension not found in router capabilities. Adding it for Chrome compatibility.');
            //     // Find the highest existing extension ID
            //     let maxId = 0;
            //     routerRtpCapabilities.headerExtensions.forEach(ext => {
            //         if (ext.id > maxId) maxId = ext.id;
            //     });
            //     // Add RID extension (RTP Stream Identifier)
            //     routerRtpCapabilities.headerExtensions.push({
            //         uri: 'urn:ietf:params:rtp-hdrext:sdes:rtp-stream-id',
            //         id: maxId + 1,
            //         direction: 'sendrecv'
            //     });
            // }

    		await this._mediasoupDevice.load({ routerRtpCapabilities });

    		if (this._produce)
    		{
    			const transportInfo = await this.sendRequest(
    				'createWebRtcTransport',
    				{
    					forceTcp  : this._forceTcp,
    					producing : true,
    					consuming : false
    				});

    			const {
    				id,
    				iceParameters,
    				iceCandidates,
    				dtlsParameters
    			} = transportInfo;

    			this._sendTransport = this._mediasoupDevice.createSendTransport(
    				{
    					id,
    					iceParameters,
    					iceCandidates,
    					dtlsParameters,
    					iceServers             : this._turnServers,
    					// TODO: Fix for issue #72
    					iceTransportPolicy     : this._device.flag === 'firefox' && this._turnServers ? 'relay' : undefined,
    					proprietaryConstraints : PC_PROPRIETARY_CONSTRAINTS
    				});

    			this._sendTransport.on(
    				'connect', ({ dtlsParameters }, callback, errback) => // eslint-disable-line no-shadow
    				{
    					this.sendRequest(
    						'connectWebRtcTransport',
    						{
    							transportId : this._sendTransport.id,
    							dtlsParameters
    						})
    						.then(callback)
    						.catch(errback);
    				});

    			this._sendTransport.on(
    				'connectionstatechange', (connectState) =>
    				{
    					switch (connectState)
    					{
    						case 'disconnected':
    						case 'failed':
    							this.restartIce(this._sendTransport, this._sendRestartIce, 2000);
    							break;

    						default:
    							clearTimeout(this._sendRestartIce.timer);
    							break;
    					}
    				});

    			this._sendTransport.on(
    				'produce', async ({ kind, rtpParameters, appData }, callback, errback) =>
    				{
    					try
    					{
    						const { paused, ...producerAppData } = appData;

    						// eslint-disable-next-line no-shadow
    						const { id, error } = await this.sendRequest(
    							'produce',
    							{
    								transportId : this._sendTransport.id,
    								kind,
    								rtpParameters,
    								appData     : producerAppData,
    								paused      : Boolean(paused)
    							});

    						if (!id)
    						{
    							errback(error);
    						}

    						callback({ id });
    					}
    					catch (error)
    					{
    						errback(error);
    					}
    				});
    		}

    		const transportInfo = await this.sendRequest(
    			'createWebRtcTransport',
    			{
    				forceTcp  : this._forceTcp,
    				producing : false,
    				consuming : true
    			});

    		const {
    			id,
    			iceParameters,
    			iceCandidates,
    			dtlsParameters
    		} = transportInfo;

    		this._recvTransport = this._mediasoupDevice.createRecvTransport(
    			{
    				id,
    				iceParameters,
    				iceCandidates,
    				dtlsParameters,
    				iceServers         : this._turnServers,
    				// TODO: Fix for issue #72
    				iceTransportPolicy : this._device.flag === 'firefox' && this._turnServers ? 'relay' : undefined,
    				additionalSettings : {
    					encodedInsertableStreams : insertableStreamsSupported && enableOpusDetails
    				},
    				appData : {
    					encodedInsertableStreams : insertableStreamsSupported && enableOpusDetails
    				}
    			});

    		this._recvTransport.on(
    			'connect', ({ dtlsParameters }, callback, errback) => // eslint-disable-line no-shadow
    			{
    				this.sendRequest(
    					'connectWebRtcTransport',
    					{
    						transportId : this._recvTransport.id,
    						dtlsParameters
    					})
    					.then(callback)
    					.catch(errback);
    			});

    		this._recvTransport.on(
    			'connectionstatechange', (connectState) =>
    			{
    				switch (connectState)
    				{
    					case 'disconnected':
    					case 'failed':
    						this.restartIce(this._recvTransport, this._recvRestartIce, 2000);
    						break;

    					default:
    						clearTimeout(this._recvRestartIce.timer);
    						break;
    				}
    			});

    		// Set our media capabilities.
    		store.dispatch(meActions.setMediaCapabilities(
    			{
    				canSendMic     : this._mediasoupDevice.canProduce('audio'),
    				canSendWebcam  : this._mediasoupDevice.canProduce('video'),
    				canShareScreen : this._mediasoupDevice.canProduce('video') &&
						this._screenSharing.isScreenShareAvailable(),
    				canShareFiles : this._torrentSupport
    			}));

    		const deviceId = await this._getWebcamDeviceId();
    		const device = deviceInfo();

    		const audioDeviceId = await this._getAudioDeviceId();

    		const {
    			authenticated,
    			roles,
    			peers,
    			tracker,
    			roomPermissions,
    			userRoles,
    			allowWhenRoleMissing,
    			chatHistory,
    			fileHistory,
    			lastNHistory,
    			locked,
    			lobbyPeers,
    			accessCode,
    			defaultLayout,
    			defaultLayoutData,
    			hostControlsObj,
    			roomTemplate,
    			streamingMode,
    			cloudRecordingMode,
    			youtubeStreamMode,
    			facebookStreamMode,
    			localRecordingState,
    			roleType,
    			isBreakoutRoom,
    			isBreakoutRoomStart,
    			breakoutRoomData,
    			youtubeLiveStreamData,
    			facebookLiveStreamData,
    			fileShare,
    			videoShare,
    			webinarLogo,
    			webinarBackground,
    			transcriptionStart,
    			webinarAudio,
    			webinarVideo,
    			annotationStart,
    			liveTpScreens,
    			tpScreenDataToClient,
    			isTelepresenseStart,
    			page,
    			roomCreationTime,
    			activeSpeaker
    		} = await this.sendRequest(
    			'join',
    			{
    				displayName     : displayName,
    				picture         : picture,
    				rtpCapabilities : this._mediasoupDevice.rtpCapabilities,
    				returning       : returning,
    				webCamDevices   : store.getState().me.webcamDevices,
    				deviceId        : deviceId,
    				prometheusData  : {
    					browser   : device?.name,
    					version   : device?.version,
    					os        : device?.os,
    					platform  : device?.platform,
    					ip        : store.getState().settings.ip,
    					network   : store.getState().settings.network,
    					osVersion : device?.osVersion,
    					app       : false
    				},
    				audioDevices  : store.getState().me.audioDevices,
    				audioDeviceId : audioDeviceId,
    				displayEmail  : store.getState().settings.displayEmail,
    				countryName   : store.getState().settings.countryName,
    				countryCode   : store.getState().settings.countryCode
    			});

    		this._roomTemplate = roomTemplate;
    		this._activeSpeaker = activeSpeaker;

    		if (webinarAudio)
    		{
    			store.dispatch(webinarActions.setSelectedWebinarAudio(webinarAudio));
    		}

    		if (store.getState().room?.scheduleType === 'presence' && roomCreationTime)
    		{
    			store.dispatch(roomActions.setRoomCreationTime(roomCreationTime));
    		}

    		if (Object.keys(hostControlsObj).length > 0)
    		{
    			store.dispatch(toolareaAction.setHostControls(hostControlsObj));
    		}
    		// else
    		// {
    		// 	let controlsObj = {
    		// 		hostControlSendChat     : roomTemplate?.data?.sendChatMsgs,
    		// 		hostControlSendFiles    : roomTemplate?.data?.sendFiles,
    		// 		hostControlMicroPhone   : roomTemplate?.data?.microphoneAccess,
    		// 		hostControlVideoControl : roomTemplate?.data?.videoAccess
    		// 	};

    		// 	store.dispatch(toolareaAction.setHostControls(controlsObj));
    		// }
    		// if (this._SIP)
    		// {
    		// 	this.performSIPConferenceTask('unvmute all');
    		// 	await this.muteMic();
    		// 	setTimeout(() =>
    		// 	{
    		// 		this.unmuteMic();
    		// 	}, 3000);
    		// }
    		if (roleType)
    		{
    			store.dispatch(meActions.setRoleType(roleType));
    		}

    		// console.log('sessionStorage.getIte', sessionStorage.getItem('auth'))

    		if (sessionStorage.getItem('auth'))
    		{
    			const decriptToken = decryptDataForVc(sessionStorage.getItem('auth'));

    			if (decriptToken)
    			{
    				store.dispatch(roomActions.setUserId(decriptToken?.userId));
    			}

    			store.dispatch(roomActions.setAuthToken(sessionStorage.getItem('auth')));
    		}

    		window.RoomTemplate = this._roomTemplate;

    		if (this._roomTemplate?.data?.telePresenceTable?.teleUsers)
    		{
    			this._totalPageLength =
					this._roomTemplate?.data?.telePresenceTable?.teleUsers.length;

    			store.dispatch(settingsActions.setTotalScreen(this._totalPageLength));
    		}

    		if (breakoutRoomData && store.getState()?.room?.breakoutRoomsNewList?.length === 0 && !isBreakoutRoom)
    		{
    			store.dispatch(roomActions.setBreakedRoomsNew([ ...breakoutRoomData ]));
    		}

    		if (isBreakoutRoom)
    		{
    			store.dispatch(meActions.setIsBreakoutRoom(isBreakoutRoom));
    		}

    		if (isTelepresenseStart)
    		{
    			store.dispatch(roomActions.setTelepresenseStart(true));
    		}

    		if (isBreakoutRoomStart)
    		{
    			store.dispatch(
    				roomActions.setIsBreakoutRoomStart(true));

    			this._isBreakoutRoomStart = true;
    		}

    		if (this._roomTemplate?.data?.removeToolBar)
    		{
    			store.dispatch(settingsActions.removeBottomBar());
    		}

    		if (!roomTemplate.data.screenShare)
    		{
    			store.dispatch(toolareaAction.templateScreenShare(false));
    		}

    		if (!roomTemplate.data.whiteBoard)
    		{
    			store.dispatch(toolareaAction.tempateWhiteBoard(false));
    		}

    		if (!roomTemplate.data.chat && !roomTemplate.data.fileSharing)
    		{
    			store.dispatch(toolareaAction.templateChat(false));
    		}

    		if (!roomTemplate.data.AddNewVideoInput)
    		{
    			store.dispatch(toolareaAction.templateAddionalCam(false));
    		}

    		if (!roomTemplate.data.fileSharing)
    		{
    			store.dispatch(toolareaAction.templateFileShare(false));
    		}

    		if (roomTemplate.data.hideParticipants)
    		{
    			store.dispatch(toolareaAction.templateHideNWPart(true));
    			this.setHideNoVideoParticipants(true);
    			store.dispatch(settingsActions.toggleHideNoVideoParticipantsManual(true));
    		}
    		else
    		{
    			this.setHideNoVideoParticipants(false);
    			store.dispatch(settingsActions.toggleHideNoVideoParticipantsManual(false));
    		}

    		if (roomTemplate.data.notificationSounds)
    		{
    			store.dispatch(settingsActions.toggleNotificationSounds(true));
    		}
    		else
    		{
    			store.dispatch(settingsActions.toggleNotificationSounds(false));
    		}

    		if (fileShare)
    		{
    			store.dispatch(roomActions.setDocument(fileShare));
    			store.dispatch(roomActions.setTotalPages(fileShare.pages));
    			if (page)
    			{
    				store.dispatch(roomActions.setPage(page));
    			}
    			this._fileShareLayoutData=fileShare;
    		}
    		if (videoShare)
    		{
    			store.dispatch(roomActions.setVideoData(videoShare));
    			this._videoData = videoShare;
    			// store.dispatch(roomActions.setDisplayMode('videoShareView'));
    		}

    		if (webinarVideo)
    		{
    			store.dispatch(webinarActions.setSelectedwebinarVideo(webinarVideo));
    			store.dispatch(roomActions.setDisplayMode(defaultLayout));
    		}

    		if (roomTemplate.data.showNotifications)
    		{
    			store.dispatch(settingsActions.toggleShowNotifications(true));
    		}
    		else
    		{
    			store.dispatch(settingsActions.toggleShowNotifications(false));
    		}
    		if (!roomTemplate.data.breakOutRooms)
    		{
    			store.dispatch(toolareaAction.breakOutRoomOnOff(false));
    		}
    		if (!roomTemplate.data.virtualBackground)
    		{
    			store.dispatch(roomActions.setBackgroundOpen(false));
    		}
    		if (roomTemplate.data.streaming)
    		{
    			if (roomTemplate.data.userAdminId === 'c36f79fd-bf43-4a2e-a68f-737aec096be8')
    			{

    				if (roomTemplate.meetingDetails.broadcast)
    				{
    					// store.dispatch(roomActions.setStreamingLicense(true));
    					store.dispatch(roomActions.setTemplateStream(true));
    				}
    				// if (roomTemplate.overrideSetting.isRecording)
    				// {
    				// 	store.dispatch(roomActions.setRecordingLicense(roomTemplate.overrideSetting.isRecording));
    				// }
    			}
    			else if (roomTemplate.data.userAdminId !== 'c36f79fd-bf43-4a2e-a68f-737aec096be8')
    			{
    				store.dispatch(roomActions.setTemplateStream(true));

    			}
    		}
    		// if (roomTemplate.data.lockRooms)
    		// {
    		// 	this.lockRoom();
    		// }
    		if (streamingMode)
    		{
    			// this.startBroadcast();
    			store.dispatch(roomActions.setBroadcastUserStatus(streamingMode));
    			store.dispatch(roomActions.setStreamConsentStatus(streamingMode));
    			if (streamingMode && roles.indexOf(5337) > -1)
    			{
    				store.dispatch(roomActions.setLiveStreamingOn(streamingMode));
    				if (this._meetingType !== 'webinar')
    				{
    					this.connectToBroadcastSocket();

    				}
    				// if (this._meetingType === 'webinar' && this._webinarSocket !== null)
    				// {
    				// 	this.connectToWebinarSocket();
    				// }
    			}
    		}

    		if (cloudRecordingMode)
    		{
    			store.dispatch(roomActions.setRecordingConsent(true));
    			store.dispatch(roomActions.setCloudRecordingLiveStatus(true));

    			if (cloudRecordingMode && roles.indexOf(5337 > -1))
    			{
    				store.dispatch(roomActions.setEnableDisableCloudRecording(cloudRecordingMode));

    			}
    		}

    		if (annotationStart)
    		{
    			this.connectToAnnotationsSocket();
    		}            
    		if (transcriptionStart)
    		{
				this.connectToTranscriptionSocket();
    			store.dispatch(roomActions.setTranscriptionConsent(true));
    		}
    		store.dispatch(roomActions.setIsTranscriptionStart(transcriptionStart));

    		if (youtubeStreamMode)
    		{

    			store.dispatch(roomActions.setYoutubeStreamStatus(youtubeStreamMode));
    			store.dispatch(roomActions.setStreamConsentStatus(youtubeStreamMode));
    		}

    		if (facebookStreamMode)
    		{
    			store.dispatch(roomActions.setFaceBookStreamStatus(facebookStreamMode));
    			store.dispatch(roomActions.setStreamConsentStatus(facebookStreamMode));

    		}
    		if (youtubeLiveStreamData)
    		{
    			if (youtubeLiveStreamData && Object.keys(youtubeLiveStreamData)?.length > 0)
    			{
    				store.dispatch(roomActions.setYoutubeStreamData(youtubeLiveStreamData));

    			}
    		}

    		if (facebookLiveStreamData)
    		{
    			if (facebookLiveStreamData && Object.keys(facebookLiveStreamData)?.length > 0)
    			{
    				store.dispatch(roomActions.setFacebookStreamData(facebookLiveStreamData));

    			}
    		}
    		if (liveTpScreens)
    		{
    			store.dispatch(roomActions.setLiveTpScreens(liveTpScreens));
    		}

    		// if ((store.getState().me.browser.platform === 'mobile' && store.getState().me.browser.name !== 'safari' && store.getState().me.browser.os !== 'iOS') || this._mDeviceType === 'andriod')
    		// {
    		// 	const fullScreen = new FullScreen(document);

    		// 	fullScreen.requestFullscreen(document.documentElement);

    		// 	// store.dispatch(settingsActions.togglePermanentTopBar());
    		// 	// store.dispatch(settingsActions.toggleHiddenControls());

    		// 	// store.dispatch(settingsActions.toggleButtonControlBar());
    		// }

    		if ((store.getState().me.browser.platform === 'mobile' || this._mDeviceType === 'andriod' || this._mDeviceType === 'ios') && store.getState().settings.permanentTopBar)
    		{
    			store.dispatch(settingsActions.togglePermanentTopBar());
    			store.dispatch(settingsActions.setTopBarTrue());
    			store.dispatch(settingsActions.toggleHiddenControls());

    			// store.dispatch(settingsActions.toggleButtonControlBar());
    		}

    		if (roleType)
    		{
    			store.dispatch(meActions.setRoleType(roleType));
    		}
    		if (!roomTemplate.data.sendChatMsgs)
    		{
    			store.dispatch(toolareaAction.sendChatOnOff(false));
    		}
    		if (!roomTemplate.data.sendFiles)
    		{
    			store.dispatch(toolareaAction.sendFilesOnOff(false));
    		}
    		if (!roomTemplate.data.microphoneAccess)
    		{
    			store.dispatch(toolareaAction.microphoneAccessOnOff(false));
    		}
    		if (!roomTemplate.data.videoAccess)
    		{
    			store.dispatch(toolareaAction.videoAccessOnOff(false));
    		}
    		if (roomTemplate.data.aspectRatio)
    		{
    			if (roomTemplate.data.aspectRatio === '16:9')
    			{
    				store.dispatch(settingsActions.setAspectRatio(1.777));
    			}
    			else if (roomTemplate.data.aspectRatio === '4:3')
    			{
    				store.dispatch(settingsActions.setAspectRatio(1.333));
    			}
    			// store.dispatch(toolareaAction.aspectRatioChange(roomTemplate.data.aspectRatio));
    		}
    		if (this._sipUserID)
    		{
    			store.dispatch(
    				settingsActions.setLastN(1));
    		}
    		else if (roomTemplate.data.visibleVideos && store.getState().me.browser.platform !== 'mobile')
    		{
    			store.dispatch(settingsActions.setLastN(roomTemplate.data.visibleVideos));
    			this._spotlights.maxSpotlights = roomTemplate.data.visibleVideos ;
    		}
    		if (!roomTemplate.data.exitUrlStatus)
    		{
    			store.dispatch(toolareaAction.exitUrl(roomTemplate.data.exitUrl));
    		}
    		if (!roomTemplate?.data?.waitingRoomUrlStatus)
    		{
    			// eslint-disable-next-line max-len
    			store.dispatch(toolareaAction.waitingRoomUrlStatusOnOff(false));
    		}

    		// if (roomTemplate.data.animoji)
    		// {
    		// 	store.dispatch(toolareaAction.emojiStatus(roomTemplate.data.animoji));
    		// }

    		if (roomTemplate.data.recordingType === 'noRecording')
    		{
    			store.dispatch(toolareaAction.noRecordingEnabled(false));
    		}
    		else if (roomTemplate.data.recordingType === 'cloudRecording')
    		{
    			if (roomTemplate.data.userAdminId === 'c36f79fd-bf43-4a2e-a68f-737aec096be8')
    			{
    				if (roomTemplate.meetingDetails.recording)
    				{

    					// store.dispatch(roomActions.setStreamingLicense(true));
    					store.dispatch(toolareaAction.templateCloudRecording(true));
    					// if (roomTemplate.overrideSetting.isRecording)
    					// {
    					// 	store.dispatch(roomActions.setRecordingLicense(roomTemplate.overrideSetting.isRecording));
    					// }
    				}
    			}
    			else if (roomTemplate.data.userAdminId !== 'c36f79fd-bf43-4a2e-a68f-737aec096be8')
    			{
    				store.dispatch(toolareaAction.templateCloudRecording(true));
    			}
    		}
    		if (roomTemplate.data.brandingImage)
    		{
    			store.dispatch(toolareaAction.brandingImage(roomTemplate.data.brandingImage.url));
    		}
    		if (tpScreenDataToClient?.length > 0 && Number(this._screenPage) === 0)
    		{
    			store.dispatch(roomActions.setTpScreensPeerData(tpScreenDataToClient));
    		}

    		// console.log('this._mDeviceType', this._mDeviceType)

    		if (roomTemplate.data.themes.length !== 0)
    		{
    			let themesData = roomTemplate.data.themes[0];

    			store.dispatch(appearanceActions.setPagebackgroundColor(themesData.pageBackgroundColor));
    			store.dispatch(appearanceActions.setActiveSpeakerBorderColor(themesData.activeSpeakerBorderColor));
    			store.dispatch(appearanceActions.setAppToolBarColor(themesData.appToolBarColor));
    			store.dispatch(appearanceActions.setChatBackgroundColor(themesData.chatBackgroundColor));
    			store.dispatch(appearanceActions.setIconsColor(themesData.iconsColor));
    			store.dispatch(appearanceActions.setIconsColorEnable(themesData.iconsColorEnable));
    			store.dispatch(appearanceActions.setPeerShadowColor(themesData.peerShadowColor));
    			store.dispatch(appearanceActions.setUserBackgroundColor(themesData.userBackgroundColor));
    			store.dispatch(appearanceActions.setUserAvator(themesData.userAvator));
    		}
    		//
    		// if(defaultLayout === 'whiteboardview') {
    		this._layoutDataWB = defaultLayoutData.whiteboarddata;
    		store.dispatch(
    			roomActions.setWhiteboardData(this._layoutDataWB));
    		// }else if(defaultLayout === 'screenshareview') {
    		this._layoutDataSC = defaultLayoutData.screensharedata;
    		if (this._layoutDataSC.length > 0)
    		{
    			this.addSelectedPeer(this._layoutDataSC[0]);
				await this.sendRequest('createConsumerForPeer', { peerList: this._layoutDataSC,source:'screen'});
    			store.dispatch(
    				roomActions.setActiveScreenId(this._layoutDataSC[0], this._layoutDataSC));
    		}

    		if (this._roomTemplate.meetingDetails &&
				this._roomTemplate.meetingDetails.multidisplay)
    		{
    			store.dispatch(
    				roomActions.enableTelepresence(true));
    		}

    		if (this._roomTemplate.meetingDetails &&
				this._roomTemplate.meetingDetails?.isSipEnable && this._roomTemplate.meetingDetails?.isSipAutoAcceptCalls)
    		{
    			store.dispatch(
    				roomActions.setSIPAutoAcceptCalls(this._roomTemplate.meetingDetails?.isSipAutoAcceptCalls));
    		}

    		if (this._roomTemplate.meetingDetails && this._roomTemplate.meetingDetails.hasOwnProperty('isSimulcastEnable') && !this._roomTemplate.meetingDetails.isSimulcastEnable)
    		{
    			this._useSimulcast = false;
    		}

    		if (this._roomTemplate.meetingDetails &&
				this._roomTemplate.meetingDetails.recording)
    		{
    			store.dispatch(roomActions.setCloudRecordingLicense(true));
    		}
    		// }
    		if (Number(this._screenPage) > 0)
    		{
    			store.dispatch(roomActions.setDisplayMode('pagescreen'));

    		}
    		else if (this._mode && this._mode === 'speaker')
    		{
    			store.dispatch(roomActions.setDisplayMode('activeSpeakerview'));
    		}
    		else if (this._mode && this._mode === 'screen')
    		{
    			store.dispatch(roomActions.setDisplayMode('presenter'));
    			if (this._layoutDataSC.length > 0)
    			{
    				store.dispatch(
    					roomActions.setTpScreenPresentationView('screenshareview')
    				);
    			}
    			else if (this._layoutDataWB)
    			{
    				store.dispatch(
    					roomActions.setTpScreenPresentationView('whiteboardview')
    				);
    			}
    			else if (this._fileShareLayoutData)
    			{
    				store.dispatch(
    					roomActions.setTpScreenPresentationView('fileShareView')
    				);
    			}
    			else
    			{
    				store.dispatch(
    					roomActions.setTpScreenPresentationView('')
    				);
    			}
    		}
    		else if (this._layoutDataWB)
    		{
    			store.dispatch(roomActions.setDisplayMode('whiteboardview'));
    		}
    		else if (this._layoutDataSC.length > 0)
    		{
    			store.dispatch(roomActions.setDisplayMode('screenshareview'));

    		}
    		else if (this._videoData)
    		{
    			store.dispatch(roomActions.setDisplayMode('videoShareView'));
    		}
    		else if (this._fileShareLayoutData)
    		{
    			store.dispatch(roomActions.setDisplayMode('fileShareView'));
    		}

    		else if (roomTemplate.data.democratic)
    		{
    			if (Number(this._screenPage) > 0)
    			{
    				store.dispatch(roomActions.setDisplayMode('pagescreen'));

    			}
    			else if (this._mode && this._mode === 'speaker')
    			{
    				store.dispatch(roomActions.setDisplayMode('activeSpeakerview'));

    			}
    			else if (this._mode && this._mode === 'screen')
    			{
    				store.dispatch(roomActions.setDisplayMode('presenter'));

    			}
    			else
    			{
    				store.dispatch(roomActions.setDisplayMode('democratic'));
    			}
    			// store.dispatch(toolareaAction.democraticLayout(false));
    		}
    		else if (roomTemplate.data.filmStrip)
    		{
    			store.dispatch(roomActions.setDisplayMode('filmstrip'));
    			// store.dispatch(toolareaAction.filmstripLayout(false));
    		}
    		else
    		{
    			store.dispatch(roomActions.setDisplayMode(defaultLayout));
    			if (page)
    			{
    				store.dispatch(roomActions.setPage(page));
    			}
    		}

    		logger.debug(
    			'_joinRoom() joined [authenticated:"%s", peers:"%o", roles:"%o", userRoles:"%o"]',
    			authenticated,
    			peers,
    			roles,
    			userRoles
    		);

    		tracker && (this._tracker = tracker);

    		store.dispatch(meActions.loggedIn(authenticated));

    		store.dispatch(roomActions.setRoomPermissions(roomPermissions));

    		const roomUserRoles = new Map();

    		Object.values(userRoles).forEach((val) => roomUserRoles.set(val.id, val));

    		store.dispatch(roomActions.setUserRoles(roomUserRoles));

    		if (allowWhenRoleMissing)
    			store.dispatch(roomActions.setAllowWhenRoleMissing(allowWhenRoleMissing));

    		// store.dispatch(meActions.addRole(roles));
    		store.dispatch(meActions.setRoles(roles));

    		const isModerator = this._havePermission(permissions.MODERATE_ROOM);

    		if (this._roomTemplate.meetingDetails?.isSipEnable && isModerator)
    		{
    			setInterval(() =>
    			{
    				this.listUsers();
    			}, 10000);
    		}
    		// const myRoles = store.getState().me.roles;

    		// for (const roleId of roles)
    		// {
    		// 	if (!myRoles.some((myRoleId) => roleId === myRoleId))
    		// 	{
    		// 		store.dispatch(meActions.addRole(roleId));

    		// 		// store.dispatch(requestActions.notify(
    		// 		// 	{
    		// 		// 		text : intl.formatMessage({
    		// 		// 			id             : 'roles.gotRole',
    		// 		// 			defaultMessage : 'You got the role: {role}'
    		// 		// 		}, {
    		// 		// 			role : roomUserRoles.get(roleId).label
    		// 		// 		})
    		// 		// 	}));
    		// 	}
    		// }

    		// this.joinToCPanel(joinVideo, joinAudio, peers);

    		// if (this._SIP)
    		// {
    		// 	this._SIP.changeActiveSpeaker(activeSpeaker);
    		// }

    		const hostPeers = [];

    		const normalPeers = [];

    		const hostObj = {
    			id          : store.getState()?.me?.id,
    			displayName : store.getState()?.me?.displayName,
    			picture     : store.getState()?.me?.picture,
    			consumers   : [],
    			roles       : store.getState()?.me?.roles,
    			isBreakoutRoom
    		};

    		let filterPeers;

    		filterPeers = [ ...this.filterBreakourPeers(store.getState()?.room?.breakoutRoomsNewList), ...store.getState().room.breakoutRoomHost, ...store.getState().room.breakoutRoomPeers ];

    		const excludeHostPeer = this.isPeerExcludeBreakoutRoom(hostObj, filterPeers);

    		if (excludeHostPeer?.isHost && excludeHostPeer?.findPeer)
    		{
    			hostPeers.push(excludeHostPeer?.findPeer);
    		}

    		if (peers.length > 0)
    		{

    			store.dispatch(peerActions.clearPeers());

    			for (const peer of peers)
    			{

    				if (Number(this._screenPage) > 0 || this._mode === 'speaker')
    				{
    					if (!peer.roles.includes(5337))
    					{
    						store.dispatch(
    							peerActions.addPeer({ ...peer, consumers: [] }));
    					}
    				}
    				else
    				{
    					store.dispatch(
    						peerActions.addPeer({ ...peer, consumers: [] }));
    					if (localRecordingState === 'init')
    					{
    						store.dispatch(
    							peerActions.setPeerLocalRecordingState(peer.id, localRecordingState));
    					}

    					const { isHost, findPeer } = this.isPeerExcludeBreakoutRoom(peer, filterPeers);

    					if (isHost && findPeer)
    					{
    						hostPeers.push(findPeer);
    					}
    					else if (!isHost && findPeer)
    					{
    						normalPeers.push(findPeer);
    					}
    				}

    			}
    			store.dispatch(roomActions.handleBreakoutRoomHostList([ ...hostPeers, ...store.getState().room.breakoutRoomHost ]));
    			store.dispatch(roomActions.handleBreakoutRoomPeers([ ...normalPeers, ...store.getState().room.breakoutRoomPeers ]));
    		}
    		else
    		{

    			if (Number(this._screenPage) === 0 || this._mode !== 'speaker')
    			{
    				store.dispatch(roomActions.handleBreakoutRoomHostList([ ...hostPeers, ...store.getState().room.breakoutRoomHost ]));
    			}
    			store.dispatch(peerActions.clearPeers());
    		}

    		if (this._pipActiveSpeaker && !store.getState().peers[this._pipActiveSpeaker])
    		{
    			this._clearPipActiveSpeaker();
    		}

    		(chatHistory.length > 0) && store.dispatch(
    			chatActions.addChatHistory(chatHistory));

    		(fileHistory.length > 0) && store.dispatch(
    			fileActions.addFileHistory(fileHistory));

    		locked ?
    			store.dispatch(roomActions.setRoomLocked()) :
    			store.dispatch(roomActions.setRoomUnLocked());

    		lobbyPeers !== null && (lobbyPeers.length > 0) && lobbyPeers.forEach((peer) =>
    		{
    			if (peer !== null)
    			{
    				store.dispatch(
    					lobbyPeerActions.addLobbyPeer(peer.id));
    				store.dispatch(
    					lobbyPeerActions.setLobbyPeerDisplayName(peer.displayName, peer.id));
    				store.dispatch(
    					lobbyPeerActions.setLobbyPeerPicture(peer.picture, peer.id));
    			}
    		});

    		(accessCode != null) && store.dispatch(
    			roomActions.setAccessCode(accessCode));

    		if (Number(this._screenPage) > 0)
    		{

    			// console.log('tpScreenDataToClient==', tpScreenDataToClient);

    			store.dispatch(roomActions.setPeersToScreensPages(tpScreenDataToClient));

    			const findScreenData = tpScreenDataToClient.find((eachScreen) => eachScreen?.screenNumber === Number(this._screenPage));

    			// console.log('findScreenData====', findScreenData, tpScreenDataToClient);

    			store.dispatch(tpScreenActions.setScreenPeers(findScreenData?.peers));
				this.sendRequest('createConsumerForPeer', { peerList: findScreenData?.peers.map((eachPeer) => eachPeer.id) });

    			store.dispatch(tpScreenActions.setScreenLimit(findScreenData?.screenSeatLimit));

    			// console.log('emtering to _screenPage', this._screenPage);
    			// const allExistingScreens = [];

    			// let filterScreenPeers = [];

    			// console.log('tpScreenDataToClient==', tpScreenDataToClient);

    			// for (let screenData of tpScreenDataToClient)
    			// {
    			// 	allExistingScreens.push(screenData.screenNumber);
    			// 	filterScreenPeers = [ ...filterScreenPeers, ...screenData.peers ];
    			// }

    			// console.log('allExistingScreens===', allExistingScreens);
    			// console.log('filterScreenPeers=====', filterScreenPeers);

    			// console.log('tpScreenDataToClient.length === liveTpScreens==', tpScreenDataToClient.length === liveTpScreens);

    			// console.log('tpScreenDataToClient.length==', tpScreenDataToClient.length);
    			// console.log('liveTpScreens==', liveTpScreens);

    			// if (tpScreenDataToClient.length > 0 && liveTpScreens > 0 && tpScreenDataToClient.length === liveTpScreens)
    			// {

    			// 	for (let screenData of tpScreenDataToClient)
    			// 	{
    			// 		if (screenData.screenNumber === this._screenPage)
    			// 		{
    			// 			this.setTPPeer(screenData.peers, screenData.screenNumber, screenData.screenSeatLimit);
    			// 		}
    			// 		else if (!allExistingScreens.includes(this._screenPage))
    			// 		{
    			// 			this.setTPPeer([], this._screenPage, 1); // default seat limit for screen is 4
    			// 		}
    			// 	}
    			// }
    			// else
    			// {
    			// 	const excludePeers = Object.values(store.getState().peers).filter((each) => !filterScreenPeers.find((peer) => peer.id === each.id));

    			// 	console.log('excludePeers==', excludePeers);

    			// 	const itemPerScreen = Math.ceil((excludePeers).length / liveTpScreens);

    			// 	const peersForThispage = excludePeers.slice((Number(this._screenPage) - 1)
    			// 		* 1, Number(this._screenPage) * 1);

    			// 	this.setTPPeer(peersForThispage, this._screenPage, 1);
    			// }

    		}
    		else if (Number(this._screenPage) === 0 && (this._mode === undefined || this._mode === null))
    		{
    			this._spotlights.addPeers(peers);

    			if (lastNHistory.length > 0)
    			{
    				logger.debug('_joinRoom() | got lastN history');

    				this._spotlights.addSpeakerList(
    					lastNHistory.filter((peerId) => peerId !== this._peerId)
    				);
    			}
    		}

    		// Simulcast is driven by the meeting record, so hit the meeting APIs
    		// and apply the flag before any producer is created below.
    		await this._resolveSimulcastBeforeProducing();

    		// Don't produce if explicitly requested to not to do it.
    		if (this._produce)
    		{
    			if (
    				joinVideo &&
					this._havePermission(permissions.SHARE_VIDEO)
    			)
    			{
    				this.updateWebcam({ init: true, start: true });
    			}
    			if (
    				joinAudio &&
					this._mediasoupDevice.canProduce('audio') &&
					this._havePermission(permissions.SHARE_AUDIO)
    			)
    				if (!this._muted)
    				{
    					const autoMuteThreshold = config.autoMuteThreshold;
    					const autoMute = autoMuteThreshold >= 0 && peers.length >= autoMuteThreshold;

    					// Produced already muted rather than muted after going live.
    					await this.updateMic({ start: true, muted: joinMuted || autoMute });
    				}
    		}

    		if (!this._micReconcileInterval)
    			this._micReconcileInterval = setInterval(() => this._reconcileMic(), 5000);

    		await this._updateAudioOutputDevices();

    		const { selectedAudioOutputDevice } = store.getState().settings;

    		if (!selectedAudioOutputDevice && this._audioOutputDevices != {})
    		{
    			store.dispatch(
    				settingsActions.setSelectedAudioOutputDevice(
    					Object.keys(this._audioOutputDevices)[0]
    				)
    			);
    		}

    		store.dispatch(roomActions.setRoomState('connected'));

    		// Clean all the existing notifications.
    		store.dispatch(notificationActions.removeAllNotifications());

    		// store.dispatch(requestActions.notify(
    		// 	{
    		// 		text : intl.formatMessage({
    		// 			id             : 'room.joined',
    		// 			defaultMessage : 'You have joined the room'
    		// 		})
    		// 	}));

    		// if (this._record)
    		// {
    		// 	this.sendRequest('streamEnrolled', { status: true });
    		// }

    		// window.allPeersRP = peers;

    		// need to check this line
    		// store.dispatch(roomActions.serRoomData());

    		this.isBreakoutRoom = false;

    		if (this._roomTemplate?.meetingDetails?.meetingId)
    		{
    			if (this._meetingType === 'webinar')
    			{
    				await this._getMeetingDetailsResponse().then((res) =>
    				{
    					// store.dispatch(roomActions.setMeetData({ meetDetails: res.data }));

    					this._applySimulcastFromMeeting(res.data[0]);

    					store.dispatch(webinarActions.setWebinarData(res.data[0]));

    					if (roles.indexOf(5337) > -1)
    					{
    						store.dispatch(roomActions.setWebinarStreamOn({ webinarStreamOn: true }));

    						this.connectToWebinarSocket();
    					}

    					if (res.data[0]?.webinarBackground[0]?.url && webinarBackground !== undefined)
    					{
    						store.dispatch(webinarActions.setSelectedBackground(res.data[0]?.webinarBackground[0]));
    					}
    					if (res.data[0]?.webinarLogo[0]?.url && webinarLogo !== undefined)
    					{
    						store.dispatch(webinarActions.setSelectedBrandingLogo(res.data[0]?.webinarLogo[0]));
    					}
    					if (res.data[0]?.surveyData && res.data[0]?.surveyData[0])
    					{
    						store.dispatch(webinarActions.setSurveyDataStore(res.data[0]?.surveyData[0]));
    					}
    				})
    					.catch((err) =>
    					{
    						console.log('error', err);
    					});
    			}
    			else
    			{
    				console.log('import.meta.env.VITE_SHEDULE==', import.meta.env.VITE_SHEDULE, import.meta.env.VITE_USERS);
    				this._getMeetingDetailsResponse()
    					.then((res) =>
    					{
    						// Late answer (pre-produce race timed out) still wins for
    						// any producer created after this point.
    						this._applySimulcastFromMeeting(res?.data);

    						store.dispatch(webinarActions.setWebinarData(res.data));
    						// if (res.data?.transcription && !this._record)
    						// {
    						// 	this.connectToTranscriptionSocket();
    						// }

    						if (res.data.transcription)
    						{
    							axios.post(`${import.meta.env.VITE_USERS}/transcription`, { email: res.data?.extra?.email })
    								.then((resp) =>
    								{
    									store.dispatch(viewTranscriptionAction.setTranscriptionOptions(resp?.data?.data));
    								})
    								.catch((e) => console.log('err', e));
    						}
    					})
    					.catch((err) =>
    					{
    						console.log('errorGetMeet', err);
    					});

    			}
    		}

    		if (this._meetingType === 'webinar' && webinarLogo)
    		{
    			store.dispatch(webinarActions.setSelectedBrandingLogo(webinarLogo));
    		}

    		if (this._meetingType === 'webinar' && webinarBackground)
    		{
    			store.dispatch(webinarActions.setSelectedBackground(webinarBackground));
    		}

    		this.getTranscription();

    		if (isBreakoutRoom)
    		{
    			this._spotpages = new Spotpages(Number(this._screenPage), this);
    		}

    	}
    	catch (error)
    	{
    		logger.error('_joinRoom() [error:"%o"]', error);

    		store.dispatch(requestActions.notify(
    			{
    				type : 'error',
    				text : intl.formatMessage({
    					id             : 'room.cantJoin',
    					defaultMessage : 'Unable to join the room'
    				})
    			}));

    		this.close(null, 'self');
    	}
    }

    getTranscription()
    {

    	try
    	{
    		getTranscriptionData(this._roomId, store.getState().viewTranscription.skip)
    			.then((res) =>
    			{

    				if (res?.data?.data?.length > 0)
    				{
    					console.log('response', res);
    					store.dispatch(viewTranscriptionAction.setAllTransCdata(res?.data?.data));
    					store.dispatch(viewTranscriptionAction.setSkip(10));
    				}
    			})
    			.catch((err) =>
    			{
    				console.log('errorGetMeet', err);
    			});
    	}
    	catch (err)
    	{
    		console.log('error in getTranscriptionData', err);
    	}

    }

    filterBreakourPeers(breakoutRoomData)
    {
    	const filterPeers = [];

    	if (breakoutRoomData && breakoutRoomData.length > 0)
    	{
    		breakoutRoomData.map((each) => filterPeers.push(...each.participantsList));
    	}

    	return filterPeers;
    }

    setBreakoutRoomData(peer, breakoutRoomData)
    {

    	const hostObj = {
    		id          : store.getState()?.me?.id,
    		displayName : store.getState()?.me?.displayName,
    		picture     : store.getState()?.me?.picture,
    		consumers   : [],
    		roles       : store.getState()?.me?.roles
    	};
    	const hostPeers = [ hostObj ];

    	const normalPeers = [];

    	const filterPeers = [];

    	breakoutRoomData.map((each) => filterPeers.push(...each.participantsList));

    	const index = filterPeers.findIndex((each) => each.id === peer.id);

    	if (index === -1)
    	{
    		if (peer.roles.includes(5337))
    		{
    			hostPeers.push(peer);
    		}
    		else
    		{
    			normalPeers.push(peer);
    		}

    	}

    	store.dispatch(roomActions.handleBreakoutRoomHostList([ ...hostPeers ]));
    	store.dispatch(roomActions.handleBreakoutRoomPeers([ ...normalPeers ]));
    }

    getRecorderSupportedMimeTypes()
    {
    	const mimeTypes = [];

    	const mimeTypeCapability = [

    		/* audio codecs
			[ 'audio/wav', [] ],
			[ 'audio/pcm', [] ],
			[ 'audio/webm', [ 'Chrome', 'Firefox', 'Safari' ] ],
			[ 'audio/ogg', [ 'Firefox' ] ],
			[ 'audio/opus', [] ],
			*/
    		[ 'video/webm', [ 'Chrome', 'Firefox', 'Safari' ] ],
    		[ 'video/webm;codecs="vp8, opus"', [ 'Chrome', 'Firefox', 'Safari' ] ],
    		[ 'video/webm;codecs="vp9, opus"', [ 'Chrome' ] ],
    		[ 'video/webm;codecs="h264, opus"', [ 'Chrome' ] ],
    		[ 'video/mp4', [] ],
    		[ 'video/mpeg', [] ],
    		[ 'video/x-matroska;codecs=avc1', [ 'Chrome' ] ]
    	];

    	if (typeof MediaRecorder === 'undefined')
    	{
    		window.MediaRecorder = {
    			isTypeSupported : function()
    			{
    				return false;
    			}
    		};
    	}
    	mimeTypeCapability.forEach((item) =>
    	{
    		if (MediaRecorder.isTypeSupported(item[0]) && !mimeTypes.includes(item[0]))
    		{
    			mimeTypes.push(item[0]);
    		}
    	});

    	return mimeTypes;
    }

    getPageLength()
    {
    	return this._totalPageLength;
    }

    async lockRoom()
    {
    	logger.debug('lockRoom()');

    	try
    	{
    		await this.sendRequest('lockRoom');

    		if (this._sipUserJoined)
    		{
    			this.performSIPConferenceTask('lock');
    		}

    		store.dispatch(
    			roomActions.setRoomLocked());

    		store.dispatch(requestActions.notify(
    			{
    				text : intl.formatMessage({
    					id             : 'room.youLocked',
    					defaultMessage : 'You locked the room'
    				})
    			}));
    	}
    	catch (error)
    	{
    		store.dispatch(requestActions.notify(
    			{
    				type : 'error',
    				text : intl.formatMessage({
    					id             : 'room.cantLock',
    					defaultMessage : 'Unable to lock the room'
    				})
    			}));

    		logger.error('lockRoom() [error:"%o"]', error);
    	}
    }
    async getLiveBroadcastChat(sessionId)
    {

    	let roomId = sessionId !== undefined ? sessionId : this._roomId;

    	axios.get(`${import.meta.env.VITE_InVcMainchatAPI}/getChat?meetingId=${roomId}`).then((res) =>
    	{

    		store.dispatch(
    			chatActions.addBroadcastMessage(
    				[
    					...res.data.data
    				]
    			)
    		);
    		console.log('store.getState().me.id', store.getState().me.id);

    		store.dispatch(
    			chatActions.setIsScrollEnd(true));
    	});
    }

    async getMeetingInfo()
    {

    	const roomId = window.location.pathname.split('/')[1];

    	const inapiRoomToken = store.getState().room?.roomToken;

    	try
    	{
    		if (!inapiRoomToken)
    		{
    			const res = await axios.get(`${import.meta.env.VITE_inApiPublicAPI}/getSessionToken?sessionId=${roomId}`);

    			if (res.status)
    			{
    				const sessionToken = res.data.data.sessionToken;

    				const sessionData = decodeToken(sessionToken, this._projectId);

    				return sessionData;
    			}
    		}
    		else
    		{
    			const sessionData = decodeToken(inapiRoomToken, this._projectId);

    			return sessionData;
    		}
    	}
    	catch (err)
    	{
    		console.log('err', err);
    	}

    }

    closeMeetingInfo()
    {
    	store.dispatch(roomActions.setHelpOpen(false));
    }

    async startBroadcast()
    {
    	// axios.post(`https://${config.serverHostname}/auth/streamingon`, { sessionId: this._roomTemplate.meetingDetails.meetingId, roomId: this._roomId, hostName: this._hostName }).then((res) =>
    	// {
    	// 	// eslint-disable-next-line no-console
    	// });

    	await this._sendRequest('startOrStopBroadCast',
    		{
    			sessionId : this._roomTemplate.meetingDetails.meetingId,
    			roomId    : this._roomId,
    			hostName  : this._hostName,
    			isStart   : true
    		});
    	if (this._meetingType !== 'webinar')
    	{
    		this.connectToBroadcastSocket();

    	}
    	if (store.getState().room.webinarStreamOn)
    	{
    		if (!this._webinarSocket)
    		{
    			await this.connectToWebinarSocket(true);
    		}
    		this._webinarSocket.emit('setWebinarStream', this._roomId, { stream: true });
    	}
    }

    async stopBroadcast()
    {
    	// axios.post(`https://${config.serverHostname}/auth/streamingoff`, { sessionId: this._roomTemplate.meetingDetails.meetingId, roomId: this._roomId }).then((res) =>
    	// {
    	await this._sendRequest('startOrStopBroadCast',
    		{
    			sessionId : this._roomTemplate.meetingDetails.meetingId,
    			roomId    : this._roomId,
    			hostName  : this._hostName,
    			isStart   : false
    		});
    	if (this._meetingType !== 'webinar')
    	{
    		this.broadcastSocket.disconnect();

    	}
    	else if (store.getState().room.webinarStreamOn && this._meetingType === 'webinar')
    	{
    		this._webinarSocket?.emit('webinar_stopped', { meetingId: this._roomId });
    		this._webinarSocket?.disconnect();

    		this._webinarSocket = null;
    	}
    	store.dispatch(
    		roomActions.setWebinarPeers([]));

    	// });
    }

    async startLiveStream(streamName, streamKey, streamUrl, streamType)
    {
    	// if (streamUrl === undefined)
    	// {
    	// 	// && streamUrl === 'rtmp://livestream.instavc.com/LiveApp'
    	// 	streamUrl = 'rtmp://livestream.instavc.com/LiveApp';
    	// 	streamKey = this._roomId;
    	// }
    	// axios.post(`https://${config.serverHostname}/auth/startLiveStream`, { sessionId: this._roomTemplate.meetingDetails.meetingId, roomId: this._roomId, hostName: this._hostName, streamKey: streamKey, streamUrl: streamUrl, streamType: streamType }).then((res) =>
    	// {
    	// 	// eslint-disable-next-line no-console
    	// });

    	await this._sendRequest('youtubeOrFbookstreaming',
    		{
    			sessionId  : this._roomTemplate.meetingDetails.meetingId,
    			roomId     : this._roomId,
    			hostName   : this._hostName,
    			streamKey  : streamKey,
    			streamUrl  : streamUrl,
    			streamType : streamType,
    			isStart    : true
    		});
    }

    async setLiveStreamDetails(streamName, streamKey, streamUrl, streamType)
    {
    	let streamData = {};

    	if (streamType === 'startYoutubeLive')
    	{
    		streamData = { 'youtube': { streamName, streamKey, streamUrl } };
    	}
    	else if (streamType === 'startFacebookLive')
    	{
    		streamData = { 'facebook': { streamName, streamKey, streamUrl } };
    	}

    	try
    	{
    		await this.sendRequest('setLiveStreamData', { data: streamData });
    	}
    	catch (error)
    	{
    		logger.error('saveStreamingDetails() [error:"%o"]', error);

    		store.dispatch(requestActions.notify(
    			{
    				type : 'error',
    				text : intl.formatMessage({
    					id             : 'saveStreamingDetails.unableToSave',
    					defaultMessage : 'Unable to save streaming details'
    				})
    			}));
    	}
    }

    async stopLiveStream(streamType)
    {
    	// axios.post(`https://${config.serverHostname}/auth/stopLiveStream`, { sessionId: this._roomTemplate.meetingDetails.meetingId, roomId: this._roomId, streamType: streamType }).then((res) =>
    	// {
    	// });

    	store.dispatch(roomActions.setWebinarPeers([]));

    	await this._sendRequest('youtubeOrFbookstreaming',
    		{
    			sessionId  : this._roomTemplate.meetingDetails.meetingId,
    			roomId     : this._roomId,
    			hostName   : this._hostName,
    			streamType : streamType,
    			isStart    : false
    		});
    }

    async startCloudRecording()
    {
    	// axios.post(`https://${config.serverHostname}/auth/recordon`, { sessionId: this._roomTemplate.meetingDetails.meetingId, roomId: this._roomId, hostName: this._hostName }).then((res) =>
    	// {
    	// 	// eslint-disable-next-line no-console
    	// });

    	await this._sendRequest('startRecording',
    		{
    			sessionId : this._roomTemplate.meetingDetails.meetingId,
    			roomId    : this._roomId,
    			hostName  : this._hostName
    		});
    }

    async stopCloudRecoding()
    {
    	// axios.post(`https://${config.serverHostname}/auth/recordoff`, { sessionId: this._roomTemplate.meetingDetails.meetingId, roomId: this._roomId }).then((res) =>
    	// {
    	// 	// eslint-disable-next-line no-console

    	// });

    	await this._sendRequest('stopRecording',
    		{
    			sessionId : this._roomTemplate.meetingDetails.meetingId,
    			roomId    : this._roomId
    		});
    }

    async startTelepresence(roomId = null)
    {
    	try
    	{
    		console.log('import.meta.env.REACT_TP_HUB_SERVER_URL===', import.meta.env.REACT_TP_HUB_SERVER_URL);
    		axios.post(`${import.meta.env.VITE_TP_HUB_SERVER_URL}startconf`, {
    			// axios.post('http://localhost:3006/startconf', {
    			projectId  : this._roomTemplate?.data?.appId,
    			clientData :
				{
					meetingId : roomId ? roomId : this._roomTemplate?.meetingDetails?.meetingId
				},
    			room        : this._roomTemplate?.meetingDetails?.telePresenceScreens,
    			meetingType : window.btoa(this._roomTemplate?.meetingDetails?.isRecurring),
    			hostName    : import.meta.env.VITE_TP_DOMAIN_URL
    		})
    			.then(async (res) =>
    			{
    				const filterWithoutHost = Object.values(store.getState().peers).filter((eachPeer) => !eachPeer?.roles.includes(5337));
    				const screenData = [];

    				// console.log('res===', res);

    				for (let i = 0; i < res?.data?.data?.length; i++)
    				{

    					// console.log('i=========================', i, config.tpScreenLimit);
    					const peersForScreenPage = filterWithoutHost?.slice(((i + 1) - 1)
							* config.tpScreenLimit, (i + 1) * config.tpScreenLimit);

    					// console.log('peersForScreenPagepeersForScreenPage===', peersForScreenPage);

    					const screen = {
    						peers           : peersForScreenPage,
    						screenNumber    : Number(res.data.data[i].screenNumber),
    						screenSeatLimit : config.tpScreenLimit
    					};

    					screenData.push(screen);

    				}

    				// console.log('screenData==', screenData);
    				await this.sendRequest('setScreenPeerData', { screenData, isStart: true });

    				store.dispatch(roomActions.setTpScreensPeerData(screenData));

    				await this.sendRequest('setLiveTpScreens', { liveTpScreens: res?.data?.data?.length });
    				store.dispatch(roomActions.setLiveTpScreens(res?.data?.data));
    				// this.cpanelStartTelepresenceRes(true);
    				store.dispatch(roomActions.setTelepresenseStart(true));

    			});
    		// 	.catch(function(error)
    		// 	{
    		// 		console.log('TP ERR', error);
    		// 	});
    	}
    	catch (err)
    	{
    		console.log('error========', err);

    	}
    }

    async ShareSendRequestFromPeer(peerId)
    {
    	if (peerId)
    	{

    		await this.sendRequest('shareSendRequest', { peerId });
    	}

    }

    async AnnotationsSendRequestFromPeer(peerId)
    {
    	if (peerId)
    	{

    		await this.sendRequest('annotationSendRequest', { peerId });
    	}

    }
    async scrollDocument(diff)
    {
    	this.sendRequest('scrollDif', { scrollDiff: diff });
    }

    getMeetingDetails()
    {
    	const _meetingDetails = {
    		meetingData : this._roomTemplate?.meetingDetails,
    		meeetingId  : this._roomTemplate?.meetingId
    	};

    	return _meetingDetails;
    }

    getInviteLink()
    {
    	if (this._roomTemplate?.data && this._roomTemplate?.meetingDetails)
    	{
    		// const _data = this._roomTemplate?.data;
    		const _meetingDetails = this._roomTemplate?.meetingDetails;

    		// return `https://${_data.subDomain}.invc.vc/inconf/${_meetingDetails.meetingId}`;
    		return `${import.meta.env.VITE_config}inconf/${_meetingDetails.meetingId}/${window.btoa(_meetingDetails.isRecurring)}`;
    	}
    }

    // getParticipantInviteLink(token)
    getParticipantInviteLink()
    {
    	const _data = this._roomTemplate?.data;
    	const _meetingDetails = this._roomTemplate?.meetingDetails;

    	if (_data.subDomain === 'outofboxapps')
    	{
    		return `https://app.instavc.net/inconf/${_meetingDetails.meetingId}`;
    	}
    	else if (this._roomTemplate?.data && this._roomTemplate?.meetingDetails)
    	{

    		// return `https://${_data.subDomain}.invc.vc/${this._roomId}?token=${token}&projectId=${_data.appId}`;

    		return `https://${window.location.hostname}/${this._roomId}?projectId=${_data.appId}&uid=UGFydGljaXBhbnQ=`;
    	}
    }

    getBroadcastLink()
    {
    	if (this._roomTemplate?.data && this._roomTemplate?.meetingDetails)
    	{
    		// const _data = this._roomTemplate?.data;
    		// const _meetingDetails = this._roomTemplate?.meetingDetails;
    		// if (_data.subDomain === 'app')
    		// {
    		// 	return `https://${_data.subDomain}.invc.vc/broadcast/${this._roomId}`;

    		// }
    		// else if (_data.subDomain === 'outofboxapps')
    		// {
    		// 	return `https://app.instavc.net/broadcast/${this._roomId}`;
    		// }
    		// else
    		// {
    		return `https://${window.location.hostname}/live?id=${this._roomId}`;
    		// }

    	}
    }

    getCpanleLink()
    {
    	if (this._roomTemplate?.data && this._roomTemplate?.meetingDetails)
    	{
    		const _meetingDetails = this._roomTemplate?.meetingDetails;

    		return `https://tpcpanel.invc.vc/meeting?meetingId=${_meetingDetails.meetingId}`;
    	}
    }

    getTpActiveSpeakerLink()
    {
    	if (this._roomTemplate?.data && this._roomTemplate?.meetingDetails)
    	{
    		const _meetingDetails = this._roomTemplate?.meetingDetails;

    		console.log('this._roomTemplate==', this._roomTemplate);

    		return `https://invctphub.invc.vc/?projectid=${this._roomTemplate?.data?.projectId}&room=${_meetingDetails?.telePresenceScreens}&mode=speaker`;
    	}
    }

    async sendTpScreenDataToSocket(data)
    {
    	await this.sendRequest('setTpScreensData', data);
    }

    async setPeersForAllScreens(data)
    {

    	console.log('setTpScreensData=====', data);
    	this.peersForAllScreens = data;

    }

    async removeExcessPeer(data)
    {
    	await this.sendRequest('removeExcessScreenPeers', data);
    }

    async addPeersToScreen(data)
    {
    	await this.sendRequest('addPeersToScreen', data);
    }

    async addPeerToEachScreen(data)
    {
    	await this.sendRequest('addPeerToEachScreen', data);
    }

    async screenFullNotification(msg)
    {
    	store.dispatch(requestActions.notify(
    		{
    			type : 'error',
    			text : intl.formatMessage({
    				id             : 'room.screenFull',
    				defaultMessage : msg
    			})
    		}));
    }

    async syncLayoutChangesToAll(layout)
    {
    	try
    	{
    		if (layout)
    		{
    			await this.sendRequest('syncLayoutToAll', { layout, peerId: this._peerId });

    		}
    	}
    	catch (error)
    	{
    		console.log('Failed to set layout');
    	}

    }

    async removeTpScreenMovePeer(data, movePeer)
    {
    	try
    	{

    		console.log('data=====', data);
    		console.log('movePeer=====', movePeer);
    		const index = data.peers.findIndex((each) => each.id === movePeer.id);

    		console.log('index======', index);

    		if (index > -1)
    		{
    			data.peers.splice(index, 1);

    			await this.sendRequest('hostRemoveScreenPeer', { peerId: movePeer.id, screenNumber: data?.screenNumber });
    		}

    		await this.sendTpScreenDataToSocket(data);
    		// await this.sendRequest('removeTpPeerInScreen', data)
    	}
    	catch (err)
    	{
    		console.log('error=', err);
    	}
    }

    async sendPeersPoolsubmitedObjToScreens(obj)
    {
    	await this.sendRequest('peersPollSubmitObjToSocket', obj);

    }

    async setTPPeer(tpPeers, screenNum, screenSeatLimit)
    {
    	console.log('setPeer====');
    	await this.sendTpScreenDataToSocket({ screenNumber: screenNum, peers: tpPeers, screenSeatLimit });

    	if (Number(this._screenPage) === screenNum)
    	{
    		store.dispatch(
    			roomActions.setTPPeers(tpPeers));
    	}

    }

    async getExcludePeers()
    {
    	try
    	{

    		let filterPeers = [];

    		for (const screenData of store.getState().room.tpScreensData)
    		{
    			filterPeers = [ ...filterPeers, ...screenData.peers ];
    		}

    		const filterExcludePeers = Object.values(store.getState().peers).filter((each) => !filterPeers.find((peer) => peer.id === each.id));

    		return filterExcludePeers;
    	}
    	catch (err)
    	{
    		console.log('error=======', err);
    	}

    }

    async handleAllScreens(screenLimit)
    {
    	try
    	{

    		this.peersForAllScreens = screenLimit;
    		const filterExcludePeers = await this.getExcludePeers();

    		for (const screenData of store.getState().room.tpScreensData)
    		{
    			let peersList;

    			let extraPeers;

    			if (screenLimit < screenData.peers.length || screenData.peers.length === 0)
    			{
    				peersList = screenData.peers.slice(0, screenLimit);

    				extraPeers = screenData.peers.slice(screenLimit, screenData.peers.length);

    				this.removeExcessPeer({ extraPeers, screenNumber: screenData?.screenNumber, limit: screenLimit });

    				this.setTPPeer(peersList, screenData.screenNumber, screenLimit);

    			}
    			else
    			{
    				// let filterPeers = [];

    				// for (const eachScreen of tpScreensData)
    				// {
    				// filterPeers = [ ...filterPeers, ...screenData.peers ];
    				// }

    				// eslint-disable-next-line no-console
    				// console.log('filterPeers====', filterPeers);

    				// const filterExcludePeers = Object.values(peers).filter((item) => !filterPeers.find((peer) => peer.id === item.id));

    				// eslint-disable-next-line no-console
    				// console.log('filterExcludePeers===', filterExcludePeers);

    				// const filterExcludePeers = getExcludePeers();

    				// const excludePeers = Object.values(store.getState().peers).filter((each) => !filterPeers.find((peer) => peer.id === each.id));

    				// const itemPerScreen = Math.ceil((excludePeers).length / liveTpScreens);

    				const peersForThispage = filterExcludePeers.splice(0, screenLimit - screenData.peers.length);

    				this.addPeersToScreen({ peersForThispage, screenNumber: screenData.screenNumber, limit: screenLimit });

    				this.setTPPeer([ ...screenData.peers, ...peersForThispage ], screenData.screenNumber, screenLimit);

    			}
    		}
    	}
    	catch (err)
    	{
    		console.log('error=====', err);
    	}
    }

    async handleSelect(screenLimit, each)
    {
    	try
    	{

    		// setScreen(e.target.value);
    		let peersList;

    		let reminingPeers;

    		let extraPeers;

    		if (screenLimit < each.peers.length || each.peers.length === 0)
    		{
    			peersList = each.peers.slice(0, screenLimit);

    			extraPeers = each.peers.slice(screenLimit, each.peers.length);

    			reminingPeers = each.peers.slice(screenLimit, each.peers.length);

    			for (const screenData of store.getState().room.tpScreensData)
    			{
    				if (screenData.peers.length < screenData.screenSeatLimit && each.screenNumber != screenData.screenNumber)
    				{
    					const moveReminingPeers = reminingPeers.splice(0, screenData.screenSeatLimit - screenData.peers.length);

    					this.addPeersToScreen({ peersForThispage: moveReminingPeers, screenNumber: screenData.screenNumber, limit: screenData.screenSeatLimit });

    					this.setTPPeer([ ...moveReminingPeers, ...screenData.peers ], screenData.screenNumber, screenData.screenSeatLimit);
    				}
    			}

    			this.removeExcessPeer({ extraPeers, screenNumber: each?.screenNumber, limit: screenLimit });

    			this.setTPPeer(peersList, each.screenNumber, screenLimit);

    		}
    		else
    		{
    			let filterPeers = [];

    			for (const screenData of store.getState().room.tpScreensData)
    			{
    				filterPeers = [ ...filterPeers, ...screenData.peers ];
    			}

    			const filterExcludePeers = Object.values(store.getState().peers).filter((item) => !filterPeers.find((peer) => peer.id === item.id));

    			// const excludePeers = Object.values(store.getState().peers).filter((each) => !filterPeers.find((peer) => peer.id === each.id));

    			// const itemPerScreen = Math.ceil((excludePeers).length / liveTpScreens);

    			const peersForThispage = filterExcludePeers.slice(0, screenLimit - each.peers.length);

    			this.addPeersToScreen({ peersForThispage, screenNumber: each.screenNumber, limit: screenLimit });

    			this.setTPPeer([ ...each.peers, ...peersForThispage ], each.screenNumber, screenLimit);

    		}

    		// eslint-disable-next-line max-len
    	}
    	catch (err)
    	{
    		console.log('error====', err);
    	}
    }

    async handleRemove(peerId, eachScreen)
    {
    	console.log('peerIdm, eachScreen', peerId, eachScreen);
    	this.removeTpScreenMovePeer(eachScreen, peerId);
    }

    async handleMovePeer(each, peer, eachScreen)
    {
    	try
    	{

    		console.log('each======', each);
    		console.log('peer======', peer);
    		console.log('eachScreen===', eachScreen);

    		// eslint-disable-next-line max-len
    		if (each.peers.length < each.screenSeatLimit)
    		{
    			const adedPeers = each.peers;

    			adedPeers.push(peer);
    			this.addPeerToEachScreen({
    				peer         : peer,
    				screenNumber : each.screenNumber
    			});

    			this.sendTpScreenDataToSocket({
    				screenNumber    : each.screenNumber,
    				peers           : adedPeers,
    				screenSeatLimit : each.screenSeatLimit
    			});

    			if (eachScreen)
    			{
    				this.removeTpScreenMovePeer(eachScreen, peer);
    			}
    			// else
    			// {
    			// 	props.moveExcludePeer();
    			// }

    			// setAnchorEl(null);
    		}
    		else
    		{
    			this.screenFullNotification('Screen is full');
    			// setAnchorEl(null);
    		}
    		// eslint-disable-next-line max-len
    	}
    	catch (err)
    	{
    		console.log('error===', err);
    	}
    }

    async stopTelepresence()
    {
    	try
    	{

    		axios.post(`${import.meta.env.VITE_TP_HUB_SERVER_URL}stopconf`, {
    			// axios.post('http://localhost:3006/stopconf', {
    			projectId  : this._roomTemplate?.data?.appId,
    			clientData :
				{
					meetingId : this._roomTemplate?.meetingDetails?.meetingId
				},
    			room     : this._roomTemplate?.meetingDetails?.telePresenceScreens,
    			hostName : import.meta.env.VITE_TP_DOMAIN_URL
    		})
    			.then(async (res) =>
    			{
    				console.log(res);
    				await this.sendRequest('clearTpScreenData', { isStart: false });
    				this.cpanelStartTelepresenceRes(false);
    				store.dispatch(roomActions.setTelepresenseStart(false));
    			})
    			.catch((error) =>
    			{
    				console.log('sdsdkkadladadsad', error);
    			});
    	}
    	catch (err)
    	{
    		console.log('error=========', err);
    	}
    }

    async unlockRoom()
    {
    	logger.debug('unlockRoom()');

    	try
    	{
    		await this.sendRequest('unlockRoom');

    		if (this._sipUserJoined)
    		{
    			this.performSIPConferenceTask('unlock');
    		}

    		store.dispatch(
    			roomActions.setRoomUnLocked());

    		store.dispatch(requestActions.notify(
    			{
    				text : intl.formatMessage({
    					id             : 'room.youUnLocked',
    					defaultMessage : 'You unlocked the room'
    				})
    			}));
    	}
    	catch (error)
    	{
    		store.dispatch(requestActions.notify(
    			{
    				type : 'error',
    				text : intl.formatMessage({
    					id             : 'room.cantUnLock',
    					defaultMessage : 'Unable to unlock the room'
    				})
    			}));

    		logger.error('unlockRoom() [error:"%o"]', error);
    	}
    }

    async addConsentForRecording(consent)
    {
    	logger.debug('addConsentForRecording()');

    	try
    	{
    		store.dispatch(
    			recorderActions.setLocalRecordingConsent(consent));
    		await this.sendRequest('addConsentForRecording', { consent });
    	}
    	catch (error)
    	{

    		logger.error('addConsentForRecording() [error:"%o"]', error);
    	}
    }

    async setAccessCode(code)
    {
    	logger.debug('setAccessCode()');

    	try
    	{
    		await this.sendRequest('setAccessCode', { accessCode: code });

    		store.dispatch(
    			roomActions.setAccessCode(code));

    		store.dispatch(requestActions.notify(
    			{
    				text : intl.formatMessage({
    					id             : 'room.saveAccessCode',
    					defaultMessage : 'Access code saved.'
    				})
    			}));
    	}
    	catch (error)
    	{
    		logger.error('setAccessCode() [error:"%o"]', error);
    		store.dispatch(requestActions.notify(
    			{
    				type : 'error',
    				text : intl.formatMessage({
    					id             : 'room.unableto_setAccessCode',
    					defaultMessage : 'Unable to set access code.'
    				})
    			}));
    	}
    }

    async setJoinByAccessCode(value)
    {
    	logger.debug('setJoinByAccessCode()');

    	try
    	{
    		await this.sendRequest('setJoinByAccessCode', { joinByAccessCode: value });

    		store.dispatch(
    			roomActions.setJoinByAccessCode(value));

    		store.dispatch(requestActions.notify(
    			{
    				text : `You switched Join by access-code to ${value}`
    			}));
    	}
    	catch (error)
    	{
    		logger.error('setAccessCode() [error:"%o"]', error);
    		store.dispatch(requestActions.notify(
    			{
    				type : 'error',
    				text : intl.formatMessage({
    					id             : 'room.acces_joinCode',
    					defaultMessage : 'Unable to set join by access code.'
    				})
    			}));
    	}
    }
    // async changeExtraVideoresolution({producerId,resolution}){
    // 	const {
    // 		aspectRatio,
    // 		frameRate
    // 	} = store.getState().settings;
    // 	const producer = this._extraVideoProducers.get(producerId);
    // 	let {track }= producer;

    // 			await track.applyConstraints(
    // 				{
    // 					...getVideoConstrains(resolution, aspectRatio),
    // 					frameRate
    // 				}
    // 			);
    // }
    async addExtraVideo(videoDeviceId)
    {
    	logger.debug(
    		'addExtraVideo() [videoDeviceId:"%s"]',
    		videoDeviceId
    	);

    	store.dispatch(
    		roomActions.setExtraVideoOpen(false));

    	if (!this._mediasoupDevice.canProduce('video'))
    	{
    		logger.error('addExtraVideo() | cannot produce video');

    		return;
    	}

    	let track;

    	store.dispatch(
    		meActions.setWebcamInProgress(true));

    	try
    	{
    		const device = this._webcams[videoDeviceId];
    		const settings = store.getState().settings;
    		const { aspectRatio, frameRate } = settings;
    		const resolution = getCaptureResolution(settings);

    		if (!device)
    			throw new Error('no webcam devices');

    		let stream;
    		
    		try {
    			stream = await navigator.mediaDevices.getUserMedia(
    				{
    					video :
						{
							deviceId : { exact: videoDeviceId },
							...getVideoConstrains(resolution, aspectRatio),
							frameRate,
							zoom     : true
						}
    				});
    		} catch (e) {
    			console.log('Failed to get exact video device, trying with ideal constraint:', e);
    			// Fallback to ideal constraint if exact fails
    			try {
    				stream = await navigator.mediaDevices.getUserMedia(
    					{
    						video :
							{
								deviceId : { ideal: videoDeviceId },
								...getVideoConstrains(resolution, aspectRatio),
								frameRate,
								zoom     : true
							}
    					});
    			} catch (fallbackError) {
    				console.log('Fallback also failed, using default video device:', fallbackError);
    				// Final fallback to default video device
    				stream = await navigator.mediaDevices.getUserMedia(
    					{
    						video :
							{
								...getVideoConstrains(resolution, aspectRatio),
								frameRate,
								zoom     : true
							}
    					});
    			}
    		}

    		const supports = navigator.mediaDevices.getSupportedConstraints();

    		([ track ] = stream?.getVideoTracks());
    		const { pan, tilt, zoom } = track.getCapabilities();

    		let isCameraControl;

    		if (supports.pan && supports.tilt && supports.zoom && pan && tilt && zoom)
    		{
    			console.log('cameraControl....', supports);
    			isCameraControl = true;
    		}
    		const { zoom: previousZoomVal } = track.getSettings();

    		if (supports.pan && supports.tilt && supports.zoom && previousZoomVal && previousZoomVal > 1)
    		{
    			console.log('checkkkkkkkkkkkkkkkkkkkkkkk');

    			if (track.getCapabilities)
    			{
    				// const { zoom } = track.getCapabilities();

    				const constraints = {
    					...getVideoConstrains(resolution, aspectRatio),
    					frameRate,
    					advanced : [ { zoom: zoom.min } ]
    				};

    				await track?.applyConstraints(constraints).then((res) =>
    				{
    					console.log('setting zoom value to 1=======', res);
    				});
    			}
    		}

    		const { deviceId: id, width, height, pan: currentPan, tilt: currentTilt, zoom: currentZoom } = track.getSettings();

    		logger.debug('extra video track settings:', track.getSettings());

    		let exists = false;

    		// this._extraVideoProducers.forEach(function(value)
    		// {
    		// 	if (value._appData.deviceId === videoDeviceId)
    		// 	{
    		// 		exists = true;
    		// 	}
    		// });

    		if (!exists)
    		{

    			let producer;

    			const networkPriority =
					config.networkPriorities?.extraVideo ?
						config.networkPriorities?.extraVideo :
						DEFAULT_NETWORK_PRIORITIES.extraVideo;

    			const lowBandwidthMode = store.getState().mediaSession.lowBandwidthMode;

    			if (this._useSimulcast && !lowBandwidthMode)
    			{
    				const encodings = this._getEncodings(width, height);
    				const resolutionScalings = getResolutionScalings(encodings);

    				/**
					 * TODO:
					 * I receive DOMException:
					 * Failed to execute 'addTransceiver' on 'RTCPeerConnection':
					 * Attempted to set an unimplemented parameter of RtpParameters.
					encodings.forEach((encoding) =>
					{
						encoding.networkPriority=networkPriority;
					});
					*/
    				encodings[0].networkPriority = networkPriority;

    				producer = await this._sendTransport.produce(
    					{
    						track,
    						encodings,
    						codecOptions :
							{
								videoGoogleStartBitrate : 1000
							},
    						appData :
							{
    								source    : 'extravideo',
    								peerName  : this._displayName,
    								panRange  : pan,
    								tiltRange : tilt,
    								zoomRange : zoom,
    								pan       : currentPan,
    								tilt      : currentTilt,
    								zoom      : currentZoom,
    								isCameraControl,
    								width,
    							height,
    							resolutionScalings,
    							deviceId  : videoDeviceId
    						}
    					});
    			}
    			else
    			{
    				producer = await this._sendTransport.produce({
    					track,
    					deviceId  : videoDeviceId,
    					encodings : [
    						lowBandwidthMode ?
    							{ networkPriority, maxBitrate: 300000 } :
    							{ networkPriority }
    					],
    					...(lowBandwidthMode ?
    						{
    							codecOptions :
    							{
    								videoGoogleStartBitrate : 150
    							}
    						} :
    						{}),
    					appData   :
						{
							source    : 'extravideo',
							peerName  : this._displayName,
							panRange  : pan,
							tiltRange : tilt,
							zoomRange : zoom,
							pan       : currentPan,
							tilt      : currentTilt,
							zoom      : currentZoom,
							isCameraControl,
							width,
							height,
							deviceId  : videoDeviceId
						}
    				});
    			}

    			this._extraVideoProducers.set(producer.id, producer);

    			store.dispatch(producerActions.addProducer(
    				{
    					id            : producer.id,
    					deviceLabel   : device.label,
    					source        : 'extravideo',
    					panRange      : pan,
    					tiltRange     : tilt,
    					zoomRange     : zoom,
    					pan           : currentPan,
    					tilt          : currentTilt,
    					zoom          : currentZoom,
    					isCameraControl,
    					paused        : producer.paused,
    					track         : producer.track,
    					rtpParameters : producer.rtpParameters,
    					codec         : producer.rtpParameters.codecs[0].mimeType.split('/')[1],
    					deviceId      : videoDeviceId
    				}));

    			// store.dispatch(settingsActions.setSelectedWebcamDevice(deviceId));

    			await this._updateWebcams();

    			producer.on('transportclose', () =>
    			{
    				this._extraVideoProducers.delete(producer.id);

    				producer = null;
    			});

    			producer.on('trackended', () =>
    			{
    				store.dispatch(requestActions.notify(
    					{
    						type : 'error',
    						text : intl.formatMessage({
    							id             : 'devices.cameraDisconnected',
    							defaultMessage : 'Camera disconnected'
    						})
    					}));

    				this.disableExtraVideo(producer.id)
    					.catch(() => { });
    			});

    			logger.debug('addExtraVideo() succeeded');

    		}
    		else
    		{
    			logger.error('addExtraVideo() duplicate');
    			store.dispatch(requestActions.notify(
    				{
    					type : 'error',
    					text : intl.formatMessage({
    						id             : 'room.extraVideoDuplication',
    						defaultMessage : 'Extra videodevice duplication errordefault'
    					})
    				}));
    		}
    	}
    	catch (error)
    	{
    		logger.error('addExtraVideo() [error:"%o"]', error);

    			store.dispatch(requestActions.notify(
    				{
    					type : 'error',
    					text : intl.formatMessage({
    						id             : 'devices.cameraError',
    						defaultMessage : 'Your camera is either in use by another application or cannot be accessed.'
    					})
    				}));

    		if (track)
    			track.stop();
    	}

    	store.dispatch(
    		meActions.setWebcamInProgress(false));
    }


	/**
 * Helper method to switch to the next available audio input device
 * when the current device is disconnected
 * @param {boolean} wasMicMuted - Whether the user had muted the mic before disconnection
 * @param {string} source - Source of the switch (for logging) - 'trackended' or 'devicechange'
 * @returns {Promise<boolean>} - Returns true if switch was successful, false otherwise
 */
	async _switchToNextAudioDevice(wasMicMuted, source = 'unknown') {
		return await switchToNextAudioDevice(this, wasMicMuted, source, store, intl);
	}


    async disableMic()
    {
    	logger.debug('disableMic()');

    	const producers = this._allMicProducers();

    	if (producers.length === 0)
    	{
    		this._micProducer = null;

    		return;
    	}

    	store.dispatch(meActions.setAudioInProgress(true));

    	// Every mic producer, not just the current one, and _micProducer is cleared before any await:
    	// nulling it afterwards wiped out a producer a concurrent updateMic() had assigned meanwhile.
    	const closing = producers.map((producer) => this._retireMicProducer(producer));

    	if ('mediaSession' in navigator && isInPIP())
    	{
    		navigator.mediaSession.setMicrophoneActive(false);
    	}

    	store.dispatch(settingsActions.setMediaPerms({
    		...store.getState().settings.mediaPerms,
    		audio : false
    	}));

    	await Promise.all(closing);

    	store.dispatch(meActions.setAudioInProgress(false));
    }
    async updateRecorderPreferredMimeType({ recorderPreferredMimeType = null } = {})
    {
    	logger.debug('updateRecorderPreferredMimeType [mime-type: "%s"]',
    		recorderPreferredMimeType
    	);
    	store.dispatch(
    		settingsActions.setRecorderPreferredMimeType(recorderPreferredMimeType));
    }

    async updateScreenSharing({
    	start = false,
    	newResolution = null,
    	newFrameRate = null
    } = {})
    {
    	logger.debug('updateScreenSharing() [start:"%s"]', start);

    	let track;

    	try
    	{
    		const available = this._screenSharing.isScreenShareAvailable();

    		const isAudioEnabled = this._screenSharing.isAudioEnabled();

    		if (!available)
    			throw new Error('screen sharing not available');

    		if (!this._mediasoupDevice.canProduce('video'))
    			throw new Error('cannot produce video');

    		if (newResolution)
    			store.dispatch(settingsActions.setScreenSharingResolution(newResolution));

    		if (newFrameRate)
    			store.dispatch(settingsActions.setScreenSharingFrameRate(newFrameRate));

    		store.dispatch(meActions.setScreenShareInProgress(true));
    		const scheduleType = store.getState().room?.scheduleType;

    		const {
    			screenSharingResolution,
    			autoGainControl,
    			echoCancellation,
    			noiseSuppression,
    			aspectRatio,
    			screenSharingFrameRate,
    			sampleRate,
    			channelCount,
    			sampleSize,
    			opusStereo,
    			opusDtx,
    			opusFec,
    			opusPtime,
    			opusMaxPlaybackRate
    		} = store.getState().settings;

    		if (start)
    		{
    			let stream;

    			let sipModerator;

    			if (isAudioEnabled)
    			{
    				stream = await this._screenSharing.start({
    					...getVideoConstrains(screenSharingResolution, aspectRatio),
    					frameRate : screenSharingFrameRate,
    					sampleRate,
    					channelCount,
    					autoGainControl,
    					echoCancellation,
    					noiseSuppression,
    					sampleSize
    				});

    			}
    			else
    			{
    				stream = await this._screenSharing.start({
    					...getVideoConstrains(screenSharingResolution, aspectRatio),
    					frameRate : screenSharingFrameRate
    				});

    			}

    			if (this._roomTemplate?.meetingDetails?.isSipEnable)
    			{
    				sipModerator = store.getState().room.SIPConferenceUsers.filter((each) => String(each?.sipNumber.split('@')[0]) === String(this._roomTemplate?.meetingDetails?.sipRooms[0].userId));
    			}

    			console.log('stream===', stream);

    			([ track ] = stream.getVideoTracks());
    			if (!store.getState().me.roles.includes(9583))
    			{
    				console.log(stream, 'sss=============');
    				stream.getTracks().forEach((eachTrack) => eachTrack.stop());
    				await this._screenSharing.stop();
    				toast.dismiss();
    				toast.error(intl.formatMessage({ id: 'Problem_starting_screen_share', defaultMessage: 'You do not have access to share screen' }), {
    					position : toast.POSITION.TOP_RIGHT
    				});

    				return;
    			}

    			const { width, height, displaySurface } = track.getSettings();

    			if (displaySurface && [ 'window', 'monitor' ].includes(displaySurface))
    			{
    				store.dispatch(roomActions.handleIgnoreMasking({
    					isShowMask   : true,
    					isShowIgnore : displaySurface === 'monitor' ? false : true
    				}));
    			}
    			else if (!displaySurface)
    			{
    				store.dispatch(roomActions.handleIgnoreMasking({
    					isShowMask   : true,
    					isShowIgnore : true
    				}));
    			}
    			logger.debug('screenSharing track settings:', track.getSettings());

    			const networkPriority =
					config.networkPriorities?.screenShare ?
						config.networkPriorities?.screenShare :
						DEFAULT_NETWORK_PRIORITIES.screenShare;

    			if (this._useSharingSimulcast)
    			{
    				let encodings = this._getEncodings(width, height, true);

    				// If VP9 is the only available video codec then use SVC.
    				const firstVideoCodec = this._mediasoupDevice
    					.rtpCapabilities
    					.codecs
    					.find((c) => c.kind === 'video');

    				if (firstVideoCodec.mimeType.toLowerCase() !== 'video/vp9')
    				{
    					encodings = encodings
    						.map((encoding) => ({ ...encoding, dtx: true }));
    				}

    				const resolutionScalings = getResolutionScalings(encodings);

    				/**
					 * TODO:
					 * I receive DOMException:
					 * Failed to execute 'addTransceiver' on 'RTCPeerConnection':
					 * Attempted to set an unimplemented parameter of RtpParameters.
					encodings.forEach((encoding) =>
					{
						encoding.networkPriority=networkPriority;
					});
					*/
    				encodings[0].networkPriority = networkPriority;

    				this._screenSharingProducer = await this._sendTransport.produce(
    					{
    						track,
    						encodings,
    						codecOptions :
							{
								videoGoogleStartBitrate : 1000
							},
    						appData :
							{
								source       : 'screen',
								peerName     : this._displayName,
								width,
								height,
								resolutionScalings,
								sipModerator : this._roomTemplate.meetingDetails?.isSipEnable && sipModerator[0]?.id ? sipModerator[0]?.id : undefined
							}
    					});
    			}
    			else
    			{
    				this._screenSharingProducer = await this._sendTransport.produce({
    					track,
    					encodings : [ { networkPriority } ],
    					appData   :
						{
							source       : 'screen',
							peerName     : this._displayName,
							width,
							height,
							sipModerator : this._roomTemplate.meetingDetails?.isSipEnable && sipModerator[0]?.id ? sipModerator[0]?.id : undefined

						}
    				});
    			}

    			store.dispatch(producerActions.addProducer(
    				{
    					id            : this._screenSharingProducer.id,
    					deviceLabel   : 'screen',
    					source        : 'screen',
    					paused        : this._screenSharingProducer.paused,
    					track         : this._screenSharingProducer.track,
    					rtpParameters : this._screenSharingProducer.rtpParameters,
    					codec         : this._screenSharingProducer.rtpParameters.codecs[0].mimeType.split('/')[1]
    				}));

    			this._screenSharingProducer.on('transportclose', () =>
    			{
    				this._screenSharingProducer = null;
    			});

    			this._screenSharingProducer.on('trackended', () =>
    			{
    				store.dispatch(requestActions.notify(
    					{
    						type : 'error',
    						text : intl.formatMessage({
    							id             : 'devices.screenSharingDisconnected',
    							defaultMessage : 'Screen sharing disconnected'
    						})
    					}));

    				this.disableScreenSharing();
    			});

    			([ track ] = stream.getAudioTracks());

    			if (isAudioEnabled && track)
    			{
    				// track.stop();

    				// if (this._micProducer)
    				// {
    				// 	await this.unmuteMic();
    				// }
    				// else
    				// {
    				// 	await this.updateMic({ start: true });
    				// 	this.screenShareWithAudio = true;

    				// }

    				this._screenSharingAudioProducer = await this._sendTransport.produce(
    					{
    						track,
    						encodings    : [ { networkPriority } ],
    						codecOptions :
							{
								opusStereo          : opusStereo,
								opusFec             : opusFec,
								opusDtx             : opusDtx,
								opusMaxPlaybackRate : opusMaxPlaybackRate,
								opusPtime           : opusPtime
							},
    						appData :
								// Shares the 'mic' source so remote peers play it, but this is content
								// audio, not the device mic: no micDevice flag, so the SFU never closes
								// or pauses it alongside the microphone.
								{ source: 'mic' }
    					});

    				// store.dispatch(producerActions.addProducer(
    				// 	{
    				// 		id            : this._screenSharingAudioProducer.id,
    				// 		source        : 'mic',
    				// 		paused        : this._screenSharingAudioProducer.paused,
    				// 		track         : this._screenSharingAudioProducer.track,
    				// 		rtpParameters : this._screenSharingAudioProducer.rtpParameters,
    				// 		codec         : this._screenSharingAudioProducer.rtpParameters.codecs[0].mimeType.split('/')[1]
    				// 	}));

    				this._screenSharingAudioProducer.on('transportclose', () =>
    				{
    					this._screenSharingAudioProducer = null;
    				});

    				this._screenSharingAudioProducer.on('trackended', () =>
    				{
    					store.dispatch(requestActions.notify(
    						{
    							type : 'error',
    							text : intl.formatMessage({
    								id             : 'devices.screenSharingDisconnected',
    								defaultMessage : 'Screen sharing disconnected'
    							})
    						}));

    					// this.disableScreenSharing();
    				});

    				// this.connectLocalHark(track);

    				this._screenSharingAudioProducer.volume = 0;
    			}

    			// await this.updateMic({ start: true });

    			if (store.getState().settings.enablePIPAutomatically)
    			{
    				store.dispatch(roomActions.setIsPip(true));
    			}
    		}
    		else
    		{
    			if (this._screenSharingProducer)
    			{
    				({ track } = this._screenSharingProducer);

    				await track.applyConstraints(
    					{
    						...getVideoConstrains(screenSharingResolution, aspectRatio),
    						frameRate : screenSharingFrameRate
    					}
    				);
    			}

    			// if (this._micProducer)
    			// {
    			// 	await this.unmuteMic();
    			// }
    			if (this._screenSharingAudioProducer)
    			{
    				({ track } = this._screenSharingAudioProducer);

    				try
    				{
    					const ua = navigator.userAgent;
    					const browser = bowser.getParser(ua);

    					await track.applyConstraints(
    						{
    							sampleRate : (browser.satisfies({ safari: '>=0' })) ? undefined : sampleRate,
    							channelCount,
    							autoGainControl,
    							echoCancellation,
    							noiseSuppression,
    							sampleSize : (browser.satisfies({ safari: '>=0' })) ? undefined : sampleSize
    						}
    					);
    				}
    				catch (err)
    				{
    					console.log('error=========', err);
    				}
    			}
    		}

    		if (scheduleType === 'presence')
    		{
    			await this.sendRequest(
    				'startScreenShare', { screenShareStatus: true, peerId: this._peerId, type: 'screenShare' });

    			store.dispatch(meActions.setScreenShareStatus(true));
    			store.dispatch(meActions.setScreenSharePeerId(this._peerId));
    		}

    		if (this._screenSharingProducer)
    		{
    			window.parent.postMessage(JSON.stringify({ cmd: 'SCREEN_SHARE', value: { screenShare: true, pId: this._peerId } }), '*');
    		}

    	}
    	catch (error)
    	{
    		logger.error('updateScreenSharing() [error:"%o"]', error);

    		const object = {
    			type  : 'screenShareStart',
    			error : error.name === 'NotAllowedError' ? 'Permission denied' : 'An error occurred while accessing your screen'
    		};

    		window.parent.postMessage(JSON.stringify({ cmd: 'eventError', value: object }), '*');

    		if (error?.type === 'presence')
    		{
    			toast.warn(error?.message);
    		}
    		else
    		{

    			store.dispatch(requestActions.notify(
    				{
    					type : 'error',
    					text : intl.formatMessage({
    						id             : 'devices.screenSharingError',
    						defaultMessage : 'An error occurred while accessing your screen'
    					})
    				}));
    		}

    		if (track)
    			track.stop();
    	}

    	store.dispatch(meActions.setScreenShareInProgress(false));
    }

    async disableScreenSharing()
    {
    	logger.debug('disableScreenSharing()');
    	const { me } = store.getState();

    	this.exitScreenShareIfRequired(me.id);

    	if (!this._screenSharingProducer)
    		return;

    	store.dispatch(meActions.setScreenShareInProgress(true));

    	this._screenSharingProducer.close();

    	if (this._screenSharingAudioProducer)
    	{
    		this._screenSharingAudioProducer.close();

    		store.dispatch(
    			producerActions.removeProducer(this._screenSharingAudioProducer.id));
    	}
    	// if (this._micProducer && this.screenShareWithAudio)
    	// {
    	// 	this.screenShareWithAudio = false;
    	// 	await this.muteMic();
    	// }

    	store.dispatch(
    		producerActions.removeProducer(this._screenSharingProducer.id));

    	try
    	{
    		await this.sendRequest(
    			'closeProducer', { producerId: this._screenSharingProducer.id });

    		if (this._screenSharingAudioProducer)
    		{
    			await this.sendRequest(
    				'closeProducer', { producerId: this._screenSharingAudioProducer.id });
    		}
    		const scheduleType = store.getState().room?.scheduleType;

    		if (scheduleType === 'presence')
    		{
    			await this.sendRequest(
    				'stopScreenShare', { peerId: me.id, type: 'screenShare', screenShareStatus: false });
    			store.dispatch(meActions.setScreenShareStatus(false));
    			store.dispatch(meActions.setScreenSharePeerId(null));

    		}

    		window.parent.postMessage(JSON.stringify({ cmd: 'SCREEN_SHARE', value: { screenShare: false, pId: this._peerId } }), '*');

    		store.getState().room.ignoreMasking && store.dispatch(roomActions.handleIgnoreMasking(null));

    	}
    	catch (error)
    	{
    		logger.error('disableScreenSharing() [error:"%o"]', error);
    	}

    	this._screenSharingProducer = null;
    	this._screenSharingAudioProducer = null;

    	this._screenSharing.stop();

    	store.dispatch(meActions.setScreenShareInProgress(false));

    	if (store.getState().room.isPip)
    	{
    		closePIP(store.getState().room.pipVideos);
    	}
    }

    async disableExtraVideo(id)
    {
    	logger.debug('disableExtraVideo()');

    	const producer = this._extraVideoProducers.get(id);

    	if (!producer)
    		return;

    	store.dispatch(meActions.setWebcamInProgress(true));

    	producer.close();

    	store.dispatch(
    		producerActions.removeProducer(id));

    	try
    	{
    		await this.sendRequest(
    			'closeProducer', { producerId: id });
    	}
    	catch (error)
    	{
    		logger.error('disableWebcam() [error:"%o"]', error);
    	}

    	this._extraVideoProducers.delete(id);

    	store.dispatch(meActions.setWebcamInProgress(false));
    }

    // async setPictureInpicture()
    // {
    // 	this.videosArray = store.getState().room.pipVideos;

    // 	if (canPIP())
    // 	{
    // 		// console.log('do to pip');
    // 		if (supportsPIP())
    // 		{
    // 			if (isInPIP())
    // 			{
    // 				closePIP(this.videosArray);
    // 			}
    // 			else
    // 			{
    // 				const arrr = [];

    // 				const webCamStates = { ...meProducersSelector(store.getState()) };

    // 				arrr.push(webCamStates);

    // 				const spotightPeers = spotlightPeersSelector(store.getState());

    // 				const getPeerConsumers = makePeerConsumerSelector();

    // 				if (spotightPeers && spotightPeers.length > 0)
    // 				{
    // 					spotightPeers.forEach((peer) =>
    // 					{
    // 						arrr.push({ ...getPeerConsumers(store.getState(), peer) });

    // 					});
    // 				}

    // 				pipViewMode(arrr);
    // 			}
    // 		}
    // 	}
    // }

    async disableWebcam(options = {})
    {
    	const { preserveChromaForVirtualBg = false } = options;

    	logger.debug('disableWebcam()');

    	if (!this._webcamProducer)
    		return;

    	store.dispatch(meActions.setWebcamInProgress(true));

    	this._webcamProducer.close();

    	store.dispatch(
    		producerActions.removeProducer(this._webcamProducer.id));

    	if ('mediaSession' in navigator && isInPIP())
    	{
    		navigator.mediaSession.setCameraActive(false);
    	}

    	store.dispatch(settingsActions.setMediaPerms({
    		...store.getState().settings.mediaPerms,
    		video : false
    	}));

    	try
    	{
    		await this.sendRequest(
    			'closeProducer', { producerId: this._webcamProducer.id });
    	}
    	catch (error)
    	{
    		logger.error('disableWebcam() [error:"%o"]', error);

    		const object = {
    			type  : 'camera',
    			error : 'Unable to update camera'
    		};

    		window.parent.postMessage(JSON.stringify({ cmd: 'eventError', value: object }), '*');
    	}

    	this._webcamProducer = null;
    	// if (this._havePermission(permissions.MODERATE_ROOM) && store.getState().me.roleType === 'Host')
    	// {
    	// 	this.cpanelSocket?.emit('conf-video-enable-disable', { videoEnableDisable: false });
    	// }
    	store.dispatch(settingsActions.setVideoMuted(true));
    	store.dispatch(meActions.setWebcamInProgress(false));

    	if (this.vBackgroundStream)
    	{
    		this.vBackgroundStream.getTracks().forEach((each) => each.stop());
    		this.vBackgroundStream = null;
    	}

    	// Virtual background pipeline used the stopped camera stream; capStream is stale.
    	// Clear chroma so createBackground() after updateWebcam() rebuilds doLoad +
    	// replaceTrack instead of the REUSE path (updateBackground only), which would
    	// leave video broken. Skip when updateChromaCam() is closing the interim raw
    	// producer (chroma is new and must be preserved).
    	if (!preserveChromaForVirtualBg && this._chromaStream)
    	{
    		this._chromaStream.close();
    		this._chromaStream = null;
    	}
    }

    async _setNoiseThreshold(threshold)
    {
    	logger.debug('_setNoiseThreshold() [threshold:"%s"]', threshold);

    	this._hark?.setThreshold(threshold);

    	store.dispatch(
    		settingsActions.setNoiseThreshold(threshold));
    }

    async _updateAudioDevices()
    {
    	logger.debug('_updateAudioDevices()');

    	// Reset the list.
    	this._audioDevices = {};

    	try
    	{
    		logger.debug('_updateAudioDevices() | calling enumerateDevices()');

    		const devices = await navigator.mediaDevices.enumerateDevices();

    		for (const device of devices)
    		{
    			if (device.kind !== 'audioinput')
    				continue;

    			this._audioDevices[device.deviceId] = device;
    		}
    		store.dispatch(
    			meActions.setAudioDevices(this._audioDevices));

    		if (this._deviceInfo.platform === 'desktop' && this._deviceInfo.name === 'electron')
    		{
    			await this.sendRequest('setAudioDevices', this._audioDevices);
    		}
    	}
    	catch (error)
    	{
    		logger.error('_updateAudioDevices() [error:"%o"]', error);
    	}
    }

    pauseMicOfNonBreakout(breakedPeers)
    {
    	// eslint-disable-next-line no-alert
    	for (const consumer of this._consumers.values())
    	{
    		if (consumer.kind === 'audio' && consumer)
    		{
    			if (!breakedPeers.includes(consumer.appData.peerId))
    			{
    				this._pauseConsumer(consumer);
    			}
    			else
    			{
    				this._resumeConsumer(consumer);
    			}
    		}
    	}
    	// alert('s');
    }

    resumeMicOfNonBreakout()
    {
    	// eslint-disable-next-line no-alert
    	for (const consumer of this._consumers.values())
    	{
    		if (consumer.kind === 'audio' && consumer)
    		{
    			this._resumeConsumer(consumer);
    		}
    	}
    	// alert('s');
    }

    // async handleVideoDeviceChange()
    // {

    // 	const mediaStream=new MediaStream();

    // 	mediaStream.getTracks().forEach((each) =>
    // 	{
    // 		each.stop();
    // 	});

    // 	if (media === 'video')
    // 	{
    // 		video.current = device?.deviceId;
    // 	}
    // }

    async controlPtzOptions(data, id)
    {

    	console.log('controlPtzOptions', data, id, store.getState().producers[id]);

    	try
    	{

    		let track;

    		// await track.applyConstraints(constraints);

    		const settings = store.getState().settings;
    		const { aspectRatio, frameRate } = settings;
    		const resolution = getCaptureResolution(settings);

    		const constraints = {
    			...getVideoConstrains(resolution, aspectRatio),
    			frameRate,
    			advanced : [ data ]
    		};

    		if (store.getState().producers[id])
    		{
    			({ track } = store.getState().producers[id]);

    			if (track)
    			{
    				await track?.applyConstraints(constraints).then((res) =>
    				{
    					console.log('res_controlPtzOptions=======', res);
    				})
    					.catch((err) =>
    					{
    						console.log('err_controlPtzOptions=====', err, track);
    					});
    			}
    		}

    		store.dispatch(producerActions.updateProducer({ id: this._webcamProducer.id, ...data }));
    	}
    	catch (err)
    	{
    		console.error('applyConstraints() failed: ', err);
    	}

    }

    async _updateWebcams()
    {
    	logger.debug('_updateWebcams()');

    	// Reset the list.
    	this._webcams = {};

    	try
    	{
    		logger.debug('_updateWebcams() | calling enumerateDevices()');

    		const devices = await navigator.mediaDevices.enumerateDevices();

    		for (const device of devices)
    		{
    			if (device.kind !== 'videoinput')
    				continue;

    			this._webcams[device.deviceId] = device;
    		}

    		store.dispatch(
    			meActions.setWebcamDevices(this._webcams));

    		// const deviceId=await this._getWebcamDeviceId();

    		if (this._deviceInfo.platform === 'desktop' && this._deviceInfo.name === 'electron')
    		{
    			await this.sendRequest('setWebCams', this._webcams);
    		}

    		if ('mediaSession' in navigator && isInPIP())
    		{
    			navigator.mediaSession.setCameraActive(true);
    		}
    	}
    	catch (error)
    	{
    		logger.error('_updateWebcams() [error:"%o"]', error);
    	}
    }

    async shareUploadFile(layoutData, layout)
    {
    	try
    	{
    		if (Object.keys(layoutData).length > 0)
    		{
    			if (this._annotationsSocket)
    			{
    				await this.clearAnnotationData();
    				await this.deleteDocumentInFileShare();
    			}
    			await this.sendAnnotationsRequst(true);
    			await this.sendRequest('shareFile', { layout, layoutData });
    		}
    	}
    	catch (err)
    	{
    		console.log(err);
    	}
    }

    async videoShare(layoutData, layout)
    {

    	try
    	{
    		if (Object.keys(layoutData).length > 0)
    		{
    			await this.sendRequest('videoShare', { layout, layoutData });
    		}
    	}
    	catch (err)
    	{
    		console.log(err);
    	}

    }

    async removeVideoShare(videoData)
    {
    	try
    	{

    		console.log('videoDatavideoData', videoData);
    		if (this._roomTemplate.data.democratic)
    		{
    			await this.sendRequest('removeVideoShare', { layout: 'democratic', layoutData: { ...videoData } });
    		}
    		if (this._roomTemplate.data.filmStrip)
    		{
    			await this.sendRequest('removeVideoShare', { layout: 'filmstrip', layoutData: { ...videoData } });
    		}
    		store.dispatch(roomActions.setVideoData(null));

    	}
    	catch (error)
    	{
    		console.log('Failed to remove layout');
    	}

    }

    async setNextAndPrevPage(page)
    {
    	await this.sendRequest('setPage', { page });
    }

    async _getAudioDeviceId()
    {
    	logger.debug('_getAudioDeviceId()');

    	try
    	{
    		logger.debug('_getAudioDeviceId() | calling _updateAudioDeviceId()');

    		await this._updateAudioDevices();

    		const { selectedAudioDevice } = store.getState().settings;

    		if (selectedAudioDevice && this._audioDevices[selectedAudioDevice])
    		{
    			if (this._deviceInfo.platform === 'desktop' && this._deviceInfo.name === 'electron')
    			{
    				await this.sendRequest('setMicId', selectedAudioDevice);
    			}

    			return selectedAudioDevice;
    		}
    		else
    		{
    			const audioDevices = Object.values(this._audioDevices);

    			if (this._deviceInfo.platform === 'desktop' && this._deviceInfo.name === 'electron')
    			{
    				await this.sendRequest('setMicId', audioDevices[0] ? audioDevices[0].deviceId : null);
    			}

    			return audioDevices[0] ? audioDevices[0].deviceId : null;
    		}
    	}
    	catch (error)
    	{
    		logger.error('_getAudioDeviceId() [error:"%o"]', error);
    	}
    }

    async _getWebcamDeviceId()
    {
    	logger.debug('_getWebcamDeviceId()');

    	try
    	{
    		logger.debug('_getWebcamDeviceId() | calling _updateWebcams()');

    		await this._updateWebcams();

    		const { selectedWebcam } = store.getState().settings;

    		if (selectedWebcam && this._webcams[selectedWebcam])
    		{
    			if (this._deviceInfo.platform === 'desktop' && this._deviceInfo.name === 'electron')
    			{
    				await this.sendRequest('setWebCamId', selectedWebcam);
    			}

    			return selectedWebcam;
    		}
    		else
    		{
    			const webcams = Object.values(this._webcams);

    			if (this._deviceInfo.platform === 'desktop' && this._deviceInfo.name === 'electron')
    			{
    				await this.sendRequest('setWebCamId', webcams[0] ? webcams[0].deviceId : null);
    			}

    			return webcams[0] ? webcams[0].deviceId : null;
    		}

    	}
    	catch (error)
    	{
    		logger.error('_getWebcamDeviceId() [error:"%o"]', error);
    	}
    }

    async _updateAudioOutputDevices()
    {
    	logger.debug('_updateAudioOutputDevices()');

    	// Reset the list.
    	this._audioOutputDevices = {};

    	try
    	{
    		logger.debug('_updateAudioOutputDevices() | calling enumerateDevices()');

    		const devices = await navigator.mediaDevices.enumerateDevices();

    		for (const device of devices)
    		{
    			if (device.kind !== 'audiooutput')
    				continue;

    			this._audioOutputDevices[device.deviceId] = device;
    		}

    		store.dispatch(
    			meActions.setAudioOutputDevices(this._audioOutputDevices));
    	}
    	catch (error)
    	{
    		logger.error('_updateAudioOutputDevices() [error:"%o"]', error);
    	}
    }

    _havePermission(permission)
    {
    	const {
    		roomPermissions,
    		allowWhenRoleMissing
    	} = store.getState().room;

    	if (!roomPermissions)
    		return false;

    	const { roles } = store.getState().me;

    	const permitted = roles.some((userRoleId) =>
    		roomPermissions[permission].some((permissionRole) =>
    			userRoleId === permissionRole.id
    		)
    	);

    	if (permitted)
    		return true;

    	if (!allowWhenRoleMissing)
    		return false;

    	const peers = Object.values(store.getState().peers);

    	// Allow if config is set, and no one is present
    	if (allowWhenRoleMissing.includes(permission) &&
			peers.filter(
				(peer) =>
					peer.roles.some(
						(roleId) => roomPermissions[permission].some((permissionRole) =>
							roleId === permissionRole.id
						)
					)
			).length === 0
    	)
    		return true;

    	return false;
    }

    _closeConsumer(consumerId)
    {
    	const consumer = this._consumers.get(consumerId);

		this._spotlights.removeVideoConsumer(consumerId);

    	console.log('removing consumer with consumerId', consumerId);

		store.dispatch(
			consumerActions.removeConsumer(consumerId));
    	if (!consumer)
    		return;

    	consumer.close();

    	if (consumer.hark != null)
    		consumer.hark.stop();

    	this._consumers.delete(consumerId);

    	const { peerId } = consumer.appData;

    	store.dispatch(
    		consumerActions.removeConsumer(consumerId, peerId));

    	if (consumer.appData.source === 'screen')
    	{
    		this.exitScreenShareIfRequired(peerId);
    	}
    	if (this._SIP)
    	{

    		this.performSIPConferenceAction(1089, 'stop-screen-share').catch((error) =>
    		{
    			console.error('Error calling performSIPConferenceAction:', error);
    		});
    		this._screenSharingActive = false;
    		if (this._activeSpeaker)
    		{
    			this._SIP.changeActiveSpeaker(this._activeSpeaker);
    		}
    	}

    	if (this._SIP)
    	{

    		this.performSIPConferenceAction(1089, 'stop-screen-share').catch((error) =>
    		{
    			console.error('Error calling performSIPConferenceAction:', error);
    		});
    		this._screenSharingActive = false;
    		if (this._activeSpeaker)
    		{
    			this._SIP.changeActiveSpeaker(this._activeSpeaker);
    		}
    	}

    }

    _chooseEncodings(simulcastProfiles, size)
    {
    	let encodings;

    	const sortedMap = new Map([ ...Object.entries(simulcastProfiles) ]
    		.sort((a, b) => parseInt(b[0]) - parseInt(a[0])));

    	for (const [ key, value ] of sortedMap)
    	{
    		if (key < size)
    		{
    			if (encodings === null)
    			{
    				encodings = value;
    			}

    			break;
    		}

    		encodings = value;
    	}
    	// Copy before returning: `encodings` is the array held inside
    	// config.simulcastProfiles. Callers mutate what they get back (they set
    	// networkPriority on it, and the single-layer hack below pushes into it),
    	// so returning the original let one producer's settings leak into the
    	// global config and into every producer created afterwards.
    	encodings = encodings.map((encoding) => ({ ...encoding }));

    	// hack as there is a bug in mediasoup
    	if (encodings.length === 1)
    	{
    		encodings.push({ ...encodings[0] });
    	}

    	return encodings;
    }

    _getEncodings(width, height, screenSharing = false)
    {
    	// If VP9 is the only available video codec then use SVC.
    	const firstVideoCodec = this._mediasoupDevice
    		.rtpCapabilities
    		.codecs
    		.find((c) => c.kind === 'video');

    	let encodings;

    	const size = (width > height ? width : height);

    	if (firstVideoCodec.mimeType.toLowerCase() === 'video/vp9')
    		encodings = screenSharing ? VIDEO_SVC_ENCODINGS : VIDEO_KSVC_ENCODINGS;
    	else if (config.simulcastProfiles)
    		encodings = this._chooseEncodings(config.simulcastProfiles, size);
    	else
    		encodings = this._chooseEncodings(VIDEO_SIMULCAST_PROFILES, size);

    	return encodings;
    }

    setHideNoVideoParticipants(hideNoVideoParticipants)
    {
    	this._spotlights.hideNoVideoParticipants = hideNoVideoParticipants;
    }

    async animeEmoji(selectedAnimeEmoji, emojiMeId)
    {
    	try
    	{
    		await this.sendRequest('setSelectedAnimeEmojis', { selectedAnimeEmoji, emojiMeId });
    		store.dispatch(toolareaAction.handleEmojis({ selectedAnimeEmoji, emojiMeId }));
    		const remoji = () =>
    		{
    			store.dispatch(toolareaAction.removeEmojis());
    		};

    		setTimeout(remoji, 5000);
    	}
    	catch (error)
    	{
    		// console.log('Failed to set layout')
    	}
    }

    async sendPolling(polling)
    {
    	try
    	{
    		if (Object.entries(polling).length !== 0)
    		{
    			store.dispatch(toolareaAction.setResultObj(polling));
    		}
    		await this.sendRequest('setPolling', polling);
    		if (store.getState().room.webinarStreamOn && this._webinarSocket)
    		{
    			this._webinarSocket.emit('setPolling', this._roomId, polling);
    		}
    		// store.dispatch(toolareaAction.handleEmojis({ selectedAnimeEmoji, emojiMeId }));
    		// const remoji = () =>
    		// {
    		// 	store.dispatch(toolareaAction.removeEmojis());
    		// };

    		// setTimeout(remoji, 5000);
    	}
    	catch (error)
    	{
    		// console.log('Failed to set layout')
    	}
    }

    async peerPollSubmit(polling)
    {
    	try
    	{
    		if (this._signalingSocket)
    		{
    			await this.sendRequest('setPeerPollSubmit', polling);
    		}
    		if (store.getState().room.webinarStreamOn && this._webinarSocket)
    		{
    			if (store.getState().webinar.webinarSocket)
    			{
    				store.getState().webinar.webinarSocket.emit('setPeerPollSubmit', polling);
    			}
    			if (this._webinarSocket)
    			{
    				this._webinarSocket.emit('setPeerPollSubmit', polling);
    			}
    		}
    		// store.dispatch(toolareaAction.handleEmojis({ selectedAnimeEmoji, emojiMeId }));
    		// const remoji = () =>
    		// {
    		// 	store.dispatch(toolareaAction.removeEmojis());
    		// };

    		// setTimeout(remoji, 5000);
    	}
    	catch (error)
    	{
    		// console.log('Failed to set layout')
    	}
    }

    async hostControlsManage(hostControlsObj)
    {
    	try
    	{
    		store.dispatch(toolareaAction.hostHandleControls(hostControlsObj));
    		await this.sendRequest('sendHostControls', hostControlsObj);
    	}
    	catch (error)
    	{
    		// console.log('Failed to set layout')
    	}
    }

    async closePopupForMrc(data)
    {
    	await this.sendRequest('closePopup', data);
    }

    async addToSpotlight(peerId)
    {
    	try
    	{
    		const alreadyAdded = store.getState().room?.selectedPeers?.includes(peerId);
    		const viewMode = store.getState().room.mode;

    		if (alreadyAdded)
    		{
    			this.removeSelectedPeer(peerId);
    			await this.sendRequest('removePeerSpotlight', { peerId });
    		}

    		!alreadyAdded? viewMode === 'filmstrip'?this.setSelectedPeer(peerId) : this.addSelectedPeer(peerId):null;

    		const consumers = store.getState().consumers;
    		const hasConsumerWithPeerId = Object.values(consumers).some((consumer) => consumer.peerId === peerId && consumer.kind === 'video');

    		if (!alreadyAdded && !hasConsumerWithPeerId)
    		{
    			await this.sendRequest('addToPeerSpotlight', { peerId });
    			// await this.sendRequest('createConsumerForPeer', { peerList: [ peerId ] });
    		}

    		if (this._deviceInfo.platform === 'desktop' && this._deviceInfo.name === 'electron')
    		{
    			await this.sendRequest('selectedPeers', { selectedPeers: store.getState().room?.selectedPeers });
    		}
    	}
    	catch (err)
    	{
    		console.log('error================', err);
    	}

    	// console.log('store.getState().room?.selectedPeers=====', store.getState().room?.selectedPeers, store.getState().room?.spotlights);
    }

    async closeHostRequestVideoOrAudio(requestObj)
    {
    	try
    	{
    		if (requestObj && requestObj.type === 'video')
    		{
    			store.dispatch(toolareaAction.moderatorRequestPeerVideoOrAudio({ type: 'video', value: false }));
    			if (requestObj.status === false)
    			{
    				await this.sendRequest('declinedHostRequestedVideoOrAudio', { peerId: requestObj.peerId, type: 'video' });
    			}
    		}

    		if (requestObj && requestObj.type === 'audio')
    		{
    			store.dispatch(toolareaAction.moderatorRequestPeerVideoOrAudio({ type: 'audio', value: false }));
    			if (requestObj.status === false)
    			{
    				await this.sendRequest('declinedHostRequestedVideoOrAudio', { peerId: requestObj.peerId, type: 'audio' });
    			}
    		}

    		this.closePopupForMrc({ type: 'mrpvoa' });

    	}
    	catch (error)
    	{
    		// console.log('Failed to set layout')
    	}
    }

    async closeBreakoutRooms(isCloseMeeting)
    {
    	let breakoutRoomIds = [];

    	for (let room of store.getState().room.breakoutRoomsNewList)
    	{
    		breakoutRoomIds.push(room.id);
    	}

    	this._isBreakoutRoomStart = false;
    	await this.sendRequest('setIsBreakoutRoomStart', { isBreakoutRoomStart: false, brData: breakoutRoomIds, isCloseMeeting });
    	store.dispatch(
    		roomActions.setIsBreakoutRoomStart(false));
    	axios.post(`https://${config.serverHostname}/auth/BreakoutRoomEnd`, { breakoutRoomData: breakoutRoomIds, isCloseMeeting, mainRoomId: this._roomId }).then(async () =>
    	{
    	});
    }

    async newBreaktRooms(data)
    {

    	try
    	{
    		// await this.sendRequest('breakoutRoomData', data);
    		// axios.post(`https://${config.serverHostname}/auth/breakout`, { breakoutRooms: data, roomId: this.getRoomID(), projectId: this._projectId, record: this._record }).then(async (res) =>
    		// {
    		const { isAlreadyStart } = await this.sendRequest('startBreakoutRooms', { breakoutRooms: data });

    		if (isAlreadyStart)
    		{
    			store.dispatch(requestActions.notify(
    				{
    					type : 'error',
    					text : intl.formatMessage({
    						id             : 'devices.bralreadyStarted',
    						defaultMessage : 'Someone has already started'
    					})
    				}));

    			return;
    		}

    		this._isBreakoutRoomStart = true;

    		store.dispatch(
    			roomActions.setIsBreakoutRoomStart(true));

    		await this.sendRequest('setIsBreakoutRoomStart', { isBreakoutRoomStart: true });

    		// });
    	}
    	catch (err)
    	{
    		console.log(err);
    	}

    }

    async sendBreakoutRoomDataToMainRoom()
    {

    	await this.sendRequest('breakoutRoomData', { breakoutRoomData: store.getState().room.breakoutRoomsNewList, isBreakoutRoom: store.getState().me.isBreakoutRoom });
    }

    async senBreakoutRoomDataToBreakoutRooms()
    {
    	// this.sendRequest('breakoutRoomDataToSubRooms', { breakoutRoomData: store.getState().room.breakoutRoomsNewList, brId: this.breakoutRoomData.id });
    	const { socketEmited } = await this.sendRequest('hostJoinedBrRoom', { breakoutRoomData: store.getState().room.breakoutRoomsNewList, brId: this.breakoutRoomData.id, currentRoomId: this._currentRoomId, type: 'breakoutRoom' });

    }

    async hostJoinBrRoom(roomData, isModerator)
    {

    	this.breakoutRoomData = roomData;

    	if (isModerator)
    	{
    		// eslint-disable-next-line no-console
    		await this.senBreakoutRoomDataToBreakoutRooms();
    	}

    	await this.breakoutRoomJoin();
    }

    async breakoutRoomJoin()
    {
    	this._closed = false;

    	this.isBreakoutRoom = true;

    	if (this._closed)
    		return;

    	this._closed = true;

    	logger.debug('close()');

    	if (this._meetingType === 'webinar' && this._webinarSocket)
    	{
    		this._webinarSocket?.disconnect();
    	}

    	this._signalingSocket?.close();

    	// Close mediasoup Transports.
    	if (this._sendTransport)
    		this._sendTransport.close();

    	if (this._recvTransport)
    		this._recvTransport.close();

    	this._spotlights?.clearSpotlights();
    	store.dispatch(peerActions.clearPeers());
    	store.dispatch(consumerActions.clearConsumers());
    	store.dispatch(producerActions.clearProducer());
    	this.disconnectLocalHark();
    	store.dispatch(roomActions.clearSpotlights());
    	store.dispatch(roomActions.setAllScreens([]));
    	store.dispatch(roomActions.setRoomState('closed'));
    	this._fileShareLayoutData = null;
    	store.dispatch(roomActions.setDocument(null));
    	store.dispatch(roomActions.setTotalPages(0));
    	this._videoData = null;
    	store.dispatch(roomActions.setVideoData(null));
    	this._layoutDataWB = null;
    	store.dispatch(roomActions.setWhiteboardData(null));
    	store.dispatch(roomActions.setDisplayMode('democratic'));
    	store.dispatch(meActions.removeRole(5337));
    	store.dispatch(meActions.removeRole(9583));
    	store.dispatch(roomActions.setWebinarPeers([]));

    	this._clearPipActiveSpeaker();

    	// const { subRoomData } = data;
    	const filterPeer = this.breakoutRoomData?.participantsList?.filter((each) => each.id === this._peerId);

    	this.join({
    		roomId         : this._roomId,
    		joinVideo      : store.getState().settings?.mediaPerms?.video,
    		joinAudio      : store.getState().settings?.mediaPerms?.audio,
    		breakoutRooms  : true,
    		breakoutPeerId : filterPeer[0]?.id,
    		breakoutRoomId : this.breakoutRoomData?.id
    	});
    }

    async joinToCPanel(joinVideo, joinAudio, peers)
    {

    	if (this._havePermission(permissions.MODERATE_ROOM) && store.getState().me.roleType === 'Host')
    	{
    		this.cpanelSocket?.emit('start-conference', { joinStatus: true, audioStatus: joinAudio, videoStatus: joinVideo });

    	}

    	if (this._havePermission(permissions.MODERATE_ROOM) && store.getState().me.roleType === 'Host')
    	{
    		this.cpanelSocket?.emit('peerList', peers);
    	}

    	this.cpanelSpotLightPeers();

    	this.cpanelPeerResponse();

    	this.cpanelSocket?.on('conf-audio-mute-all', (payload) =>
    	{
    		if (this._havePermission(permissions.MODERATE_ROOM) && store.getState().me.roleType === 'Host')
    		{
    			if (payload.muteAudioAll)
    			{
    				this.muteAllPeers();

    			}
    			if (payload.muteVideoAll)
    			{
    				this.stopAllPeerVideo();
    			}

    		}

    	});

    	this.cpanelSocket?.on('conf-mute-video-audio-each-peer', (payload) =>
    	{
    		if (this._havePermission(permissions.MODERATE_ROOM) && store.getState().me.roleType === 'Host')
    		{
    			if (payload.peerId && payload.audio)
    			{
    				this.mutePeer(payload.peerId);
    			}
    			if (payload.peerId && payload.video)
    			{
    				this.stopPeerVideo(payload.peerId);
    			}

    		}
    	});

    	this.cpanelSocket?.on('end-conf-status', (payload) =>
    	{
    		// eslint-disable-next-line no-console
    		console.log('end-conf-status', payload);

    		if (payload.endStatus && this._havePermission(permissions.MODERATE_ROOM) && store.getState().me.roleType === 'Host')
    		{
    			this.closeMeeting();
    		}
    	}
    	);

    	this.cpanelSocket?.on('conf-audio-status', (payload) =>
    	{
    		if (payload.audioStatus && this._havePermission(permissions.MODERATE_ROOM) && store.getState().me.roleType === 'Host')
    		{
    			this.unmuteMic();
    		}
    		else if (!payload.audioStatus && this._havePermission(permissions.MODERATE_ROOM) && store.getState().me.roleType === 'Host')
    		{
    			this.muteMic();

    		}
    	});

    	this.cpanelSocket?.on('conf-video-status', (payload) =>
    	{
    		console.log('conf-video-status==');
    		if (!payload.videoStatus && this._havePermission(permissions.MODERATE_ROOM) && store.getState().me.roleType === 'Host')
    		{
    			this.disableWebcam();
    		}
    		else if (payload.videoStatus && this._havePermission(permissions.MODERATE_ROOM) && store.getState().me.roleType === 'Host')
    		{
    			this.updateWebcam({ start: true });
    		}
    	});

    	this.cpanelSocket?.on('conf-peer-kickout', (payload) =>
    	{
    		if (this._havePermission(permissions.MODERATE_ROOM) && store.getState().me.roleType === 'Host')
    		{
    			this.kickPeer(payload.peerId);
    		}
    	});

    	this.cpanelSocket?.on('conf-add-spotLight', (payload) =>
    	{
    		if (this._havePermission(permissions.MODERATE_ROOM) && store.getState().me.roleType === 'Host')
    		{
    			const cpanelRoom = store.getState().room;
    			const cpanelSelectedPeer = cpanelRoom.selectedPeers;
    			const cpanelSpotLights = cpanelRoom.spotlights;
    			const isSelected = cpanelSelectedPeer.includes(payload.peerId);
    			const mode = cpanelSpotLights.mode;

    			isSelected ? this.removeSelectedPeer(payload.peerId) :
    				mode === 'filmstrip' ? this.setSelectedPeer(payload.peerId) : this.addSelectedPeer(payload.peerId);
    			this.cpanelSpotLightPeers();
    		}
    	});

    	this.cpanelSocket?.on('conf-cpanel-telepresence', async (payload) =>
    	{
    		console.log('conf-cpanel-telepresence', payload);
    		const telePresenseMenu = store.getState().room.telePresenseMenu;

    		console.log('telePresenseMenu', telePresenseMenu);
    		if (this._havePermission(permissions.MODERATE_ROOM) && telePresenseMenu && store.getState().me.roleType === 'Host')
    		{
    			console.log('ksudsiudifsdiuf');
    			if (payload.isTp)
    			{
    				await this.startTelepresence();
    			}
    			else
    			{
    				await this.stopTelepresence();
    			}
    		}
    	});
    }

    async cpanelStartTelepresenceRes(status)
    {
    	console.log('stst==', status);
    	this.cpanelSocket?.emit('cpanel-start-tp-res', { cpanelTpStarted: status });
    }

    async cpanelSpotLightPeers()
    {
    	const cpanelSelSpotPeer = store.getState().room.selectedPeers;

    	this.cpanelSocket?.emit('cpanel-spotlight-peer', cpanelSelSpotPeer);
    }

    async cpanelPeerData()
    {
    	const cpanelPeerlist = store.getState().peers;

    	if (this._havePermission(permissions.MODERATE_ROOM) && store.getState().me.roleType === 'Host')
    	{
    		this.cpanelSocket?.emit('peerList', Object.values(cpanelPeerlist));

    	}
    }

    async cpanelPeerResponse()
    {
    	const cpanelPeerResponseData = store.getState().consumers;

    	if (this._havePermission(permissions.MODERATE_ROOM) && store.getState().me.roleType === 'Host')
    	{
    		this.cpanelSocket?.emit('conf-cpanel-peer-audio-video-response', Object.values(cpanelPeerResponseData));

    	}
    }

    async joinBreakoutRoomToMainRoom()
    {

    	clearInterval(this.timmerForJoinMainRoom);

    	this._closed = false;

    	if (this._closed)
    		return;

    	this._closed = true;

    	logger.debug('close()');

    	if (this._meetingType === 'webinar' && this._webinarSocket)
    	{
    		this._webinarSocket.disconnect();
    	}

    	this._signalingSocket?.close();

    	// Close mediasoup Transports.
    	if (this._sendTransport)
    		this._sendTransport.close();

    	if (this._recvTransport)
    		this._recvTransport.close();

    	this._spotlights?.clearSpotlights();
    	store.dispatch(peerActions.clearPeers());
    	store.dispatch(consumerActions.clearConsumers());
    	store.dispatch(producerActions.clearProducer());
    	this.disconnectLocalHark();
    	store.dispatch(roomActions.clearSpotlights());
    	store.dispatch(roomActions.setAllScreens([]));
    	store.dispatch(meActions.removeRole(5337));
    	store.dispatch(meActions.removeRole(9583));
    	store.dispatch(roomActions.setRoomState('closed'));
    	this._fileShareLayoutData = null;
    	store.dispatch(roomActions.setDocument(null));
    	store.dispatch(roomActions.setTotalPages(0));
    	this._videoData = null;
    	store.dispatch(roomActions.setVideoData(null));
    	this._layoutDataWB = null;
    	store.dispatch(roomActions.setWhiteboardData(null));
    	store.dispatch(roomActions.setDisplayMode('democratic'));
    	store.dispatch(meActions.setIsBreakoutRoom(false));
    	store.dispatch(roomActions.setWebinarPeers([]));
    	this._clearPipActiveSpeaker();

    	this.join({
    		roomId    : this._roomId,
    		joinVideo : store.getState().settings?.mediaPerms?.video,
    		joinAudio : store.getState().settings?.mediaPerms?.audio,
    		from      : 'brRoomToMainRoom'
    	});
    }

    peerDirectLeaveBrRoom()
    {
    	this.breakoutRoomData = null;
    	this.joinBreakoutRoomToMainRoom();
    	store.dispatch(roomActions.setEndBreakoutSession(''));
    }

    async joinBrRoomToMainRoomHostPeersAndTpScreeen()
    {
    	// if (store.getState().me.roles.includes(5337))
    	// {
    	// 	this.sendRequest('hostJoinedBrRoom', { breakoutRoomData: store.getState().room.breakoutRoomsNewList, brId: this._roomId, currentRoomId: this._currentRoomId, type: 'mainRoom' });
    	// }

    	store.dispatch(roomActions.setBreakoutRoomJoin(false));
    	store.dispatch(roomActions.setIsBreakoutRoomJoin(false));
    	if (store.getState().me.isBreakoutRoom)
    	{

    		if (store.getState().me.roles.includes(5337))
    		{

    			// store.dispatch(roomActions.setEndBreakoutSession('breakoutRoomMovePeerToMainRoom'));
    			this.timmerForJoinMainRoom = setTimeout(() =>
    			{
    				this.breakoutRoomData = null;
    				this.joinBreakoutRoomToMainRoom();
    				// store.dispatch(roomActions.setEndBreakoutSession(''));
    			}, 1000);
    		}
    		else if (Number(this._screenPage) > 0 || this._mode === 'speaker' || this._mode === 'screen')
    		{
    			this.breakoutRoomData = null;
    			this.joinBreakoutRoomToMainRoom();
    		}
    		else
    		{
    			store.dispatch(roomActions.setEndBreakoutSession('breakoutRoomMovePeerToMainRoom'));
    			this.timmerForJoinMainRoom = setTimeout(() =>
    			{
    				this.breakoutRoomData = null;
    				this.joinBreakoutRoomToMainRoom();
    				store.dispatch(roomActions.setEndBreakoutSession(''));
    			}, 20000);

    		}
    	}
    }

    async handleMoveBtBrRoomsByHost(toRoom, peer)
    {
    	try
    	{

    		const roomData = toRoom;

    		await this.sendRequest('handleBrToMrByHost', { peerId: peer.id, data: roomData, type: 'movePeerBtBrRooms' });
    	}
    	catch (error)
    	{
    		// console.log('error==============', error);
    	}
    }

    async tpScreenBreakoutRoomJoin(roomId)
    {
    	this._closed = false;

    	this.isBreakoutRoom = true;

    	if (this._closed)
    		return;

    	this._closed = true;

    	logger.debug('close()');

    	this._signalingSocket.close();

    	// Close mediasoup Transports.
    	if (this._sendTransport)
    		this._sendTransport.close();

    	if (this._recvTransport)
    		this._recvTransport.close();

    	this._spotlights.clearSpotlights();
    	store.dispatch(peerActions.clearPeers());
    	this._clearPipActiveSpeaker();
    	store.dispatch(consumerActions.clearConsumers());
    	store.dispatch(producerActions.clearProducer());
    	store.dispatch(roomActions.clearSpotlights());

    	store.dispatch(roomActions.setRoomState('closed'));

    	this.join({
    		roomId         : this._roomId,
    		joinVideo      : false,
    		joinAudio      : false,
    		breakoutRooms  : true,
    		breakoutPeerId : this._peerId,
    		breakoutRoomId : roomId
    	});
    }

    async handleBrakoutRoomToMainRoomByHost(room, peer)
    {
    	try
    	{
    		if (store.getState().me.roles.includes(5337) && store.getState().me.id === peer.id)
    		{
    			await this.sendRequest('hostJoinedBrRoom', { breakoutRoomData: store.getState().room.breakoutRoomsNewList, brId: this._roomId, currentRoomId: this._currentRoomId, type: 'mainRoom' });
    		}

    		await this.sendRequest('handleBrToMrByHost', { peerId: peer.id, data: null, type: 'movePeerToBrToMr' });

    	}
    	catch (error)
    	{
    		// console.log('Failed to set layout')
    	}
    }

	// async tpScreenSeatLimit(tpObj)
	// {
	// 	try
	// 	{
	// 		console.log('tp screen seat limit called in room client::', tpObj);
	// 		await this.sendRequest('setTpScreenSeatLimit', tpObj);
	// 	}
	// 	catch (error)
	// 	{
	// 		// console.log('Failed to set layout')
	// 	}
	// }
}
